var map = {
	"./00001/00001-01/00001-01-01/here comes a blue airplane.mp3": [
		1734,
		409
	],
	"./00001/00001-01/00001-01-01/here comes a blue bus.mp3": [
		1735,
		410
	],
	"./00001/00001-01/00001-01-01/here comes a blue car.mp3": [
		1736,
		411
	],
	"./00001/00001-01/00001-01-01/here comes a blue helicopter.mp3": [
		1737,
		412
	],
	"./00001/00001-01/00001-01-01/here comes a blue motorcycle.mp3": [
		1738,
		413
	],
	"./00001/00001-01/00001-01-01/here comes a blue train.mp3": [
		1739,
		414
	],
	"./00001/00001-01/00001-01-01/here comes a blue truck.mp3": [
		1740,
		415
	],
	"./00001/00001-01/00001-01-01/intro.mp3": [
		357
	],
	"./00001/00001-01/00001-01-01/main idea.mp3": [
		738
	],
	"./00001/00001-01/00001-01-01/the blue vehicle book.mp3": [
		1741,
		416
	],
	"./00001/00001-01/00001-01-01/things that fly.mp3": [
		1742,
		417
	],
	"./00001/00001-01/00001-01-02/intro.mp3": [
		358
	],
	"./00001/00001-01/00001-01-02/main idea.mp3": [
		739
	],
	"./00001/00001-01/00001-01-02/the bird is red.mp3": [
		1743,
		418
	],
	"./00001/00001-01/00001-01-02/the butterfly is red.mp3": [
		1744,
		419
	],
	"./00001/00001-01/00001-01-02/the fire truck is red.mp3": [
		1745,
		420
	],
	"./00001/00001-01/00001-01-02/the frog is red.mp3": [
		1746,
		421
	],
	"./00001/00001-01/00001-01-02/the ladybug is red.mp3": [
		1747,
		422
	],
	"./00001/00001-01/00001-01-02/the red book.mp3": [
		1748,
		423
	],
	"./00001/00001-01/00001-01-02/the snake is red.mp3": [
		1749,
		424
	],
	"./00001/00001-01/00001-01-02/the starfish is red.mp3": [
		1750,
		425
	],
	"./00001/00001-01/00001-01-02/things that are red.mp3": [
		1751,
		426
	],
	"./00001/00001-01/00001-01-03/i see the yellow bananas.mp3": [
		1752,
		427
	],
	"./00001/00001-01/00001-01-03/i see the yellow chick.mp3": [
		1753,
		428
	],
	"./00001/00001-01/00001-01-03/i see the yellow lion.mp3": [
		1754,
		429
	],
	"./00001/00001-01/00001-01-03/i see the yellow slug.mp3": [
		1755,
		430
	],
	"./00001/00001-01/00001-01-03/i see the yellow snake.mp3": [
		1756,
		431
	],
	"./00001/00001-01/00001-01-03/i see the yellow sun.mp3": [
		1757,
		432
	],
	"./00001/00001-01/00001-01-03/i see the yellow yoyo.mp3": [
		1758,
		433
	],
	"./00001/00001-01/00001-01-03/intro.mp3": [
		359
	],
	"./00001/00001-01/00001-01-03/main idea.mp3": [
		740
	],
	"./00001/00001-01/00001-01-03/the blue vehicle book.mp3": [
		1759,
		434
	],
	"./00001/00001-01/00001-01-03/the yellow book.mp3": [
		1760,
		435
	],
	"./00001/00001-01/00001-01-03/things that are yellow.mp3": [
		1761,
		436
	],
	"./00001/00001-01/00001-01-04/intro.mp3": [
		360
	],
	"./00001/00001-01/00001-01-04/look at the orange butterfly.mp3": [
		1762,
		437
	],
	"./00001/00001-01/00001-01-04/look at the orange cat.mp3": [
		1763,
		438
	],
	"./00001/00001-01/00001-01-04/look at the orange fish.mp3": [
		1764,
		439
	],
	"./00001/00001-01/00001-01-04/look at the orange fox.mp3": [
		1765,
		440
	],
	"./00001/00001-01/00001-01-04/look at the orange octopus.mp3": [
		1766,
		441
	],
	"./00001/00001-01/00001-01-04/look at the orange salamander.mp3": [
		1767,
		442
	],
	"./00001/00001-01/00001-01-04/look at the orange tiger.mp3": [
		1768,
		443
	],
	"./00001/00001-01/00001-01-04/main idea.mp3": [
		741
	],
	"./00001/00001-01/00001-01-04/orange things.mp3": [
		1769,
		444
	],
	"./00001/00001-01/00001-01-04/the orange animal book.mp3": [
		1770,
		445
	],
	"./00001/00001-01/00001-01-05/i like the purple ball.mp3": [
		1771,
		446
	],
	"./00001/00001-01/00001-01-05/i like the purple dinosaur.mp3": [
		1772,
		447
	],
	"./00001/00001-01/00001-01-05/i like the purple flower.mp3": [
		1773,
		448
	],
	"./00001/00001-01/00001-01-05/i like the purple hat.mp3": [
		1774,
		449
	],
	"./00001/00001-01/00001-01-05/i like the purple jellyfish.mp3": [
		1775,
		450
	],
	"./00001/00001-01/00001-01-05/i like the purple monster.mp3": [
		1776,
		451
	],
	"./00001/00001-01/00001-01-05/i like the purple starfish.mp3": [
		1777,
		452
	],
	"./00001/00001-01/00001-01-05/intro.mp3": [
		361
	],
	"./00001/00001-01/00001-01-05/main idea.mp3": [
		742
	],
	"./00001/00001-01/00001-01-05/the purple book.mp3": [
		1778,
		453
	],
	"./00001/00001-01/00001-01-05/things that are purple.mp3": [
		1779,
		454
	],
	"./00001/00001-01/00001-01-06/animals that are green.mp3": [
		1780,
		455
	],
	"./00001/00001-01/00001-01-06/i see the green alligator.mp3": [
		1781,
		456
	],
	"./00001/00001-01/00001-01-06/i see the green caterpillar.mp3": [
		1782,
		457
	],
	"./00001/00001-01/00001-01-06/i see the green frog.mp3": [
		1783,
		458
	],
	"./00001/00001-01/00001-01-06/i see the green grasshopper.mp3": [
		1784,
		459
	],
	"./00001/00001-01/00001-01-06/i see the green iguana.mp3": [
		1785,
		460
	],
	"./00001/00001-01/00001-01-06/i see the green leaf.mp3": [
		1786,
		461
	],
	"./00001/00001-01/00001-01-06/i see the green turtle.mp3": [
		1787,
		462
	],
	"./00001/00001-01/00001-01-06/intro.mp3": [
		362
	],
	"./00001/00001-01/00001-01-06/main idea.mp3": [
		743
	],
	"./00001/00001-01/00001-01-06/the green book.mp3": [
		1788,
		463
	],
	"./00001/00001-01/00001-01-07/animals that are brown.mp3": [
		1789,
		464
	],
	"./00001/00001-01/00001-01-07/i am a brown bat.mp3": [
		1790,
		465
	],
	"./00001/00001-01/00001-01-07/i am a brown bear.mp3": [
		1791,
		466
	],
	"./00001/00001-01/00001-01-07/i am a brown deer.mp3": [
		1792,
		467
	],
	"./00001/00001-01/00001-01-07/i am a brown eagle.mp3": [
		1793,
		468
	],
	"./00001/00001-01/00001-01-07/i am a brown mouse.mp3": [
		1794,
		469
	],
	"./00001/00001-01/00001-01-07/i am a brown rabbit.mp3": [
		1795,
		470
	],
	"./00001/00001-01/00001-01-07/intro.mp3": [
		363
	],
	"./00001/00001-01/00001-01-07/main idea.mp3": [
		744
	],
	"./00001/00001-01/00001-01-07/the brown book.mp3": [
		1796,
		471
	],
	"./00001/00001-01/00001-01-07/we are brown kangaroos.mp3": [
		1797,
		472
	],
	"./00001/00001-01/00001-01-08/animals.mp3": [
		1798,
		473
	],
	"./00001/00001-01/00001-01-08/intro.mp3": [
		364
	],
	"./00001/00001-01/00001-01-08/look at the black ant.mp3": [
		1799,
		474
	],
	"./00001/00001-01/00001-01-08/look at the black bear.mp3": [
		1800,
		475
	],
	"./00001/00001-01/00001-01-08/look at the black bird.mp3": [
		1801,
		476
	],
	"./00001/00001-01/00001-01-08/look at the black cat.mp3": [
		1802,
		477
	],
	"./00001/00001-01/00001-01-08/look at the black dog.mp3": [
		1803,
		478
	],
	"./00001/00001-01/00001-01-08/look at the black horse.mp3": [
		1804,
		479
	],
	"./00001/00001-01/00001-01-08/look at the black spider.mp3": [
		1805,
		480
	],
	"./00001/00001-01/00001-01-08/main idea.mp3": [
		745
	],
	"./00001/00001-01/00001-01-08/the black book.mp3": [
		1806,
		481
	],
	"./00001/00001-01/00001-01-09/animals that live in the snow.mp3": [
		1807,
		482
	],
	"./00001/00001-01/00001-01-09/intro.mp3": [
		365
	],
	"./00001/00001-01/00001-01-09/main idea.mp3": [
		746
	],
	"./00001/00001-01/00001-01-09/the fox is white.mp3": [
		1808,
		483
	],
	"./00001/00001-01/00001-01-09/the owl is white.mp3": [
		1809,
		484
	],
	"./00001/00001-01/00001-01-09/the penguin is black and white.mp3": [
		1810,
		485
	],
	"./00001/00001-01/00001-01-09/the polar bear is white.mp3": [
		1811,
		486
	],
	"./00001/00001-01/00001-01-09/the rabbit is white.mp3": [
		1812,
		487
	],
	"./00001/00001-01/00001-01-09/the seal is white.mp3": [
		1813,
		488
	],
	"./00001/00001-01/00001-01-09/the white book.mp3": [
		1814,
		489
	],
	"./00001/00001-01/00001-01-09/the wolf is white.mp3": [
		1815,
		490
	],
	"./00001/00001-01/00001-01-10/i like the pink crab.mp3": [
		1816,
		491
	],
	"./00001/00001-01/00001-01-10/i like the pink flamingo.mp3": [
		1817,
		492
	],
	"./00001/00001-01/00001-01-10/i like the pink flower.mp3": [
		1818,
		493
	],
	"./00001/00001-01/00001-01-10/i like the pink hat.mp3": [
		1819,
		494
	],
	"./00001/00001-01/00001-01-10/i like the pink heart.mp3": [
		1820,
		495
	],
	"./00001/00001-01/00001-01-10/i like the pink pig.mp3": [
		1821,
		496
	],
	"./00001/00001-01/00001-01-10/i like the pink shell.mp3": [
		1822,
		497
	],
	"./00001/00001-01/00001-01-10/intro.mp3": [
		366
	],
	"./00001/00001-01/00001-01-10/main idea.mp3": [
		747
	],
	"./00001/00001-01/00001-01-10/the pink book.mp3": [
		1823,
		498
	],
	"./00001/00001-01/00001-01-10/things that are pink.mp3": [
		1824,
		499
	],
	"./00001/00001-01/00001-01-11/animals that are gray.mp3": [
		1825,
		500
	],
	"./00001/00001-01/00001-01-11/here comes the gray elephant.mp3": [
		1826,
		501
	],
	"./00001/00001-01/00001-01-11/here comes the gray hippo.mp3": [
		1827,
		502
	],
	"./00001/00001-01/00001-01-11/here comes the gray raccoon.mp3": [
		1828,
		503
	],
	"./00001/00001-01/00001-01-11/here comes the gray rhino.mp3": [
		1829,
		504
	],
	"./00001/00001-01/00001-01-11/here comes the gray seal.mp3": [
		1830,
		505
	],
	"./00001/00001-01/00001-01-11/here comes the gray whale.mp3": [
		1831,
		506
	],
	"./00001/00001-01/00001-01-11/here comes the gray wolf.mp3": [
		1832,
		507
	],
	"./00001/00001-01/00001-01-11/intro.mp3": [
		367
	],
	"./00001/00001-01/00001-01-11/main idea.mp3": [
		748
	],
	"./00001/00001-01/00001-01-11/the gray book.mp3": [
		1833,
		508
	],
	"./00001/00001-01/color park.mp3": [
		1834,
		509
	],
	"./00001/00001-01/colors.mp3": [
		1835,
		510
	],
	"./00001/00001-02/00001-02-01/animals.mp3": [
		1836,
		511
	],
	"./00001/00001-02/00001-02-01/intro.mp3": [
		368
	],
	"./00001/00001-02/00001-02-01/look at the bear.mp3": [
		1837,
		512
	],
	"./00001/00001-02/00001-02-01/look at the fox.mp3": [
		1838,
		513
	],
	"./00001/00001-02/00001-02-01/look at the mitten.mp3": [
		1839,
		514
	],
	"./00001/00001-02/00001-02-01/look at the mouse.mp3": [
		1840,
		515
	],
	"./00001/00001-02/00001-02-01/look at the owl.mp3": [
		1841,
		516
	],
	"./00001/00001-02/00001-02-01/look at the rabbit.mp3": [
		1842,
		517
	],
	"./00001/00001-02/00001-02-01/main idea.mp3": [
		749
	],
	"./00001/00001-02/00001-02-01/the mitten.mp3": [
		1843,
		518
	],
	"./00001/00001-02/00001-02-02/dogs.mp3": [
		1844,
		519
	],
	"./00001/00001-02/00001-02-02/intro.mp3": [
		369
	],
	"./00001/00001-02/00001-02-02/look in the bathroom.mp3": [
		1845,
		520
	],
	"./00001/00001-02/00001-02-02/look in the bedroom.mp3": [
		1846,
		521
	],
	"./00001/00001-02/00001-02-02/look in the box.mp3": [
		1847,
		522
	],
	"./00001/00001-02/00001-02-02/look in the kitchen.mp3": [
		1848,
		523
	],
	"./00001/00001-02/00001-02-02/look in the living room.mp3": [
		1849,
		524
	],
	"./00001/00001-02/00001-02-02/look in the shower.mp3": [
		1850,
		525
	],
	"./00001/00001-02/00001-02-02/look.mp3": [
		1851,
		526
	],
	"./00001/00001-02/00001-02-02/main idea.mp3": [
		750
	],
	"./00001/00001-02/00001-02-02/where are the puppies.mp3": [
		1852,
		527
	],
	"./00001/00001-02/00001-02-03/farm animals.mp3": [
		1853,
		528
	],
	"./00001/00001-02/00001-02-03/intro.mp3": [
		370
	],
	"./00001/00001-02/00001-02-03/main idea.mp3": [
		751
	],
	"./00001/00001-02/00001-02-03/the bus ride.mp3": [
		1854,
		529
	],
	"./00001/00001-02/00001-02-03/the cats go on the bus.mp3": [
		1855,
		530
	],
	"./00001/00001-02/00001-02-03/the cows go on the bus.mp3": [
		1856,
		531
	],
	"./00001/00001-02/00001-02-03/the dogs go on the bus.mp3": [
		1857,
		532
	],
	"./00001/00001-02/00001-02-03/the ducks go on the bus.mp3": [
		1858,
		533
	],
	"./00001/00001-02/00001-02-03/the horses go on the bus.mp3": [
		1859,
		534
	],
	"./00001/00001-02/00001-02-03/the lions go on the bus.mp3": [
		1860,
		535
	],
	"./00001/00001-02/00001-02-03/the sheep go on the bus.mp3": [
		1861,
		536
	],
	"./00001/00001-02/00001-02-04/dogs.mp3": [
		1862,
		537
	],
	"./00001/00001-02/00001-02-04/intro.mp3": [
		371
	],
	"./00001/00001-02/00001-02-04/main idea.mp3": [
		752
	],
	"./00001/00001-02/00001-02-04/no no puppy.mp3": [
		1863,
		538
	],
	"./00001/00001-02/00001-02-04/you can not play with the hedgehog.mp3": [
		1864,
		539
	],
	"./00001/00001-02/00001-02-04/you can not play with the owl.mp3": [
		1865,
		540
	],
	"./00001/00001-02/00001-02-04/you can not play with the rabbit.mp3": [
		1866,
		541
	],
	"./00001/00001-02/00001-02-04/you can not play with the skunk.mp3": [
		1867,
		542
	],
	"./00001/00001-02/00001-02-04/you can not play with the snake.mp3": [
		1868,
		543
	],
	"./00001/00001-02/00001-02-04/you can not play with the turtle.mp3": [
		1869,
		544
	],
	"./00001/00001-02/00001-02-04/you can play with the kitten.mp3": [
		1870,
		545
	],
	"./00001/00001-02/00001-02-05/animals that are gray.mp3": [
		1871,
		546
	],
	"./00001/00001-02/00001-02-05/i love black and white.mp3": [
		1872,
		547
	],
	"./00001/00001-02/00001-02-05/i love blue.mp3": [
		1873,
		548
	],
	"./00001/00001-02/00001-02-05/i love gray.mp3": [
		1874,
		549
	],
	"./00001/00001-02/00001-02-05/i love green.mp3": [
		1875,
		550
	],
	"./00001/00001-02/00001-02-05/i love orange.mp3": [
		1876,
		551
	],
	"./00001/00001-02/00001-02-05/i love purple.mp3": [
		1877,
		552
	],
	"./00001/00001-02/00001-02-05/i love red.mp3": [
		1878,
		553
	],
	"./00001/00001-02/00001-02-05/i love to paint.mp3": [
		1879,
		554
	],
	"./00001/00001-02/00001-02-05/intro.mp3": [
		372
	],
	"./00001/00001-02/00001-02-05/main idea.mp3": [
		753
	],
	"./00001/00001-02/00001-02-06/food.mp3": [
		1880,
		555
	],
	"./00001/00001-02/00001-02-06/intro.mp3": [
		373
	],
	"./00001/00001-02/00001-02-06/look at the alligator.mp3": [
		1881,
		556
	],
	"./00001/00001-02/00001-02-06/look at the cow.mp3": [
		1882,
		557
	],
	"./00001/00001-02/00001-02-06/look at the dog.mp3": [
		1883,
		558
	],
	"./00001/00001-02/00001-02-06/look at the gingerbread man.mp3": [
		1884,
		559
	],
	"./00001/00001-02/00001-02-06/look at the horse.mp3": [
		1885,
		560
	],
	"./00001/00001-02/00001-02-06/look at the sheep.mp3": [
		1886,
		561
	],
	"./00001/00001-02/00001-02-06/main idea.mp3": [
		754
	],
	"./00001/00001-02/00001-02-06/the gingerbread man.mp3": [
		1887,
		562
	],
	"./00001/00001-02/00001-02-07/0 little frogs sat on a log.mp3": [
		1888,
		563
	],
	"./00001/00001-02/00001-02-07/1 little frog sat on a log.mp3": [
		1889,
		564
	],
	"./00001/00001-02/00001-02-07/2 little frogs sat on a log.mp3": [
		1890,
		565
	],
	"./00001/00001-02/00001-02-07/3 little frogs sat on a log.mp3": [
		1891,
		566
	],
	"./00001/00001-02/00001-02-07/4 little frogs sat on a log.mp3": [
		1892,
		567
	],
	"./00001/00001-02/00001-02-07/5 little frogs sat in the pond.mp3": [
		1893,
		568
	],
	"./00001/00001-02/00001-02-07/5 little frogs sat on a log.mp3": [
		1894,
		569
	],
	"./00001/00001-02/00001-02-07/5 little frogs.mp3": [
		1895,
		570
	],
	"./00001/00001-02/00001-02-07/intro.mp3": [
		374
	],
	"./00001/00001-02/00001-02-07/main idea.mp3": [
		755
	],
	"./00001/00001-02/00001-02-07/water animals.mp3": [
		1896,
		571
	],
	"./00001/00001-02/00001-02-08/can i have a pet.mp3": [
		1897,
		572
	],
	"./00001/00001-02/00001-02-08/intro.mp3": [
		375
	],
	"./00001/00001-02/00001-02-08/main idea.mp3": [
		756
	],
	"./00001/00001-02/00001-02-08/pets.mp3": [
		1898,
		573
	],
	"./00001/00001-02/00001-02-08/you can have a dog.mp3": [
		1899,
		574
	],
	"./00001/00001-02/00001-02-08/you can not have a crocodile.mp3": [
		1900,
		575
	],
	"./00001/00001-02/00001-02-08/you can not have a giraffe.mp3": [
		1901,
		576
	],
	"./00001/00001-02/00001-02-08/you can not have a monkey.mp3": [
		1902,
		577
	],
	"./00001/00001-02/00001-02-08/you can not have a snake.mp3": [
		1903,
		578
	],
	"./00001/00001-02/00001-02-08/you can not have an elephant.mp3": [
		1904,
		579
	],
	"./00001/00001-02/00001-02-08/you can not have an ostrich.mp3": [
		1905,
		580
	],
	"./00001/00001-02/00001-02-09/i like the horse.mp3": [
		1906,
		581
	],
	"./00001/00001-02/00001-02-09/i like the slide.mp3": [
		1907,
		582
	],
	"./00001/00001-02/00001-02-09/i like the swings.mp3": [
		1908,
		583
	],
	"./00001/00001-02/00001-02-09/intro.mp3": [
		376
	],
	"./00001/00001-02/00001-02-09/main idea.mp3": [
		757
	],
	"./00001/00001-02/00001-02-09/the playground.mp3": [
		1909,
		584
	],
	"./00001/00001-02/00001-02-09/toys.mp3": [
		1910,
		585
	],
	"./00001/00001-02/00001-02-09/we like the seesaw.mp3": [
		1911,
		586
	],
	"./00001/00001-02/00001-02-10/farm animals.mp3": [
		1912,
		587
	],
	"./00001/00001-02/00001-02-10/hello cat i like your hat.mp3": [
		1913,
		588
	],
	"./00001/00001-02/00001-02-10/hello chicken i like your hat.mp3": [
		1914,
		589
	],
	"./00001/00001-02/00001-02-10/hello cow i like your hat.mp3": [
		1915,
		590
	],
	"./00001/00001-02/00001-02-10/hello dog i like your hat.mp3": [
		1916,
		591
	],
	"./00001/00001-02/00001-02-10/hello goat i like your hat.mp3": [
		1917,
		592
	],
	"./00001/00001-02/00001-02-10/hello horse i like your hat.mp3": [
		1918,
		593
	],
	"./00001/00001-02/00001-02-10/hello sheep i like your hat.mp3": [
		1919,
		594
	],
	"./00001/00001-02/00001-02-10/intro.mp3": [
		377
	],
	"./00001/00001-02/00001-02-10/main idea.mp3": [
		758
	],
	"./00001/00001-02/00001-02-11/animals.mp3": [
		1920,
		595
	],
	"./00001/00001-02/00001-02-11/intro.mp3": [
		378
	],
	"./00001/00001-02/00001-02-11/main idea.mp3": [
		759
	],
	"./00001/00001-02/00001-02-11/the bat likes ice cream.mp3": [
		1921,
		596
	],
	"./00001/00001-02/00001-02-11/the cat likes ice cream.mp3": [
		1922,
		597
	],
	"./00001/00001-02/00001-02-11/the dog likes ice cream.mp3": [
		1923,
		598
	],
	"./00001/00001-02/00001-02-11/the elephant likes ice cream.mp3": [
		1924,
		599
	],
	"./00001/00001-02/00001-02-11/the lion likes ice cream.mp3": [
		1925,
		600
	],
	"./00001/00001-02/00001-02-11/the octopus loves ice cream.mp3": [
		1926,
		601
	],
	"./00001/00001-02/00001-02-11/the snake likes ice cream.mp3": [
		1927,
		602
	],
	"./00001/00001-02/00001-02-11/we like ice cream.mp3": [
		1928,
		603
	],
	"./00001/00001-02/story park.mp3": [
		1929,
		604
	],
	"./00001/00001-03/00001-03-01/a sea turtle lives in the sea.mp3": [
		1930,
		605
	],
	"./00001/00001-03/00001-03-01/a seahorse lives in the sea.mp3": [
		1931,
		606
	],
	"./00001/00001-03/00001-03-01/a shark lives in the sea.mp3": [
		1932,
		607
	],
	"./00001/00001-03/00001-03-01/a whale lives in the sea.mp3": [
		1933,
		608
	],
	"./00001/00001-03/00001-03-01/intro.mp3": [
		379
	],
	"./00001/00001-03/00001-03-01/main idea.mp3": [
		760
	],
	"./00001/00001-03/00001-03-01/sea animals.mp3": [
		1934,
		609
	],
	"./00001/00001-03/00001-03-01/the crab lives in the sea.mp3": [
		1935,
		610
	],
	"./00001/00001-03/00001-03-01/the dolphin lives in the sea.mp3": [
		1936,
		611
	],
	"./00001/00001-03/00001-03-01/the octopus lives in the sea.mp3": [
		1937,
		612
	],
	"./00001/00001-03/00001-03-02/intro.mp3": [
		380
	],
	"./00001/00001-03/00001-03-02/look at the beaver.mp3": [
		1938,
		613
	],
	"./00001/00001-03/00001-03-02/look at the dragonfly.mp3": [
		1939,
		614
	],
	"./00001/00001-03/00001-03-02/look at the duck.mp3": [
		1940,
		615
	],
	"./00001/00001-03/00001-03-02/look at the frog.mp3": [
		1941,
		616
	],
	"./00001/00001-03/00001-03-02/look at the salamander.mp3": [
		1942,
		617
	],
	"./00001/00001-03/00001-03-02/look at the toad.mp3": [
		1943,
		618
	],
	"./00001/00001-03/00001-03-02/look at the turtle.mp3": [
		1944,
		619
	],
	"./00001/00001-03/00001-03-02/main idea.mp3": [
		761
	],
	"./00001/00001-03/00001-03-02/pond animals.mp3": [
		1945,
		620
	],
	"./00001/00001-03/00001-03-03/i am a giraffe.mp3": [
		1946,
		621
	],
	"./00001/00001-03/00001-03-03/i am a hippo.mp3": [
		1947,
		622
	],
	"./00001/00001-03/00001-03-03/i am a lion.mp3": [
		1948,
		623
	],
	"./00001/00001-03/00001-03-03/i am a rhino.mp3": [
		1949,
		624
	],
	"./00001/00001-03/00001-03-03/i am a tiger.mp3": [
		1950,
		625
	],
	"./00001/00001-03/00001-03-03/i am a zebra.mp3": [
		1951,
		626
	],
	"./00001/00001-03/00001-03-03/intro.mp3": [
		381
	],
	"./00001/00001-03/00001-03-03/main idea.mp3": [
		762
	],
	"./00001/00001-03/00001-03-03/we are kangaroos.mp3": [
		1952,
		627
	],
	"./00001/00001-03/00001-03-03/wild animals.mp3": [
		1953,
		628
	],
	"./00001/00001-03/00001-03-04/i love my cat.mp3": [
		1954,
		629
	],
	"./00001/00001-03/00001-03-04/i love my dinosaur.mp3": [
		1955,
		630
	],
	"./00001/00001-03/00001-03-04/i love my dog.mp3": [
		1956,
		631
	],
	"./00001/00001-03/00001-03-04/i love my fish.mp3": [
		1957,
		632
	],
	"./00001/00001-03/00001-03-04/i love my rabbit.mp3": [
		1958,
		633
	],
	"./00001/00001-03/00001-03-04/i love my snake.mp3": [
		1959,
		634
	],
	"./00001/00001-03/00001-03-04/i love my turtle.mp3": [
		1960,
		635
	],
	"./00001/00001-03/00001-03-04/intro.mp3": [
		382
	],
	"./00001/00001-03/00001-03-04/main idea.mp3": [
		763
	],
	"./00001/00001-03/00001-03-04/pets.mp3": [
		1961,
		636
	],
	"./00001/00001-03/00001-03-05/forest animals.mp3": [
		1962,
		637
	],
	"./00001/00001-03/00001-03-05/i see a bear.mp3": [
		1963,
		638
	],
	"./00001/00001-03/00001-03-05/i see a bird.mp3": [
		1964,
		639
	],
	"./00001/00001-03/00001-03-05/i see a deer.mp3": [
		1965,
		640
	],
	"./00001/00001-03/00001-03-05/i see a fox.mp3": [
		1966,
		641
	],
	"./00001/00001-03/00001-03-05/i see a hedgehog.mp3": [
		1967,
		642
	],
	"./00001/00001-03/00001-03-05/i see a rabbit.mp3": [
		1968,
		643
	],
	"./00001/00001-03/00001-03-05/i see a squirrel.mp3": [
		1969,
		644
	],
	"./00001/00001-03/00001-03-05/intro.mp3": [
		383
	],
	"./00001/00001-03/00001-03-05/main idea.mp3": [
		764
	],
	"./00001/00001-03/00001-03-06/farm animals.mp3": [
		1970,
		645
	],
	"./00001/00001-03/00001-03-06/here is a chicken.mp3": [
		1971,
		646
	],
	"./00001/00001-03/00001-03-06/here is a cow.mp3": [
		1972,
		647
	],
	"./00001/00001-03/00001-03-06/here is a donkey.mp3": [
		1973,
		648
	],
	"./00001/00001-03/00001-03-06/here is a goat.mp3": [
		1974,
		649
	],
	"./00001/00001-03/00001-03-06/here is a horse.mp3": [
		1975,
		650
	],
	"./00001/00001-03/00001-03-06/here is a pig.mp3": [
		1976,
		651
	],
	"./00001/00001-03/00001-03-06/here is a sheep.mp3": [
		1977,
		652
	],
	"./00001/00001-03/00001-03-06/intro.mp3": [
		384
	],
	"./00001/00001-03/00001-03-06/main idea.mp3": [
		765
	],
	"./00001/00001-03/00001-03-07/animals that live in the snow.mp3": [
		1978,
		653
	],
	"./00001/00001-03/00001-03-07/arctic animals.mp3": [
		1979,
		654
	],
	"./00001/00001-03/00001-03-07/intro.mp3": [
		385
	],
	"./00001/00001-03/00001-03-07/main idea.mp3": [
		766
	],
	"./00001/00001-03/00001-03-07/the bird is white.mp3": [
		1980,
		655
	],
	"./00001/00001-03/00001-03-07/the fox is white.mp3": [
		1981,
		656
	],
	"./00001/00001-03/00001-03-07/the owl is white.mp3": [
		1982,
		657
	],
	"./00001/00001-03/00001-03-07/the polar bear is white.mp3": [
		1983,
		658
	],
	"./00001/00001-03/00001-03-07/the rabbit is white.mp3": [
		1984,
		659
	],
	"./00001/00001-03/00001-03-07/the seal is white.mp3": [
		1985,
		660
	],
	"./00001/00001-03/00001-03-07/the wolf is white.mp3": [
		1986,
		661
	],
	"./00001/00001-03/00001-03-08/desert animals.mp3": [
		1987,
		662
	],
	"./00001/00001-03/00001-03-08/i am a bighorn sheep.mp3": [
		1988,
		663
	],
	"./00001/00001-03/00001-03-08/i am a camel.mp3": [
		1989,
		664
	],
	"./00001/00001-03/00001-03-08/i am a fox.mp3": [
		1990,
		665
	],
	"./00001/00001-03/00001-03-08/i am a rabbit.mp3": [
		1991,
		666
	],
	"./00001/00001-03/00001-03-08/i am a snake.mp3": [
		1992,
		667
	],
	"./00001/00001-03/00001-03-08/i am a spider.mp3": [
		1993,
		668
	],
	"./00001/00001-03/00001-03-08/i am an iguana.mp3": [
		1994,
		669
	],
	"./00001/00001-03/00001-03-08/i live in the desert.mp3": [
		1995,
		670
	],
	"./00001/00001-03/00001-03-08/intro.mp3": [
		386
	],
	"./00001/00001-03/00001-03-08/main idea.mp3": [
		767
	],
	"./00001/00001-03/00001-03-09/i am a butterfly.mp3": [
		1996,
		671
	],
	"./00001/00001-03/00001-03-09/i am a frog.mp3": [
		1997,
		672
	],
	"./00001/00001-03/00001-03-09/i am a jaguar.mp3": [
		1998,
		673
	],
	"./00001/00001-03/00001-03-09/i am a monket.mp3": [
		1999,
		674
	],
	"./00001/00001-03/00001-03-09/i am a monkey.mp3": [
		2000,
		675
	],
	"./00001/00001-03/00001-03-09/i am a parrot.mp3": [
		2001,
		676
	],
	"./00001/00001-03/00001-03-09/i am a snake.mp3": [
		2002,
		677
	],
	"./00001/00001-03/00001-03-09/i am a toucan.mp3": [
		2003,
		678
	],
	"./00001/00001-03/00001-03-09/i live in the rainforest.mp3": [
		2004,
		679
	],
	"./00001/00001-03/00001-03-09/intro.mp3": [
		387
	],
	"./00001/00001-03/00001-03-09/main idea.mp3": [
		768
	],
	"./00001/00001-03/00001-03-09/rainforest animals.mp3": [
		2005,
		680
	],
	"./00001/00001-03/00001-03-10/i am a cat.mp3": [
		2006,
		681
	],
	"./00001/00001-03/00001-03-10/i am a dog.mp3": [
		2007,
		682
	],
	"./00001/00001-03/00001-03-10/i am a horse.mp3": [
		2008,
		683
	],
	"./00001/00001-03/00001-03-10/i am a lion.mp3": [
		2009,
		684
	],
	"./00001/00001-03/00001-03-10/i am a parrot.mp3": [
		2010,
		685
	],
	"./00001/00001-03/00001-03-10/i am a zebra.mp3": [
		2011,
		686
	],
	"./00001/00001-03/00001-03-10/i am an owl.mp3": [
		2012,
		687
	],
	"./00001/00001-03/00001-03-10/i am wild.mp3": [
		2013,
		688
	],
	"./00001/00001-03/00001-03-10/intro.mp3": [
		388
	],
	"./00001/00001-03/00001-03-10/main idea.mp3": [
		769
	],
	"./00001/00001-03/00001-03-10/wild animals.mp3": [
		2014,
		689
	],
	"./00001/00001-03/00001-03-10/wild or tame.mp3": [
		2015,
		690
	],
	"./00001/00001-03/animal park.mp3": [
		2016,
		691
	],
	"./00001/00001-03/animals.mp3": [
		2017,
		692
	],
	"./00001/00001-04/00001-04-01/animals.mp3": [
		2018,
		693
	],
	"./00001/00001-04/00001-04-01/i see 1 box.mp3": [
		2019,
		694
	],
	"./00001/00001-04/00001-04-01/i see 1 cat.mp3": [
		2020,
		695
	],
	"./00001/00001-04/00001-04-01/i see 1 fox.mp3": [
		2021,
		696
	],
	"./00001/00001-04/00001-04-01/i see 1 hat.mp3": [
		2022,
		697
	],
	"./00001/00001-04/00001-04-01/i see 1 house.mp3": [
		2023,
		698
	],
	"./00001/00001-04/00001-04-01/i see 1 mouse.mp3": [
		2024,
		699
	],
	"./00001/00001-04/00001-04-01/i see 1 sun.mp3": [
		2025,
		700
	],
	"./00001/00001-04/00001-04-01/intro.mp3": [
		389
	],
	"./00001/00001-04/00001-04-01/main idea.mp3": [
		770
	],
	"./00001/00001-04/00001-04-01/my book of one.mp3": [
		2026,
		701
	],
	"./00001/00001-04/00001-04-02/animals with two legs.mp3": [
		2027,
		702
	],
	"./00001/00001-04/00001-04-02/i have 2 ears.mp3": [
		2028,
		703
	],
	"./00001/00001-04/00001-04-02/i have 2 eyes.mp3": [
		2029,
		704
	],
	"./00001/00001-04/00001-04-02/i have 2 horns.mp3": [
		2030,
		705
	],
	"./00001/00001-04/00001-04-02/i have 2 humps.mp3": [
		2031,
		706
	],
	"./00001/00001-04/00001-04-02/i have 2 legs.mp3": [
		2032,
		707
	],
	"./00001/00001-04/00001-04-02/i have 2 tusks.mp3": [
		2033,
		708
	],
	"./00001/00001-04/00001-04-02/i have 2 wings.mp3": [
		2034,
		709
	],
	"./00001/00001-04/00001-04-02/intro.mp3": [
		390
	],
	"./00001/00001-04/00001-04-02/main idea.mp3": [
		771
	],
	"./00001/00001-04/00001-04-02/my book of two.mp3": [
		2035,
		710
	],
	"./00001/00001-04/00001-04-03/animals with four legs.mp3": [
		2036,
		711
	],
	"./00001/00001-04/00001-04-03/can you see 3 dogs.mp3": [
		2037,
		712
	],
	"./00001/00001-04/00001-04-03/can you see 3 frogs.mp3": [
		2038,
		713
	],
	"./00001/00001-04/00001-04-03/can you see 3 hats.mp3": [
		2039,
		714
	],
	"./00001/00001-04/00001-04-03/can you see 3 kittens.mp3": [
		2040,
		715
	],
	"./00001/00001-04/00001-04-03/can you see 3 mittens.mp3": [
		2041,
		716
	],
	"./00001/00001-04/00001-04-03/can you see 3 rats.mp3": [
		2042,
		717
	],
	"./00001/00001-04/00001-04-03/can you see 3 trees.mp3": [
		2043,
		718
	],
	"./00001/00001-04/00001-04-03/intro.mp3": [
		391
	],
	"./00001/00001-04/00001-04-03/main idea.mp3": [
		772
	],
	"./00001/00001-04/00001-04-03/my book of three.mp3": [
		2044,
		719
	],
	"./00001/00001-04/00001-04-04/here come 4 boats.mp3": [
		2045,
		720
	],
	"./00001/00001-04/00001-04-04/here come 4 cars.mp3": [
		2046,
		721
	],
	"./00001/00001-04/00001-04-04/here come 4 fire trucks.mp3": [
		2047,
		722
	],
	"./00001/00001-04/00001-04-04/here come 4 helicopters.mp3": [
		2048,
		723
	],
	"./00001/00001-04/00001-04-04/here come 4 planes.mp3": [
		2049,
		724
	],
	"./00001/00001-04/00001-04-04/here come 4 rockets.mp3": [
		2050,
		725
	],
	"./00001/00001-04/00001-04-04/here come 4 trucks.mp3": [
		2051,
		726
	],
	"./00001/00001-04/00001-04-04/intro.mp3": [
		392
	],
	"./00001/00001-04/00001-04-04/main idea.mp3": [
		773
	],
	"./00001/00001-04/00001-04-04/my book of four.mp3": [
		2052,
		727
	],
	"./00001/00001-04/00001-04-04/vehicles.mp3": [
		2053,
		728
	],
	"./00001/00001-04/00001-04-05/farm animals.mp3": [
		2054,
		729
	],
	"./00001/00001-04/00001-04-05/i can see 5 animals on the farm.mp3": [
		2055,
		730
	],
	"./00001/00001-04/00001-04-05/i can see 5 animals.mp3": [
		2056,
		731
	],
	"./00001/00001-04/00001-04-05/i can see 5 chickens.mp3": [
		2057,
		732
	],
	"./00001/00001-04/00001-04-05/i can see 5 cows.mp3": [
		2058,
		733
	],
	"./00001/00001-04/00001-04-05/i can see 5 goats.mp3": [
		2059,
		734
	],
	"./00001/00001-04/00001-04-05/i can see 5 horses.mp3": [
		2060,
		735
	],
	"./00001/00001-04/00001-04-05/i can see 5 rabbits.mp3": [
		2061,
		736
	],
	"./00001/00001-04/00001-04-05/i can see 5 sheep.mp3": [
		2062,
		737
	],
	"./00001/00001-04/00001-04-05/intro.mp3": [
		393
	],
	"./00001/00001-04/00001-04-05/main idea.mp3": [
		774
	],
	"./00001/00001-04/00001-04-05/my book of five.mp3": [
		2063,
		738
	],
	"./00001/00001-04/00001-04-06/can you see 6 birds.mp3": [
		2064,
		739
	],
	"./00001/00001-04/00001-04-06/can you see 6 cats.mp3": [
		2065,
		740
	],
	"./00001/00001-04/00001-04-06/can you see 6 dogs.mp3": [
		2066,
		741
	],
	"./00001/00001-04/00001-04-06/can you see 6 fish.mp3": [
		2067,
		742
	],
	"./00001/00001-04/00001-04-06/can you see 6 pets.mp3": [
		2068,
		743
	],
	"./00001/00001-04/00001-04-06/can you see 6 snakes.mp3": [
		2069,
		744
	],
	"./00001/00001-04/00001-04-06/can you see 6 turtles.mp3": [
		2070,
		745
	],
	"./00001/00001-04/00001-04-06/intro.mp3": [
		394
	],
	"./00001/00001-04/00001-04-06/main idea.mp3": [
		775
	],
	"./00001/00001-04/00001-04-06/my book of six.mp3": [
		2071,
		746
	],
	"./00001/00001-04/00001-04-06/pet animals.mp3": [
		2072,
		747
	],
	"./00001/00001-04/00001-04-07/intro.mp3": [
		395
	],
	"./00001/00001-04/00001-04-07/main idea.mp3": [
		776
	],
	"./00001/00001-04/00001-04-07/my book of seven.mp3": [
		2073,
		748
	],
	"./00001/00001-04/00001-04-07/sea animals.mp3": [
		2074,
		749
	],
	"./00001/00001-04/00001-04-07/you can count 7 animals in the sea.mp3": [
		2075,
		750
	],
	"./00001/00001-04/00001-04-07/you can count 7 penguins.mp3": [
		2076,
		751
	],
	"./00001/00001-04/00001-04-07/you can count 7 sea turtles.mp3": [
		2077,
		752
	],
	"./00001/00001-04/00001-04-07/you can count 7 seahorses.mp3": [
		2078,
		753
	],
	"./00001/00001-04/00001-04-07/you can count 7 sharks.mp3": [
		2079,
		754
	],
	"./00001/00001-04/00001-04-07/you can count 7 swordfish.mp3": [
		2080,
		755
	],
	"./00001/00001-04/00001-04-07/you can count 7 whales.mp3": [
		2081,
		756
	],
	"./00001/00001-04/00001-04-07/you can count to 7.mp3": [
		2082,
		757
	],
	"./00001/00001-04/00001-04-08/can you count 8 astronauts.mp3": [
		2083,
		758
	],
	"./00001/00001-04/00001-04-08/can you count 8 planets.mp3": [
		2084,
		759
	],
	"./00001/00001-04/00001-04-08/can you count 8 rockets.mp3": [
		2085,
		760
	],
	"./00001/00001-04/00001-04-08/can you count 8 satellites.mp3": [
		2086,
		761
	],
	"./00001/00001-04/00001-04-08/can you count 8 spaceships.mp3": [
		2087,
		762
	],
	"./00001/00001-04/00001-04-08/can you count 8 stars.mp3": [
		2088,
		763
	],
	"./00001/00001-04/00001-04-08/can you count 8 things up in space.mp3": [
		2089,
		764
	],
	"./00001/00001-04/00001-04-08/can you count to 8.mp3": [
		2090,
		765
	],
	"./00001/00001-04/00001-04-08/intro.mp3": [
		396
	],
	"./00001/00001-04/00001-04-08/main idea.mp3": [
		777
	],
	"./00001/00001-04/00001-04-08/my book of eight.mp3": [
		2091,
		766
	],
	"./00001/00001-04/00001-04-08/things in space.mp3": [
		2092,
		767
	],
	"./00001/00001-04/00001-04-09/i see 9 baby alligators.mp3": [
		2093,
		768
	],
	"./00001/00001-04/00001-04-09/i see 9 baby animals.mp3": [
		2094,
		769
	],
	"./00001/00001-04/00001-04-09/i see 9 baby elephants.mp3": [
		2095,
		770
	],
	"./00001/00001-04/00001-04-09/i see 9 baby lions.mp3": [
		2096,
		771
	],
	"./00001/00001-04/00001-04-09/i see 9 baby rhinos.mp3": [
		2097,
		772
	],
	"./00001/00001-04/00001-04-09/i see 9 baby tigers.mp3": [
		2098,
		773
	],
	"./00001/00001-04/00001-04-09/i see 9 baby zebras.mp3": [
		2099,
		774
	],
	"./00001/00001-04/00001-04-09/intro.mp3": [
		397
	],
	"./00001/00001-04/00001-04-09/main idea.mp3": [
		778
	],
	"./00001/00001-04/00001-04-09/my book of 9.mp3": [
		2100,
		775
	],
	"./00001/00001-04/00001-04-09/my book of nine.mp3": [
		2101,
		776
	],
	"./00001/00001-04/00001-04-09/wild animals.mp3": [
		2102,
		777
	],
	"./00001/00001-04/00001-04-10/brown animals.mp3": [
		2103,
		778
	],
	"./00001/00001-04/00001-04-10/intro.mp3": [
		398
	],
	"./00001/00001-04/00001-04-10/main idea.mp3": [
		779
	],
	"./00001/00001-04/00001-04-10/my book of ten.mp3": [
		2104,
		779
	],
	"./00001/00001-04/00001-04-10/you can see 10 blue elephants.mp3": [
		2105,
		780
	],
	"./00001/00001-04/00001-04-10/you can see 10 brown monkeys.mp3": [
		2106,
		781
	],
	"./00001/00001-04/00001-04-10/you can see 10 gray hippos.mp3": [
		2107,
		782
	],
	"./00001/00001-04/00001-04-10/you can see 10 green dragons.mp3": [
		2108,
		783
	],
	"./00001/00001-04/00001-04-10/you can see 10 pink dinosaurs.mp3": [
		2109,
		784
	],
	"./00001/00001-04/00001-04-10/you can see 10 white unicorns.mp3": [
		2110,
		785
	],
	"./00001/00001-04/00001-04-10/you can see 10 yellow giraffes.mp3": [
		2111,
		786
	],
	"./00001/00001-04/number park.mp3": [
		2112,
		787
	],
	"./00001/00001-04/numbers.mp3": [
		2113,
		788
	],
	"./00001/00001-05/00001-05-01/all circles are round.mp3": [
		2114,
		789
	],
	"./00001/00001-05/00001-05-01/circles are round.mp3": [
		2115,
		790
	],
	"./00001/00001-05/00001-05-01/i can see big circles.mp3": [
		2116,
		791
	],
	"./00001/00001-05/00001-05-01/i can see little circles.mp3": [
		2117,
		792
	],
	"./00001/00001-05/00001-05-01/intro.mp3": [
		399
	],
	"./00001/00001-05/00001-05-01/main idea.mp3": [
		780
	],
	"./00001/00001-05/00001-05-01/some circles are black.mp3": [
		2118,
		793
	],
	"./00001/00001-05/00001-05-01/some circles are blue.mp3": [
		2119,
		794
	],
	"./00001/00001-05/00001-05-01/some circles are green.mp3": [
		2120,
		795
	],
	"./00001/00001-05/00001-05-01/some circles are orange.mp3": [
		2121,
		796
	],
	"./00001/00001-05/00001-05-01/some circles are purple.mp3": [
		2122,
		797
	],
	"./00001/00001-05/00001-05-01/some circles are red.mp3": [
		2123,
		798
	],
	"./00001/00001-05/00001-05-01/some circles are white.mp3": [
		2124,
		799
	],
	"./00001/00001-05/00001-05-01/some circles are yellow.mp3": [
		2125,
		800
	],
	"./00001/00001-05/00001-05-01/things that are round.mp3": [
		2126,
		801
	],
	"./00001/00001-05/00001-05-02/intro.mp3": [
		400
	],
	"./00001/00001-05/00001-05-02/main idea.mp3": [
		781
	],
	"./00001/00001-05/00001-05-02/my square is black.mp3": [
		2127,
		802
	],
	"./00001/00001-05/00001-05-02/my square is blue.mp3": [
		2128,
		803
	],
	"./00001/00001-05/00001-05-02/my square is orange.mp3": [
		2129,
		804
	],
	"./00001/00001-05/00001-05-02/my square is red.mp3": [
		2130,
		805
	],
	"./00001/00001-05/00001-05-02/my square is yellow.mp3": [
		2131,
		806
	],
	"./00001/00001-05/00001-05-02/my squares are green.mp3": [
		2132,
		807
	],
	"./00001/00001-05/00001-05-02/my squares are pink.mp3": [
		2133,
		808
	],
	"./00001/00001-05/00001-05-02/shapes.mp3": [
		2134,
		809
	],
	"./00001/00001-05/00001-05-02/squares have four corners.mp3": [
		2135,
		810
	],
	"./00001/00001-05/00001-05-02/squares have four sides.mp3": [
		2136,
		811
	],
	"./00001/00001-05/00001-05-03/elephant likes the gray triangle.mp3": [
		2137,
		812
	],
	"./00001/00001-05/00001-05-03/goat likes the orange triangle.mp3": [
		2138,
		813
	],
	"./00001/00001-05/00001-05-03/intro.mp3": [
		401
	],
	"./00001/00001-05/00001-05-03/main idea.mp3": [
		782
	],
	"./00001/00001-05/00001-05-03/monkey likes the triangle.mp3": [
		2139,
		814
	],
	"./00001/00001-05/00001-05-03/mouse likes the blue triangle.mp3": [
		2140,
		815
	],
	"./00001/00001-05/00001-05-03/musical instruments.mp3": [
		2141,
		816
	],
	"./00001/00001-05/00001-05-03/rabbit likes the red triangle.mp3": [
		2142,
		817
	],
	"./00001/00001-05/00001-05-03/the boy likes the purple triangle.mp3": [
		2143,
		818
	],
	"./00001/00001-05/00001-05-03/the girl likes the green triangle.mp3": [
		2144,
		819
	],
	"./00001/00001-05/00001-05-03/this triangle is big.mp3": [
		2145,
		820
	],
	"./00001/00001-05/00001-05-03/this triangle is little.mp3": [
		2146,
		821
	],
	"./00001/00001-05/00001-05-03/triangles have three corners.mp3": [
		2147,
		822
	],
	"./00001/00001-05/00001-05-03/triangles have three sides.mp3": [
		2148,
		823
	],
	"./00001/00001-05/00001-05-04/animals with four legs.mp3": [
		2149,
		824
	],
	"./00001/00001-05/00001-05-04/crocodile can see a long rectangle.mp3": [
		2150,
		825
	],
	"./00001/00001-05/00001-05-04/giraffe can see a long rectangle.mp3": [
		2151,
		826
	],
	"./00001/00001-05/00001-05-04/hedgehog can see a short rectangle.mp3": [
		2152,
		827
	],
	"./00001/00001-05/00001-05-04/intro.mp3": [
		402
	],
	"./00001/00001-05/00001-05-04/main idea.mp3": [
		783
	],
	"./00001/00001-05/00001-05-04/pig can see a fat rectangle.mp3": [
		2153,
		828
	],
	"./00001/00001-05/00001-05-04/rectangles have four sides.mp3": [
		2154,
		829
	],
	"./00001/00001-05/00001-05-04/sheep can see a fat rectangle.mp3": [
		2155,
		830
	],
	"./00001/00001-05/00001-05-04/snake can see a thin rectangle.mp3": [
		2156,
		831
	],
	"./00001/00001-05/00001-05-04/turtle can see a short rectangle.mp3": [
		2157,
		832
	],
	"./00001/00001-05/00001-05-05/i can see a pentagon.mp3": [
		2158,
		833
	],
	"./00001/00001-05/00001-05-05/i can see a rectangle.mp3": [
		2159,
		834
	],
	"./00001/00001-05/00001-05-05/i can see a square.mp3": [
		2160,
		835
	],
	"./00001/00001-05/00001-05-05/i can see a triangle.mp3": [
		2161,
		836
	],
	"./00001/00001-05/00001-05-05/i can see an octagon.mp3": [
		2162,
		837
	],
	"./00001/00001-05/00001-05-05/i can see circles.mp3": [
		2163,
		838
	],
	"./00001/00001-05/00001-05-05/i can see hexagons.mp3": [
		2164,
		839
	],
	"./00001/00001-05/00001-05-05/intro.mp3": [
		403
	],
	"./00001/00001-05/00001-05-05/lets go look for shapes.mp3": [
		2165,
		840
	],
	"./00001/00001-05/00001-05-05/main idea.mp3": [
		784
	],
	"./00001/00001-05/00001-05-05/shapes.mp3": [
		2166,
		841
	],
	"./00001/00001-05/00001-05-06/balls are solid.mp3": [
		2167,
		842
	],
	"./00001/00001-05/00001-05-06/boxes are solid.mp3": [
		2168,
		843
	],
	"./00001/00001-05/00001-05-06/cones are solid.mp3": [
		2169,
		844
	],
	"./00001/00001-05/00001-05-06/cubes are solid.mp3": [
		2170,
		845
	],
	"./00001/00001-05/00001-05-06/cylinders are solid.mp3": [
		2171,
		846
	],
	"./00001/00001-05/00001-05-06/intro.mp3": [
		404
	],
	"./00001/00001-05/00001-05-06/main idea.mp3": [
		785
	],
	"./00001/00001-05/00001-05-06/pyramids are solid.mp3": [
		2172,
		847
	],
	"./00001/00001-05/00001-05-06/solid shapes.mp3": [
		2173,
		848
	],
	"./00001/00001-05/00001-05-06/spheres are solid.mp3": [
		2174,
		849
	],
	"./00001/00001-05/00001-05-07/cubes have six faces.mp3": [
		2175,
		850
	],
	"./00001/00001-05/00001-05-07/forest animals.mp3": [
		2176,
		851
	],
	"./00001/00001-05/00001-05-07/intro.mp3": [
		405
	],
	"./00001/00001-05/00001-05-07/look at the bear face.mp3": [
		2177,
		852
	],
	"./00001/00001-05/00001-05-07/look at the deer face.mp3": [
		2178,
		853
	],
	"./00001/00001-05/00001-05-07/look at the elephant face.mp3": [
		2179,
		854
	],
	"./00001/00001-05/00001-05-07/look at the faces.mp3": [
		2180,
		855
	],
	"./00001/00001-05/00001-05-07/look at the fox face.mp3": [
		2181,
		856
	],
	"./00001/00001-05/00001-05-07/look at the panda face.mp3": [
		2182,
		857
	],
	"./00001/00001-05/00001-05-07/look at the rabbit face.mp3": [
		2183,
		858
	],
	"./00001/00001-05/00001-05-07/main idea.mp3": [
		786
	],
	"./00001/00001-05/00001-05-08/intro.mp3": [
		406
	],
	"./00001/00001-05/00001-05-08/look at the circles.mp3": [
		2184,
		859
	],
	"./00001/00001-05/00001-05-08/look at the hexagons.mp3": [
		2185,
		860
	],
	"./00001/00001-05/00001-05-08/look at the octagons.mp3": [
		2186,
		861
	],
	"./00001/00001-05/00001-05-08/look at the pentagons.mp3": [
		2187,
		862
	],
	"./00001/00001-05/00001-05-08/look at the rectangles.mp3": [
		2188,
		863
	],
	"./00001/00001-05/00001-05-08/look at the squares.mp3": [
		2189,
		864
	],
	"./00001/00001-05/00001-05-08/look at the triangles.mp3": [
		2190,
		865
	],
	"./00001/00001-05/00001-05-08/main idea.mp3": [
		787
	],
	"./00001/00001-05/00001-05-08/non living things.mp3": [
		2191,
		866
	],
	"./00001/00001-05/00001-05-08/there are shapes on the quilt.mp3": [
		2192,
		867
	],
	"./00001/00001-05/00001-05-09/i can make a circle.mp3": [
		2193,
		868
	],
	"./00001/00001-05/00001-05-09/i can make a fox.mp3": [
		2194,
		869
	],
	"./00001/00001-05/00001-05-09/i can make a hexagon.mp3": [
		2195,
		870
	],
	"./00001/00001-05/00001-05-09/i can make a new shape.mp3": [
		2196,
		871
	],
	"./00001/00001-05/00001-05-09/i can make a pentagon.mp3": [
		2197,
		872
	],
	"./00001/00001-05/00001-05-09/i can make a rectangle.mp3": [
		2198,
		873
	],
	"./00001/00001-05/00001-05-09/i can make a square.mp3": [
		2199,
		874
	],
	"./00001/00001-05/00001-05-09/i can make an octagon.mp3": [
		2200,
		875
	],
	"./00001/00001-05/00001-05-09/intro.mp3": [
		407
	],
	"./00001/00001-05/00001-05-09/main idea.mp3": [
		788
	],
	"./00001/00001-05/00001-05-09/shapes.mp3": [
		2201,
		876
	],
	"./00001/00001-05/00001-05-10/intro.mp3": [
		408
	],
	"./00001/00001-05/00001-05-10/main idea.mp3": [
		789
	],
	"./00001/00001-05/00001-05-10/places.mp3": [
		2202,
		877
	],
	"./00001/00001-05/00001-05-10/shapes are all around us.mp3": [
		2203,
		878
	],
	"./00001/00001-05/00001-05-10/we can see circles.mp3": [
		2204,
		879
	],
	"./00001/00001-05/00001-05-10/we can see cones.mp3": [
		2205,
		880
	],
	"./00001/00001-05/00001-05-10/we can see cubes.mp3": [
		2206,
		881
	],
	"./00001/00001-05/00001-05-10/we can see cylinders.mp3": [
		2207,
		882
	],
	"./00001/00001-05/00001-05-10/we can see rectangles.mp3": [
		2208,
		883
	],
	"./00001/00001-05/00001-05-10/we can see squares.mp3": [
		2209,
		884
	],
	"./00001/00001-05/00001-05-10/we can see triangles.mp3": [
		2210,
		885
	],
	"./00001/00001-05/shapes park.mp3": [
		2211,
		886
	],
	"./00001/00001-05/shapes.mp3": [
		2212,
		887
	],
	"./00001/00001-06/00001-06-01/i do not need air said the octopus.mp3": [
		2213,
		888
	],
	"./00001/00001-06/00001-06-01/i need air said the astronaut.mp3": [
		2214,
		889
	],
	"./00001/00001-06/00001-06-01/i need air said the bee.mp3": [
		2215,
		890
	],
	"./00001/00001-06/00001-06-01/i need air said the cat.mp3": [
		2216,
		891
	],
	"./00001/00001-06/00001-06-01/i need air said the dolphin.mp3": [
		2217,
		892
	],
	"./00001/00001-06/00001-06-01/i need air said the scuba diver.mp3": [
		2218,
		893
	],
	"./00001/00001-06/00001-06-01/i need air said the seal.mp3": [
		2219,
		894
	],
	"./00001/00001-06/00001-06-01/intro.mp3": [
		409
	],
	"./00001/00001-06/00001-06-01/main idea.mp3": [
		790
	],
	"./00001/00001-06/00001-06-01/water animals.mp3": [
		2220,
		895
	],
	"./00001/00001-06/00001-06-01/we need air.mp3": [
		2221,
		896
	],
	"./00001/00001-06/00001-06-02/farm animals.mp3": [
		2222,
		897
	],
	"./00001/00001-06/00001-06-02/intro.mp3": [
		410
	],
	"./00001/00001-06/00001-06-02/main idea.mp3": [
		791
	],
	"./00001/00001-06/00001-06-02/the cow lives on the farm.mp3": [
		2223,
		898
	],
	"./00001/00001-06/00001-06-02/the duck lives at the pond too.mp3": [
		2224,
		899
	],
	"./00001/00001-06/00001-06-02/the frog lives at the pond.mp3": [
		2225,
		900
	],
	"./00001/00001-06/00001-06-02/the monkey lives in a tree.mp3": [
		2226,
		901
	],
	"./00001/00001-06/00001-06-02/the shark lives in the sea too.mp3": [
		2227,
		902
	],
	"./00001/00001-06/00001-06-02/the sheep lives on the farm too.mp3": [
		2228,
		903
	],
	"./00001/00001-06/00001-06-02/the whale lives in the sea.mp3": [
		2229,
		904
	],
	"./00001/00001-06/00001-06-02/we need homes.mp3": [
		2230,
		905
	],
	"./00001/00001-06/00001-06-03/animals that eat plants.mp3": [
		2231,
		906
	],
	"./00001/00001-06/00001-06-03/intro.mp3": [
		411
	],
	"./00001/00001-06/00001-06-03/main idea.mp3": [
		792
	],
	"./00001/00001-06/00001-06-03/the bat likes insects.mp3": [
		2232,
		907
	],
	"./00001/00001-06/00001-06-03/the dinosaur likes leaves too.mp3": [
		2233,
		908
	],
	"./00001/00001-06/00001-06-03/the giraffe likes leaves.mp3": [
		2234,
		909
	],
	"./00001/00001-06/00001-06-03/the monkey likes bananas.mp3": [
		2235,
		910
	],
	"./00001/00001-06/00001-06-03/the shark likes fish.mp3": [
		2236,
		911
	],
	"./00001/00001-06/00001-06-03/the squirrel likes nuts.mp3": [
		2237,
		912
	],
	"./00001/00001-06/00001-06-03/the zebra likes grass.mp3": [
		2238,
		913
	],
	"./00001/00001-06/00001-06-03/we need to eat.mp3": [
		2239,
		914
	],
	"./00001/00001-06/00001-06-04/animals that live in the snow.mp3": [
		2240,
		915
	],
	"./00001/00001-06/00001-06-04/he is out in the snow.mp3": [
		2241,
		916
	],
	"./00001/00001-06/00001-06-04/i am out in the snow too.mp3": [
		2242,
		917
	],
	"./00001/00001-06/00001-06-04/i am out in the snow.mp3": [
		2243,
		918
	],
	"./00001/00001-06/00001-06-04/intro.mp3": [
		412
	],
	"./00001/00001-06/00001-06-04/it is snowing.mp3": [
		2244,
		919
	],
	"./00001/00001-06/00001-06-04/it is winter.mp3": [
		2245,
		920
	],
	"./00001/00001-06/00001-06-04/look at me.mp3": [
		2246,
		921
	],
	"./00001/00001-06/00001-06-04/look at the deer.mp3": [
		2247,
		922
	],
	"./00001/00001-06/00001-06-04/look at the dog.mp3": [
		2248,
		923
	],
	"./00001/00001-06/00001-06-04/look at the fox.mp3": [
		2249,
		924
	],
	"./00001/00001-06/00001-06-04/look at the owl.mp3": [
		2250,
		925
	],
	"./00001/00001-06/00001-06-04/look at the rabbit.mp3": [
		2251,
		926
	],
	"./00001/00001-06/00001-06-04/look at the squirrel.mp3": [
		2252,
		927
	],
	"./00001/00001-06/00001-06-04/main idea.mp3": [
		793
	],
	"./00001/00001-06/00001-06-04/out in the snow.mp3": [
		2253,
		928
	],
	"./00001/00001-06/00001-06-04/she is out in the snow.mp3": [
		2254,
		929
	],
	"./00001/00001-06/00001-06-05/are they alive.mp3": [
		2255,
		930
	],
	"./00001/00001-06/00001-06-05/intro.mp3": [
		413
	],
	"./00001/00001-06/00001-06-05/living things.mp3": [
		2256,
		931
	],
	"./00001/00001-06/00001-06-05/main idea.mp3": [
		794
	],
	"./00001/00001-06/00001-06-05/the cat is alive.mp3": [
		2257,
		932
	],
	"./00001/00001-06/00001-06-05/the duck is alive.mp3": [
		2258,
		933
	],
	"./00001/00001-06/00001-06-05/the fox is alive.mp3": [
		2259,
		934
	],
	"./00001/00001-06/00001-06-05/the frog is alive.mp3": [
		2260,
		935
	],
	"./00001/00001-06/00001-06-05/the mouse is alive.mp3": [
		2261,
		936
	],
	"./00001/00001-06/00001-06-05/the seal is alive.mp3": [
		2262,
		937
	],
	"./00001/00001-06/00001-06-05/the sheep is alive.mp3": [
		2263,
		938
	],
	"./00001/00001-06/00001-06-05/which one is alive.mp3": [
		2264,
		939
	],
	"./00001/00001-06/00001-06-06/baby animals.mp3": [
		2265,
		940
	],
	"./00001/00001-06/00001-06-06/here is my mother.mp3": [
		2266,
		941
	],
	"./00001/00001-06/00001-06-06/i love my mother.mp3": [
		2267,
		942
	],
	"./00001/00001-06/00001-06-06/intro.mp3": [
		414
	],
	"./00001/00001-06/00001-06-06/main idea.mp3": [
		795
	],
	"./00001/00001-06/00001-06-06/mammals.mp3": [
		2268,
		943
	],
	"./00001/00001-06/00001-06-06/mother.mp3": [
		2269,
		944
	],
	"./00001/00001-06/00001-06-06/my mother is a bear.mp3": [
		2270,
		945
	],
	"./00001/00001-06/00001-06-06/my mother is a cow.mp3": [
		2271,
		946
	],
	"./00001/00001-06/00001-06-06/my mother is a dolphin.mp3": [
		2272,
		947
	],
	"./00001/00001-06/00001-06-06/my mother is a duck.mp3": [
		2273,
		948
	],
	"./00001/00001-06/00001-06-06/my mother is a kangaroo.mp3": [
		2274,
		949
	],
	"./00001/00001-06/00001-06-06/my mother is a rabbit.mp3": [
		2275,
		950
	],
	"./00001/00001-06/00001-06-06/my mother is a sheep.mp3": [
		2276,
		951
	],
	"./00001/00001-06/00001-06-07/birds need water.mp3": [
		2277,
		952
	],
	"./00001/00001-06/00001-06-07/deer need water.mp3": [
		2278,
		953
	],
	"./00001/00001-06/00001-06-07/dogs need water too.mp3": [
		2279,
		954
	],
	"./00001/00001-06/00001-06-07/dolphins need water.mp3": [
		2280,
		955
	],
	"./00001/00001-06/00001-06-07/ducks need water.mp3": [
		2281,
		956
	],
	"./00001/00001-06/00001-06-07/everyone needs water.mp3": [
		2282,
		957
	],
	"./00001/00001-06/00001-06-07/flowers need water.mp3": [
		2283,
		958
	],
	"./00001/00001-06/00001-06-07/frogs need water.mp3": [
		2284,
		959
	],
	"./00001/00001-06/00001-06-07/intro.mp3": [
		415
	],
	"./00001/00001-06/00001-06-07/main idea.mp3": [
		796
	],
	"./00001/00001-06/00001-06-07/water.mp3": [
		2285,
		960
	],
	"./00001/00001-06/00001-06-08/grow seeds grow.mp3": [
		2286,
		961
	],
	"./00001/00001-06/00001-06-08/intro.mp3": [
		416
	],
	"./00001/00001-06/00001-06-08/look at the apples.mp3": [
		2287,
		962
	],
	"./00001/00001-06/00001-06-08/look at the branch.mp3": [
		2288,
		963
	],
	"./00001/00001-06/00001-06-08/look at the flowers.mp3": [
		2289,
		964
	],
	"./00001/00001-06/00001-06-08/look at the leaves.mp3": [
		2290,
		965
	],
	"./00001/00001-06/00001-06-08/look at the roots.mp3": [
		2291,
		966
	],
	"./00001/00001-06/00001-06-08/look at the seeds.mp3": [
		2292,
		967
	],
	"./00001/00001-06/00001-06-08/look at the stem.mp3": [
		2293,
		968
	],
	"./00001/00001-06/00001-06-08/main idea.mp3": [
		797
	],
	"./00001/00001-06/00001-06-08/things that grow on trees.mp3": [
		2294,
		969
	],
	"./00001/00001-06/00001-06-09/baby animals.mp3": [
		2295,
		970
	],
	"./00001/00001-06/00001-06-09/i love my dad.mp3": [
		2296,
		971
	],
	"./00001/00001-06/00001-06-09/intro.mp3": [
		417
	],
	"./00001/00001-06/00001-06-09/main idea.mp3": [
		798
	],
	"./00001/00001-06/00001-06-09/my dad is a deer.mp3": [
		2297,
		972
	],
	"./00001/00001-06/00001-06-09/my dad is a dinosaur.mp3": [
		2298,
		973
	],
	"./00001/00001-06/00001-06-09/my dad is a dog.mp3": [
		2299,
		974
	],
	"./00001/00001-06/00001-06-09/my dad is a pig.mp3": [
		2300,
		975
	],
	"./00001/00001-06/00001-06-09/my dad is a rooster.mp3": [
		2301,
		976
	],
	"./00001/00001-06/00001-06-09/my dad is a seahorse.mp3": [
		2302,
		977
	],
	"./00001/00001-06/00001-06-09/my dad is an elephant.mp3": [
		2303,
		978
	],
	"./00001/00001-06/00001-06-10/do they grow.mp3": [
		2304,
		979
	],
	"./00001/00001-06/00001-06-10/intro.mp3": [
		418
	],
	"./00001/00001-06/00001-06-10/living things.mp3": [
		2305,
		980
	],
	"./00001/00001-06/00001-06-10/main idea.mp3": [
		799
	],
	"./00001/00001-06/00001-06-10/non living things.mp3": [
		2306,
		981
	],
	"./00001/00001-06/00001-06-10/the foxes grow.mp3": [
		2307,
		982
	],
	"./00001/00001-06/00001-06-10/the frogs grow.mp3": [
		2308,
		983
	],
	"./00001/00001-06/00001-06-10/the goats grow.mp3": [
		2309,
		984
	],
	"./00001/00001-06/00001-06-10/the kittens grow.mp3": [
		2310,
		985
	],
	"./00001/00001-06/00001-06-10/the rats grow.mp3": [
		2311,
		986
	],
	"./00001/00001-06/00001-06-10/the snails grow.mp3": [
		2312,
		987
	],
	"./00001/00001-06/00001-06-10/the snakes grow.mp3": [
		2313,
		988
	],
	"./00001/00001-06/life science.mp3": [
		2314,
		989
	],
	"./00001/00001-07/00001-07-01/intro.mp3": [
		419
	],
	"./00001/00001-07/00001-07-01/little things.mp3": [
		2315,
		990
	],
	"./00001/00001-07/00001-07-01/main idea.mp3": [
		800
	],
	"./00001/00001-07/00001-07-01/my bus is little.mp3": [
		2316,
		991
	],
	"./00001/00001-07/00001-07-01/my car is little.mp3": [
		2317,
		992
	],
	"./00001/00001-07/00001-07-01/my dump truck is little.mp3": [
		2318,
		993
	],
	"./00001/00001-07/00001-07-01/my fire truck is little.mp3": [
		2319,
		994
	],
	"./00001/00001-07/00001-07-01/my helicopter is little.mp3": [
		2320,
		995
	],
	"./00001/00001-07/00001-07-01/my monster is little.mp3": [
		2321,
		996
	],
	"./00001/00001-07/00001-07-01/my plane is little.mp3": [
		2322,
		997
	],
	"./00001/00001-07/00001-07-01/vehicles.mp3": [
		2323,
		998
	],
	"./00001/00001-07/00001-07-02/intro.mp3": [
		420
	],
	"./00001/00001-07/00001-07-02/loud and soft.mp3": [
		2324,
		999
	],
	"./00001/00001-07/00001-07-02/main idea.mp3": [
		801
	],
	"./00001/00001-07/00001-07-02/musical instruments.mp3": [
		2325,
		1000
	],
	"./00001/00001-07/00001-07-02/the banjo is loud.mp3": [
		2326,
		1001
	],
	"./00001/00001-07/00001-07-02/the drum is loud.mp3": [
		2327,
		1002
	],
	"./00001/00001-07/00001-07-02/the piano is loud.mp3": [
		2328,
		1003
	],
	"./00001/00001-07/00001-07-02/the tambourine is soft.mp3": [
		2329,
		1004
	],
	"./00001/00001-07/00001-07-02/the triangle is soft.mp3": [
		2330,
		1005
	],
	"./00001/00001-07/00001-07-02/the violin is loud.mp3": [
		2331,
		1006
	],
	"./00001/00001-07/00001-07-02/the xylophone is soft.mp3": [
		2332,
		1007
	],
	"./00001/00001-07/00001-07-03/electricity.mp3": [
		2333,
		1008
	],
	"./00001/00001-07/00001-07-03/intro.mp3": [
		421
	],
	"./00001/00001-07/00001-07-03/main idea.mp3": [
		802
	],
	"./00001/00001-07/00001-07-03/the computer uses electricity.mp3": [
		2334,
		1009
	],
	"./00001/00001-07/00001-07-03/the fan uses electricity.mp3": [
		2335,
		1010
	],
	"./00001/00001-07/00001-07-03/the fridge uses electricity.mp3": [
		2336,
		1011
	],
	"./00001/00001-07/00001-07-03/the guitar uses electricity.mp3": [
		2337,
		1012
	],
	"./00001/00001-07/00001-07-03/the light uses electricity.mp3": [
		2338,
		1013
	],
	"./00001/00001-07/00001-07-03/the stove uses electricity.mp3": [
		2339,
		1014
	],
	"./00001/00001-07/00001-07-03/the television uses electricity.mp3": [
		2340,
		1015
	],
	"./00001/00001-07/00001-07-03/things that use electricity.mp3": [
		2341,
		1016
	],
	"./00001/00001-07/00001-07-04/deer goes up in the pulley.mp3": [
		2342,
		1017
	],
	"./00001/00001-07/00001-07-04/elephant goes down in the pulley.mp3": [
		2343,
		1018
	],
	"./00001/00001-07/00001-07-04/elephant goes up in the pulley.mp3": [
		2344,
		1019
	],
	"./00001/00001-07/00001-07-04/intro.mp3": [
		422
	],
	"./00001/00001-07/00001-07-04/lion goes up in the pulley.mp3": [
		2345,
		1020
	],
	"./00001/00001-07/00001-07-04/main idea.mp3": [
		803
	],
	"./00001/00001-07/00001-07-04/panda goes up in the pulley.mp3": [
		2346,
		1021
	],
	"./00001/00001-07/00001-07-04/skunk goes up in the pulley.mp3": [
		2347,
		1022
	],
	"./00001/00001-07/00001-07-04/tiger goes up in the pulley.mp3": [
		2348,
		1023
	],
	"./00001/00001-07/00001-07-04/up in the pulley.mp3": [
		2349,
		1024
	],
	"./00001/00001-07/00001-07-04/wild animals.mp3": [
		2350,
		1025
	],
	"./00001/00001-07/00001-07-05/intro.mp3": [
		423
	],
	"./00001/00001-07/00001-07-05/main idea.mp3": [
		804
	],
	"./00001/00001-07/00001-07-05/the ball will move.mp3": [
		2351,
		1026
	],
	"./00001/00001-07/00001-07-05/the car will move.mp3": [
		2352,
		1027
	],
	"./00001/00001-07/00001-07-05/the swing will move.mp3": [
		2353,
		1028
	],
	"./00001/00001-07/00001-07-05/the swing will not move.mp3": [
		2354,
		1029
	],
	"./00001/00001-07/00001-07-05/the truck will move.mp3": [
		2355,
		1030
	],
	"./00001/00001-07/00001-07-05/the truck will not move.mp3": [
		2356,
		1031
	],
	"./00001/00001-07/00001-07-05/toys.mp3": [
		2357,
		1032
	],
	"./00001/00001-07/00001-07-05/will it move.mp3": [
		2358,
		1033
	],
	"./00001/00001-07/00001-07-06/intro.mp3": [
		424
	],
	"./00001/00001-07/00001-07-06/main idea.mp3": [
		805
	],
	"./00001/00001-07/00001-07-06/the apple floats.mp3": [
		2359,
		1034
	],
	"./00001/00001-07/00001-07-06/the ball floats.mp3": [
		2360,
		1035
	],
	"./00001/00001-07/00001-07-06/the boat floats.mp3": [
		2361,
		1036
	],
	"./00001/00001-07/00001-07-06/the cube floats.mp3": [
		2362,
		1037
	],
	"./00001/00001-07/00001-07-06/the duck floats too.mp3": [
		2363,
		1038
	],
	"./00001/00001-07/00001-07-06/the key sinks.mp3": [
		2364,
		1039
	],
	"./00001/00001-07/00001-07-06/the nail sinks.mp3": [
		2365,
		1040
	],
	"./00001/00001-07/00001-07-06/things that float.mp3": [
		2366,
		1041
	],
	"./00001/00001-07/00001-07-06/will it float.mp3": [
		2367,
		1042
	],
	"./00001/00001-07/00001-07-06/will it sink.mp3": [
		2368,
		1043
	],
	"./00001/00001-07/00001-07-07/fishing with a magnet.mp3": [
		2369,
		1044
	],
	"./00001/00001-07/00001-07-07/intro.mp3": [
		425
	],
	"./00001/00001-07/00001-07-07/made.mp3": [
		2370,
		1045
	],
	"./00001/00001-07/00001-07-07/magnet.mp3": [
		2371,
		1046
	],
	"./00001/00001-07/00001-07-07/magnets.mp3": [
		2372,
		1047
	],
	"./00001/00001-07/00001-07-07/main idea.mp3": [
		806
	],
	"./00001/00001-07/00001-07-07/metal.mp3": [
		2373,
		1048
	],
	"./00001/00001-07/00001-07-07/the chipmunk got a nail.mp3": [
		2374,
		1049
	],
	"./00001/00001-07/00001-07-07/the deer got a helicopter.mp3": [
		2375,
		1050
	],
	"./00001/00001-07/00001-07-07/the fox got a magnet.mp3": [
		2376,
		1051
	],
	"./00001/00001-07/00001-07-07/the lion got a rocket.mp3": [
		2377,
		1052
	],
	"./00001/00001-07/00001-07-07/the sheep got an anchor.mp3": [
		2378,
		1053
	],
	"./00001/00001-07/00001-07-07/the squirrel got a ball.mp3": [
		2379,
		1054
	],
	"./00001/00001-07/00001-07-07/the tiger got a car.mp3": [
		2380,
		1055
	],
	"./00001/00001-07/00001-07-07/things made of metal.mp3": [
		2381,
		1056
	],
	"./00001/00001-07/00001-07-08/intro.mp3": [
		426
	],
	"./00001/00001-07/00001-07-08/main idea.mp3": [
		807
	],
	"./00001/00001-07/00001-07-08/the bus has 6 wheels.mp3": [
		2382,
		1057
	],
	"./00001/00001-07/00001-07-08/the car has 4 wheels.mp3": [
		2383,
		1058
	],
	"./00001/00001-07/00001-07-08/the car truck has 4 wheels.mp3": [
		2384,
		1059
	],
	"./00001/00001-07/00001-07-08/the dump truck has 4 wheels.mp3": [
		2385,
		1060
	],
	"./00001/00001-07/00001-07-08/the motorcycle has 2 wheels.mp3": [
		2386,
		1061
	],
	"./00001/00001-07/00001-07-08/the plane has 3 wheels.mp3": [
		2387,
		1062
	],
	"./00001/00001-07/00001-07-08/the train has 8 wheels.mp3": [
		2388,
		1063
	],
	"./00001/00001-07/00001-07-08/the unicycle has 1 wheel.mp3": [
		2389,
		1064
	],
	"./00001/00001-07/00001-07-08/vehicles.mp3": [
		2390,
		1065
	],
	"./00001/00001-07/00001-07-08/wheels make things go.mp3": [
		2391,
		1066
	],
	"./00001/00001-07/00001-07-08/wheels.mp3": [
		2392,
		1067
	],
	"./00001/00001-07/00001-07-09/intro.mp3": [
		427
	],
	"./00001/00001-07/00001-07-09/is it cold.mp3": [
		2393,
		1068
	],
	"./00001/00001-07/00001-07-09/is it hot is it cold.mp3": [
		2394,
		1069
	],
	"./00001/00001-07/00001-07-09/is it hot.mp3": [
		2395,
		1070
	],
	"./00001/00001-07/00001-07-09/main idea.mp3": [
		808
	],
	"./00001/00001-07/00001-07-09/non living things.mp3": [
		2396,
		1071
	],
	"./00001/00001-07/00001-07-09/saturn is cold.mp3": [
		2397,
		1072
	],
	"./00001/00001-07/00001-07-09/the fire is hot.mp3": [
		2398,
		1073
	],
	"./00001/00001-07/00001-07-09/the fridge is cold.mp3": [
		2399,
		1074
	],
	"./00001/00001-07/00001-07-09/the iceberg is cold.mp3": [
		2400,
		1075
	],
	"./00001/00001-07/00001-07-09/the stove is hot.mp3": [
		2401,
		1076
	],
	"./00001/00001-07/00001-07-09/the sun is hot.mp3": [
		2402,
		1077
	],
	"./00001/00001-07/00001-07-09/the volcano is hot.mp3": [
		2403,
		1078
	],
	"./00001/00001-07/00001-07-10/big things.mp3": [
		2404,
		1079
	],
	"./00001/00001-07/00001-07-10/intro.mp3": [
		428
	],
	"./00001/00001-07/00001-07-10/main idea.mp3": [
		809
	],
	"./00001/00001-07/00001-07-10/this bus is big.mp3": [
		2405,
		1080
	],
	"./00001/00001-07/00001-07-10/this car is big.mp3": [
		2406,
		1081
	],
	"./00001/00001-07/00001-07-10/this dump truck is big.mp3": [
		2407,
		1082
	],
	"./00001/00001-07/00001-07-10/this fire truck is big.mp3": [
		2408,
		1083
	],
	"./00001/00001-07/00001-07-10/this helicopter is big.mp3": [
		2409,
		1084
	],
	"./00001/00001-07/00001-07-10/this monster is big.mp3": [
		2410,
		1085
	],
	"./00001/00001-07/00001-07-10/this plane is big.mp3": [
		2411,
		1086
	],
	"./00001/00001-07/00001-07-10/vehicles.mp3": [
		2412,
		1087
	],
	"./00001/00001-07/physical science.mp3": [
		2413,
		1088
	],
	"./00001/00001-08/00001-08-01/intro.mp3": [
		429
	],
	"./00001/00001-08/00001-08-01/main idea.mp3": [
		810
	],
	"./00001/00001-08/00001-08-01/things on the earth.mp3": [
		2414,
		1089
	],
	"./00001/00001-08/00001-08-01/we love the animals.mp3": [
		2415,
		1090
	],
	"./00001/00001-08/00001-08-01/we love the earth.mp3": [
		2416,
		1091
	],
	"./00001/00001-08/00001-08-01/we love the forests.mp3": [
		2417,
		1092
	],
	"./00001/00001-08/00001-08-01/we love the lakes.mp3": [
		2418,
		1093
	],
	"./00001/00001-08/00001-08-01/we love the mountains.mp3": [
		2419,
		1094
	],
	"./00001/00001-08/00001-08-01/we love the rivers.mp3": [
		2420,
		1095
	],
	"./00001/00001-08/00001-08-01/we love the sea.mp3": [
		2421,
		1096
	],
	"./00001/00001-08/00001-08-02/earth is the 3rd planet.mp3": [
		2422,
		1097
	],
	"./00001/00001-08/00001-08-02/intro.mp3": [
		430
	],
	"./00001/00001-08/00001-08-02/jupiter is the 5th planet.mp3": [
		2423,
		1098
	],
	"./00001/00001-08/00001-08-02/main idea.mp3": [
		811
	],
	"./00001/00001-08/00001-08-02/mars is the 4th planet.mp3": [
		2424,
		1099
	],
	"./00001/00001-08/00001-08-02/mercury is the 1st planet.mp3": [
		2425,
		1100
	],
	"./00001/00001-08/00001-08-02/neptune is the 8th planet.mp3": [
		2426,
		1101
	],
	"./00001/00001-08/00001-08-02/saturn is the 6th planet.mp3": [
		2427,
		1102
	],
	"./00001/00001-08/00001-08-02/the planets.mp3": [
		2428,
		1103
	],
	"./00001/00001-08/00001-08-02/things in space.mp3": [
		2429,
		1104
	],
	"./00001/00001-08/00001-08-02/uranus is the 7th planet.mp3": [
		2430,
		1105
	],
	"./00001/00001-08/00001-08-02/venus is the 2nd planet.mp3": [
		2431,
		1106
	],
	"./00001/00001-08/00001-08-03/animals that live in the snow.mp3": [
		2432,
		1107
	],
	"./00001/00001-08/00001-08-03/in the winter.mp3": [
		2433,
		1108
	],
	"./00001/00001-08/00001-08-03/intro.mp3": [
		431
	],
	"./00001/00001-08/00001-08-03/look at the bear.mp3": [
		2434,
		1109
	],
	"./00001/00001-08/00001-08-03/look at the frost.mp3": [
		2435,
		1110
	],
	"./00001/00001-08/00001-08-03/look at the ice.mp3": [
		2436,
		1111
	],
	"./00001/00001-08/00001-08-03/look at the mountains.mp3": [
		2437,
		1112
	],
	"./00001/00001-08/00001-08-03/look at the pond.mp3": [
		2438,
		1113
	],
	"./00001/00001-08/00001-08-03/look at the river.mp3": [
		2439,
		1114
	],
	"./00001/00001-08/00001-08-03/look at the trees.mp3": [
		2440,
		1115
	],
	"./00001/00001-08/00001-08-03/main idea.mp3": [
		812
	],
	"./00001/00001-08/00001-08-04/i can see 2 lambs.mp3": [
		2441,
		1116
	],
	"./00001/00001-08/00001-08-04/i can see 3 frogs.mp3": [
		2442,
		1117
	],
	"./00001/00001-08/00001-08-04/i can see 4 chicks.mp3": [
		2443,
		1118
	],
	"./00001/00001-08/00001-08-04/i can see 5 ducklings.mp3": [
		2444,
		1119
	],
	"./00001/00001-08/00001-08-04/i can see 6 butterflies.mp3": [
		2445,
		1120
	],
	"./00001/00001-08/00001-08-04/i can see 7 flowers.mp3": [
		2446,
		1121
	],
	"./00001/00001-08/00001-08-04/i can see the 4 chicks.mp3": [
		2447,
		1122
	],
	"./00001/00001-08/00001-08-04/i can see the 5 ducklings.mp3": [
		2448,
		1123
	],
	"./00001/00001-08/00001-08-04/i can see the rain.mp3": [
		2449,
		1124
	],
	"./00001/00001-08/00001-08-04/intro.mp3": [
		432
	],
	"./00001/00001-08/00001-08-04/main idea.mp3": [
		813
	],
	"./00001/00001-08/00001-08-04/signs of spring.mp3": [
		2450,
		1125
	],
	"./00001/00001-08/00001-08-04/spring is here.mp3": [
		2451,
		1126
	],
	"./00001/00001-08/00001-08-04/spring is on the way.mp3": [
		2452,
		1127
	],
	"./00001/00001-08/00001-08-04/what can i see.mp3": [
		2453,
		1128
	],
	"./00001/00001-08/00001-08-05/i like summer.mp3": [
		2454,
		1129
	],
	"./00001/00001-08/00001-08-05/i like the hermit crab.mp3": [
		2455,
		1130
	],
	"./00001/00001-08/00001-08-05/i like the sandcastle.mp3": [
		2456,
		1131
	],
	"./00001/00001-08/00001-08-05/i like the sea.mp3": [
		2457,
		1132
	],
	"./00001/00001-08/00001-08-05/i like the seagull.mp3": [
		2458,
		1133
	],
	"./00001/00001-08/00001-08-05/i like the shell.mp3": [
		2459,
		1134
	],
	"./00001/00001-08/00001-08-05/i like the starfish.mp3": [
		2460,
		1135
	],
	"./00001/00001-08/00001-08-05/i like the sun.mp3": [
		2461,
		1136
	],
	"./00001/00001-08/00001-08-05/intro.mp3": [
		433
	],
	"./00001/00001-08/00001-08-05/main idea.mp3": [
		814
	],
	"./00001/00001-08/00001-08-05/sea animals.mp3": [
		2462,
		1137
	],
	"./00001/00001-08/00001-08-06/colors in the fall.mp3": [
		2463,
		1138
	],
	"./00001/00001-08/00001-08-06/intro.mp3": [
		434
	],
	"./00001/00001-08/00001-08-06/look at the brown nuts.mp3": [
		2464,
		1139
	],
	"./00001/00001-08/00001-08-06/look at the gray geese.mp3": [
		2465,
		1140
	],
	"./00001/00001-08/00001-08-06/look at the green apples.mp3": [
		2466,
		1141
	],
	"./00001/00001-08/00001-08-06/look at the orange pumpkin.mp3": [
		2467,
		1142
	],
	"./00001/00001-08/00001-08-06/look at the purple grapes.mp3": [
		2468,
		1143
	],
	"./00001/00001-08/00001-08-06/look at the red leaves.mp3": [
		2469,
		1144
	],
	"./00001/00001-08/00001-08-06/look at the yellow hay.mp3": [
		2470,
		1145
	],
	"./00001/00001-08/00001-08-06/main idea.mp3": [
		815
	],
	"./00001/00001-08/00001-08-06/things we see in the fall.mp3": [
		2471,
		1146
	],
	"./00001/00001-08/00001-08-07/intro.mp3": [
		435
	],
	"./00001/00001-08/00001-08-07/main idea.mp3": [
		816
	],
	"./00001/00001-08/00001-08-07/things we see in the soil.mp3": [
		2472,
		1147
	],
	"./00001/00001-08/00001-08-07/we can see ants.mp3": [
		2473,
		1148
	],
	"./00001/00001-08/00001-08-07/we can see bones.mp3": [
		2474,
		1149
	],
	"./00001/00001-08/00001-08-07/we can see leaves.mp3": [
		2475,
		1150
	],
	"./00001/00001-08/00001-08-07/we can see rocks.mp3": [
		2476,
		1151
	],
	"./00001/00001-08/00001-08-07/we can see roots.mp3": [
		2477,
		1152
	],
	"./00001/00001-08/00001-08-07/we can see shells.mp3": [
		2478,
		1153
	],
	"./00001/00001-08/00001-08-07/we can see worms.mp3": [
		2479,
		1154
	],
	"./00001/00001-08/00001-08-07/what is in the soil.mp3": [
		2480,
		1155
	],
	"./00001/00001-08/00001-08-08/alligator likes the green rock.mp3": [
		2481,
		1156
	],
	"./00001/00001-08/00001-08-08/cheetah likes the yellow rock.mp3": [
		2482,
		1157
	],
	"./00001/00001-08/00001-08-08/chipmunk likes the brown rock.mp3": [
		2483,
		1158
	],
	"./00001/00001-08/00001-08-08/elephant likes the gray rock.mp3": [
		2484,
		1159
	],
	"./00001/00001-08/00001-08-08/fox likes the red rock.mp3": [
		2485,
		1160
	],
	"./00001/00001-08/00001-08-08/intro.mp3": [
		436
	],
	"./00001/00001-08/00001-08-08/main idea.mp3": [
		817
	],
	"./00001/00001-08/00001-08-08/non living things.mp3": [
		2486,
		1161
	],
	"./00001/00001-08/00001-08-08/rocks.mp3": [
		2487,
		1162
	],
	"./00001/00001-08/00001-08-08/skunk likes the black rock.mp3": [
		2488,
		1163
	],
	"./00001/00001-08/00001-08-08/tiger likes the orange rock.mp3": [
		2489,
		1164
	],
	"./00001/00001-08/00001-08-09/intro.mp3": [
		437
	],
	"./00001/00001-08/00001-08-09/main idea.mp3": [
		818
	],
	"./00001/00001-08/00001-08-09/things in the sky.mp3": [
		2490,
		1165
	],
	"./00001/00001-08/00001-08-09/what can you see in the sky.mp3": [
		2491,
		1166
	],
	"./00001/00001-08/00001-08-09/you can see a dragon.mp3": [
		2492,
		1167
	],
	"./00001/00001-08/00001-08-09/you can see the clouds.mp3": [
		2493,
		1168
	],
	"./00001/00001-08/00001-08-09/you can see the moon.mp3": [
		2494,
		1169
	],
	"./00001/00001-08/00001-08-09/you can see the rain.mp3": [
		2495,
		1170
	],
	"./00001/00001-08/00001-08-09/you can see the rainbow.mp3": [
		2496,
		1171
	],
	"./00001/00001-08/00001-08-09/you can see the stars.mp3": [
		2497,
		1172
	],
	"./00001/00001-08/00001-08-09/you can see the sun.mp3": [
		2498,
		1173
	],
	"./00001/00001-08/00001-08-10/intro.mp3": [
		438
	],
	"./00001/00001-08/00001-08-10/it is a cloudy day.mp3": [
		2499,
		1174
	],
	"./00001/00001-08/00001-08-10/it is a rainy day.mp3": [
		2500,
		1175
	],
	"./00001/00001-08/00001-08-10/it is a rainy night.mp3": [
		2501,
		1176
	],
	"./00001/00001-08/00001-08-10/it is a snowy day.mp3": [
		2502,
		1177
	],
	"./00001/00001-08/00001-08-10/it is a snowy night.mp3": [
		2503,
		1178
	],
	"./00001/00001-08/00001-08-10/it is a sunny day.mp3": [
		2504,
		1179
	],
	"./00001/00001-08/00001-08-10/it is a windy day.mp3": [
		2505,
		1180
	],
	"./00001/00001-08/00001-08-10/main idea.mp3": [
		819
	],
	"./00001/00001-08/00001-08-10/weather.mp3": [
		2506,
		1181
	],
	"./00001/00001-08/earth and space.mp3": [
		2507,
		1182
	],
	"./00001/00001-09/00001-09-01/fish.mp3": [
		2508,
		1183
	],
	"./00001/00001-09/00001-09-01/i see the clown fish.mp3": [
		2509,
		1184
	],
	"./00001/00001-09/00001-09-01/i see the eel.mp3": [
		2510,
		1185
	],
	"./00001/00001-09/00001-09-01/i see the flying fish.mp3": [
		2511,
		1186
	],
	"./00001/00001-09/00001-09-01/i see the hammerhead shark.mp3": [
		2512,
		1187
	],
	"./00001/00001-09/00001-09-01/i see the seahorse.mp3": [
		2513,
		1188
	],
	"./00001/00001-09/00001-09-01/i see the shark.mp3": [
		2514,
		1189
	],
	"./00001/00001-09/00001-09-01/i see the swordfish.mp3": [
		2515,
		1190
	],
	"./00001/00001-09/00001-09-01/intro.mp3": [
		439
	],
	"./00001/00001-09/00001-09-01/main idea.mp3": [
		820
	],
	"./00001/00001-09/00001-09-02/i like the bat.mp3": [
		2516,
		1191
	],
	"./00001/00001-09/00001-09-02/i like the fox.mp3": [
		2517,
		1192
	],
	"./00001/00001-09/00001-09-02/i like the panda.mp3": [
		2518,
		1193
	],
	"./00001/00001-09/00001-09-02/i like the skunk.mp3": [
		2519,
		1194
	],
	"./00001/00001-09/00001-09-02/i like the tiger.mp3": [
		2520,
		1195
	],
	"./00001/00001-09/00001-09-02/i like the whale.mp3": [
		2521,
		1196
	],
	"./00001/00001-09/00001-09-02/i like the zebra.mp3": [
		2522,
		1197
	],
	"./00001/00001-09/00001-09-02/intro.mp3": [
		440
	],
	"./00001/00001-09/00001-09-02/main idea.mp3": [
		821
	],
	"./00001/00001-09/00001-09-02/mammals.mp3": [
		2523,
		1198
	],
	"./00001/00001-09/00001-09-03/intro.mp3": [
		441
	],
	"./00001/00001-09/00001-09-03/look at the alligator.mp3": [
		2524,
		1199
	],
	"./00001/00001-09/00001-09-03/look at the crocodile.mp3": [
		2525,
		1200
	],
	"./00001/00001-09/00001-09-03/look at the iguana.mp3": [
		2526,
		1201
	],
	"./00001/00001-09/00001-09-03/look at the lizard.mp3": [
		2527,
		1202
	],
	"./00001/00001-09/00001-09-03/look at the sea turtle.mp3": [
		2528,
		1203
	],
	"./00001/00001-09/00001-09-03/look at the snake.mp3": [
		2529,
		1204
	],
	"./00001/00001-09/00001-09-03/look at the turtle.mp3": [
		2530,
		1205
	],
	"./00001/00001-09/00001-09-03/main idea.mp3": [
		822
	],
	"./00001/00001-09/00001-09-03/reptiles.mp3": [
		2531,
		1206
	],
	"./00001/00001-09/00001-09-04/amphibians.mp3": [
		2532,
		1207
	],
	"./00001/00001-09/00001-09-04/i can see 1 frog.mp3": [
		2533,
		1208
	],
	"./00001/00001-09/00001-09-04/i can see 1 salamander.mp3": [
		2534,
		1209
	],
	"./00001/00001-09/00001-09-04/i can see 1 toad.mp3": [
		2535,
		1210
	],
	"./00001/00001-09/00001-09-04/i can see 2 frogs.mp3": [
		2536,
		1211
	],
	"./00001/00001-09/00001-09-04/i can see 2 salamanders.mp3": [
		2537,
		1212
	],
	"./00001/00001-09/00001-09-04/i can see 2 toads.mp3": [
		2538,
		1213
	],
	"./00001/00001-09/00001-09-04/i can see 6 amphibians.mp3": [
		2539,
		1214
	],
	"./00001/00001-09/00001-09-04/intro.mp3": [
		442
	],
	"./00001/00001-09/00001-09-04/main idea.mp3": [
		823
	],
	"./00001/00001-09/00001-09-05/birds.mp3": [
		2540,
		1215
	],
	"./00001/00001-09/00001-09-05/intro.mp3": [
		443
	],
	"./00001/00001-09/00001-09-05/main idea.mp3": [
		824
	],
	"./00001/00001-09/00001-09-05/the bat is not a bird.mp3": [
		2541,
		1216
	],
	"./00001/00001-09/00001-09-05/the duck is a bird.mp3": [
		2542,
		1217
	],
	"./00001/00001-09/00001-09-05/the eagle is a bird.mp3": [
		2543,
		1218
	],
	"./00001/00001-09/00001-09-05/the flamingo is a bird.mp3": [
		2544,
		1219
	],
	"./00001/00001-09/00001-09-05/the ostrich is a bird.mp3": [
		2545,
		1220
	],
	"./00001/00001-09/00001-09-05/the penguin is a bird.mp3": [
		2546,
		1221
	],
	"./00001/00001-09/00001-09-05/the rooster is a bird.mp3": [
		2547,
		1222
	],
	"./00001/00001-09/00001-09-06/animals without backbones.mp3": [
		2548,
		1223
	],
	"./00001/00001-09/00001-09-06/here is a butterfly.mp3": [
		2549,
		1224
	],
	"./00001/00001-09/00001-09-06/here is a jellyfish.mp3": [
		2550,
		1225
	],
	"./00001/00001-09/00001-09-06/here is a ladybug.mp3": [
		2551,
		1226
	],
	"./00001/00001-09/00001-09-06/here is a lobster.mp3": [
		2552,
		1227
	],
	"./00001/00001-09/00001-09-06/here is a slug.mp3": [
		2553,
		1228
	],
	"./00001/00001-09/00001-09-06/here is a squid.mp3": [
		2554,
		1229
	],
	"./00001/00001-09/00001-09-06/here is a starfish.mp3": [
		2555,
		1230
	],
	"./00001/00001-09/00001-09-06/intro.mp3": [
		444
	],
	"./00001/00001-09/00001-09-06/main idea.mp3": [
		825
	],
	"./00001/00001-09/00001-09-07/ants are insects.mp3": [
		2556,
		1231
	],
	"./00001/00001-09/00001-09-07/bees are insects.mp3": [
		2557,
		1232
	],
	"./00001/00001-09/00001-09-07/butterflies are insects.mp3": [
		2558,
		1233
	],
	"./00001/00001-09/00001-09-07/grasshoppers are insects.mp3": [
		2559,
		1234
	],
	"./00001/00001-09/00001-09-07/insects.mp3": [
		2560,
		1235
	],
	"./00001/00001-09/00001-09-07/intro.mp3": [
		445
	],
	"./00001/00001-09/00001-09-07/ladybugs are insects.mp3": [
		2561,
		1236
	],
	"./00001/00001-09/00001-09-07/main idea.mp3": [
		826
	],
	"./00001/00001-09/00001-09-07/praying mantises are insects.mp3": [
		2562,
		1237
	],
	"./00001/00001-09/00001-09-07/spiders are not insects.mp3": [
		2563,
		1238
	],
	"./00001/00001-09/00001-09-08/big animals.mp3": [
		2564,
		1239
	],
	"./00001/00001-09/00001-09-08/intro.mp3": [
		446
	],
	"./00001/00001-09/00001-09-08/main idea.mp3": [
		827
	],
	"./00001/00001-09/00001-09-08/this dinosaur is huge.mp3": [
		2565,
		1240
	],
	"./00001/00001-09/00001-09-08/this elephant is big.mp3": [
		2566,
		1241
	],
	"./00001/00001-09/00001-09-08/this giraffe is big.mp3": [
		2567,
		1242
	],
	"./00001/00001-09/00001-09-08/this ostrich is big.mp3": [
		2568,
		1243
	],
	"./00001/00001-09/00001-09-08/this squid is big.mp3": [
		2569,
		1244
	],
	"./00001/00001-09/00001-09-08/this whale is big.mp3": [
		2570,
		1245
	],
	"./00001/00001-09/00001-09-08/this whale shark is big.mp3": [
		2571,
		1246
	],
	"./00001/00001-09/00001-09-09/animals.mp3": [
		2572,
		1247
	],
	"./00001/00001-09/00001-09-09/intro.mp3": [
		447
	],
	"./00001/00001-09/00001-09-09/main idea.mp3": [
		828
	],
	"./00001/00001-09/00001-09-09/the alligator is a reptile.mp3": [
		2573,
		1248
	],
	"./00001/00001-09/00001-09-09/the animal book.mp3": [
		2574,
		1249
	],
	"./00001/00001-09/00001-09-09/the cat is a mammal.mp3": [
		2575,
		1250
	],
	"./00001/00001-09/00001-09-09/the eagle is a bird.mp3": [
		2576,
		1251
	],
	"./00001/00001-09/00001-09-09/the frog is an amphibian.mp3": [
		2577,
		1252
	],
	"./00001/00001-09/00001-09-09/the ladybug is an insect.mp3": [
		2578,
		1253
	],
	"./00001/00001-09/00001-09-09/the shark is a fish.mp3": [
		2579,
		1254
	],
	"./00001/00001-09/00001-09-09/the skunk is a mammal.mp3": [
		2580,
		1255
	],
	"./00001/00001-09/00001-09-10/dinosaurs.mp3": [
		2581,
		1256
	],
	"./00001/00001-09/00001-09-10/i am a long neck dinosaur.mp3": [
		2582,
		1257
	],
	"./00001/00001-09/00001-09-10/i am a pterosaur.mp3": [
		2583,
		1258
	],
	"./00001/00001-09/00001-09-10/i am a raptor.mp3": [
		2584,
		1259
	],
	"./00001/00001-09/00001-09-10/i am a stegosaurus.mp3": [
		2585,
		1260
	],
	"./00001/00001-09/00001-09-10/i am a swimming dinosaur.mp3": [
		2586,
		1261
	],
	"./00001/00001-09/00001-09-10/i am a t rex.mp3": [
		2587,
		1262
	],
	"./00001/00001-09/00001-09-10/i am a triceratops.mp3": [
		2588,
		1263
	],
	"./00001/00001-09/00001-09-10/intro.mp3": [
		448
	],
	"./00001/00001-09/00001-09-10/main idea.mp3": [
		829
	],
	"./00001/00001-09/animal groups.mp3": [
		2589,
		1264
	],
	"./00001/00001-10/00001-10-01/animals with 4 legs.mp3": [
		2590,
		1265
	],
	"./00001/00001-10/00001-10-01/i have 10 legs.mp3": [
		2591,
		1266
	],
	"./00001/00001-10/00001-10-01/i have 12 legs.mp3": [
		2592,
		1267
	],
	"./00001/00001-10/00001-10-01/i have 2 legs.mp3": [
		2593,
		1268
	],
	"./00001/00001-10/00001-10-01/i have 3 legs.mp3": [
		2594,
		1269
	],
	"./00001/00001-10/00001-10-01/i have 4 legs.mp3": [
		2595,
		1270
	],
	"./00001/00001-10/00001-10-01/i have 6 legs.mp3": [
		2596,
		1271
	],
	"./00001/00001-10/00001-10-01/i have 8 legs.mp3": [
		2597,
		1272
	],
	"./00001/00001-10/00001-10-01/intro.mp3": [
		449
	],
	"./00001/00001-10/00001-10-01/legs.mp3": [
		2598,
		1273
	],
	"./00001/00001-10/00001-10-01/main idea.mp3": [
		830
	],
	"./00001/00001-10/00001-10-02/animals with spots.mp3": [
		2599,
		1274
	],
	"./00001/00001-10/00001-10-02/intro.mp3": [
		450
	],
	"./00001/00001-10/00001-10-02/main idea.mp3": [
		831
	],
	"./00001/00001-10/00001-10-02/stripes and spots.mp3": [
		2600,
		1275
	],
	"./00001/00001-10/00001-10-02/the deer has spots.mp3": [
		2601,
		1276
	],
	"./00001/00001-10/00001-10-02/the dinosaur has spots too.mp3": [
		2602,
		1277
	],
	"./00001/00001-10/00001-10-02/the giraffe has spots.mp3": [
		2603,
		1278
	],
	"./00001/00001-10/00001-10-02/the ladybug has spots.mp3": [
		2604,
		1279
	],
	"./00001/00001-10/00001-10-02/the raccoon has stripes.mp3": [
		2605,
		1280
	],
	"./00001/00001-10/00001-10-02/the tiger has stripes.mp3": [
		2606,
		1281
	],
	"./00001/00001-10/00001-10-02/the zebra has stripes.mp3": [
		2607,
		1282
	],
	"./00001/00001-10/00001-10-03/animals with 2 eyes.mp3": [
		2608,
		1283
	],
	"./00001/00001-10/00001-10-03/eyes.mp3": [
		2609,
		1284
	],
	"./00001/00001-10/00001-10-03/i have 10 eyes.mp3": [
		2610,
		1285
	],
	"./00001/00001-10/00001-10-03/i have 2 eyes.mp3": [
		2611,
		1286
	],
	"./00001/00001-10/00001-10-03/i have 5 eyes.mp3": [
		2612,
		1287
	],
	"./00001/00001-10/00001-10-03/i have 8 eyes.mp3": [
		2613,
		1288
	],
	"./00001/00001-10/00001-10-03/intro.mp3": [
		451
	],
	"./00001/00001-10/00001-10-03/main idea.mp3": [
		832
	],
	"./00001/00001-10/00001-10-04/animals with 2 horns.mp3": [
		2614,
		1289
	],
	"./00001/00001-10/00001-10-04/here is a cow.mp3": [
		2615,
		1290
	],
	"./00001/00001-10/00001-10-04/here is a dinosaur.mp3": [
		2616,
		1291
	],
	"./00001/00001-10/00001-10-04/here is a giraffe.mp3": [
		2617,
		1292
	],
	"./00001/00001-10/00001-10-04/here is a goat.mp3": [
		2618,
		1293
	],
	"./00001/00001-10/00001-10-04/here is a monster.mp3": [
		2619,
		1294
	],
	"./00001/00001-10/00001-10-04/here is a rhino.mp3": [
		2620,
		1295
	],
	"./00001/00001-10/00001-10-04/here is a unicorn.mp3": [
		2621,
		1296
	],
	"./00001/00001-10/00001-10-04/horns.mp3": [
		2622,
		1297
	],
	"./00001/00001-10/00001-10-04/intro.mp3": [
		452
	],
	"./00001/00001-10/00001-10-04/main idea.mp3": [
		833
	],
	"./00001/00001-10/00001-10-05/animals with long necks.mp3": [
		2623,
		1298
	],
	"./00001/00001-10/00001-10-05/i can see a camel.mp3": [
		2624,
		1299
	],
	"./00001/00001-10/00001-10-05/i can see a dinosaur.mp3": [
		2625,
		1300
	],
	"./00001/00001-10/00001-10-05/i can see a flamingo.mp3": [
		2626,
		1301
	],
	"./00001/00001-10/00001-10-05/i can see a giraffe.mp3": [
		2627,
		1302
	],
	"./00001/00001-10/00001-10-05/i can see a goose.mp3": [
		2628,
		1303
	],
	"./00001/00001-10/00001-10-05/i can see a snake.mp3": [
		2629,
		1304
	],
	"./00001/00001-10/00001-10-05/i can see an ostrich.mp3": [
		2630,
		1305
	],
	"./00001/00001-10/00001-10-05/intro.mp3": [
		453
	],
	"./00001/00001-10/00001-10-05/main idea.mp3": [
		834
	],
	"./00001/00001-10/00001-10-05/necks.mp3": [
		2631,
		1306
	],
	"./00001/00001-10/00001-10-06/animals we saw in the book.mp3": [
		2632,
		1307
	],
	"./00001/00001-10/00001-10-06/animals with long teeth.mp3": [
		2633,
		1308
	],
	"./00001/00001-10/00001-10-06/intro.mp3": [
		454
	],
	"./00001/00001-10/00001-10-06/look at the alligator.mp3": [
		2634,
		1309
	],
	"./00001/00001-10/00001-10-06/look at the bat.mp3": [
		2635,
		1310
	],
	"./00001/00001-10/00001-10-06/look at the beaver.mp3": [
		2636,
		1311
	],
	"./00001/00001-10/00001-10-06/look at the dinosaur.mp3": [
		2637,
		1312
	],
	"./00001/00001-10/00001-10-06/look at the eel.mp3": [
		2638,
		1313
	],
	"./00001/00001-10/00001-10-06/look at the elephant.mp3": [
		2639,
		1314
	],
	"./00001/00001-10/00001-10-06/look at the walrus.mp3": [
		2640,
		1315
	],
	"./00001/00001-10/00001-10-06/main idea.mp3": [
		835
	],
	"./00001/00001-10/00001-10-06/teeth.mp3": [
		2641,
		1316
	],
	"./00001/00001-10/00001-10-07/animals with 2 feet.mp3": [
		2642,
		1317
	],
	"./00001/00001-10/00001-10-07/feet.mp3": [
		2643,
		1318
	],
	"./00001/00001-10/00001-10-07/intro.mp3": [
		455
	],
	"./00001/00001-10/00001-10-07/main idea.mp3": [
		836
	],
	"./00001/00001-10/00001-10-07/the bird has 2 feet.mp3": [
		2644,
		1319
	],
	"./00001/00001-10/00001-10-07/the duck has 2 feet.mp3": [
		2645,
		1320
	],
	"./00001/00001-10/00001-10-07/the frog has 4 feet.mp3": [
		2646,
		1321
	],
	"./00001/00001-10/00001-10-07/the raccoon has 4 feet.mp3": [
		2647,
		1322
	],
	"./00001/00001-10/00001-10-07/the slug has 1 foot.mp3": [
		2648,
		1323
	],
	"./00001/00001-10/00001-10-07/the snail has 1 foot.mp3": [
		2649,
		1324
	],
	"./00001/00001-10/00001-10-07/the whale has no feet.mp3": [
		2650,
		1325
	],
	"./00001/00001-10/00001-10-08/animals with shells.mp3": [
		2651,
		1326
	],
	"./00001/00001-10/00001-10-08/i am a crab.mp3": [
		2652,
		1327
	],
	"./00001/00001-10/00001-10-08/i am a hermit crab.mp3": [
		2653,
		1328
	],
	"./00001/00001-10/00001-10-08/i am a lobster.mp3": [
		2654,
		1329
	],
	"./00001/00001-10/00001-10-08/i am a sea turtle.mp3": [
		2655,
		1330
	],
	"./00001/00001-10/00001-10-08/i am a shrimp.mp3": [
		2656,
		1331
	],
	"./00001/00001-10/00001-10-08/i am a snail.mp3": [
		2657,
		1332
	],
	"./00001/00001-10/00001-10-08/i am a turtle.mp3": [
		2658,
		1333
	],
	"./00001/00001-10/00001-10-08/intro.mp3": [
		456
	],
	"./00001/00001-10/00001-10-08/main idea.mp3": [
		837
	],
	"./00001/00001-10/00001-10-08/shells.mp3": [
		2659,
		1334
	],
	"./00001/00001-10/00001-10-09/animals with long noses.mp3": [
		2660,
		1335
	],
	"./00001/00001-10/00001-10-09/i see the alligator.mp3": [
		2661,
		1336
	],
	"./00001/00001-10/00001-10-09/i see the anteater.mp3": [
		2662,
		1337
	],
	"./00001/00001-10/00001-10-09/i see the dog.mp3": [
		2663,
		1338
	],
	"./00001/00001-10/00001-10-09/i see the elephant.mp3": [
		2664,
		1339
	],
	"./00001/00001-10/00001-10-09/i see the monster.mp3": [
		2665,
		1340
	],
	"./00001/00001-10/00001-10-09/i see the seahorse.mp3": [
		2666,
		1341
	],
	"./00001/00001-10/00001-10-09/i see the swordfish.mp3": [
		2667,
		1342
	],
	"./00001/00001-10/00001-10-09/intro.mp3": [
		457
	],
	"./00001/00001-10/00001-10-09/main idea.mp3": [
		838
	],
	"./00001/00001-10/00001-10-09/noses.mp3": [
		2668,
		1343
	],
	"./00001/00001-10/00001-10-10/animals with big ears.mp3": [
		2669,
		1344
	],
	"./00001/00001-10/00001-10-10/i like the donkey.mp3": [
		2670,
		1345
	],
	"./00001/00001-10/00001-10-10/i like the elephant.mp3": [
		2671,
		1346
	],
	"./00001/00001-10/00001-10-10/i like the fox.mp3": [
		2672,
		1347
	],
	"./00001/00001-10/00001-10-10/i like the kangaroo.mp3": [
		2673,
		1348
	],
	"./00001/00001-10/00001-10-10/i like the monster.mp3": [
		2674,
		1349
	],
	"./00001/00001-10/00001-10-10/i like the mouse.mp3": [
		2675,
		1350
	],
	"./00001/00001-10/00001-10-10/i like the rabbit.mp3": [
		2676,
		1351
	],
	"./00001/00001-10/00001-10-10/intro.mp3": [
		458
	],
	"./00001/00001-10/00001-10-10/main idea.mp3": [
		839
	],
	"./00001/00001-10/creature features.mp3": [
		2677,
		1352
	],
	"./00001/00001-11/00001-11-01/flying animals.mp3": [
		2678,
		1353
	],
	"./00001/00001-11/00001-11-01/intro.mp3": [
		459
	],
	"./00001/00001-11/00001-11-01/main idea.mp3": [
		840
	],
	"./00001/00001-11/00001-11-01/the dragon can fly.mp3": [
		2679,
		1354
	],
	"./00001/00001-11/00001-11-01/the eagle can fly.mp3": [
		2680,
		1355
	],
	"./00001/00001-11/00001-11-01/the pig can fly.mp3": [
		2681,
		1356
	],
	"./00001/00001-11/00001-11-01/the rabbit can fly.mp3": [
		2682,
		1357
	],
	"./00001/00001-11/00001-11-01/the spaceship can fly.mp3": [
		2683,
		1358
	],
	"./00001/00001-11/00001-11-01/the tiger can fly.mp3": [
		2684,
		1359
	],
	"./00001/00001-11/00001-11-01/the unicorn can fly.mp3": [
		2685,
		1360
	],
	"./00001/00001-11/00001-11-01/what can fly.mp3": [
		2686,
		1361
	],
	"./00001/00001-11/00001-11-02/5 little dinosaurs.mp3": [
		2687,
		1362
	],
	"./00001/00001-11/00001-11-02/dinosaurs.mp3": [
		2688,
		1363
	],
	"./00001/00001-11/00001-11-02/i see 0 little dinosaurs.mp3": [
		2689,
		1364
	],
	"./00001/00001-11/00001-11-02/i see 1 big dinosaur.mp3": [
		2690,
		1365
	],
	"./00001/00001-11/00001-11-02/i see 1 little dinosaur.mp3": [
		2691,
		1366
	],
	"./00001/00001-11/00001-11-02/i see 2 little dinosaurs.mp3": [
		2692,
		1367
	],
	"./00001/00001-11/00001-11-02/i see 3 little dinosaurs.mp3": [
		2693,
		1368
	],
	"./00001/00001-11/00001-11-02/i see 4 little dinosaurs.mp3": [
		2694,
		1369
	],
	"./00001/00001-11/00001-11-02/i see 5 little dinosaurs.mp3": [
		2695,
		1370
	],
	"./00001/00001-11/00001-11-02/intro.mp3": [
		460
	],
	"./00001/00001-11/00001-11-02/main idea.mp3": [
		841
	],
	"./00001/00001-11/00001-11-03/i am flying.mp3": [
		2696,
		1371
	],
	"./00001/00001-11/00001-11-03/i am running.mp3": [
		2697,
		1372
	],
	"./00001/00001-11/00001-11-03/i am skating.mp3": [
		2698,
		1373
	],
	"./00001/00001-11/00001-11-03/i am sleeping.mp3": [
		2699,
		1374
	],
	"./00001/00001-11/00001-11-03/i am sliding.mp3": [
		2700,
		1375
	],
	"./00001/00001-11/00001-11-03/i am swimming.mp3": [
		2701,
		1376
	],
	"./00001/00001-11/00001-11-03/intro.mp3": [
		461
	],
	"./00001/00001-11/00001-11-03/main idea.mp3": [
		842
	],
	"./00001/00001-11/00001-11-03/swimming animals.mp3": [
		2702,
		1377
	],
	"./00001/00001-11/00001-11-03/we are jumping.mp3": [
		2703,
		1378
	],
	"./00001/00001-11/00001-11-04/intro.mp3": [
		462
	],
	"./00001/00001-11/00001-11-04/look at the big snowball.mp3": [
		2704,
		1379
	],
	"./00001/00001-11/00001-11-04/look at the carrot.mp3": [
		2705,
		1380
	],
	"./00001/00001-11/00001-11-04/look at the hat.mp3": [
		2706,
		1381
	],
	"./00001/00001-11/00001-11-04/look at the little snowball.mp3": [
		2707,
		1382
	],
	"./00001/00001-11/00001-11-04/look at the rocks.mp3": [
		2708,
		1383
	],
	"./00001/00001-11/00001-11-04/look at the scarf.mp3": [
		2709,
		1384
	],
	"./00001/00001-11/00001-11-04/look at the snowman.mp3": [
		2710,
		1385
	],
	"./00001/00001-11/00001-11-04/main idea.mp3": [
		843
	],
	"./00001/00001-11/00001-11-04/making a snowman.mp3": [
		2711,
		1386
	],
	"./00001/00001-11/00001-11-04/things you need to make a snowman.mp3": [
		2712,
		1387
	],
	"./00001/00001-11/00001-11-05/going up and down.mp3": [
		2713,
		1388
	],
	"./00001/00001-11/00001-11-05/intro.mp3": [
		463
	],
	"./00001/00001-11/00001-11-05/look at the cat.mp3": [
		2714,
		1389
	],
	"./00001/00001-11/00001-11-05/look at the dog.mp3": [
		2715,
		1390
	],
	"./00001/00001-11/00001-11-05/look at the mouse.mp3": [
		2716,
		1391
	],
	"./00001/00001-11/00001-11-05/main idea.mp3": [
		844
	],
	"./00001/00001-11/00001-11-05/the cat is going down.mp3": [
		2717,
		1392
	],
	"./00001/00001-11/00001-11-05/the cat is going up.mp3": [
		2718,
		1393
	],
	"./00001/00001-11/00001-11-05/the dog is going down.mp3": [
		2719,
		1394
	],
	"./00001/00001-11/00001-11-05/the dog is going up.mp3": [
		2720,
		1395
	],
	"./00001/00001-11/00001-11-05/the mouse is going down.mp3": [
		2721,
		1396
	],
	"./00001/00001-11/00001-11-05/the mouse is going up.mp3": [
		2722,
		1397
	],
	"./00001/00001-11/00001-11-05/things you can see up in the sky.mp3": [
		2723,
		1398
	],
	"./00001/00001-11/00001-11-06/here comes the cheetah.mp3": [
		2724,
		1399
	],
	"./00001/00001-11/00001-11-06/here comes the elephant.mp3": [
		2725,
		1400
	],
	"./00001/00001-11/00001-11-06/here comes the fox.mp3": [
		2726,
		1401
	],
	"./00001/00001-11/00001-11-06/here comes the giraffe.mp3": [
		2727,
		1402
	],
	"./00001/00001-11/00001-11-06/here comes the lion.mp3": [
		2728,
		1403
	],
	"./00001/00001-11/00001-11-06/here comes the ostrich.mp3": [
		2729,
		1404
	],
	"./00001/00001-11/00001-11-06/here comes the zebra.mp3": [
		2730,
		1405
	],
	"./00001/00001-11/00001-11-06/intro.mp3": [
		464
	],
	"./00001/00001-11/00001-11-06/main idea.mp3": [
		845
	],
	"./00001/00001-11/00001-11-06/the animal race.mp3": [
		2731,
		1406
	],
	"./00001/00001-11/00001-11-06/wild animals.mp3": [
		2732,
		1407
	],
	"./00001/00001-11/00001-11-07/here is my bird said the dinosaur.mp3": [
		2733,
		1408
	],
	"./00001/00001-11/00001-11-07/here is my bird said the girl.mp3": [
		2734,
		1409
	],
	"./00001/00001-11/00001-11-07/here is my bird said the monster.mp3": [
		2735,
		1410
	],
	"./00001/00001-11/00001-11-07/here is my cat said the boy.mp3": [
		2736,
		1411
	],
	"./00001/00001-11/00001-11-07/here is my cat said the monster.mp3": [
		2737,
		1412
	],
	"./00001/00001-11/00001-11-07/here is my dog said the girl.mp3": [
		2738,
		1413
	],
	"./00001/00001-11/00001-11-07/here is my dog said the monster.mp3": [
		2739,
		1414
	],
	"./00001/00001-11/00001-11-07/here is my pet.mp3": [
		2740,
		1415
	],
	"./00001/00001-11/00001-11-07/intro.mp3": [
		465
	],
	"./00001/00001-11/00001-11-07/main idea.mp3": [
		846
	],
	"./00001/00001-11/00001-11-07/pets.mp3": [
		2741,
		1416
	],
	"./00001/00001-11/00001-11-07/wild animals.mp3": [
		2742,
		1417
	],
	"./00001/00001-11/00001-11-08/can you.mp3": [
		2743,
		1418
	],
	"./00001/00001-11/00001-11-08/characters who can skate in the book.mp3": [
		2744,
		1419
	],
	"./00001/00001-11/00001-11-08/i can not skate said the bear.mp3": [
		2745,
		1420
	],
	"./00001/00001-11/00001-11-08/i can skate said the deer.mp3": [
		2746,
		1421
	],
	"./00001/00001-11/00001-11-08/i can skate said the monster.mp3": [
		2747,
		1422
	],
	"./00001/00001-11/00001-11-08/i can skate said the panda.mp3": [
		2748,
		1423
	],
	"./00001/00001-11/00001-11-08/i can skate said the penguin.mp3": [
		2749,
		1424
	],
	"./00001/00001-11/00001-11-08/intro.mp3": [
		466
	],
	"./00001/00001-11/00001-11-08/look at me.mp3": [
		2750,
		1425
	],
	"./00001/00001-11/00001-11-08/look at us.mp3": [
		2751,
		1426
	],
	"./00001/00001-11/00001-11-08/main idea.mp3": [
		847
	],
	"./00001/00001-11/00001-11-08/oh no.mp3": [
		2752,
		1427
	],
	"./00001/00001-11/00001-11-08/the bear can not skate.mp3": [
		2753,
		1428
	],
	"./00001/00001-11/00001-11-08/the deer can skate.mp3": [
		2754,
		1429
	],
	"./00001/00001-11/00001-11-08/the lions can skate.mp3": [
		2755,
		1430
	],
	"./00001/00001-11/00001-11-08/the monster can skate.mp3": [
		2756,
		1431
	],
	"./00001/00001-11/00001-11-08/the panda can skate.mp3": [
		2757,
		1432
	],
	"./00001/00001-11/00001-11-08/the penguin can skate.mp3": [
		2758,
		1433
	],
	"./00001/00001-11/00001-11-08/the rabbits can skate.mp3": [
		2759,
		1434
	],
	"./00001/00001-11/00001-11-08/we can skate said the lions.mp3": [
		2760,
		1435
	],
	"./00001/00001-11/00001-11-08/we can skate said the rabbits.mp3": [
		2761,
		1436
	],
	"./00001/00001-11/00001-11-08/who can skate.mp3": [
		2762,
		1437
	],
	"./00001/00001-11/00001-11-09/animals with four legs.mp3": [
		2763,
		1438
	],
	"./00001/00001-11/00001-11-09/balloons.mp3": [
		2764,
		1439
	],
	"./00001/00001-11/00001-11-09/cat likes the orange balloon.mp3": [
		2765,
		1440
	],
	"./00001/00001-11/00001-11-09/dinosaur likes the blue balloon.mp3": [
		2766,
		1441
	],
	"./00001/00001-11/00001-11-09/dog likes the red balloon.mp3": [
		2767,
		1442
	],
	"./00001/00001-11/00001-11-09/intro.mp3": [
		467
	],
	"./00001/00001-11/00001-11-09/lion likes the yellow balloon.mp3": [
		2768,
		1443
	],
	"./00001/00001-11/00001-11-09/main idea.mp3": [
		848
	],
	"./00001/00001-11/00001-11-09/monkey likes the green balloon.mp3": [
		2769,
		1444
	],
	"./00001/00001-11/00001-11-09/octopus likes the balloons.mp3": [
		2770,
		1445
	],
	"./00001/00001-11/00001-11-09/rabbit likes the pink balloon.mp3": [
		2771,
		1446
	],
	"./00001/00001-11/00001-11-10/ant sees the yellow flower.mp3": [
		2772,
		1447
	],
	"./00001/00001-11/00001-11-10/bee sees the orange flower.mp3": [
		2773,
		1448
	],
	"./00001/00001-11/00001-11-10/butterfly sees the red flower.mp3": [
		2774,
		1449
	],
	"./00001/00001-11/00001-11-10/grasshopper sees the pink flower.mp3": [
		2775,
		1450
	],
	"./00001/00001-11/00001-11-10/hummingbird sees the blue flower.mp3": [
		2776,
		1451
	],
	"./00001/00001-11/00001-11-10/insects.mp3": [
		2777,
		1452
	],
	"./00001/00001-11/00001-11-10/intro.mp3": [
		468
	],
	"./00001/00001-11/00001-11-10/ladybug sees the purple flower.mp3": [
		2778,
		1453
	],
	"./00001/00001-11/00001-11-10/main idea.mp3": [
		849
	],
	"./00001/00001-11/00001-11-10/we see flowers.mp3": [
		2779,
		1454
	],
	"./00001/00001-11/00001-11-10/we see the flowers.mp3": [
		2780,
		1455
	],
	"./00001/00001-11/story town.mp3": [
		2781,
		1456
	],
	"./00001/00001-12/00001-12-01/alligator wants an airplane.mp3": [
		2782,
		1457
	],
	"./00001/00001-12/00001-12-01/bear wants a bike.mp3": [
		2783,
		1458
	],
	"./00001/00001-12/00001-12-01/cat wants a car.mp3": [
		2784,
		1459
	],
	"./00001/00001-12/00001-12-01/dog wants a dinosaur.mp3": [
		2785,
		1460
	],
	"./00001/00001-12/00001-12-01/fox wants a fire truck.mp3": [
		2786,
		1461
	],
	"./00001/00001-12/00001-12-01/hippo wants a helicopter.mp3": [
		2787,
		1462
	],
	"./00001/00001-12/00001-12-01/intro.mp3": [
		469
	],
	"./00001/00001-12/00001-12-01/main idea.mp3": [
		850
	],
	"./00001/00001-12/00001-12-01/toys.mp3": [
		2788,
		1463
	],
	"./00001/00001-12/00001-12-01/vehicles.mp3": [
		2789,
		1464
	],
	"./00001/00001-12/00001-12-01/wolf wants a wagon.mp3": [
		2790,
		1465
	],
	"./00001/00001-12/00001-12-02/alligator got a saxophone.mp3": [
		2791,
		1466
	],
	"./00001/00001-12/00001-12-02/bear got a guitar.mp3": [
		2792,
		1467
	],
	"./00001/00001-12/00001-12-02/beaver got a xylophone.mp3": [
		2793,
		1468
	],
	"./00001/00001-12/00001-12-02/dog got a tambourine.mp3": [
		2794,
		1469
	],
	"./00001/00001-12/00001-12-02/fox got a fiddle.mp3": [
		2795,
		1470
	],
	"./00001/00001-12/00001-12-02/i love music.mp3": [
		2796,
		1471
	],
	"./00001/00001-12/00001-12-02/intro.mp3": [
		470
	],
	"./00001/00001-12/00001-12-02/main idea.mp3": [
		851
	],
	"./00001/00001-12/00001-12-02/monkey got a triangle.mp3": [
		2797,
		1472
	],
	"./00001/00001-12/00001-12-02/musical instruments.mp3": [
		2798,
		1473
	],
	"./00001/00001-12/00001-12-02/raccoon got a banjo.mp3": [
		2799,
		1474
	],
	"./00001/00001-12/00001-12-03/cat is going to the party.mp3": [
		2800,
		1475
	],
	"./00001/00001-12/00001-12-03/crocodile is going to the party.mp3": [
		2801,
		1476
	],
	"./00001/00001-12/00001-12-03/elephant is going to the party.mp3": [
		2802,
		1477
	],
	"./00001/00001-12/00001-12-03/going to the party.mp3": [
		2803,
		1478
	],
	"./00001/00001-12/00001-12-03/here is the party.mp3": [
		2804,
		1479
	],
	"./00001/00001-12/00001-12-03/intro.mp3": [
		471
	],
	"./00001/00001-12/00001-12-03/jaguar is going to the party.mp3": [
		2805,
		1480
	],
	"./00001/00001-12/00001-12-03/main idea.mp3": [
		852
	],
	"./00001/00001-12/00001-12-03/panda is going to the party.mp3": [
		2806,
		1481
	],
	"./00001/00001-12/00001-12-03/tiger is going to the party.mp3": [
		2807,
		1482
	],
	"./00001/00001-12/00001-12-03/wild animals.mp3": [
		2808,
		1483
	],
	"./00001/00001-12/00001-12-03/zebra is going to the party.mp3": [
		2809,
		1484
	],
	"./00001/00001-12/00001-12-04/a friend for yellow duck.mp3": [
		2810,
		1485
	],
	"./00001/00001-12/00001-12-04/animals with 4 legs.mp3": [
		2811,
		1486
	],
	"./00001/00001-12/00001-12-04/intro.mp3": [
		472
	],
	"./00001/00001-12/00001-12-04/look at the animals.mp3": [
		2812,
		1487
	],
	"./00001/00001-12/00001-12-04/look at the deer.mp3": [
		2813,
		1488
	],
	"./00001/00001-12/00001-12-04/look at the ducks.mp3": [
		2814,
		1489
	],
	"./00001/00001-12/00001-12-04/look at the fox.mp3": [
		2815,
		1490
	],
	"./00001/00001-12/00001-12-04/look at the frog.mp3": [
		2816,
		1491
	],
	"./00001/00001-12/00001-12-04/look at the sheep.mp3": [
		2817,
		1492
	],
	"./00001/00001-12/00001-12-04/look at the squirrel.mp3": [
		2818,
		1493
	],
	"./00001/00001-12/00001-12-04/main idea.mp3": [
		853
	],
	"./00001/00001-12/00001-12-04/no.mp3": [
		2819,
		1494
	],
	"./00001/00001-12/00001-12-04/will you play with me said yellow duck.mp3": [
		2820,
		1495
	],
	"./00001/00001-12/00001-12-04/yes.mp3": [
		2821,
		1496
	],
	"./00001/00001-12/00001-12-05/cat likes to play soccer.mp3": [
		2822,
		1497
	],
	"./00001/00001-12/00001-12-05/fox likes to play soccer.mp3": [
		2823,
		1498
	],
	"./00001/00001-12/00001-12-05/intro.mp3": [
		473
	],
	"./00001/00001-12/00001-12-05/lion likes to play soccer.mp3": [
		2824,
		1499
	],
	"./00001/00001-12/00001-12-05/main idea.mp3": [
		854
	],
	"./00001/00001-12/00001-12-05/rabbit likes to play soccer too.mp3": [
		2825,
		1500
	],
	"./00001/00001-12/00001-12-05/sheep likes to play soccer.mp3": [
		2826,
		1501
	],
	"./00001/00001-12/00001-12-05/skunk likes to play soccer.mp3": [
		2827,
		1502
	],
	"./00001/00001-12/00001-12-05/the soccer game.mp3": [
		2828,
		1503
	],
	"./00001/00001-12/00001-12-05/tiger likes to play soccer.mp3": [
		2829,
		1504
	],
	"./00001/00001-12/00001-12-05/wild animals.mp3": [
		2830,
		1505
	],
	"./00001/00001-12/00001-12-06/baby animals.mp3": [
		2831,
		1506
	],
	"./00001/00001-12/00001-12-06/can i be your mother.mp3": [
		2832,
		1507
	],
	"./00001/00001-12/00001-12-06/intro.mp3": [
		474
	],
	"./00001/00001-12/00001-12-06/main idea.mp3": [
		855
	],
	"./00001/00001-12/00001-12-06/no.mp3": [
		2833,
		1508
	],
	"./00001/00001-12/00001-12-06/yes.mp3": [
		2834,
		1509
	],
	"./00001/00001-12/00001-12-07/birds.mp3": [
		2835,
		1510
	],
	"./00001/00001-12/00001-12-07/characters in the book.mp3": [
		2836,
		1511
	],
	"./00001/00001-12/00001-12-07/intro.mp3": [
		475
	],
	"./00001/00001-12/00001-12-07/look at the deer.mp3": [
		2837,
		1512
	],
	"./00001/00001-12/00001-12-07/look at the elephant.mp3": [
		2838,
		1513
	],
	"./00001/00001-12/00001-12-07/look at the fox.mp3": [
		2839,
		1514
	],
	"./00001/00001-12/00001-12-07/look at the jaguar.mp3": [
		2840,
		1515
	],
	"./00001/00001-12/00001-12-07/look at the lion.mp3": [
		2841,
		1516
	],
	"./00001/00001-12/00001-12-07/look at the tiger.mp3": [
		2842,
		1517
	],
	"./00001/00001-12/00001-12-07/main idea.mp3": [
		856
	],
	"./00001/00001-12/00001-12-07/the sky is falling said chicken little.mp3": [
		2843,
		1518
	],
	"./00001/00001-12/00001-12-07/the sky is falling.mp3": [
		2844,
		1519
	],
	"./00001/00001-12/00001-12-07/the sky is not falling.mp3": [
		2845,
		1520
	],
	"./00001/00001-12/00001-12-08/intro.mp3": [
		476
	],
	"./00001/00001-12/00001-12-08/main idea.mp3": [
		857
	],
	"./00001/00001-12/00001-12-08/mother cat looked in the bathroom.mp3": [
		2846,
		1521
	],
	"./00001/00001-12/00001-12-08/mother cat looked in the bathtub.mp3": [
		2847,
		1522
	],
	"./00001/00001-12/00001-12-08/mother cat looked in the bedroom.mp3": [
		2848,
		1523
	],
	"./00001/00001-12/00001-12-08/mother cat looked in the living room.mp3": [
		2849,
		1524
	],
	"./00001/00001-12/00001-12-08/mother cat looked on the bed.mp3": [
		2850,
		1525
	],
	"./00001/00001-12/00001-12-08/mother cat looked on the couch.mp3": [
		2851,
		1526
	],
	"./00001/00001-12/00001-12-08/mother cat looked on the table.mp3": [
		2852,
		1527
	],
	"./00001/00001-12/00001-12-08/non living things.mp3": [
		2853,
		1528
	],
	"./00001/00001-12/00001-12-08/where is the kitten.mp3": [
		2854,
		1529
	],
	"./00001/00001-12/00001-12-09/i love the mountains.mp3": [
		2855,
		1530
	],
	"./00001/00001-12/00001-12-09/i love to see the bees.mp3": [
		2856,
		1531
	],
	"./00001/00001-12/00001-12-09/i love to see the boats.mp3": [
		2857,
		1532
	],
	"./00001/00001-12/00001-12-09/i love to see the dogs.mp3": [
		2858,
		1533
	],
	"./00001/00001-12/00001-12-09/i love to see the frogs.mp3": [
		2859,
		1534
	],
	"./00001/00001-12/00001-12-09/i love to see the goats.mp3": [
		2860,
		1535
	],
	"./00001/00001-12/00001-12-09/i love to see the trees.mp3": [
		2861,
		1536
	],
	"./00001/00001-12/00001-12-09/intro.mp3": [
		477
	],
	"./00001/00001-12/00001-12-09/main idea.mp3": [
		858
	],
	"./00001/00001-12/00001-12-09/things on the earth.mp3": [
		2862,
		1537
	],
	"./00001/00001-12/00001-12-10/birds.mp3": [
		2863,
		1538
	],
	"./00001/00001-12/00001-12-10/have you seen my mother.mp3": [
		2864,
		1539
	],
	"./00001/00001-12/00001-12-10/help.mp3": [
		2865,
		1540
	],
	"./00001/00001-12/00001-12-10/here is a dog.mp3": [
		2866,
		1541
	],
	"./00001/00001-12/00001-12-10/here is a duck.mp3": [
		2867,
		1542
	],
	"./00001/00001-12/00001-12-10/here is a pig.mp3": [
		2868,
		1543
	],
	"./00001/00001-12/00001-12-10/here is a rabbit.mp3": [
		2869,
		1544
	],
	"./00001/00001-12/00001-12-10/here is a snake.mp3": [
		2870,
		1545
	],
	"./00001/00001-12/00001-12-10/here is baby bird.mp3": [
		2871,
		1546
	],
	"./00001/00001-12/00001-12-10/here is mother bird.mp3": [
		2872,
		1547
	],
	"./00001/00001-12/00001-12-10/intro.mp3": [
		478
	],
	"./00001/00001-12/00001-12-10/main idea.mp3": [
		859
	],
	"./00001/00001-12/00001-12-11/0 little monkeys jumped on the bed.mp3": [
		2873,
		1548
	],
	"./00001/00001-12/00001-12-11/1 little monkey jumped on the bed.mp3": [
		2874,
		1549
	],
	"./00001/00001-12/00001-12-11/2 little monkeys jumped on the bed.mp3": [
		2875,
		1550
	],
	"./00001/00001-12/00001-12-11/3 little monkeys jumped on the bed.mp3": [
		2876,
		1551
	],
	"./00001/00001-12/00001-12-11/4 little monkeys jumped on the bed.mp3": [
		2877,
		1552
	],
	"./00001/00001-12/00001-12-11/5 little monkeys jumped on the bed.mp3": [
		2878,
		1553
	],
	"./00001/00001-12/00001-12-11/5 little monkeys.mp3": [
		2879,
		1554
	],
	"./00001/00001-12/00001-12-11/animals that live in trees.mp3": [
		2880,
		1555
	],
	"./00001/00001-12/00001-12-11/intro.mp3": [
		479
	],
	"./00001/00001-12/00001-12-11/main idea.mp3": [
		860
	],
	"./00001/00001-12/story land.mp3": [
		2881,
		1556
	],
	"./00002/00002-01/00002-01-01/blue toys.mp3": [
		2882,
		1557
	],
	"./00002/00002-01/00002-01-01/here is a blue boat.mp3": [
		2883,
		1558
	],
	"./00002/00002-01/00002-01-01/here is a blue helicopter.mp3": [
		2884,
		1559
	],
	"./00002/00002-01/00002-01-01/here is my car.mp3": [
		2885,
		1560
	],
	"./00002/00002-01/00002-01-01/here is my robot.mp3": [
		2886,
		1561
	],
	"./00002/00002-01/00002-01-01/intro.mp3": [
		480
	],
	"./00002/00002-01/00002-01-01/look at my airplane.mp3": [
		2887,
		1562
	],
	"./00002/00002-01/00002-01-01/look at my boat.mp3": [
		2888,
		1563
	],
	"./00002/00002-01/00002-01-01/look at my helicopter.mp3": [
		2889,
		1564
	],
	"./00002/00002-01/00002-01-01/look at my train.mp3": [
		2890,
		1565
	],
	"./00002/00002-01/00002-01-01/look at my truck.mp3": [
		2891,
		1566
	],
	"./00002/00002-01/00002-01-01/main idea.mp3": [
		861
	],
	"./00002/00002-01/00002-01-01/my airplane is blue.mp3": [
		2892,
		1567
	],
	"./00002/00002-01/00002-01-01/my car is blue too.mp3": [
		2893,
		1568
	],
	"./00002/00002-01/00002-01-01/my robot is blue.mp3": [
		2894,
		1569
	],
	"./00002/00002-01/00002-01-01/my train is blue.mp3": [
		2895,
		1570
	],
	"./00002/00002-01/00002-01-01/my truck is blue.mp3": [
		2896,
		1571
	],
	"./00002/00002-01/00002-01-01/vehicles.mp3": [
		2897,
		1572
	],
	"./00002/00002-01/00002-01-02/here comes the car.mp3": [
		2898,
		1573
	],
	"./00002/00002-01/00002-01-02/here comes the fire truck.mp3": [
		2899,
		1574
	],
	"./00002/00002-01/00002-01-02/here comes the helicopter.mp3": [
		2900,
		1575
	],
	"./00002/00002-01/00002-01-02/here comes the motorcycle.mp3": [
		2901,
		1576
	],
	"./00002/00002-01/00002-01-02/here comes the plane.mp3": [
		2902,
		1577
	],
	"./00002/00002-01/00002-01-02/here comes the tractor.mp3": [
		2903,
		1578
	],
	"./00002/00002-01/00002-01-02/here comes the train.mp3": [
		2904,
		1579
	],
	"./00002/00002-01/00002-01-02/intro.mp3": [
		481
	],
	"./00002/00002-01/00002-01-02/main idea.mp3": [
		862
	],
	"./00002/00002-01/00002-01-02/red vehicles.mp3": [
		2905,
		1580
	],
	"./00002/00002-01/00002-01-02/the car is red.mp3": [
		2906,
		1581
	],
	"./00002/00002-01/00002-01-02/the fire truck is red.mp3": [
		2907,
		1582
	],
	"./00002/00002-01/00002-01-02/the helicopter is red.mp3": [
		2908,
		1583
	],
	"./00002/00002-01/00002-01-02/the motorcycle is red.mp3": [
		2909,
		1584
	],
	"./00002/00002-01/00002-01-02/the plane is red.mp3": [
		2910,
		1585
	],
	"./00002/00002-01/00002-01-02/the tractor is red.mp3": [
		2911,
		1586
	],
	"./00002/00002-01/00002-01-02/the train is red.mp3": [
		2912,
		1587
	],
	"./00002/00002-01/00002-01-02/things that are red.mp3": [
		2913,
		1588
	],
	"./00002/00002-01/00002-01-03/i like the bird.mp3": [
		2914,
		1589
	],
	"./00002/00002-01/00002-01-03/i like the butterfly.mp3": [
		2915,
		1590
	],
	"./00002/00002-01/00002-01-03/i like the caterpillar.mp3": [
		2916,
		1591
	],
	"./00002/00002-01/00002-01-03/i like the crab.mp3": [
		2917,
		1592
	],
	"./00002/00002-01/00002-01-03/i like the dog.mp3": [
		2918,
		1593
	],
	"./00002/00002-01/00002-01-03/i like the ducks.mp3": [
		2919,
		1594
	],
	"./00002/00002-01/00002-01-03/i like the fish.mp3": [
		2920,
		1595
	],
	"./00002/00002-01/00002-01-03/i like the spider.mp3": [
		2921,
		1596
	],
	"./00002/00002-01/00002-01-03/intro.mp3": [
		482
	],
	"./00002/00002-01/00002-01-03/main idea.mp3": [
		863
	],
	"./00002/00002-01/00002-01-03/the bird is yellow.mp3": [
		2922,
		1597
	],
	"./00002/00002-01/00002-01-03/the butterfly is yellow.mp3": [
		2923,
		1598
	],
	"./00002/00002-01/00002-01-03/the caterpillar is yellow.mp3": [
		2924,
		1599
	],
	"./00002/00002-01/00002-01-03/the crab is yellow.mp3": [
		2925,
		1600
	],
	"./00002/00002-01/00002-01-03/the dog is yellow.mp3": [
		2926,
		1601
	],
	"./00002/00002-01/00002-01-03/the ducks are yellow too.mp3": [
		2927,
		1602
	],
	"./00002/00002-01/00002-01-03/the fish is yellow.mp3": [
		2928,
		1603
	],
	"./00002/00002-01/00002-01-03/the spider is yellow.mp3": [
		2929,
		1604
	],
	"./00002/00002-01/00002-01-03/things that are yellow.mp3": [
		2930,
		1605
	],
	"./00002/00002-01/00002-01-03/yellow animals.mp3": [
		2931,
		1606
	],
	"./00002/00002-01/00002-01-04/i can not see the orange fox.mp3": [
		2932,
		1607
	],
	"./00002/00002-01/00002-01-04/i can see the orange butterfly.mp3": [
		2933,
		1608
	],
	"./00002/00002-01/00002-01-04/i can see the orange cat.mp3": [
		2934,
		1609
	],
	"./00002/00002-01/00002-01-04/i can see the orange fish.mp3": [
		2935,
		1610
	],
	"./00002/00002-01/00002-01-04/i can see the orange fox.mp3": [
		2936,
		1611
	],
	"./00002/00002-01/00002-01-04/i can see the orange salamander.mp3": [
		2937,
		1612
	],
	"./00002/00002-01/00002-01-04/i can see the orange snake.mp3": [
		2938,
		1613
	],
	"./00002/00002-01/00002-01-04/i can see the orange tiger.mp3": [
		2939,
		1614
	],
	"./00002/00002-01/00002-01-04/intro.mp3": [
		483
	],
	"./00002/00002-01/00002-01-04/main idea.mp3": [
		864
	],
	"./00002/00002-01/00002-01-04/orange things.mp3": [
		2940,
		1615
	],
	"./00002/00002-01/00002-01-04/the orange animal book.mp3": [
		2941,
		1616
	],
	"./00002/00002-01/00002-01-04/what else can i see.mp3": [
		2942,
		1617
	],
	"./00002/00002-01/00002-01-05/i look good in purple.mp3": [
		2943,
		1618
	],
	"./00002/00002-01/00002-01-05/i love purple he said.mp3": [
		2944,
		1619
	],
	"./00002/00002-01/00002-01-05/i love purple she said.mp3": [
		2945,
		1620
	],
	"./00002/00002-01/00002-01-05/i love purple.mp3": [
		2946,
		1621
	],
	"./00002/00002-01/00002-01-05/intro.mp3": [
		484
	],
	"./00002/00002-01/00002-01-05/look at me.mp3": [
		2947,
		1622
	],
	"./00002/00002-01/00002-01-05/main idea.mp3": [
		865
	],
	"./00002/00002-01/00002-01-05/the dog has a purple jacket.mp3": [
		2948,
		1623
	],
	"./00002/00002-01/00002-01-05/the goat has a purple scarf.mp3": [
		2949,
		1624
	],
	"./00002/00002-01/00002-01-05/the lion has a purple shirt.mp3": [
		2950,
		1625
	],
	"./00002/00002-01/00002-01-05/the octopus has purple mittens.mp3": [
		2951,
		1626
	],
	"./00002/00002-01/00002-01-05/the penguin has a purple helmet.mp3": [
		2952,
		1627
	],
	"./00002/00002-01/00002-01-05/the rabbit has a purple hat.mp3": [
		2953,
		1628
	],
	"./00002/00002-01/00002-01-05/the skunk has a purple dress.mp3": [
		2954,
		1629
	],
	"./00002/00002-01/00002-01-05/things that are purple.mp3": [
		2955,
		1630
	],
	"./00002/00002-01/00002-01-06/animals that are green.mp3": [
		2956,
		1631
	],
	"./00002/00002-01/00002-01-06/i am a green alligator.mp3": [
		2957,
		1632
	],
	"./00002/00002-01/00002-01-06/i am a green frog.mp3": [
		2958,
		1633
	],
	"./00002/00002-01/00002-01-06/i am a green grasshopper.mp3": [
		2959,
		1634
	],
	"./00002/00002-01/00002-01-06/i am a green praying mantis.mp3": [
		2960,
		1635
	],
	"./00002/00002-01/00002-01-06/i am a green turtle.mp3": [
		2961,
		1636
	],
	"./00002/00002-01/00002-01-06/i can hide from the alligator.mp3": [
		2962,
		1637
	],
	"./00002/00002-01/00002-01-06/i can hide from the frog.mp3": [
		2963,
		1638
	],
	"./00002/00002-01/00002-01-06/i can hide in the leaves.mp3": [
		2964,
		1639
	],
	"./00002/00002-01/00002-01-06/intro.mp3": [
		485
	],
	"./00002/00002-01/00002-01-06/main idea.mp3": [
		866
	],
	"./00002/00002-01/00002-01-06/the green book.mp3": [
		2965,
		1640
	],
	"./00002/00002-01/00002-01-06/we are green aphids.mp3": [
		2966,
		1641
	],
	"./00002/00002-01/00002-01-06/we are green dinosaurs.mp3": [
		2967,
		1642
	],
	"./00002/00002-01/00002-01-06/we can hide in the leaves too.mp3": [
		2968,
		1643
	],
	"./00002/00002-01/00002-01-06/you can not see me.mp3": [
		2969,
		1644
	],
	"./00002/00002-01/00002-01-06/you can not see us.mp3": [
		2970,
		1645
	],
	"./00002/00002-01/00002-01-07/animals that are brown.mp3": [
		2971,
		1646
	],
	"./00002/00002-01/00002-01-07/i saw 2 brown birds.mp3": [
		2972,
		1647
	],
	"./00002/00002-01/00002-01-07/i saw 2 brown rabbits.mp3": [
		2973,
		1648
	],
	"./00002/00002-01/00002-01-07/i saw 2 little brown bears.mp3": [
		2974,
		1649
	],
	"./00002/00002-01/00002-01-07/i saw 2 little brown deer.mp3": [
		2975,
		1650
	],
	"./00002/00002-01/00002-01-07/i saw a big brown bear.mp3": [
		2976,
		1651
	],
	"./00002/00002-01/00002-01-07/i saw a big brown deer.mp3": [
		2977,
		1652
	],
	"./00002/00002-01/00002-01-07/i saw a brown hedgehog.mp3": [
		2978,
		1653
	],
	"./00002/00002-01/00002-01-07/i went to the forest.mp3": [
		2979,
		1654
	],
	"./00002/00002-01/00002-01-07/intro.mp3": [
		486
	],
	"./00002/00002-01/00002-01-07/main idea.mp3": [
		867
	],
	"./00002/00002-01/00002-01-07/the brown book.mp3": [
		2980,
		1655
	],
	"./00002/00002-01/00002-01-07/what did i see.mp3": [
		2981,
		1656
	],
	"./00002/00002-01/00002-01-08/animals.mp3": [
		2982,
		1657
	],
	"./00002/00002-01/00002-01-08/intro.mp3": [
		487
	],
	"./00002/00002-01/00002-01-08/look at the ants.mp3": [
		2983,
		1658
	],
	"./00002/00002-01/00002-01-08/look at the birds.mp3": [
		2984,
		1659
	],
	"./00002/00002-01/00002-01-08/look at the cats.mp3": [
		2985,
		1660
	],
	"./00002/00002-01/00002-01-08/look at the cows.mp3": [
		2986,
		1661
	],
	"./00002/00002-01/00002-01-08/look at the dogs.mp3": [
		2987,
		1662
	],
	"./00002/00002-01/00002-01-08/look at the horses.mp3": [
		2988,
		1663
	],
	"./00002/00002-01/00002-01-08/look at the spiders.mp3": [
		2989,
		1664
	],
	"./00002/00002-01/00002-01-08/main idea.mp3": [
		868
	],
	"./00002/00002-01/00002-01-08/one of them is black.mp3": [
		2990,
		1665
	],
	"./00002/00002-01/00002-01-08/one of them is red.mp3": [
		2991,
		1666
	],
	"./00002/00002-01/00002-01-08/one of them is white.mp3": [
		2992,
		1667
	],
	"./00002/00002-01/00002-01-08/the black book.mp3": [
		2993,
		1668
	],
	"./00002/00002-01/00002-01-09/animals that live in the snow.mp3": [
		2994,
		1669
	],
	"./00002/00002-01/00002-01-09/he is white in the winter.mp3": [
		2995,
		1670
	],
	"./00002/00002-01/00002-01-09/he is white like the snow.mp3": [
		2996,
		1671
	],
	"./00002/00002-01/00002-01-09/intro.mp3": [
		488
	],
	"./00002/00002-01/00002-01-09/main idea.mp3": [
		869
	],
	"./00002/00002-01/00002-01-09/she is white in the winter.mp3": [
		2997,
		1672
	],
	"./00002/00002-01/00002-01-09/she is white like the snow.mp3": [
		2998,
		1673
	],
	"./00002/00002-01/00002-01-09/the arctic fox is white.mp3": [
		2999,
		1674
	],
	"./00002/00002-01/00002-01-09/the arctic wolf is white.mp3": [
		3000,
		1675
	],
	"./00002/00002-01/00002-01-09/the polar bear is white.mp3": [
		3001,
		1676
	],
	"./00002/00002-01/00002-01-09/the ptarmigan is white.mp3": [
		3002,
		1677
	],
	"./00002/00002-01/00002-01-09/the seal pup is white.mp3": [
		3003,
		1678
	],
	"./00002/00002-01/00002-01-09/the snowshoe rabbit is white.mp3": [
		3004,
		1679
	],
	"./00002/00002-01/00002-01-09/the snowy owl is white.mp3": [
		3005,
		1680
	],
	"./00002/00002-01/00002-01-09/the white book.mp3": [
		3006,
		1681
	],
	"./00002/00002-01/00002-01-10/i see a pink flamingo.mp3": [
		3007,
		1682
	],
	"./00002/00002-01/00002-01-10/i see a pink hermit crab.mp3": [
		3008,
		1683
	],
	"./00002/00002-01/00002-01-10/i see a pink pig.mp3": [
		3009,
		1684
	],
	"./00002/00002-01/00002-01-10/i see a pink rabbit.mp3": [
		3010,
		1685
	],
	"./00002/00002-01/00002-01-10/i see a pink shell.mp3": [
		3011,
		1686
	],
	"./00002/00002-01/00002-01-10/i see a pink starfish.mp3": [
		3012,
		1687
	],
	"./00002/00002-01/00002-01-10/i see some pink flowers.mp3": [
		3013,
		1688
	],
	"./00002/00002-01/00002-01-10/i spy something pink.mp3": [
		3014,
		1689
	],
	"./00002/00002-01/00002-01-10/i spy with my little eye said the boy.mp3": [
		3015,
		1690
	],
	"./00002/00002-01/00002-01-10/i spy with my little eye said the girl.mp3": [
		3016,
		1691
	],
	"./00002/00002-01/00002-01-10/intro.mp3": [
		489
	],
	"./00002/00002-01/00002-01-10/main idea.mp3": [
		870
	],
	"./00002/00002-01/00002-01-10/the pig likes the flowers.mp3": [
		3017,
		1692
	],
	"./00002/00002-01/00002-01-10/the pink book.mp3": [
		3018,
		1693
	],
	"./00002/00002-01/00002-01-10/things that are pink.mp3": [
		3019,
		1694
	],
	"./00002/00002-01/color town.mp3": [
		3020,
		1695
	],
	"./00002/00002-01/colors.mp3": [
		3021,
		1696
	],
	"./00002/00002-02/00002-02-01/animals.mp3": [
		3022,
		1697
	],
	"./00002/00002-02/00002-02-01/here is a bear.mp3": [
		3023,
		1698
	],
	"./00002/00002-02/00002-02-01/here is a mitten.mp3": [
		3024,
		1699
	],
	"./00002/00002-02/00002-02-01/intro.mp3": [
		490
	],
	"./00002/00002-02/00002-02-01/look at the bear.mp3": [
		3025,
		1700
	],
	"./00002/00002-02/00002-02-01/look at the fox.mp3": [
		3026,
		1701
	],
	"./00002/00002-02/00002-02-01/look at the mitten.mp3": [
		3027,
		1702
	],
	"./00002/00002-02/00002-02-01/look at the mouse.mp3": [
		3028,
		1703
	],
	"./00002/00002-02/00002-02-01/look at the owl.mp3": [
		3029,
		1704
	],
	"./00002/00002-02/00002-02-01/look at the rabbit.mp3": [
		3030,
		1705
	],
	"./00002/00002-02/00002-02-01/main idea.mp3": [
		871
	],
	"./00002/00002-02/00002-02-01/the fox is going in the mitten.mp3": [
		3031,
		1706
	],
	"./00002/00002-02/00002-02-01/the mitten.mp3": [
		3032,
		1707
	],
	"./00002/00002-02/00002-02-01/the mouse is going in the mitten.mp3": [
		3033,
		1708
	],
	"./00002/00002-02/00002-02-01/the owl is going in the mitten.mp3": [
		3034,
		1709
	],
	"./00002/00002-02/00002-02-01/the rabbit is going in the mitten.mp3": [
		3035,
		1710
	],
	"./00002/00002-02/00002-02-02/dogs.mp3": [
		3036,
		1711
	],
	"./00002/00002-02/00002-02-02/here they are.mp3": [
		3037,
		1712
	],
	"./00002/00002-02/00002-02-02/intro.mp3": [
		491
	],
	"./00002/00002-02/00002-02-02/look in the bathroom.mp3": [
		3038,
		1713
	],
	"./00002/00002-02/00002-02-02/look in the bedroom.mp3": [
		3039,
		1714
	],
	"./00002/00002-02/00002-02-02/look in the box.mp3": [
		3040,
		1715
	],
	"./00002/00002-02/00002-02-02/look in the kitchen.mp3": [
		3041,
		1716
	],
	"./00002/00002-02/00002-02-02/look in the living room.mp3": [
		3042,
		1717
	],
	"./00002/00002-02/00002-02-02/look in the shower.mp3": [
		3043,
		1718
	],
	"./00002/00002-02/00002-02-02/look.mp3": [
		3044,
		1719
	],
	"./00002/00002-02/00002-02-02/main idea.mp3": [
		872
	],
	"./00002/00002-02/00002-02-02/where are the puppies.mp3": [
		3045,
		1720
	],
	"./00002/00002-02/00002-02-03/farm animals.mp3": [
		3046,
		1721
	],
	"./00002/00002-02/00002-02-03/intro.mp3": [
		492
	],
	"./00002/00002-02/00002-02-03/main idea.mp3": [
		873
	],
	"./00002/00002-02/00002-02-03/the animals get off the bus.mp3": [
		3047,
		1722
	],
	"./00002/00002-02/00002-02-03/the bus ride.mp3": [
		3048,
		1723
	],
	"./00002/00002-02/00002-02-03/the cats go on the bus.mp3": [
		3049,
		1724
	],
	"./00002/00002-02/00002-02-03/the cows go on the bus.mp3": [
		3050,
		1725
	],
	"./00002/00002-02/00002-02-03/the dogs go on the bus.mp3": [
		3051,
		1726
	],
	"./00002/00002-02/00002-02-03/the ducks go on the bus.mp3": [
		3052,
		1727
	],
	"./00002/00002-02/00002-02-03/the horses go on the bus.mp3": [
		3053,
		1728
	],
	"./00002/00002-02/00002-02-03/the lions go on the bus.mp3": [
		3054,
		1729
	],
	"./00002/00002-02/00002-02-03/the sheep go on the bus.mp3": [
		3055,
		1730
	],
	"./00002/00002-02/00002-02-03/then the bus goes fast.mp3": [
		3056,
		1731
	],
	"./00002/00002-02/00002-02-04/can i play with the hedgehog.mp3": [
		3057,
		1732
	],
	"./00002/00002-02/00002-02-04/can i play with the kitten.mp3": [
		3058,
		1733
	],
	"./00002/00002-02/00002-02-04/can i play with the owl.mp3": [
		3059,
		1734
	],
	"./00002/00002-02/00002-02-04/can i play with the rabbit.mp3": [
		3060,
		1735
	],
	"./00002/00002-02/00002-02-04/can i play with the skunk.mp3": [
		3061,
		1736
	],
	"./00002/00002-02/00002-02-04/can i play with the snake.mp3": [
		3062,
		1737
	],
	"./00002/00002-02/00002-02-04/can i play with the turtle.mp3": [
		3063,
		1738
	],
	"./00002/00002-02/00002-02-04/dogs.mp3": [
		3064,
		1739
	],
	"./00002/00002-02/00002-02-04/intro.mp3": [
		493
	],
	"./00002/00002-02/00002-02-04/main idea.mp3": [
		874
	],
	"./00002/00002-02/00002-02-04/no no puppy.mp3": [
		3065,
		1740
	],
	"./00002/00002-02/00002-02-04/no puppy no.mp3": [
		3066,
		1741
	],
	"./00002/00002-02/00002-02-04/no puppy.mp3": [
		3067,
		1742
	],
	"./00002/00002-02/00002-02-04/yes yes puppy.mp3": [
		3068,
		1743
	],
	"./00002/00002-02/00002-02-04/you can not play with the hedgehog.mp3": [
		3069,
		1744
	],
	"./00002/00002-02/00002-02-04/you can not play with the owl.mp3": [
		3070,
		1745
	],
	"./00002/00002-02/00002-02-04/you can not play with the rabbit.mp3": [
		3071,
		1746
	],
	"./00002/00002-02/00002-02-04/you can not play with the skunk.mp3": [
		3072,
		1747
	],
	"./00002/00002-02/00002-02-04/you can not play with the snake.mp3": [
		3073,
		1748
	],
	"./00002/00002-02/00002-02-04/you can not play with the turtle.mp3": [
		3074,
		1749
	],
	"./00002/00002-02/00002-02-04/you can play with the kitten.mp3": [
		3075,
		1750
	],
	"./00002/00002-02/00002-02-05/animals that are gray.mp3": [
		3076,
		1751
	],
	"./00002/00002-02/00002-02-05/i love black and white.mp3": [
		3077,
		1752
	],
	"./00002/00002-02/00002-02-05/i love blue.mp3": [
		3078,
		1753
	],
	"./00002/00002-02/00002-02-05/i love gray said the elephant.mp3": [
		3079,
		1754
	],
	"./00002/00002-02/00002-02-05/i love green.mp3": [
		3080,
		1755
	],
	"./00002/00002-02/00002-02-05/i love orange said the goat.mp3": [
		3081,
		1756
	],
	"./00002/00002-02/00002-02-05/i love purple said the girl.mp3": [
		3082,
		1757
	],
	"./00002/00002-02/00002-02-05/i love red.mp3": [
		3083,
		1758
	],
	"./00002/00002-02/00002-02-05/i love to paint said the boy.mp3": [
		3084,
		1759
	],
	"./00002/00002-02/00002-02-05/i love to paint said the mouse.mp3": [
		3085,
		1760
	],
	"./00002/00002-02/00002-02-05/i love to paint said the rabbit.mp3": [
		3086,
		1761
	],
	"./00002/00002-02/00002-02-05/i love to paint said the zebra.mp3": [
		3087,
		1762
	],
	"./00002/00002-02/00002-02-05/i love to paint.mp3": [
		3088,
		1763
	],
	"./00002/00002-02/00002-02-05/intro.mp3": [
		494
	],
	"./00002/00002-02/00002-02-05/main idea.mp3": [
		875
	],
	"./00002/00002-02/00002-02-06/food.mp3": [
		3089,
		1764
	],
	"./00002/00002-02/00002-02-06/intro.mp3": [
		495
	],
	"./00002/00002-02/00002-02-06/look at the alligator.mp3": [
		3090,
		1765
	],
	"./00002/00002-02/00002-02-06/look at the cow.mp3": [
		3091,
		1766
	],
	"./00002/00002-02/00002-02-06/look at the dog.mp3": [
		3092,
		1767
	],
	"./00002/00002-02/00002-02-06/look at the gingerbread man.mp3": [
		3093,
		1768
	],
	"./00002/00002-02/00002-02-06/look at the horse.mp3": [
		3094,
		1769
	],
	"./00002/00002-02/00002-02-06/look at the sheep.mp3": [
		3095,
		1770
	],
	"./00002/00002-02/00002-02-06/main idea.mp3": [
		876
	],
	"./00002/00002-02/00002-02-06/no said the gingerbread man.mp3": [
		3096,
		1771
	],
	"./00002/00002-02/00002-02-06/stop said the alligator.mp3": [
		3097,
		1772
	],
	"./00002/00002-02/00002-02-06/stop said the cow.mp3": [
		3098,
		1773
	],
	"./00002/00002-02/00002-02-06/stop said the dog.mp3": [
		3099,
		1774
	],
	"./00002/00002-02/00002-02-06/stop said the horse.mp3": [
		3100,
		1775
	],
	"./00002/00002-02/00002-02-06/stop said the sheep.mp3": [
		3101,
		1776
	],
	"./00002/00002-02/00002-02-06/the gingerbread man.mp3": [
		3102,
		1777
	],
	"./00002/00002-02/00002-02-06/you cant catch me.mp3": [
		3103,
		1778
	],
	"./00002/00002-02/00002-02-07/0 little frogs sat on a log.mp3": [
		3104,
		1779
	],
	"./00002/00002-02/00002-02-07/1 frog jumped into the pond.mp3": [
		3105,
		1780
	],
	"./00002/00002-02/00002-02-07/1 little frog sat on a log.mp3": [
		3106,
		1781
	],
	"./00002/00002-02/00002-02-07/2 little frogs sat on a log.mp3": [
		3107,
		1782
	],
	"./00002/00002-02/00002-02-07/3 little frogs sat on a log.mp3": [
		3108,
		1783
	],
	"./00002/00002-02/00002-02-07/4 little frogs sat on a log.mp3": [
		3109,
		1784
	],
	"./00002/00002-02/00002-02-07/5 little frogs sat in the pond.mp3": [
		3110,
		1785
	],
	"./00002/00002-02/00002-02-07/5 little frogs sat on a log.mp3": [
		3111,
		1786
	],
	"./00002/00002-02/00002-02-07/5 little frogs.mp3": [
		3112,
		1787
	],
	"./00002/00002-02/00002-02-07/intro.mp3": [
		496
	],
	"./00002/00002-02/00002-02-07/main idea.mp3": [
		877
	],
	"./00002/00002-02/00002-02-07/she jumped into the pond.mp3": [
		3113,
		1788
	],
	"./00002/00002-02/00002-02-07/water animals.mp3": [
		3114,
		1789
	],
	"./00002/00002-02/00002-02-07/where are the frogs.mp3": [
		3115,
		1790
	],
	"./00002/00002-02/00002-02-08/can i have a crocodile said sam.mp3": [
		3116,
		1791
	],
	"./00002/00002-02/00002-02-08/can i have a dog said sam.mp3": [
		3117,
		1792
	],
	"./00002/00002-02/00002-02-08/can i have a giraffe said sam.mp3": [
		3118,
		1793
	],
	"./00002/00002-02/00002-02-08/can i have a pet.mp3": [
		3119,
		1794
	],
	"./00002/00002-02/00002-02-08/can i have an elephant said sam.mp3": [
		3120,
		1795
	],
	"./00002/00002-02/00002-02-08/intro.mp3": [
		497
	],
	"./00002/00002-02/00002-02-08/main idea.mp3": [
		878
	],
	"./00002/00002-02/00002-02-08/no monkeys.mp3": [
		3121,
		1796
	],
	"./00002/00002-02/00002-02-08/no said dad.mp3": [
		3122,
		1797
	],
	"./00002/00002-02/00002-02-08/no said mom and dad.mp3": [
		3123,
		1798
	],
	"./00002/00002-02/00002-02-08/no said mom.mp3": [
		3124,
		1799
	],
	"./00002/00002-02/00002-02-08/pets.mp3": [
		3125,
		1800
	],
	"./00002/00002-02/00002-02-08/sam said can i have a monkey.mp3": [
		3126,
		1801
	],
	"./00002/00002-02/00002-02-08/sam said can i have a snake.mp3": [
		3127,
		1802
	],
	"./00002/00002-02/00002-02-08/sam said can i have an ostrich.mp3": [
		3128,
		1803
	],
	"./00002/00002-02/00002-02-08/yes said mom and dad.mp3": [
		3129,
		1804
	],
	"./00002/00002-02/00002-02-09/i like to play on the horse said the boy.mp3": [
		3130,
		1805
	],
	"./00002/00002-02/00002-02-09/i like to play on the horse said the monster.mp3": [
		3131,
		1806
	],
	"./00002/00002-02/00002-02-09/i like to play on the slide said the boy.mp3": [
		3132,
		1807
	],
	"./00002/00002-02/00002-02-09/i like to play on the swings said the girl.mp3": [
		3133,
		1808
	],
	"./00002/00002-02/00002-02-09/i like to play on the swings said the monster.mp3": [
		3134,
		1809
	],
	"./00002/00002-02/00002-02-09/intro.mp3": [
		498
	],
	"./00002/00002-02/00002-02-09/main idea.mp3": [
		879
	],
	"./00002/00002-02/00002-02-09/the playground.mp3": [
		3135,
		1810
	],
	"./00002/00002-02/00002-02-09/toys.mp3": [
		3136,
		1811
	],
	"./00002/00002-02/00002-02-09/we like to play on the seesaw said the kids.mp3": [
		3137,
		1812
	],
	"./00002/00002-02/00002-02-09/we like to play on the slide said the monsters.mp3": [
		3138,
		1813
	],
	"./00002/00002-02/00002-02-10/farm animals.mp3": [
		3139,
		1814
	],
	"./00002/00002-02/00002-02-10/hello cat i like your hat.mp3": [
		3140,
		1815
	],
	"./00002/00002-02/00002-02-10/hello chicken i like your hat.mp3": [
		3141,
		1816
	],
	"./00002/00002-02/00002-02-10/hello cow i like your hat.mp3": [
		3142,
		1817
	],
	"./00002/00002-02/00002-02-10/hello dog i like your hat.mp3": [
		3143,
		1818
	],
	"./00002/00002-02/00002-02-10/hello goat i like your hat.mp3": [
		3144,
		1819
	],
	"./00002/00002-02/00002-02-10/hello horse i like your hat.mp3": [
		3145,
		1820
	],
	"./00002/00002-02/00002-02-10/hello sheep i like your hat.mp3": [
		3146,
		1821
	],
	"./00002/00002-02/00002-02-10/intro.mp3": [
		499
	],
	"./00002/00002-02/00002-02-10/main idea.mp3": [
		880
	],
	"./00002/00002-02/00002-02-10/thank you.mp3": [
		3147,
		1822
	],
	"./00002/00002-02/00002-02-10/you can have it.mp3": [
		3148,
		1823
	],
	"./00002/00002-02/00002-02-11/animals.mp3": [
		3149,
		1824
	],
	"./00002/00002-02/00002-02-11/intro.mp3": [
		500
	],
	"./00002/00002-02/00002-02-11/look at the bat.mp3": [
		3150,
		1825
	],
	"./00002/00002-02/00002-02-11/look at the cat.mp3": [
		3151,
		1826
	],
	"./00002/00002-02/00002-02-11/look at the dog.mp3": [
		3152,
		1827
	],
	"./00002/00002-02/00002-02-11/look at the elephant.mp3": [
		3153,
		1828
	],
	"./00002/00002-02/00002-02-11/look at the lion.mp3": [
		3154,
		1829
	],
	"./00002/00002-02/00002-02-11/look at the octopus.mp3": [
		3155,
		1830
	],
	"./00002/00002-02/00002-02-11/look at the snake.mp3": [
		3156,
		1831
	],
	"./00002/00002-02/00002-02-11/main idea.mp3": [
		881
	],
	"./00002/00002-02/00002-02-11/the bat likes ice cream.mp3": [
		3157,
		1832
	],
	"./00002/00002-02/00002-02-11/the cat likes ice cream.mp3": [
		3158,
		1833
	],
	"./00002/00002-02/00002-02-11/the dog likes ice cream.mp3": [
		3159,
		1834
	],
	"./00002/00002-02/00002-02-11/the elephant likes ice cream.mp3": [
		3160,
		1835
	],
	"./00002/00002-02/00002-02-11/the lion likes ice cream.mp3": [
		3161,
		1836
	],
	"./00002/00002-02/00002-02-11/the octopus loves ice cream.mp3": [
		3162,
		1837
	],
	"./00002/00002-02/00002-02-11/the snake likes ice cream.mp3": [
		3163,
		1838
	],
	"./00002/00002-02/00002-02-11/we like ice cream.mp3": [
		3164,
		1839
	],
	"./00002/00002-02/story park.mp3": [
		3165,
		1840
	],
	"./00002/00002-03/00002-03-01/a sea turtle lives in the sea.mp3": [
		3166,
		1841
	],
	"./00002/00002-03/00002-03-01/a seahorse lives in the sea.mp3": [
		3167,
		1842
	],
	"./00002/00002-03/00002-03-01/a shark lives in the sea.mp3": [
		3168,
		1843
	],
	"./00002/00002-03/00002-03-01/a whale lives in the sea.mp3": [
		3169,
		1844
	],
	"./00002/00002-03/00002-03-01/here is a dolphin.mp3": [
		3170,
		1845
	],
	"./00002/00002-03/00002-03-01/here is a sea turtle.mp3": [
		3171,
		1846
	],
	"./00002/00002-03/00002-03-01/here is a seahorse.mp3": [
		3172,
		1847
	],
	"./00002/00002-03/00002-03-01/intro.mp3": [
		501
	],
	"./00002/00002-03/00002-03-01/look at the crab.mp3": [
		3173,
		1848
	],
	"./00002/00002-03/00002-03-01/look at the octopus.mp3": [
		3174,
		1849
	],
	"./00002/00002-03/00002-03-01/look at the shark.mp3": [
		3175,
		1850
	],
	"./00002/00002-03/00002-03-01/look at the whale.mp3": [
		3176,
		1851
	],
	"./00002/00002-03/00002-03-01/main idea.mp3": [
		882
	],
	"./00002/00002-03/00002-03-01/sea animals.mp3": [
		3177,
		1852
	],
	"./00002/00002-03/00002-03-01/the crab lives in the sea.mp3": [
		3178,
		1853
	],
	"./00002/00002-03/00002-03-01/the dolphin lives in the sea.mp3": [
		3179,
		1854
	],
	"./00002/00002-03/00002-03-01/the octopus lives in the sea.mp3": [
		3180,
		1855
	],
	"./00002/00002-03/00002-03-02/intro.mp3": [
		502
	],
	"./00002/00002-03/00002-03-02/look at the beaver.mp3": [
		3181,
		1856
	],
	"./00002/00002-03/00002-03-02/look at the dragonfly.mp3": [
		3182,
		1857
	],
	"./00002/00002-03/00002-03-02/look at the duck.mp3": [
		3183,
		1858
	],
	"./00002/00002-03/00002-03-02/look at the frog.mp3": [
		3184,
		1859
	],
	"./00002/00002-03/00002-03-02/look at the salamander.mp3": [
		3185,
		1860
	],
	"./00002/00002-03/00002-03-02/look at the toad.mp3": [
		3186,
		1861
	],
	"./00002/00002-03/00002-03-02/look at the turtle.mp3": [
		3187,
		1862
	],
	"./00002/00002-03/00002-03-02/main idea.mp3": [
		883
	],
	"./00002/00002-03/00002-03-02/me too said the dragonfly.mp3": [
		3188,
		1863
	],
	"./00002/00002-03/00002-03-02/pond animals.mp3": [
		3189,
		1864
	],
	"./00002/00002-03/00002-03-02/the beaver lives at the pond.mp3": [
		3190,
		1865
	],
	"./00002/00002-03/00002-03-02/the dragonfly lives at the pond.mp3": [
		3191,
		1866
	],
	"./00002/00002-03/00002-03-02/the duck lives at the pond too.mp3": [
		3192,
		1867
	],
	"./00002/00002-03/00002-03-02/the frog lives at the pond.mp3": [
		3193,
		1868
	],
	"./00002/00002-03/00002-03-02/the salamander lives at the pond.mp3": [
		3194,
		1869
	],
	"./00002/00002-03/00002-03-02/the toad lives at the pond.mp3": [
		3195,
		1870
	],
	"./00002/00002-03/00002-03-02/the turtle lives at the pond.mp3": [
		3196,
		1871
	],
	"./00002/00002-03/00002-03-03/i am a giraffe.mp3": [
		3197,
		1872
	],
	"./00002/00002-03/00002-03-03/i am a hippo.mp3": [
		3198,
		1873
	],
	"./00002/00002-03/00002-03-03/i am a lion.mp3": [
		3199,
		1874
	],
	"./00002/00002-03/00002-03-03/i am a rhino.mp3": [
		3200,
		1875
	],
	"./00002/00002-03/00002-03-03/i am a tiger.mp3": [
		3201,
		1876
	],
	"./00002/00002-03/00002-03-03/i am a wild animal.mp3": [
		3202,
		1877
	],
	"./00002/00002-03/00002-03-03/i am a zebra.mp3": [
		3203,
		1878
	],
	"./00002/00002-03/00002-03-03/intro.mp3": [
		503
	],
	"./00002/00002-03/00002-03-03/main idea.mp3": [
		884
	],
	"./00002/00002-03/00002-03-03/we are kangaroos.mp3": [
		3204,
		1879
	],
	"./00002/00002-03/00002-03-03/we are wild animals too.mp3": [
		3205,
		1880
	],
	"./00002/00002-03/00002-03-03/wild animals.mp3": [
		3206,
		1881
	],
	"./00002/00002-03/00002-03-04/here is my pet.mp3": [
		3207,
		1882
	],
	"./00002/00002-03/00002-03-04/i love my cat.mp3": [
		3208,
		1883
	],
	"./00002/00002-03/00002-03-04/i love my dinosaur.mp3": [
		3209,
		1884
	],
	"./00002/00002-03/00002-03-04/i love my dog.mp3": [
		3210,
		1885
	],
	"./00002/00002-03/00002-03-04/i love my fish.mp3": [
		3211,
		1886
	],
	"./00002/00002-03/00002-03-04/i love my rabbit.mp3": [
		3212,
		1887
	],
	"./00002/00002-03/00002-03-04/i love my snake.mp3": [
		3213,
		1888
	],
	"./00002/00002-03/00002-03-04/i love my turtle.mp3": [
		3214,
		1889
	],
	"./00002/00002-03/00002-03-04/intro.mp3": [
		504
	],
	"./00002/00002-03/00002-03-04/look at my pet.mp3": [
		3215,
		1890
	],
	"./00002/00002-03/00002-03-04/main idea.mp3": [
		885
	],
	"./00002/00002-03/00002-03-04/pets.mp3": [
		3216,
		1891
	],
	"./00002/00002-03/00002-03-05/forest animals.mp3": [
		3217,
		1892
	],
	"./00002/00002-03/00002-03-05/here is a bear.mp3": [
		3218,
		1893
	],
	"./00002/00002-03/00002-03-05/here is a deer.mp3": [
		3219,
		1894
	],
	"./00002/00002-03/00002-03-05/here is a rabbit.mp3": [
		3220,
		1895
	],
	"./00002/00002-03/00002-03-05/i see a bear.mp3": [
		3221,
		1896
	],
	"./00002/00002-03/00002-03-05/i see a bird.mp3": [
		3222,
		1897
	],
	"./00002/00002-03/00002-03-05/i see a deer.mp3": [
		3223,
		1898
	],
	"./00002/00002-03/00002-03-05/i see a fox.mp3": [
		3224,
		1899
	],
	"./00002/00002-03/00002-03-05/i see a hedgehog.mp3": [
		3225,
		1900
	],
	"./00002/00002-03/00002-03-05/i see a rabbit.mp3": [
		3226,
		1901
	],
	"./00002/00002-03/00002-03-05/i see a squirrel.mp3": [
		3227,
		1902
	],
	"./00002/00002-03/00002-03-05/intro.mp3": [
		505
	],
	"./00002/00002-03/00002-03-05/look at the bear.mp3": [
		3228,
		1903
	],
	"./00002/00002-03/00002-03-05/look at the bird.mp3": [
		3229,
		1904
	],
	"./00002/00002-03/00002-03-05/look at the deer.mp3": [
		3230,
		1905
	],
	"./00002/00002-03/00002-03-05/look at the fox.mp3": [
		3231,
		1906
	],
	"./00002/00002-03/00002-03-05/look at the hedgehog.mp3": [
		3232,
		1907
	],
	"./00002/00002-03/00002-03-05/look at the owl.mp3": [
		3233,
		1908
	],
	"./00002/00002-03/00002-03-05/look at the rabbit.mp3": [
		3234,
		1909
	],
	"./00002/00002-03/00002-03-05/look at the squirrel.mp3": [
		3235,
		1910
	],
	"./00002/00002-03/00002-03-05/main idea.mp3": [
		886
	],
	"./00002/00002-03/00002-03-06/farm animals.mp3": [
		3236,
		1911
	],
	"./00002/00002-03/00002-03-06/he lives on a farm.mp3": [
		3237,
		1912
	],
	"./00002/00002-03/00002-03-06/here is a chicken.mp3": [
		3238,
		1913
	],
	"./00002/00002-03/00002-03-06/here is a cow.mp3": [
		3239,
		1914
	],
	"./00002/00002-03/00002-03-06/here is a donkey.mp3": [
		3240,
		1915
	],
	"./00002/00002-03/00002-03-06/here is a goat.mp3": [
		3241,
		1916
	],
	"./00002/00002-03/00002-03-06/here is a horse.mp3": [
		3242,
		1917
	],
	"./00002/00002-03/00002-03-06/here is a pig.mp3": [
		3243,
		1918
	],
	"./00002/00002-03/00002-03-06/here is a sheep.mp3": [
		3244,
		1919
	],
	"./00002/00002-03/00002-03-06/intro.mp3": [
		506
	],
	"./00002/00002-03/00002-03-06/look at the cow.mp3": [
		3245,
		1920
	],
	"./00002/00002-03/00002-03-06/look at the donkey.mp3": [
		3246,
		1921
	],
	"./00002/00002-03/00002-03-06/look at the horse.mp3": [
		3247,
		1922
	],
	"./00002/00002-03/00002-03-06/main idea.mp3": [
		887
	],
	"./00002/00002-03/00002-03-06/she lives on a farm.mp3": [
		3248,
		1923
	],
	"./00002/00002-03/00002-03-07/animals that live in the snow.mp3": [
		3249,
		1924
	],
	"./00002/00002-03/00002-03-07/arctic animals.mp3": [
		3250,
		1925
	],
	"./00002/00002-03/00002-03-07/he lives in the snow.mp3": [
		3251,
		1926
	],
	"./00002/00002-03/00002-03-07/intro.mp3": [
		507
	],
	"./00002/00002-03/00002-03-07/main idea.mp3": [
		888
	],
	"./00002/00002-03/00002-03-07/she lives in the snow.mp3": [
		3252,
		1927
	],
	"./00002/00002-03/00002-03-07/the arctic fox is white.mp3": [
		3253,
		1928
	],
	"./00002/00002-03/00002-03-07/the arctic wolf is white.mp3": [
		3254,
		1929
	],
	"./00002/00002-03/00002-03-07/the bird is white.mp3": [
		3255,
		1930
	],
	"./00002/00002-03/00002-03-07/the polar bear is white.mp3": [
		3256,
		1931
	],
	"./00002/00002-03/00002-03-07/the seal is white.mp3": [
		3257,
		1932
	],
	"./00002/00002-03/00002-03-07/the snowshoe rabbit is white.mp3": [
		3258,
		1933
	],
	"./00002/00002-03/00002-03-07/the snowy owl is white.mp3": [
		3259,
		1934
	],
	"./00002/00002-03/00002-03-08/desert animals.mp3": [
		3260,
		1935
	],
	"./00002/00002-03/00002-03-08/i am a big horned sheep.mp3": [
		3261,
		1936
	],
	"./00002/00002-03/00002-03-08/i am a bighorn sheep.mp3": [
		3262,
		1937
	],
	"./00002/00002-03/00002-03-08/i am a camel.mp3": [
		3263,
		1938
	],
	"./00002/00002-03/00002-03-08/i am a fennec fox.mp3": [
		3264,
		1939
	],
	"./00002/00002-03/00002-03-08/i am a fox.mp3": [
		3265,
		1940
	],
	"./00002/00002-03/00002-03-08/i am a rabbit.mp3": [
		3266,
		1941
	],
	"./00002/00002-03/00002-03-08/i am a snake.mp3": [
		3267,
		1942
	],
	"./00002/00002-03/00002-03-08/i am a spider.mp3": [
		3268,
		1943
	],
	"./00002/00002-03/00002-03-08/i am an iguana.mp3": [
		3269,
		1944
	],
	"./00002/00002-03/00002-03-08/i live in the desert too.mp3": [
		3270,
		1945
	],
	"./00002/00002-03/00002-03-08/i live in the desert.mp3": [
		3271,
		1946
	],
	"./00002/00002-03/00002-03-08/intro.mp3": [
		508
	],
	"./00002/00002-03/00002-03-08/main idea.mp3": [
		889
	],
	"./00002/00002-03/00002-03-09/i am a butterfly.mp3": [
		3272,
		1947
	],
	"./00002/00002-03/00002-03-09/i am a frog.mp3": [
		3273,
		1948
	],
	"./00002/00002-03/00002-03-09/i am a jaguar.mp3": [
		3274,
		1949
	],
	"./00002/00002-03/00002-03-09/i am a monkey.mp3": [
		3275,
		1950
	],
	"./00002/00002-03/00002-03-09/i am a parrot.mp3": [
		3276,
		1951
	],
	"./00002/00002-03/00002-03-09/i am a snake.mp3": [
		3277,
		1952
	],
	"./00002/00002-03/00002-03-09/i am a toucan.mp3": [
		3278,
		1953
	],
	"./00002/00002-03/00002-03-09/i live in the rainforest too.mp3": [
		3279,
		1954
	],
	"./00002/00002-03/00002-03-09/i live in the rainforest.mp3": [
		3280,
		1955
	],
	"./00002/00002-03/00002-03-09/intro.mp3": [
		509
	],
	"./00002/00002-03/00002-03-09/main idea.mp3": [
		890
	],
	"./00002/00002-03/00002-03-09/rainforest animals.mp3": [
		3281,
		1956
	],
	"./00002/00002-03/00002-03-10/here is a cat.mp3": [
		3282,
		1957
	],
	"./00002/00002-03/00002-03-10/here is a dog.mp3": [
		3283,
		1958
	],
	"./00002/00002-03/00002-03-10/here is a horse.mp3": [
		3284,
		1959
	],
	"./00002/00002-03/00002-03-10/i am a dog.mp3": [
		3285,
		1960
	],
	"./00002/00002-03/00002-03-10/i am a lion.mp3": [
		3286,
		1961
	],
	"./00002/00002-03/00002-03-10/i am a parrot.mp3": [
		3287,
		1962
	],
	"./00002/00002-03/00002-03-10/i am a zebra.mp3": [
		3288,
		1963
	],
	"./00002/00002-03/00002-03-10/i am an owl.mp3": [
		3289,
		1964
	],
	"./00002/00002-03/00002-03-10/intro.mp3": [
		510
	],
	"./00002/00002-03/00002-03-10/is it tame.mp3": [
		3290,
		1965
	],
	"./00002/00002-03/00002-03-10/is it wild is it tame.mp3": [
		3291,
		1966
	],
	"./00002/00002-03/00002-03-10/is it wild.mp3": [
		3292,
		1967
	],
	"./00002/00002-03/00002-03-10/look at the lion.mp3": [
		3293,
		1968
	],
	"./00002/00002-03/00002-03-10/look at the owl.mp3": [
		3294,
		1969
	],
	"./00002/00002-03/00002-03-10/look at the parrot.mp3": [
		3295,
		1970
	],
	"./00002/00002-03/00002-03-10/look at the zebra.mp3": [
		3296,
		1971
	],
	"./00002/00002-03/00002-03-10/main idea.mp3": [
		891
	],
	"./00002/00002-03/00002-03-10/wild animals.mp3": [
		3297,
		1972
	],
	"./00002/00002-03/00002-03-10/wild or tame.mp3": [
		3298,
		1973
	],
	"./00002/00002-03/animal town.mp3": [
		3299,
		1974
	],
	"./00002/00002-03/animals.mp3": [
		3300,
		1975
	],
	"./00002/00002-04/00002-04-01/animals.mp3": [
		3301,
		1976
	],
	"./00002/00002-04/00002-04-01/i can see 1 box.mp3": [
		3302,
		1977
	],
	"./00002/00002-04/00002-04-01/i can see 1 car.mp3": [
		3303,
		1978
	],
	"./00002/00002-04/00002-04-01/i can see 1 cat.mp3": [
		3304,
		1979
	],
	"./00002/00002-04/00002-04-01/i can see 1 clock.mp3": [
		3305,
		1980
	],
	"./00002/00002-04/00002-04-01/i can see 1 dog.mp3": [
		3306,
		1981
	],
	"./00002/00002-04/00002-04-01/i can see 1 duck.mp3": [
		3307,
		1982
	],
	"./00002/00002-04/00002-04-01/i can see 1 fox.mp3": [
		3308,
		1983
	],
	"./00002/00002-04/00002-04-01/i can see 1 frog.mp3": [
		3309,
		1984
	],
	"./00002/00002-04/00002-04-01/i can see 1 hat.mp3": [
		3310,
		1985
	],
	"./00002/00002-04/00002-04-01/i can see 1 house.mp3": [
		3311,
		1986
	],
	"./00002/00002-04/00002-04-01/i can see 1 mouse.mp3": [
		3312,
		1987
	],
	"./00002/00002-04/00002-04-01/i can see 1 sock.mp3": [
		3313,
		1988
	],
	"./00002/00002-04/00002-04-01/i can see 1 star.mp3": [
		3314,
		1989
	],
	"./00002/00002-04/00002-04-01/i can see 1 truck.mp3": [
		3315,
		1990
	],
	"./00002/00002-04/00002-04-01/intro.mp3": [
		511
	],
	"./00002/00002-04/00002-04-01/main idea.mp3": [
		892
	],
	"./00002/00002-04/00002-04-01/my book of one.mp3": [
		3316,
		1991
	],
	"./00002/00002-04/00002-04-02/animals with two legs.mp3": [
		3317,
		1992
	],
	"./00002/00002-04/00002-04-02/i have two ears.mp3": [
		3318,
		1993
	],
	"./00002/00002-04/00002-04-02/i have two eyes.mp3": [
		3319,
		1994
	],
	"./00002/00002-04/00002-04-02/i have two horns.mp3": [
		3320,
		1995
	],
	"./00002/00002-04/00002-04-02/i have two humps.mp3": [
		3321,
		1996
	],
	"./00002/00002-04/00002-04-02/i have two legs.mp3": [
		3322,
		1997
	],
	"./00002/00002-04/00002-04-02/i have two tusks.mp3": [
		3323,
		1998
	],
	"./00002/00002-04/00002-04-02/i have two wings.mp3": [
		3324,
		1999
	],
	"./00002/00002-04/00002-04-02/intro.mp3": [
		512
	],
	"./00002/00002-04/00002-04-02/look at my ears said the rabbit.mp3": [
		3325,
		2000
	],
	"./00002/00002-04/00002-04-02/look at my humps said the camel.mp3": [
		3326,
		2001
	],
	"./00002/00002-04/00002-04-02/look at my tusks said the elephant.mp3": [
		3327,
		2002
	],
	"./00002/00002-04/00002-04-02/look at my wings said the bat.mp3": [
		3328,
		2003
	],
	"./00002/00002-04/00002-04-02/look said the ostrich.mp3": [
		3329,
		2004
	],
	"./00002/00002-04/00002-04-02/look said the owl.mp3": [
		3330,
		2005
	],
	"./00002/00002-04/00002-04-02/look said the rhino.mp3": [
		3331,
		2006
	],
	"./00002/00002-04/00002-04-02/main idea.mp3": [
		893
	],
	"./00002/00002-04/00002-04-02/my book of two.mp3": [
		3332,
		2007
	],
	"./00002/00002-04/00002-04-03/animals with four legs.mp3": [
		3333,
		2008
	],
	"./00002/00002-04/00002-04-03/can you see 3 boats.mp3": [
		3334,
		2009
	],
	"./00002/00002-04/00002-04-03/can you see 3 boxes.mp3": [
		3335,
		2010
	],
	"./00002/00002-04/00002-04-03/can you see 3 cakes.mp3": [
		3336,
		2011
	],
	"./00002/00002-04/00002-04-03/can you see 3 dogs.mp3": [
		3337,
		2012
	],
	"./00002/00002-04/00002-04-03/can you see 3 foxes.mp3": [
		3338,
		2013
	],
	"./00002/00002-04/00002-04-03/can you see 3 frogs.mp3": [
		3339,
		2014
	],
	"./00002/00002-04/00002-04-03/can you see 3 goats.mp3": [
		3340,
		2015
	],
	"./00002/00002-04/00002-04-03/can you see 3 hats.mp3": [
		3341,
		2016
	],
	"./00002/00002-04/00002-04-03/can you see 3 kittens.mp3": [
		3342,
		2017
	],
	"./00002/00002-04/00002-04-03/can you see 3 mittens.mp3": [
		3343,
		2018
	],
	"./00002/00002-04/00002-04-03/can you see 3 rats.mp3": [
		3344,
		2019
	],
	"./00002/00002-04/00002-04-03/can you see 3 snails.mp3": [
		3345,
		2020
	],
	"./00002/00002-04/00002-04-03/can you see 3 snakes.mp3": [
		3346,
		2021
	],
	"./00002/00002-04/00002-04-03/can you see 3 whales.mp3": [
		3347,
		2022
	],
	"./00002/00002-04/00002-04-03/intro.mp3": [
		513
	],
	"./00002/00002-04/00002-04-03/main idea.mp3": [
		894
	],
	"./00002/00002-04/00002-04-03/my book of three.mp3": [
		3348,
		2023
	],
	"./00002/00002-04/00002-04-04/here come three cars.mp3": [
		3349,
		2024
	],
	"./00002/00002-04/00002-04-04/here come three rockets.mp3": [
		3350,
		2025
	],
	"./00002/00002-04/00002-04-04/here come two boats.mp3": [
		3351,
		2026
	],
	"./00002/00002-04/00002-04-04/here come two cars.mp3": [
		3352,
		2027
	],
	"./00002/00002-04/00002-04-04/here come two helicopters.mp3": [
		3353,
		2028
	],
	"./00002/00002-04/00002-04-04/here come two planes.mp3": [
		3354,
		2029
	],
	"./00002/00002-04/00002-04-04/here come two trucks.mp3": [
		3355,
		2030
	],
	"./00002/00002-04/00002-04-04/here comes one fire truck.mp3": [
		3356,
		2031
	],
	"./00002/00002-04/00002-04-04/here comes one spaceship.mp3": [
		3357,
		2032
	],
	"./00002/00002-04/00002-04-04/intro.mp3": [
		514
	],
	"./00002/00002-04/00002-04-04/main idea.mp3": [
		895
	],
	"./00002/00002-04/00002-04-04/my book of four.mp3": [
		3358,
		2033
	],
	"./00002/00002-04/00002-04-04/vehicles.mp3": [
		3359,
		2034
	],
	"./00002/00002-04/00002-04-05/farm animals.mp3": [
		3360,
		2035
	],
	"./00002/00002-04/00002-04-05/four and one is five.mp3": [
		3361,
		2036
	],
	"./00002/00002-04/00002-04-05/i can see five farm animals.mp3": [
		3362,
		2037
	],
	"./00002/00002-04/00002-04-05/i can see four chicks.mp3": [
		3363,
		2038
	],
	"./00002/00002-04/00002-04-05/i can see four cows.mp3": [
		3364,
		2039
	],
	"./00002/00002-04/00002-04-05/i can see four ducklings.mp3": [
		3365,
		2040
	],
	"./00002/00002-04/00002-04-05/i can see one chicken.mp3": [
		3366,
		2041
	],
	"./00002/00002-04/00002-04-05/i can see one duck.mp3": [
		3367,
		2042
	],
	"./00002/00002-04/00002-04-05/i can see three goats.mp3": [
		3368,
		2043
	],
	"./00002/00002-04/00002-04-05/i can see three sheep.mp3": [
		3369,
		2044
	],
	"./00002/00002-04/00002-04-05/i can see two dogs.mp3": [
		3370,
		2045
	],
	"./00002/00002-04/00002-04-05/i can see two horses.mp3": [
		3371,
		2046
	],
	"./00002/00002-04/00002-04-05/intro.mp3": [
		515
	],
	"./00002/00002-04/00002-04-05/main idea.mp3": [
		896
	],
	"./00002/00002-04/00002-04-05/my book of five.mp3": [
		3372,
		2047
	],
	"./00002/00002-04/00002-04-06/can you see five dogs.mp3": [
		3373,
		2048
	],
	"./00002/00002-04/00002-04-06/can you see five fish.mp3": [
		3374,
		2049
	],
	"./00002/00002-04/00002-04-06/can you see four birds.mp3": [
		3375,
		2050
	],
	"./00002/00002-04/00002-04-06/can you see four brids.mp3": [
		3376,
		2051
	],
	"./00002/00002-04/00002-04-06/can you see four fish.mp3": [
		3377,
		2052
	],
	"./00002/00002-04/00002-04-06/can you see one cat.mp3": [
		3378,
		2053
	],
	"./00002/00002-04/00002-04-06/can you see three cats.mp3": [
		3379,
		2054
	],
	"./00002/00002-04/00002-04-06/can you see three rabbits.mp3": [
		3380,
		2055
	],
	"./00002/00002-04/00002-04-06/can you see two snakes.mp3": [
		3381,
		2056
	],
	"./00002/00002-04/00002-04-06/can you see two turtles.mp3": [
		3382,
		2057
	],
	"./00002/00002-04/00002-04-06/intro.mp3": [
		516
	],
	"./00002/00002-04/00002-04-06/main idea.mp3": [
		897
	],
	"./00002/00002-04/00002-04-06/my book of six.mp3": [
		3383,
		2058
	],
	"./00002/00002-04/00002-04-06/pet animals.mp3": [
		3384,
		2059
	],
	"./00002/00002-04/00002-04-07/can you see five little fish.mp3": [
		3385,
		2060
	],
	"./00002/00002-04/00002-04-07/can you see four little penguins.mp3": [
		3386,
		2061
	],
	"./00002/00002-04/00002-04-07/can you see four little starfish.mp3": [
		3387,
		2062
	],
	"./00002/00002-04/00002-04-07/can you see one little seahorse.mp3": [
		3388,
		2063
	],
	"./00002/00002-04/00002-04-07/can you see three little crabs.mp3": [
		3389,
		2064
	],
	"./00002/00002-04/00002-04-07/intro.mp3": [
		517
	],
	"./00002/00002-04/00002-04-07/main idea.mp3": [
		898
	],
	"./00002/00002-04/00002-04-07/my book of seven.mp3": [
		3390,
		2065
	],
	"./00002/00002-04/00002-04-07/sea animals.mp3": [
		3391,
		2066
	],
	"./00002/00002-04/00002-04-07/you can see five sea turtles.mp3": [
		3392,
		2067
	],
	"./00002/00002-04/00002-04-07/you can see six big seahorses.mp3": [
		3393,
		2068
	],
	"./00002/00002-04/00002-04-07/you can see three big penguins.mp3": [
		3394,
		2069
	],
	"./00002/00002-04/00002-04-07/you can see two big sharks.mp3": [
		3395,
		2070
	],
	"./00002/00002-04/00002-04-07/you can see two whales.mp3": [
		3396,
		2071
	],
	"./00002/00002-04/00002-04-08/can you count eight things up in space.mp3": [
		3397,
		2072
	],
	"./00002/00002-04/00002-04-08/can you count five little planets.mp3": [
		3398,
		2073
	],
	"./00002/00002-04/00002-04-08/can you count four astronauts.mp3": [
		3399,
		2074
	],
	"./00002/00002-04/00002-04-08/can you count four rockets.mp3": [
		3400,
		2075
	],
	"./00002/00002-04/00002-04-08/can you count four spaceships.mp3": [
		3401,
		2076
	],
	"./00002/00002-04/00002-04-08/can you count to 8.mp3": [
		3402,
		2077
	],
	"./00002/00002-04/00002-04-08/can you see six little stars.mp3": [
		3403,
		2078
	],
	"./00002/00002-04/00002-04-08/can you see two big stars.mp3": [
		3404,
		2079
	],
	"./00002/00002-04/00002-04-08/intro.mp3": [
		518
	],
	"./00002/00002-04/00002-04-08/main idea.mp3": [
		899
	],
	"./00002/00002-04/00002-04-08/my book of eight.mp3": [
		3405,
		2080
	],
	"./00002/00002-04/00002-04-08/things in space.mp3": [
		3406,
		2081
	],
	"./00002/00002-04/00002-04-08/you can count seven satellites.mp3": [
		3407,
		2082
	],
	"./00002/00002-04/00002-04-08/you can see one planet.mp3": [
		3408,
		2083
	],
	"./00002/00002-04/00002-04-08/you can see three big planets.mp3": [
		3409,
		2084
	],
	"./00002/00002-04/00002-04-09/eight and one makes nine.mp3": [
		3410,
		2085
	],
	"./00002/00002-04/00002-04-09/five and four makes nine.mp3": [
		3411,
		2086
	],
	"./00002/00002-04/00002-04-09/four and five makes nine.mp3": [
		3412,
		2087
	],
	"./00002/00002-04/00002-04-09/i see elephants and zebras.mp3": [
		3413,
		2088
	],
	"./00002/00002-04/00002-04-09/i see hippos and rhinos.mp3": [
		3414,
		2089
	],
	"./00002/00002-04/00002-04-09/i see hippos rhinos and alligators.mp3": [
		3415,
		2090
	],
	"./00002/00002-04/00002-04-09/i see nine animals in all.mp3": [
		3416,
		2091
	],
	"./00002/00002-04/00002-04-09/i see nine baby animals.mp3": [
		3417,
		2092
	],
	"./00002/00002-04/00002-04-09/i see tigers and lions.mp3": [
		3418,
		2093
	],
	"./00002/00002-04/00002-04-09/intro.mp3": [
		519
	],
	"./00002/00002-04/00002-04-09/lets count the animals.mp3": [
		3419,
		2094
	],
	"./00002/00002-04/00002-04-09/main idea.mp3": [
		900
	],
	"./00002/00002-04/00002-04-09/my book of nine.mp3": [
		3420,
		2095
	],
	"./00002/00002-04/00002-04-09/seven and two makes nine.mp3": [
		3421,
		2096
	],
	"./00002/00002-04/00002-04-09/six and three makes nine.mp3": [
		3422,
		2097
	],
	"./00002/00002-04/00002-04-09/three and three and three makes nine.mp3": [
		3423,
		2098
	],
	"./00002/00002-04/00002-04-09/wild animals.mp3": [
		3424,
		2099
	],
	"./00002/00002-04/00002-04-10/brown animals.mp3": [
		3425,
		2100
	],
	"./00002/00002-04/00002-04-10/can you see five green dragons.mp3": [
		3426,
		2101
	],
	"./00002/00002-04/00002-04-10/can you see five green turtles.mp3": [
		3427,
		2102
	],
	"./00002/00002-04/00002-04-10/can you see six yellow giraffes.mp3": [
		3428,
		2103
	],
	"./00002/00002-04/00002-04-10/can you see three brown deer.mp3": [
		3429,
		2104
	],
	"./00002/00002-04/00002-04-10/eight and two equals ten.mp3": [
		3430,
		2105
	],
	"./00002/00002-04/00002-04-10/five and five equals ten.mp3": [
		3431,
		2106
	],
	"./00002/00002-04/00002-04-10/four and six equals ten.mp3": [
		3432,
		2107
	],
	"./00002/00002-04/00002-04-10/intro.mp3": [
		520
	],
	"./00002/00002-04/00002-04-10/main idea.mp3": [
		901
	],
	"./00002/00002-04/00002-04-10/my book of ten.mp3": [
		3433,
		2108
	],
	"./00002/00002-04/00002-04-10/one and nine equals ten.mp3": [
		3434,
		2109
	],
	"./00002/00002-04/00002-04-10/seven and three equals ten.mp3": [
		3435,
		2110
	],
	"./00002/00002-04/00002-04-10/ten and zero equals ten.mp3": [
		3436,
		2111
	],
	"./00002/00002-04/00002-04-10/you can see eight gray hippos.mp3": [
		3437,
		2112
	],
	"./00002/00002-04/00002-04-10/you can see five green alligators.mp3": [
		3438,
		2113
	],
	"./00002/00002-04/00002-04-10/you can see four yellow chicks.mp3": [
		3439,
		2114
	],
	"./00002/00002-04/00002-04-10/you can see nine white unicorns.mp3": [
		3440,
		2115
	],
	"./00002/00002-04/00002-04-10/you can see one white sheep.mp3": [
		3441,
		2116
	],
	"./00002/00002-04/00002-04-10/you can see seven brown monkeys.mp3": [
		3442,
		2117
	],
	"./00002/00002-04/00002-04-10/you can see ten pink dinosaurs.mp3": [
		3443,
		2118
	],
	"./00002/00002-04/00002-04-10/you can see two gray elephants.mp3": [
		3444,
		2119
	],
	"./00002/00002-04/00002-04-10/you can see zero pink cats.mp3": [
		3445,
		2120
	],
	"./00002/00002-04/number town.mp3": [
		3446,
		2121
	],
	"./00002/00002-04/numbers.mp3": [
		3447,
		2122
	],
	"./00002/00002-05/00002-05-01/all circles are round.mp3": [
		3448,
		2123
	],
	"./00002/00002-05/00002-05-01/circles are round.mp3": [
		3449,
		2124
	],
	"./00002/00002-05/00002-05-01/i can see big circles.mp3": [
		3450,
		2125
	],
	"./00002/00002-05/00002-05-01/i can see little circles.mp3": [
		3451,
		2126
	],
	"./00002/00002-05/00002-05-01/intro.mp3": [
		521
	],
	"./00002/00002-05/00002-05-01/main idea.mp3": [
		902
	],
	"./00002/00002-05/00002-05-01/some circles are black.mp3": [
		3452,
		2127
	],
	"./00002/00002-05/00002-05-01/some circles are blue.mp3": [
		3453,
		2128
	],
	"./00002/00002-05/00002-05-01/some circles are green.mp3": [
		3454,
		2129
	],
	"./00002/00002-05/00002-05-01/some circles are orange.mp3": [
		3455,
		2130
	],
	"./00002/00002-05/00002-05-01/some circles are purple.mp3": [
		3456,
		2131
	],
	"./00002/00002-05/00002-05-01/some circles are red.mp3": [
		3457,
		2132
	],
	"./00002/00002-05/00002-05-01/some circles are white.mp3": [
		3458,
		2133
	],
	"./00002/00002-05/00002-05-01/some circles are yellow.mp3": [
		3459,
		2134
	],
	"./00002/00002-05/00002-05-01/things that are round.mp3": [
		3460,
		2135
	],
	"./00002/00002-05/00002-05-02/can you count the corners.mp3": [
		3461,
		2136
	],
	"./00002/00002-05/00002-05-02/can you count the sides.mp3": [
		3462,
		2137
	],
	"./00002/00002-05/00002-05-02/intro.mp3": [
		522
	],
	"./00002/00002-05/00002-05-02/main idea.mp3": [
		903
	],
	"./00002/00002-05/00002-05-02/my square is black.mp3": [
		3463,
		2138
	],
	"./00002/00002-05/00002-05-02/my square is blue.mp3": [
		3464,
		2139
	],
	"./00002/00002-05/00002-05-02/my square is orange.mp3": [
		3465,
		2140
	],
	"./00002/00002-05/00002-05-02/my square is red.mp3": [
		3466,
		2141
	],
	"./00002/00002-05/00002-05-02/my square is yellow.mp3": [
		3467,
		2142
	],
	"./00002/00002-05/00002-05-02/my squares are green.mp3": [
		3468,
		2143
	],
	"./00002/00002-05/00002-05-02/my squares are pink.mp3": [
		3469,
		2144
	],
	"./00002/00002-05/00002-05-02/shapes.mp3": [
		3470,
		2145
	],
	"./00002/00002-05/00002-05-02/squares have four corners.mp3": [
		3471,
		2146
	],
	"./00002/00002-05/00002-05-02/squares have four sides.mp3": [
		3472,
		2147
	],
	"./00002/00002-05/00002-05-03/elephant likes the gray triangle.mp3": [
		3473,
		2148
	],
	"./00002/00002-05/00002-05-03/goat likes the orange triangle.mp3": [
		3474,
		2149
	],
	"./00002/00002-05/00002-05-03/intro.mp3": [
		523
	],
	"./00002/00002-05/00002-05-03/main idea.mp3": [
		904
	],
	"./00002/00002-05/00002-05-03/monkey likes the triangle.mp3": [
		3475,
		2150
	],
	"./00002/00002-05/00002-05-03/mouse likes the blue triangle.mp3": [
		3476,
		2151
	],
	"./00002/00002-05/00002-05-03/musical instruments.mp3": [
		3477,
		2152
	],
	"./00002/00002-05/00002-05-03/rabbit likes the red triangle.mp3": [
		3478,
		2153
	],
	"./00002/00002-05/00002-05-03/the boy likes the purple triangle.mp3": [
		3479,
		2154
	],
	"./00002/00002-05/00002-05-03/the girl likes the green triangle.mp3": [
		3480,
		2155
	],
	"./00002/00002-05/00002-05-03/this triangle is big.mp3": [
		3481,
		2156
	],
	"./00002/00002-05/00002-05-03/this triangle is little.mp3": [
		3482,
		2157
	],
	"./00002/00002-05/00002-05-03/triangles have three sides.mp3": [
		3483,
		2158
	],
	"./00002/00002-05/00002-05-04/animals with four legs.mp3": [
		3484,
		2159
	],
	"./00002/00002-05/00002-05-04/crocodile can see a long rectangle.mp3": [
		3485,
		2160
	],
	"./00002/00002-05/00002-05-04/giraffe can see a long rectangle.mp3": [
		3486,
		2161
	],
	"./00002/00002-05/00002-05-04/hedgehog can see a short rectangle.mp3": [
		3487,
		2162
	],
	"./00002/00002-05/00002-05-04/intro.mp3": [
		524
	],
	"./00002/00002-05/00002-05-04/main idea.mp3": [
		905
	],
	"./00002/00002-05/00002-05-04/pig can see a fat rectangle.mp3": [
		3488,
		2163
	],
	"./00002/00002-05/00002-05-04/rectangles have four corners.mp3": [
		3489,
		2164
	],
	"./00002/00002-05/00002-05-04/rectangles have four sides.mp3": [
		3490,
		2165
	],
	"./00002/00002-05/00002-05-04/sheep can see a fat rectangle.mp3": [
		3491,
		2166
	],
	"./00002/00002-05/00002-05-04/snake can see a thin rectangle.mp3": [
		3492,
		2167
	],
	"./00002/00002-05/00002-05-04/turtle can see a short rectangle.mp3": [
		3493,
		2168
	],
	"./00002/00002-05/00002-05-05/can you see it too.mp3": [
		3494,
		2169
	],
	"./00002/00002-05/00002-05-05/i can see a hexagon.mp3": [
		3495,
		2170
	],
	"./00002/00002-05/00002-05-05/i can see a pentagon.mp3": [
		3496,
		2171
	],
	"./00002/00002-05/00002-05-05/i can see a rectangle.mp3": [
		3497,
		2172
	],
	"./00002/00002-05/00002-05-05/i can see a square.mp3": [
		3498,
		2173
	],
	"./00002/00002-05/00002-05-05/i can see a triangle.mp3": [
		3499,
		2174
	],
	"./00002/00002-05/00002-05-05/i can see an octagon.mp3": [
		3500,
		2175
	],
	"./00002/00002-05/00002-05-05/i can see circles.mp3": [
		3501,
		2176
	],
	"./00002/00002-05/00002-05-05/i can see hexagons.mp3": [
		3502,
		2177
	],
	"./00002/00002-05/00002-05-05/intro.mp3": [
		525
	],
	"./00002/00002-05/00002-05-05/lets go look for shapes.mp3": [
		3503,
		2178
	],
	"./00002/00002-05/00002-05-05/main idea.mp3": [
		906
	],
	"./00002/00002-05/00002-05-05/shapes.mp3": [
		3504,
		2179
	],
	"./00002/00002-05/00002-05-05/what can you see.mp3": [
		3505,
		2180
	],
	"./00002/00002-05/00002-05-06/balls are solid.mp3": [
		3506,
		2181
	],
	"./00002/00002-05/00002-05-06/boxes are solid.mp3": [
		3507,
		2182
	],
	"./00002/00002-05/00002-05-06/cones are solid.mp3": [
		3508,
		2183
	],
	"./00002/00002-05/00002-05-06/cubes are solid.mp3": [
		3509,
		2184
	],
	"./00002/00002-05/00002-05-06/cylinders are solid.mp3": [
		3510,
		2185
	],
	"./00002/00002-05/00002-05-06/intro.mp3": [
		526
	],
	"./00002/00002-05/00002-05-06/main idea.mp3": [
		907
	],
	"./00002/00002-05/00002-05-06/pyramids are solid.mp3": [
		3511,
		2186
	],
	"./00002/00002-05/00002-05-06/solid shapes.mp3": [
		3512,
		2187
	],
	"./00002/00002-05/00002-05-06/spheres are solid.mp3": [
		3513,
		2188
	],
	"./00002/00002-05/00002-05-06/they have four faces.mp3": [
		3514,
		2189
	],
	"./00002/00002-05/00002-05-06/they have one face.mp3": [
		3515,
		2190
	],
	"./00002/00002-05/00002-05-06/they have six faces.mp3": [
		3516,
		2191
	],
	"./00002/00002-05/00002-05-06/they have two faces.mp3": [
		3517,
		2192
	],
	"./00002/00002-05/00002-05-06/they have zero faces.mp3": [
		3518,
		2193
	],
	"./00002/00002-05/00002-05-07/cubes have six faces.mp3": [
		3519,
		2194
	],
	"./00002/00002-05/00002-05-07/forest animals.mp3": [
		3520,
		2195
	],
	"./00002/00002-05/00002-05-07/intro.mp3": [
		527
	],
	"./00002/00002-05/00002-05-07/look at the bear face.mp3": [
		3521,
		2196
	],
	"./00002/00002-05/00002-05-07/look at the deer face.mp3": [
		3522,
		2197
	],
	"./00002/00002-05/00002-05-07/look at the elephant face.mp3": [
		3523,
		2198
	],
	"./00002/00002-05/00002-05-07/look at the faces.mp3": [
		3524,
		2199
	],
	"./00002/00002-05/00002-05-07/look at the fox face.mp3": [
		3525,
		2200
	],
	"./00002/00002-05/00002-05-07/look at the panda face.mp3": [
		3526,
		2201
	],
	"./00002/00002-05/00002-05-07/look at the rabbit face.mp3": [
		3527,
		2202
	],
	"./00002/00002-05/00002-05-07/main idea.mp3": [
		908
	],
	"./00002/00002-05/00002-05-08/intro.mp3": [
		528
	],
	"./00002/00002-05/00002-05-08/look at the circles.mp3": [
		3528,
		2203
	],
	"./00002/00002-05/00002-05-08/look at the hexagons.mp3": [
		3529,
		2204
	],
	"./00002/00002-05/00002-05-08/look at the octagons.mp3": [
		3530,
		2205
	],
	"./00002/00002-05/00002-05-08/look at the pentagons.mp3": [
		3531,
		2206
	],
	"./00002/00002-05/00002-05-08/look at the rectangles.mp3": [
		3532,
		2207
	],
	"./00002/00002-05/00002-05-08/look at the squares.mp3": [
		3533,
		2208
	],
	"./00002/00002-05/00002-05-08/look at the triangles.mp3": [
		3534,
		2209
	],
	"./00002/00002-05/00002-05-08/main idea.mp3": [
		909
	],
	"./00002/00002-05/00002-05-08/non living things.mp3": [
		3535,
		2210
	],
	"./00002/00002-05/00002-05-08/there are shapes on the quilt.mp3": [
		3536,
		2211
	],
	"./00002/00002-05/00002-05-09/i can make a circle.mp3": [
		3537,
		2212
	],
	"./00002/00002-05/00002-05-09/i can make a fox.mp3": [
		3538,
		2213
	],
	"./00002/00002-05/00002-05-09/i can make a hexagon.mp3": [
		3539,
		2214
	],
	"./00002/00002-05/00002-05-09/i can make a new shape.mp3": [
		3540,
		2215
	],
	"./00002/00002-05/00002-05-09/i can make a pentagon.mp3": [
		3541,
		2216
	],
	"./00002/00002-05/00002-05-09/i can make a rectangle.mp3": [
		3542,
		2217
	],
	"./00002/00002-05/00002-05-09/i can make a square.mp3": [
		3543,
		2218
	],
	"./00002/00002-05/00002-05-09/i can make an octagon.mp3": [
		3544,
		2219
	],
	"./00002/00002-05/00002-05-09/intro.mp3": [
		529
	],
	"./00002/00002-05/00002-05-09/main idea.mp3": [
		910
	],
	"./00002/00002-05/00002-05-09/shapes.mp3": [
		3545,
		2220
	],
	"./00002/00002-05/00002-05-09/what can i make.mp3": [
		3546,
		2221
	],
	"./00002/00002-05/00002-05-10/intro.mp3": [
		530
	],
	"./00002/00002-05/00002-05-10/main idea.mp3": [
		911
	],
	"./00002/00002-05/00002-05-10/places.mp3": [
		3547,
		2222
	],
	"./00002/00002-05/00002-05-10/shapes are all around us.mp3": [
		3548,
		2223
	],
	"./00002/00002-05/00002-05-10/we can see circles.mp3": [
		3549,
		2224
	],
	"./00002/00002-05/00002-05-10/we can see cones.mp3": [
		3550,
		2225
	],
	"./00002/00002-05/00002-05-10/we can see cubes.mp3": [
		3551,
		2226
	],
	"./00002/00002-05/00002-05-10/we can see cylinders.mp3": [
		3552,
		2227
	],
	"./00002/00002-05/00002-05-10/we can see rectangles.mp3": [
		3553,
		2228
	],
	"./00002/00002-05/00002-05-10/we can see squares.mp3": [
		3554,
		2229
	],
	"./00002/00002-05/00002-05-10/we can see triangles.mp3": [
		3555,
		2230
	],
	"./00002/00002-05/shapes town.mp3": [
		3556,
		2231
	],
	"./00002/00002-05/shapes.mp3": [
		3557,
		2232
	],
	"./00002/00002-06/00002-06-01/i do not need air said the octopus.mp3": [
		3558,
		2233
	],
	"./00002/00002-06/00002-06-01/i need air said the astronaut.mp3": [
		3559,
		2234
	],
	"./00002/00002-06/00002-06-01/i need air said the cat.mp3": [
		3560,
		2235
	],
	"./00002/00002-06/00002-06-01/i need air said the dolphin.mp3": [
		3561,
		2236
	],
	"./00002/00002-06/00002-06-01/intro.mp3": [
		531
	],
	"./00002/00002-06/00002-06-01/main idea.mp3": [
		912
	],
	"./00002/00002-06/00002-06-01/me too said the eagle.mp3": [
		3562,
		2237
	],
	"./00002/00002-06/00002-06-01/me too said the scuba diver.mp3": [
		3563,
		2238
	],
	"./00002/00002-06/00002-06-01/me too said the whale.mp3": [
		3564,
		2239
	],
	"./00002/00002-06/00002-06-01/water animals.mp3": [
		3565,
		2240
	],
	"./00002/00002-06/00002-06-01/we need air.mp3": [
		3566,
		2241
	],
	"./00002/00002-06/00002-06-02/farm animals.mp3": [
		3567,
		2242
	],
	"./00002/00002-06/00002-06-02/intro.mp3": [
		532
	],
	"./00002/00002-06/00002-06-02/look at the cow.mp3": [
		3568,
		2243
	],
	"./00002/00002-06/00002-06-02/look at the duck.mp3": [
		3569,
		2244
	],
	"./00002/00002-06/00002-06-02/look at the frog.mp3": [
		3570,
		2245
	],
	"./00002/00002-06/00002-06-02/look at the monkey.mp3": [
		3571,
		2246
	],
	"./00002/00002-06/00002-06-02/look at the shark.mp3": [
		3572,
		2247
	],
	"./00002/00002-06/00002-06-02/look at the sheep.mp3": [
		3573,
		2248
	],
	"./00002/00002-06/00002-06-02/look at the whale.mp3": [
		3574,
		2249
	],
	"./00002/00002-06/00002-06-02/main idea.mp3": [
		913
	],
	"./00002/00002-06/00002-06-02/the cow lives on the farm.mp3": [
		3575,
		2250
	],
	"./00002/00002-06/00002-06-02/the duck lives at the pond too.mp3": [
		3576,
		2251
	],
	"./00002/00002-06/00002-06-02/the frog lives at the pond.mp3": [
		3577,
		2252
	],
	"./00002/00002-06/00002-06-02/the monkey lives in a tree.mp3": [
		3578,
		2253
	],
	"./00002/00002-06/00002-06-02/the shark lives in the sea too.mp3": [
		3579,
		2254
	],
	"./00002/00002-06/00002-06-02/the sheep lives on the farm too.mp3": [
		3580,
		2255
	],
	"./00002/00002-06/00002-06-02/the whale lives in the sea.mp3": [
		3581,
		2256
	],
	"./00002/00002-06/00002-06-02/we need homes.mp3": [
		3582,
		2257
	],
	"./00002/00002-06/00002-06-03/animals that eat plants.mp3": [
		3583,
		2258
	],
	"./00002/00002-06/00002-06-03/do you.mp3": [
		3584,
		2259
	],
	"./00002/00002-06/00002-06-03/i like bananas.mp3": [
		3585,
		2260
	],
	"./00002/00002-06/00002-06-03/i like fish.mp3": [
		3586,
		2261
	],
	"./00002/00002-06/00002-06-03/i like grass said the zebra.mp3": [
		3587,
		2262
	],
	"./00002/00002-06/00002-06-03/i like insects said the bat.mp3": [
		3588,
		2263
	],
	"./00002/00002-06/00002-06-03/i like leaves too.mp3": [
		3589,
		2264
	],
	"./00002/00002-06/00002-06-03/i like leaves.mp3": [
		3590,
		2265
	],
	"./00002/00002-06/00002-06-03/i like nuts said the squirrel.mp3": [
		3591,
		2266
	],
	"./00002/00002-06/00002-06-03/intro.mp3": [
		533
	],
	"./00002/00002-06/00002-06-03/main idea.mp3": [
		914
	],
	"./00002/00002-06/00002-06-03/me too said the dinosaur.mp3": [
		3592,
		2267
	],
	"./00002/00002-06/00002-06-03/not me said the giraffe.mp3": [
		3593,
		2268
	],
	"./00002/00002-06/00002-06-03/not me said the monkey.mp3": [
		3594,
		2269
	],
	"./00002/00002-06/00002-06-03/not me said the shark.mp3": [
		3595,
		2270
	],
	"./00002/00002-06/00002-06-03/water animals.mp3": [
		3596,
		2271
	],
	"./00002/00002-06/00002-06-03/we need to eat.mp3": [
		3597,
		2272
	],
	"./00002/00002-06/00002-06-04/animals that live in the snow.mp3": [
		3598,
		2273
	],
	"./00002/00002-06/00002-06-04/he is out in the snow.mp3": [
		3599,
		2274
	],
	"./00002/00002-06/00002-06-04/i am out in the snow too.mp3": [
		3600,
		2275
	],
	"./00002/00002-06/00002-06-04/intro.mp3": [
		534
	],
	"./00002/00002-06/00002-06-04/it is snowing.mp3": [
		3601,
		2276
	],
	"./00002/00002-06/00002-06-04/it is winter.mp3": [
		3602,
		2277
	],
	"./00002/00002-06/00002-06-04/look at me.mp3": [
		3603,
		2278
	],
	"./00002/00002-06/00002-06-04/look at the deer.mp3": [
		3604,
		2279
	],
	"./00002/00002-06/00002-06-04/look at the dog.mp3": [
		3605,
		2280
	],
	"./00002/00002-06/00002-06-04/look at the fox.mp3": [
		3606,
		2281
	],
	"./00002/00002-06/00002-06-04/look at the owl.mp3": [
		3607,
		2282
	],
	"./00002/00002-06/00002-06-04/look at the rabbit.mp3": [
		3608,
		2283
	],
	"./00002/00002-06/00002-06-04/look at the squirrel.mp3": [
		3609,
		2284
	],
	"./00002/00002-06/00002-06-04/main idea.mp3": [
		915
	],
	"./00002/00002-06/00002-06-04/out in the snow.mp3": [
		3610,
		2285
	],
	"./00002/00002-06/00002-06-04/she is out in the snow.mp3": [
		3611,
		2286
	],
	"./00002/00002-06/00002-06-05/are they alive.mp3": [
		3612,
		2287
	],
	"./00002/00002-06/00002-06-05/i can see a log.mp3": [
		3613,
		2288
	],
	"./00002/00002-06/00002-06-05/i can see a seal.mp3": [
		3614,
		2289
	],
	"./00002/00002-06/00002-06-05/i can see a wheel.mp3": [
		3615,
		2290
	],
	"./00002/00002-06/00002-06-05/i can see one box.mp3": [
		3616,
		2291
	],
	"./00002/00002-06/00002-06-05/i can see one cat.mp3": [
		3617,
		2292
	],
	"./00002/00002-06/00002-06-05/i can see one duck.mp3": [
		3618,
		2293
	],
	"./00002/00002-06/00002-06-05/i can see one fox.mp3": [
		3619,
		2294
	],
	"./00002/00002-06/00002-06-05/i can see one frog.mp3": [
		3620,
		2295
	],
	"./00002/00002-06/00002-06-05/i can see one hat.mp3": [
		3621,
		2296
	],
	"./00002/00002-06/00002-06-05/i can see one house.mp3": [
		3622,
		2297
	],
	"./00002/00002-06/00002-06-05/i can see one mouse.mp3": [
		3623,
		2298
	],
	"./00002/00002-06/00002-06-05/i can see one truck.mp3": [
		3624,
		2299
	],
	"./00002/00002-06/00002-06-05/intro.mp3": [
		535
	],
	"./00002/00002-06/00002-06-05/living things.mp3": [
		3625,
		2300
	],
	"./00002/00002-06/00002-06-05/look at the jeep.mp3": [
		3626,
		2301
	],
	"./00002/00002-06/00002-06-05/look at the sheep.mp3": [
		3627,
		2302
	],
	"./00002/00002-06/00002-06-05/main idea.mp3": [
		916
	],
	"./00002/00002-06/00002-06-05/the cat is alive.mp3": [
		3628,
		2303
	],
	"./00002/00002-06/00002-06-05/the duck is alive.mp3": [
		3629,
		2304
	],
	"./00002/00002-06/00002-06-05/the fox is alive.mp3": [
		3630,
		2305
	],
	"./00002/00002-06/00002-06-05/the frog is alive.mp3": [
		3631,
		2306
	],
	"./00002/00002-06/00002-06-05/the mouse is alive.mp3": [
		3632,
		2307
	],
	"./00002/00002-06/00002-06-05/the seal is alive.mp3": [
		3633,
		2308
	],
	"./00002/00002-06/00002-06-05/the sheep is alive.mp3": [
		3634,
		2309
	],
	"./00002/00002-06/00002-06-05/which one is alive.mp3": [
		3635,
		2310
	],
	"./00002/00002-06/00002-06-06/baby animals.mp3": [
		3636,
		2311
	],
	"./00002/00002-06/00002-06-06/here is my mother.mp3": [
		3637,
		2312
	],
	"./00002/00002-06/00002-06-06/i am a puppy.mp3": [
		3638,
		2313
	],
	"./00002/00002-06/00002-06-06/i love my mother.mp3": [
		3639,
		2314
	],
	"./00002/00002-06/00002-06-06/intro.mp3": [
		536
	],
	"./00002/00002-06/00002-06-06/main idea.mp3": [
		917
	],
	"./00002/00002-06/00002-06-06/mammals.mp3": [
		3640,
		2315
	],
	"./00002/00002-06/00002-06-06/mother.mp3": [
		3641,
		2316
	],
	"./00002/00002-06/00002-06-06/my mother is a bear.mp3": [
		3642,
		2317
	],
	"./00002/00002-06/00002-06-06/my mother is a cow.mp3": [
		3643,
		2318
	],
	"./00002/00002-06/00002-06-06/my mother is a dolphin.mp3": [
		3644,
		2319
	],
	"./00002/00002-06/00002-06-06/my mother is a duck.mp3": [
		3645,
		2320
	],
	"./00002/00002-06/00002-06-06/my mother is a kangaroo.mp3": [
		3646,
		2321
	],
	"./00002/00002-06/00002-06-06/my mother is a rabbit.mp3": [
		3647,
		2322
	],
	"./00002/00002-06/00002-06-06/my mother is a sheep.mp3": [
		3648,
		2323
	],
	"./00002/00002-06/00002-06-07/birds need water.mp3": [
		3649,
		2324
	],
	"./00002/00002-06/00002-06-07/deer need water.mp3": [
		3650,
		2325
	],
	"./00002/00002-06/00002-06-07/dogs need water too.mp3": [
		3651,
		2326
	],
	"./00002/00002-06/00002-06-07/dolphins need water.mp3": [
		3652,
		2327
	],
	"./00002/00002-06/00002-06-07/ducks need water.mp3": [
		3653,
		2328
	],
	"./00002/00002-06/00002-06-07/everyone needs water.mp3": [
		3654,
		2329
	],
	"./00002/00002-06/00002-06-07/flowers need water.mp3": [
		3655,
		2330
	],
	"./00002/00002-06/00002-06-07/frogs need water.mp3": [
		3656,
		2331
	],
	"./00002/00002-06/00002-06-07/intro.mp3": [
		537
	],
	"./00002/00002-06/00002-06-07/look at the birds.mp3": [
		3657,
		2332
	],
	"./00002/00002-06/00002-06-07/look at the deer.mp3": [
		3658,
		2333
	],
	"./00002/00002-06/00002-06-07/look at the dog.mp3": [
		3659,
		2334
	],
	"./00002/00002-06/00002-06-07/look at the dolphins.mp3": [
		3660,
		2335
	],
	"./00002/00002-06/00002-06-07/look at the ducks.mp3": [
		3661,
		2336
	],
	"./00002/00002-06/00002-06-07/look at the flowers.mp3": [
		3662,
		2337
	],
	"./00002/00002-06/00002-06-07/look at the frogs.mp3": [
		3663,
		2338
	],
	"./00002/00002-06/00002-06-07/main idea.mp3": [
		918
	],
	"./00002/00002-06/00002-06-07/water.mp3": [
		3664,
		2339
	],
	"./00002/00002-06/00002-06-08/grow seeds grow.mp3": [
		3665,
		2340
	],
	"./00002/00002-06/00002-06-08/i can see the apples.mp3": [
		3666,
		2341
	],
	"./00002/00002-06/00002-06-08/i can see the branch.mp3": [
		3667,
		2342
	],
	"./00002/00002-06/00002-06-08/i can see the flowers.mp3": [
		3668,
		2343
	],
	"./00002/00002-06/00002-06-08/i can see the leaves.mp3": [
		3669,
		2344
	],
	"./00002/00002-06/00002-06-08/i can see the roots.mp3": [
		3670,
		2345
	],
	"./00002/00002-06/00002-06-08/i can see the seeds.mp3": [
		3671,
		2346
	],
	"./00002/00002-06/00002-06-08/i can see the stem.mp3": [
		3672,
		2347
	],
	"./00002/00002-06/00002-06-08/intro.mp3": [
		538
	],
	"./00002/00002-06/00002-06-08/look at the apples.mp3": [
		3673,
		2348
	],
	"./00002/00002-06/00002-06-08/look at the branch.mp3": [
		3674,
		2349
	],
	"./00002/00002-06/00002-06-08/look at the flowers.mp3": [
		3675,
		2350
	],
	"./00002/00002-06/00002-06-08/look at the leaves.mp3": [
		3676,
		2351
	],
	"./00002/00002-06/00002-06-08/look at the roots.mp3": [
		3677,
		2352
	],
	"./00002/00002-06/00002-06-08/look at the seeds.mp3": [
		3678,
		2353
	],
	"./00002/00002-06/00002-06-08/look at the stem.mp3": [
		3679,
		2354
	],
	"./00002/00002-06/00002-06-08/main idea.mp3": [
		919
	],
	"./00002/00002-06/00002-06-08/things that grow on trees.mp3": [
		3680,
		2355
	],
	"./00002/00002-06/00002-06-09/baby animals.mp3": [
		3681,
		2356
	],
	"./00002/00002-06/00002-06-09/i love my dad.mp3": [
		3682,
		2357
	],
	"./00002/00002-06/00002-06-09/intro.mp3": [
		539
	],
	"./00002/00002-06/00002-06-09/look at my dad.mp3": [
		3683,
		2358
	],
	"./00002/00002-06/00002-06-09/look at us.mp3": [
		3684,
		2359
	],
	"./00002/00002-06/00002-06-09/main idea.mp3": [
		920
	],
	"./00002/00002-06/00002-06-09/my dad is a deer.mp3": [
		3685,
		2360
	],
	"./00002/00002-06/00002-06-09/my dad is a dinosaur.mp3": [
		3686,
		2361
	],
	"./00002/00002-06/00002-06-09/my dad is a dog.mp3": [
		3687,
		2362
	],
	"./00002/00002-06/00002-06-09/my dad is a pig.mp3": [
		3688,
		2363
	],
	"./00002/00002-06/00002-06-09/my dad is a rooster.mp3": [
		3689,
		2364
	],
	"./00002/00002-06/00002-06-09/my dad is a seahorse.mp3": [
		3690,
		2365
	],
	"./00002/00002-06/00002-06-09/my dad is an elephant.mp3": [
		3691,
		2366
	],
	"./00002/00002-06/00002-06-10/can you see 3 boats.mp3": [
		3692,
		2367
	],
	"./00002/00002-06/00002-06-10/can you see 3 boxes.mp3": [
		3693,
		2368
	],
	"./00002/00002-06/00002-06-10/can you see 3 cakes.mp3": [
		3694,
		2369
	],
	"./00002/00002-06/00002-06-10/can you see 3 foxes.mp3": [
		3695,
		2370
	],
	"./00002/00002-06/00002-06-10/can you see 3 frogs.mp3": [
		3696,
		2371
	],
	"./00002/00002-06/00002-06-10/can you see 3 goats.mp3": [
		3697,
		2372
	],
	"./00002/00002-06/00002-06-10/can you see 3 hats.mp3": [
		3698,
		2373
	],
	"./00002/00002-06/00002-06-10/can you see 3 kittens.mp3": [
		3699,
		2374
	],
	"./00002/00002-06/00002-06-10/can you see 3 logs.mp3": [
		3700,
		2375
	],
	"./00002/00002-06/00002-06-10/can you see 3 mittens.mp3": [
		3701,
		2376
	],
	"./00002/00002-06/00002-06-10/can you see 3 nails.mp3": [
		3702,
		2377
	],
	"./00002/00002-06/00002-06-10/can you see 3 rats.mp3": [
		3703,
		2378
	],
	"./00002/00002-06/00002-06-10/can you see 3 snails.mp3": [
		3704,
		2379
	],
	"./00002/00002-06/00002-06-10/can you see 3 snakes.mp3": [
		3705,
		2380
	],
	"./00002/00002-06/00002-06-10/do they grow.mp3": [
		3706,
		2381
	],
	"./00002/00002-06/00002-06-10/intro.mp3": [
		540
	],
	"./00002/00002-06/00002-06-10/living things.mp3": [
		3707,
		2382
	],
	"./00002/00002-06/00002-06-10/main idea.mp3": [
		921
	],
	"./00002/00002-06/00002-06-10/non living things.mp3": [
		3708,
		2383
	],
	"./00002/00002-06/00002-06-10/the foxes grow.mp3": [
		3709,
		2384
	],
	"./00002/00002-06/00002-06-10/the frogs grow.mp3": [
		3710,
		2385
	],
	"./00002/00002-06/00002-06-10/the goats grow.mp3": [
		3711,
		2386
	],
	"./00002/00002-06/00002-06-10/the kittens grow.mp3": [
		3712,
		2387
	],
	"./00002/00002-06/00002-06-10/the rats grow.mp3": [
		3713,
		2388
	],
	"./00002/00002-06/00002-06-10/the snails grow.mp3": [
		3714,
		2389
	],
	"./00002/00002-06/00002-06-10/the snakes grow.mp3": [
		3715,
		2390
	],
	"./00002/00002-06/life science.mp3": [
		3716,
		2391
	],
	"./00002/00002-07/00002-07-01/big and little.mp3": [
		3717,
		2392
	],
	"./00002/00002-07/00002-07-01/intro.mp3": [
		541
	],
	"./00002/00002-07/00002-07-01/main idea.mp3": [
		922
	],
	"./00002/00002-07/00002-07-01/my bus is little.mp3": [
		3718,
		2393
	],
	"./00002/00002-07/00002-07-01/my car is little.mp3": [
		3719,
		2394
	],
	"./00002/00002-07/00002-07-01/my dump truck is little.mp3": [
		3720,
		2395
	],
	"./00002/00002-07/00002-07-01/my fire truck is little.mp3": [
		3721,
		2396
	],
	"./00002/00002-07/00002-07-01/my green monster is little.mp3": [
		3722,
		2397
	],
	"./00002/00002-07/00002-07-01/my helicopter is little.mp3": [
		3723,
		2398
	],
	"./00002/00002-07/00002-07-01/my plane is little.mp3": [
		3724,
		2399
	],
	"./00002/00002-07/00002-07-01/my red monster is big.mp3": [
		3725,
		2400
	],
	"./00002/00002-07/00002-07-01/this bus is big.mp3": [
		3726,
		2401
	],
	"./00002/00002-07/00002-07-01/this car is big.mp3": [
		3727,
		2402
	],
	"./00002/00002-07/00002-07-01/this dump truck is big.mp3": [
		3728,
		2403
	],
	"./00002/00002-07/00002-07-01/this fire truck is big.mp3": [
		3729,
		2404
	],
	"./00002/00002-07/00002-07-01/this helicopter is big.mp3": [
		3730,
		2405
	],
	"./00002/00002-07/00002-07-01/this plane is big.mp3": [
		3731,
		2406
	],
	"./00002/00002-07/00002-07-01/vehicles.mp3": [
		3732,
		2407
	],
	"./00002/00002-07/00002-07-02/electricity.mp3": [
		3733,
		2408
	],
	"./00002/00002-07/00002-07-02/intro.mp3": [
		542
	],
	"./00002/00002-07/00002-07-02/look at the computer.mp3": [
		3734,
		2409
	],
	"./00002/00002-07/00002-07-02/look at the fan.mp3": [
		3735,
		2410
	],
	"./00002/00002-07/00002-07-02/look at the fridge.mp3": [
		3736,
		2411
	],
	"./00002/00002-07/00002-07-02/look at the guitar.mp3": [
		3737,
		2412
	],
	"./00002/00002-07/00002-07-02/look at the light.mp3": [
		3738,
		2413
	],
	"./00002/00002-07/00002-07-02/look at the stove.mp3": [
		3739,
		2414
	],
	"./00002/00002-07/00002-07-02/look at the television.mp3": [
		3740,
		2415
	],
	"./00002/00002-07/00002-07-02/main idea.mp3": [
		923
	],
	"./00002/00002-07/00002-07-02/the computer uses electricity.mp3": [
		3741,
		2416
	],
	"./00002/00002-07/00002-07-02/the fan uses electricity.mp3": [
		3742,
		2417
	],
	"./00002/00002-07/00002-07-02/the fridge uses electricity.mp3": [
		3743,
		2418
	],
	"./00002/00002-07/00002-07-02/the guitar uses electricity.mp3": [
		3744,
		2419
	],
	"./00002/00002-07/00002-07-02/the light uses electricity.mp3": [
		3745,
		2420
	],
	"./00002/00002-07/00002-07-02/the stove uses electricity.mp3": [
		3746,
		2421
	],
	"./00002/00002-07/00002-07-02/the television uses electricity.mp3": [
		3747,
		2422
	],
	"./00002/00002-07/00002-07-02/things that use electricity.mp3": [
		3748,
		2423
	],
	"./00002/00002-07/00002-07-03/bear is playing the guitar.mp3": [
		3749,
		2424
	],
	"./00002/00002-07/00002-07-03/beaver is playing the xylophone.mp3": [
		3750,
		2425
	],
	"./00002/00002-07/00002-07-03/donkey is playing the harp.mp3": [
		3751,
		2426
	],
	"./00002/00002-07/00002-07-03/elephant is playing the cymbals.mp3": [
		3752,
		2427
	],
	"./00002/00002-07/00002-07-03/giraffe is playing the piano.mp3": [
		3753,
		2428
	],
	"./00002/00002-07/00002-07-03/intro.mp3": [
		543
	],
	"./00002/00002-07/00002-07-03/loud and soft.mp3": [
		3754,
		2429
	],
	"./00002/00002-07/00002-07-03/main idea.mp3": [
		924
	],
	"./00002/00002-07/00002-07-03/monkey is playing the triangle.mp3": [
		3755,
		2430
	],
	"./00002/00002-07/00002-07-03/musical instruments.mp3": [
		3756,
		2431
	],
	"./00002/00002-07/00002-07-03/rabbit is playing the drum.mp3": [
		3757,
		2432
	],
	"./00002/00002-07/00002-07-03/the cymbals are loud.mp3": [
		3758,
		2433
	],
	"./00002/00002-07/00002-07-03/the drum is loud.mp3": [
		3759,
		2434
	],
	"./00002/00002-07/00002-07-03/the guitar is loud.mp3": [
		3760,
		2435
	],
	"./00002/00002-07/00002-07-03/the harp is soft.mp3": [
		3761,
		2436
	],
	"./00002/00002-07/00002-07-03/the piano is loud.mp3": [
		3762,
		2437
	],
	"./00002/00002-07/00002-07-03/the triangle is soft.mp3": [
		3763,
		2438
	],
	"./00002/00002-07/00002-07-03/the xylophone is soft.mp3": [
		3764,
		2439
	],
	"./00002/00002-07/00002-07-04/deer goes up in the pulley.mp3": [
		3765,
		2440
	],
	"./00002/00002-07/00002-07-04/elephant goes down in the pulley.mp3": [
		3766,
		2441
	],
	"./00002/00002-07/00002-07-04/elephant goes up in the pulley.mp3": [
		3767,
		2442
	],
	"./00002/00002-07/00002-07-04/intro.mp3": [
		544
	],
	"./00002/00002-07/00002-07-04/lion goes up in the pulley.mp3": [
		3768,
		2443
	],
	"./00002/00002-07/00002-07-04/main idea.mp3": [
		925
	],
	"./00002/00002-07/00002-07-04/panda goes up in the pulley.mp3": [
		3769,
		2444
	],
	"./00002/00002-07/00002-07-04/skunk goes up in the pulley.mp3": [
		3770,
		2445
	],
	"./00002/00002-07/00002-07-04/squirrel lets go.mp3": [
		3771,
		2446
	],
	"./00002/00002-07/00002-07-04/squirrel pulls hard.mp3": [
		3772,
		2447
	],
	"./00002/00002-07/00002-07-04/tiger goes up in the pulley.mp3": [
		3773,
		2448
	],
	"./00002/00002-07/00002-07-04/up in the pulley.mp3": [
		3774,
		2449
	],
	"./00002/00002-07/00002-07-04/wild animals.mp3": [
		3775,
		2450
	],
	"./00002/00002-07/00002-07-05/intro.mp3": [
		545
	],
	"./00002/00002-07/00002-07-05/main idea.mp3": [
		926
	],
	"./00002/00002-07/00002-07-05/no.mp3": [
		3776,
		2451
	],
	"./00002/00002-07/00002-07-05/the ball will move.mp3": [
		3777,
		2452
	],
	"./00002/00002-07/00002-07-05/the car will move.mp3": [
		3778,
		2453
	],
	"./00002/00002-07/00002-07-05/the swing will move.mp3": [
		3779,
		2454
	],
	"./00002/00002-07/00002-07-05/the swing will not move.mp3": [
		3780,
		2455
	],
	"./00002/00002-07/00002-07-05/the truck will move.mp3": [
		3781,
		2456
	],
	"./00002/00002-07/00002-07-05/the truck will not move.mp3": [
		3782,
		2457
	],
	"./00002/00002-07/00002-07-05/toys.mp3": [
		3783,
		2458
	],
	"./00002/00002-07/00002-07-05/will it move.mp3": [
		3784,
		2459
	],
	"./00002/00002-07/00002-07-05/yes.mp3": [
		3785,
		2460
	],
	"./00002/00002-07/00002-07-06/i can see the nail.mp3": [
		3786,
		2461
	],
	"./00002/00002-07/00002-07-06/intro.mp3": [
		546
	],
	"./00002/00002-07/00002-07-06/look at the apple.mp3": [
		3787,
		2462
	],
	"./00002/00002-07/00002-07-06/look at the ball.mp3": [
		3788,
		2463
	],
	"./00002/00002-07/00002-07-06/look at the boat.mp3": [
		3789,
		2464
	],
	"./00002/00002-07/00002-07-06/look at the cube.mp3": [
		3790,
		2465
	],
	"./00002/00002-07/00002-07-06/look at the duck.mp3": [
		3791,
		2466
	],
	"./00002/00002-07/00002-07-06/look at the key.mp3": [
		3792,
		2467
	],
	"./00002/00002-07/00002-07-06/look.mp3": [
		3793,
		2468
	],
	"./00002/00002-07/00002-07-06/main idea.mp3": [
		927
	],
	"./00002/00002-07/00002-07-06/the apple floats.mp3": [
		3794,
		2469
	],
	"./00002/00002-07/00002-07-06/the ball floats.mp3": [
		3795,
		2470
	],
	"./00002/00002-07/00002-07-06/the boat floats.mp3": [
		3796,
		2471
	],
	"./00002/00002-07/00002-07-06/the cube floats.mp3": [
		3797,
		2472
	],
	"./00002/00002-07/00002-07-06/the duck floats too.mp3": [
		3798,
		2473
	],
	"./00002/00002-07/00002-07-06/the key sinks.mp3": [
		3799,
		2474
	],
	"./00002/00002-07/00002-07-06/the nail sinks.mp3": [
		3800,
		2475
	],
	"./00002/00002-07/00002-07-06/things that float.mp3": [
		3801,
		2476
	],
	"./00002/00002-07/00002-07-06/will it float.mp3": [
		3802,
		2477
	],
	"./00002/00002-07/00002-07-06/will it sink.mp3": [
		3803,
		2478
	],
	"./00002/00002-07/00002-07-07/fishing with a magnet.mp3": [
		3804,
		2479
	],
	"./00002/00002-07/00002-07-07/intro.mp3": [
		547
	],
	"./00002/00002-07/00002-07-07/look at the chipmunk.mp3": [
		3805,
		2480
	],
	"./00002/00002-07/00002-07-07/look at the deer.mp3": [
		3806,
		2481
	],
	"./00002/00002-07/00002-07-07/look at the fox.mp3": [
		3807,
		2482
	],
	"./00002/00002-07/00002-07-07/look at the lion.mp3": [
		3808,
		2483
	],
	"./00002/00002-07/00002-07-07/look at the sheep.mp3": [
		3809,
		2484
	],
	"./00002/00002-07/00002-07-07/look at the squirrel.mp3": [
		3810,
		2485
	],
	"./00002/00002-07/00002-07-07/look at the tiger.mp3": [
		3811,
		2486
	],
	"./00002/00002-07/00002-07-07/made.mp3": [
		3812,
		2487
	],
	"./00002/00002-07/00002-07-07/magnet.mp3": [
		3813,
		2488
	],
	"./00002/00002-07/00002-07-07/magnets.mp3": [
		3814,
		2489
	],
	"./00002/00002-07/00002-07-07/main idea.mp3": [
		928
	],
	"./00002/00002-07/00002-07-07/metal.mp3": [
		3815,
		2490
	],
	"./00002/00002-07/00002-07-07/the chipmunk got a nail.mp3": [
		3816,
		2491
	],
	"./00002/00002-07/00002-07-07/the deer got a helicopter.mp3": [
		3817,
		2492
	],
	"./00002/00002-07/00002-07-07/the fox got a magnet.mp3": [
		3818,
		2493
	],
	"./00002/00002-07/00002-07-07/the lion got a rocket.mp3": [
		3819,
		2494
	],
	"./00002/00002-07/00002-07-07/the sheep got an anchor.mp3": [
		3820,
		2495
	],
	"./00002/00002-07/00002-07-07/the squirrel got a ball.mp3": [
		3821,
		2496
	],
	"./00002/00002-07/00002-07-07/the tiger got a car.mp3": [
		3822,
		2497
	],
	"./00002/00002-07/00002-07-07/things made of metal.mp3": [
		3823,
		2498
	],
	"./00002/00002-07/00002-07-08/intro.mp3": [
		548
	],
	"./00002/00002-07/00002-07-08/main idea.mp3": [
		929
	],
	"./00002/00002-07/00002-07-08/the bus has 6 wheels.mp3": [
		3824,
		2499
	],
	"./00002/00002-07/00002-07-08/the car has 4 wheels.mp3": [
		3825,
		2500
	],
	"./00002/00002-07/00002-07-08/the car truck has 4 wheels.mp3": [
		3826,
		2501
	],
	"./00002/00002-07/00002-07-08/the dump truck has 4 wheels.mp3": [
		3827,
		2502
	],
	"./00002/00002-07/00002-07-08/the motorcycle has 2 wheels.mp3": [
		3828,
		2503
	],
	"./00002/00002-07/00002-07-08/the plane has 3 wheels.mp3": [
		3829,
		2504
	],
	"./00002/00002-07/00002-07-08/the train has 8 wheels.mp3": [
		3830,
		2505
	],
	"./00002/00002-07/00002-07-08/the unicycle has 1 wheel.mp3": [
		3831,
		2506
	],
	"./00002/00002-07/00002-07-08/vehicles.mp3": [
		3832,
		2507
	],
	"./00002/00002-07/00002-07-08/wheels make things go.mp3": [
		3833,
		2508
	],
	"./00002/00002-07/00002-07-08/wheels.mp3": [
		3834,
		2509
	],
	"./00002/00002-07/00002-07-09/intro.mp3": [
		549
	],
	"./00002/00002-07/00002-07-09/is it cold.mp3": [
		3835,
		2510
	],
	"./00002/00002-07/00002-07-09/is it hot is it cold.mp3": [
		3836,
		2511
	],
	"./00002/00002-07/00002-07-09/is it hot or cold.mp3": [
		3837,
		2512
	],
	"./00002/00002-07/00002-07-09/is it hot.mp3": [
		3838,
		2513
	],
	"./00002/00002-07/00002-07-09/main idea.mp3": [
		930
	],
	"./00002/00002-07/00002-07-09/non living things.mp3": [
		3839,
		2514
	],
	"./00002/00002-07/00002-07-09/saturn is cold.mp3": [
		3840,
		2515
	],
	"./00002/00002-07/00002-07-09/the fire is hot.mp3": [
		3841,
		2516
	],
	"./00002/00002-07/00002-07-09/the fridge is cold.mp3": [
		3842,
		2517
	],
	"./00002/00002-07/00002-07-09/the iceberg is cold.mp3": [
		3843,
		2518
	],
	"./00002/00002-07/00002-07-09/the stove is hot.mp3": [
		3844,
		2519
	],
	"./00002/00002-07/00002-07-09/the sun is hot.mp3": [
		3845,
		2520
	],
	"./00002/00002-07/00002-07-09/the volcano is hot.mp3": [
		3846,
		2521
	],
	"./00002/00002-07/00002-07-10/big things.mp3": [
		3847,
		2522
	],
	"./00002/00002-07/00002-07-10/here comes the fire truck.mp3": [
		3848,
		2523
	],
	"./00002/00002-07/00002-07-10/here comes the plane.mp3": [
		3849,
		2524
	],
	"./00002/00002-07/00002-07-10/here is a dump truck.mp3": [
		3850,
		2525
	],
	"./00002/00002-07/00002-07-10/here is a helicopter.mp3": [
		3851,
		2526
	],
	"./00002/00002-07/00002-07-10/here is a monster.mp3": [
		3852,
		2527
	],
	"./00002/00002-07/00002-07-10/intro.mp3": [
		550
	],
	"./00002/00002-07/00002-07-10/main idea.mp3": [
		931
	],
	"./00002/00002-07/00002-07-10/this bus is big.mp3": [
		3853,
		2528
	],
	"./00002/00002-07/00002-07-10/this car is big.mp3": [
		3854,
		2529
	],
	"./00002/00002-07/00002-07-10/this dinosaur is huge.mp3": [
		3855,
		2530
	],
	"./00002/00002-07/00002-07-10/this dump truck is big.mp3": [
		3856,
		2531
	],
	"./00002/00002-07/00002-07-10/this fire truck is big.mp3": [
		3857,
		2532
	],
	"./00002/00002-07/00002-07-10/this giraffe is big.mp3": [
		3858,
		2533
	],
	"./00002/00002-07/00002-07-10/this helicopter is big.mp3": [
		3859,
		2534
	],
	"./00002/00002-07/00002-07-10/this monster is big.mp3": [
		3860,
		2535
	],
	"./00002/00002-07/00002-07-10/this plane is big.mp3": [
		3861,
		2536
	],
	"./00002/00002-07/00002-07-10/this whale is big.mp3": [
		3862,
		2537
	],
	"./00002/00002-07/00002-07-10/vehicles.mp3": [
		3863,
		2538
	],
	"./00002/00002-07/physical science.mp3": [
		3864,
		2539
	],
	"./00002/00002-08/00002-08-01/intro.mp3": [
		551
	],
	"./00002/00002-08/00002-08-01/main idea.mp3": [
		932
	],
	"./00002/00002-08/00002-08-01/the animals are on the earth.mp3": [
		3865,
		2540
	],
	"./00002/00002-08/00002-08-01/the forests are on the earth.mp3": [
		3866,
		2541
	],
	"./00002/00002-08/00002-08-01/the lakes are on the earth.mp3": [
		3867,
		2542
	],
	"./00002/00002-08/00002-08-01/the mountains are on the earth.mp3": [
		3868,
		2543
	],
	"./00002/00002-08/00002-08-01/the rivers are on the earth.mp3": [
		3869,
		2544
	],
	"./00002/00002-08/00002-08-01/the sea is on the earth.mp3": [
		3870,
		2545
	],
	"./00002/00002-08/00002-08-01/things on the earth.mp3": [
		3871,
		2546
	],
	"./00002/00002-08/00002-08-01/we are on the earth too.mp3": [
		3872,
		2547
	],
	"./00002/00002-08/00002-08-01/we love the animals.mp3": [
		3873,
		2548
	],
	"./00002/00002-08/00002-08-01/we love the earth.mp3": [
		3874,
		2549
	],
	"./00002/00002-08/00002-08-01/we love the forests.mp3": [
		3875,
		2550
	],
	"./00002/00002-08/00002-08-01/we love the lakes.mp3": [
		3876,
		2551
	],
	"./00002/00002-08/00002-08-01/we love the mountains.mp3": [
		3877,
		2552
	],
	"./00002/00002-08/00002-08-01/we love the rivers.mp3": [
		3878,
		2553
	],
	"./00002/00002-08/00002-08-01/we love the sea.mp3": [
		3879,
		2554
	],
	"./00002/00002-08/00002-08-02/earth is the 3rd planet.mp3": [
		3880,
		2555
	],
	"./00002/00002-08/00002-08-02/here is jupiter.mp3": [
		3881,
		2556
	],
	"./00002/00002-08/00002-08-02/here is mars.mp3": [
		3882,
		2557
	],
	"./00002/00002-08/00002-08-02/here is mercury.mp3": [
		3883,
		2558
	],
	"./00002/00002-08/00002-08-02/here is saturn.mp3": [
		3884,
		2559
	],
	"./00002/00002-08/00002-08-02/here is the earth.mp3": [
		3885,
		2560
	],
	"./00002/00002-08/00002-08-02/here is venus.mp3": [
		3886,
		2561
	],
	"./00002/00002-08/00002-08-02/intro.mp3": [
		552
	],
	"./00002/00002-08/00002-08-02/jupiter is the 5th planet.mp3": [
		3887,
		2562
	],
	"./00002/00002-08/00002-08-02/main idea.mp3": [
		933
	],
	"./00002/00002-08/00002-08-02/mars is the 4th planet.mp3": [
		3888,
		2563
	],
	"./00002/00002-08/00002-08-02/mercury is the 1st planet.mp3": [
		3889,
		2564
	],
	"./00002/00002-08/00002-08-02/neptune is the 8th planet.mp3": [
		3890,
		2565
	],
	"./00002/00002-08/00002-08-02/saturn is the 6th planet.mp3": [
		3891,
		2566
	],
	"./00002/00002-08/00002-08-02/the planets.mp3": [
		3892,
		2567
	],
	"./00002/00002-08/00002-08-02/things in space.mp3": [
		3893,
		2568
	],
	"./00002/00002-08/00002-08-02/uranus is the 7th planet.mp3": [
		3894,
		2569
	],
	"./00002/00002-08/00002-08-02/venus is the 2nd planet.mp3": [
		3895,
		2570
	],
	"./00002/00002-08/00002-08-02/venus is the second planet.mp3": [
		3896,
		2571
	],
	"./00002/00002-08/00002-08-03/animals that live in the snow.mp3": [
		3897,
		2572
	],
	"./00002/00002-08/00002-08-03/in the winter.mp3": [
		3898,
		2573
	],
	"./00002/00002-08/00002-08-03/intro.mp3": [
		553
	],
	"./00002/00002-08/00002-08-03/it is winter.mp3": [
		3899,
		2574
	],
	"./00002/00002-08/00002-08-03/look at the bear.mp3": [
		3900,
		2575
	],
	"./00002/00002-08/00002-08-03/look at the frost.mp3": [
		3901,
		2576
	],
	"./00002/00002-08/00002-08-03/look at the ice.mp3": [
		3902,
		2577
	],
	"./00002/00002-08/00002-08-03/look at the mountains.mp3": [
		3903,
		2578
	],
	"./00002/00002-08/00002-08-03/look at the pond.mp3": [
		3904,
		2579
	],
	"./00002/00002-08/00002-08-03/look at the river.mp3": [
		3905,
		2580
	],
	"./00002/00002-08/00002-08-03/look at the trees.mp3": [
		3906,
		2581
	],
	"./00002/00002-08/00002-08-03/main idea.mp3": [
		934
	],
	"./00002/00002-08/00002-08-04/i can see 2 lambs.mp3": [
		3907,
		2582
	],
	"./00002/00002-08/00002-08-04/i can see 3 frogs.mp3": [
		3908,
		2583
	],
	"./00002/00002-08/00002-08-04/i can see 4 chicks.mp3": [
		3909,
		2584
	],
	"./00002/00002-08/00002-08-04/i can see 5 ducklings.mp3": [
		3910,
		2585
	],
	"./00002/00002-08/00002-08-04/i can see 6 butterflies.mp3": [
		3911,
		2586
	],
	"./00002/00002-08/00002-08-04/i can see 7 flowers.mp3": [
		3912,
		2587
	],
	"./00002/00002-08/00002-08-04/i can see the rain.mp3": [
		3913,
		2588
	],
	"./00002/00002-08/00002-08-04/intro.mp3": [
		554
	],
	"./00002/00002-08/00002-08-04/main idea.mp3": [
		935
	],
	"./00002/00002-08/00002-08-04/signs of spring.mp3": [
		3914,
		2589
	],
	"./00002/00002-08/00002-08-04/spring is here.mp3": [
		3915,
		2590
	],
	"./00002/00002-08/00002-08-04/spring is on the way.mp3": [
		3916,
		2591
	],
	"./00002/00002-08/00002-08-04/what can i see.mp3": [
		3917,
		2592
	],
	"./00002/00002-08/00002-08-05/i like summer.mp3": [
		3918,
		2593
	],
	"./00002/00002-08/00002-08-05/i like the hermit crab.mp3": [
		3919,
		2594
	],
	"./00002/00002-08/00002-08-05/i like the sandcastle.mp3": [
		3920,
		2595
	],
	"./00002/00002-08/00002-08-05/i like the sea.mp3": [
		3921,
		2596
	],
	"./00002/00002-08/00002-08-05/i like the seagull.mp3": [
		3922,
		2597
	],
	"./00002/00002-08/00002-08-05/i like the shell.mp3": [
		3923,
		2598
	],
	"./00002/00002-08/00002-08-05/i like the starfish.mp3": [
		3924,
		2599
	],
	"./00002/00002-08/00002-08-05/i like the sun.mp3": [
		3925,
		2600
	],
	"./00002/00002-08/00002-08-05/intro.mp3": [
		555
	],
	"./00002/00002-08/00002-08-05/main idea.mp3": [
		936
	],
	"./00002/00002-08/00002-08-05/sea animals.mp3": [
		3926,
		2601
	],
	"./00002/00002-08/00002-08-06/colors in the fall.mp3": [
		3927,
		2602
	],
	"./00002/00002-08/00002-08-06/intro.mp3": [
		556
	],
	"./00002/00002-08/00002-08-06/look at the ant.mp3": [
		3928,
		2603
	],
	"./00002/00002-08/00002-08-06/look at the bear.mp3": [
		3929,
		2604
	],
	"./00002/00002-08/00002-08-06/look at the bird.mp3": [
		3930,
		2605
	],
	"./00002/00002-08/00002-08-06/look at the brown nuts.mp3": [
		3931,
		2606
	],
	"./00002/00002-08/00002-08-06/look at the cow.mp3": [
		3932,
		2607
	],
	"./00002/00002-08/00002-08-06/look at the gray geese.mp3": [
		3933,
		2608
	],
	"./00002/00002-08/00002-08-06/look at the green apples.mp3": [
		3934,
		2609
	],
	"./00002/00002-08/00002-08-06/look at the horse.mp3": [
		3935,
		2610
	],
	"./00002/00002-08/00002-08-06/look at the orange pumpkin.mp3": [
		3936,
		2611
	],
	"./00002/00002-08/00002-08-06/look at the purple grapes.mp3": [
		3937,
		2612
	],
	"./00002/00002-08/00002-08-06/look at the red leaves.mp3": [
		3938,
		2613
	],
	"./00002/00002-08/00002-08-06/look at the squirrel.mp3": [
		3939,
		2614
	],
	"./00002/00002-08/00002-08-06/look at the trees.mp3": [
		3940,
		2615
	],
	"./00002/00002-08/00002-08-06/look at the yellow hay.mp3": [
		3941,
		2616
	],
	"./00002/00002-08/00002-08-06/main idea.mp3": [
		937
	],
	"./00002/00002-08/00002-08-06/things we see in the fall.mp3": [
		3942,
		2617
	],
	"./00002/00002-08/00002-08-07/intro.mp3": [
		557
	],
	"./00002/00002-08/00002-08-07/main idea.mp3": [
		938
	],
	"./00002/00002-08/00002-08-07/things we see in the soil.mp3": [
		3943,
		2618
	],
	"./00002/00002-08/00002-08-07/we can see ants.mp3": [
		3944,
		2619
	],
	"./00002/00002-08/00002-08-07/we can see bones.mp3": [
		3945,
		2620
	],
	"./00002/00002-08/00002-08-07/we can see leaves.mp3": [
		3946,
		2621
	],
	"./00002/00002-08/00002-08-07/we can see rocks.mp3": [
		3947,
		2622
	],
	"./00002/00002-08/00002-08-07/we can see roots.mp3": [
		3948,
		2623
	],
	"./00002/00002-08/00002-08-07/we can see shells.mp3": [
		3949,
		2624
	],
	"./00002/00002-08/00002-08-07/we can see worms.mp3": [
		3950,
		2625
	],
	"./00002/00002-08/00002-08-07/what is in the soil.mp3": [
		3951,
		2626
	],
	"./00002/00002-08/00002-08-08/alligator likes the green rock.mp3": [
		3952,
		2627
	],
	"./00002/00002-08/00002-08-08/cheetah likes the yellow rock.mp3": [
		3953,
		2628
	],
	"./00002/00002-08/00002-08-08/chipmunk likes the brown rock.mp3": [
		3954,
		2629
	],
	"./00002/00002-08/00002-08-08/elephant likes the gray rock.mp3": [
		3955,
		2630
	],
	"./00002/00002-08/00002-08-08/fox likes the red rock.mp3": [
		3956,
		2631
	],
	"./00002/00002-08/00002-08-08/intro.mp3": [
		558
	],
	"./00002/00002-08/00002-08-08/look at my rock he said.mp3": [
		3957,
		2632
	],
	"./00002/00002-08/00002-08-08/look at my rock she said.mp3": [
		3958,
		2633
	],
	"./00002/00002-08/00002-08-08/main idea.mp3": [
		939
	],
	"./00002/00002-08/00002-08-08/non living things.mp3": [
		3959,
		2634
	],
	"./00002/00002-08/00002-08-08/rocks.mp3": [
		3960,
		2635
	],
	"./00002/00002-08/00002-08-08/skunk likes the black rock.mp3": [
		3961,
		2636
	],
	"./00002/00002-08/00002-08-08/tiger likes the orange rock.mp3": [
		3962,
		2637
	],
	"./00002/00002-08/00002-08-09/intro.mp3": [
		559
	],
	"./00002/00002-08/00002-08-09/look up in the sky.mp3": [
		3963,
		2638
	],
	"./00002/00002-08/00002-08-09/main idea.mp3": [
		940
	],
	"./00002/00002-08/00002-08-09/things in the sky.mp3": [
		3964,
		2639
	],
	"./00002/00002-08/00002-08-09/what can you see in the sky.mp3": [
		3965,
		2640
	],
	"./00002/00002-08/00002-08-09/you can see a dragon.mp3": [
		3966,
		2641
	],
	"./00002/00002-08/00002-08-09/you can see the clouds.mp3": [
		3967,
		2642
	],
	"./00002/00002-08/00002-08-09/you can see the moon.mp3": [
		3968,
		2643
	],
	"./00002/00002-08/00002-08-09/you can see the rain.mp3": [
		3969,
		2644
	],
	"./00002/00002-08/00002-08-09/you can see the rainbow.mp3": [
		3970,
		2645
	],
	"./00002/00002-08/00002-08-09/you can see the stars.mp3": [
		3971,
		2646
	],
	"./00002/00002-08/00002-08-09/you can see the sun.mp3": [
		3972,
		2647
	],
	"./00002/00002-08/00002-08-10/intro.mp3": [
		560
	],
	"./00002/00002-08/00002-08-10/it is a cloudy day.mp3": [
		3973,
		2648
	],
	"./00002/00002-08/00002-08-10/it is a rainy day.mp3": [
		3974,
		2649
	],
	"./00002/00002-08/00002-08-10/it is a rainy night.mp3": [
		3975,
		2650
	],
	"./00002/00002-08/00002-08-10/it is a snowy day.mp3": [
		3976,
		2651
	],
	"./00002/00002-08/00002-08-10/it is a snowy night.mp3": [
		3977,
		2652
	],
	"./00002/00002-08/00002-08-10/it is a sunny day.mp3": [
		3978,
		2653
	],
	"./00002/00002-08/00002-08-10/it is a windy day.mp3": [
		3979,
		2654
	],
	"./00002/00002-08/00002-08-10/look at me.mp3": [
		3980,
		2655
	],
	"./00002/00002-08/00002-08-10/look at us.mp3": [
		3981,
		2656
	],
	"./00002/00002-08/00002-08-10/main idea.mp3": [
		941
	],
	"./00002/00002-08/00002-08-10/weather.mp3": [
		3982,
		2657
	],
	"./00002/00002-08/earth and space.mp3": [
		3983,
		2658
	],
	"./00002/00002-09/00002-09-01/fish.mp3": [
		3984,
		2659
	],
	"./00002/00002-09/00002-09-01/i am a dolphin.mp3": [
		3985,
		2660
	],
	"./00002/00002-09/00002-09-01/i am a fish.mp3": [
		3986,
		2661
	],
	"./00002/00002-09/00002-09-01/i am a flying fish.mp3": [
		3987,
		2662
	],
	"./00002/00002-09/00002-09-01/i am a hammerhead shark.mp3": [
		3988,
		2663
	],
	"./00002/00002-09/00002-09-01/i am a seahorse.mp3": [
		3989,
		2664
	],
	"./00002/00002-09/00002-09-01/i am a shark.mp3": [
		3990,
		2665
	],
	"./00002/00002-09/00002-09-01/i am a swordfish.mp3": [
		3991,
		2666
	],
	"./00002/00002-09/00002-09-01/i am an eel.mp3": [
		3992,
		2667
	],
	"./00002/00002-09/00002-09-01/i am not a fish.mp3": [
		3993,
		2668
	],
	"./00002/00002-09/00002-09-01/i live in the water.mp3": [
		3994,
		2669
	],
	"./00002/00002-09/00002-09-01/intro.mp3": [
		561
	],
	"./00002/00002-09/00002-09-01/main idea.mp3": [
		942
	],
	"./00002/00002-09/00002-09-02/here is a skunk.mp3": [
		3995,
		2670
	],
	"./00002/00002-09/00002-09-02/i am a fox.mp3": [
		3996,
		2671
	],
	"./00002/00002-09/00002-09-02/i am a mammal.mp3": [
		3997,
		2672
	],
	"./00002/00002-09/00002-09-02/i am a panda.mp3": [
		3998,
		2673
	],
	"./00002/00002-09/00002-09-02/i am a shark.mp3": [
		3999,
		2674
	],
	"./00002/00002-09/00002-09-02/i am a zebra.mp3": [
		4000,
		2675
	],
	"./00002/00002-09/00002-09-02/i am not a mammal.mp3": [
		4001,
		2676
	],
	"./00002/00002-09/00002-09-02/i like the bat.mp3": [
		4002,
		2677
	],
	"./00002/00002-09/00002-09-02/i like the skunk.mp3": [
		4003,
		2678
	],
	"./00002/00002-09/00002-09-02/i like the whale.mp3": [
		4004,
		2679
	],
	"./00002/00002-09/00002-09-02/i see a whale.mp3": [
		4005,
		2680
	],
	"./00002/00002-09/00002-09-02/intro.mp3": [
		562
	],
	"./00002/00002-09/00002-09-02/look at the bat.mp3": [
		4006,
		2681
	],
	"./00002/00002-09/00002-09-02/main idea.mp3": [
		943
	],
	"./00002/00002-09/00002-09-02/mammals.mp3": [
		4007,
		2682
	],
	"./00002/00002-09/00002-09-03/alligators are reptiles.mp3": [
		4008,
		2683
	],
	"./00002/00002-09/00002-09-03/here is a sea turtle.mp3": [
		4009,
		2684
	],
	"./00002/00002-09/00002-09-03/intro.mp3": [
		563
	],
	"./00002/00002-09/00002-09-03/lizards are reptiles.mp3": [
		4010,
		2685
	],
	"./00002/00002-09/00002-09-03/look at the alligator.mp3": [
		4011,
		2686
	],
	"./00002/00002-09/00002-09-03/look at the crocodile.mp3": [
		4012,
		2687
	],
	"./00002/00002-09/00002-09-03/look at the iguana.mp3": [
		4013,
		2688
	],
	"./00002/00002-09/00002-09-03/look at the lizard.mp3": [
		4014,
		2689
	],
	"./00002/00002-09/00002-09-03/look at the reptiles.mp3": [
		4015,
		2690
	],
	"./00002/00002-09/00002-09-03/look at the sea turtle.mp3": [
		4016,
		2691
	],
	"./00002/00002-09/00002-09-03/look at the snake.mp3": [
		4017,
		2692
	],
	"./00002/00002-09/00002-09-03/look at the turtle.mp3": [
		4018,
		2693
	],
	"./00002/00002-09/00002-09-03/main idea.mp3": [
		944
	],
	"./00002/00002-09/00002-09-03/reptiles.mp3": [
		4019,
		2694
	],
	"./00002/00002-09/00002-09-03/snakes are reptiles.mp3": [
		4020,
		2695
	],
	"./00002/00002-09/00002-09-03/the crocodile is a reptile.mp3": [
		4021,
		2696
	],
	"./00002/00002-09/00002-09-03/turtles are reptiles.mp3": [
		4022,
		2697
	],
	"./00002/00002-09/00002-09-04/amphibians.mp3": [
		4023,
		2698
	],
	"./00002/00002-09/00002-09-04/i am a shark.mp3": [
		4024,
		2699
	],
	"./00002/00002-09/00002-09-04/i am an amphibian said the frog.mp3": [
		4025,
		2700
	],
	"./00002/00002-09/00002-09-04/i am an amphibian said the salamander.mp3": [
		4026,
		2701
	],
	"./00002/00002-09/00002-09-04/i am an amphibian said the toad.mp3": [
		4027,
		2702
	],
	"./00002/00002-09/00002-09-04/i am not an amphibian.mp3": [
		4028,
		2703
	],
	"./00002/00002-09/00002-09-04/i can see 1 frog.mp3": [
		4029,
		2704
	],
	"./00002/00002-09/00002-09-04/i can see 1 salamander.mp3": [
		4030,
		2705
	],
	"./00002/00002-09/00002-09-04/i can see 1 toad.mp3": [
		4031,
		2706
	],
	"./00002/00002-09/00002-09-04/i can see 2 frogs.mp3": [
		4032,
		2707
	],
	"./00002/00002-09/00002-09-04/i can see 2 salamanders.mp3": [
		4033,
		2708
	],
	"./00002/00002-09/00002-09-04/i can see 2 toads.mp3": [
		4034,
		2709
	],
	"./00002/00002-09/00002-09-04/i can see 6 amphibians.mp3": [
		4035,
		2710
	],
	"./00002/00002-09/00002-09-04/intro.mp3": [
		564
	],
	"./00002/00002-09/00002-09-04/look at the frog.mp3": [
		4036,
		2711
	],
	"./00002/00002-09/00002-09-04/look at the salamander.mp3": [
		4037,
		2712
	],
	"./00002/00002-09/00002-09-04/look at the toad.mp3": [
		4038,
		2713
	],
	"./00002/00002-09/00002-09-04/main idea.mp3": [
		945
	],
	"./00002/00002-09/00002-09-05/birds.mp3": [
		4039,
		2714
	],
	"./00002/00002-09/00002-09-05/here is a duck.mp3": [
		4040,
		2715
	],
	"./00002/00002-09/00002-09-05/i am a bird.mp3": [
		4041,
		2716
	],
	"./00002/00002-09/00002-09-05/i am a parrot.mp3": [
		4042,
		2717
	],
	"./00002/00002-09/00002-09-05/i am a penguin.mp3": [
		4043,
		2718
	],
	"./00002/00002-09/00002-09-05/i see a flamingo.mp3": [
		4044,
		2719
	],
	"./00002/00002-09/00002-09-05/i see the ostrich.mp3": [
		4045,
		2720
	],
	"./00002/00002-09/00002-09-05/intro.mp3": [
		565
	],
	"./00002/00002-09/00002-09-05/look at the bat.mp3": [
		4046,
		2721
	],
	"./00002/00002-09/00002-09-05/look at the eagle.mp3": [
		4047,
		2722
	],
	"./00002/00002-09/00002-09-05/main idea.mp3": [
		946
	],
	"./00002/00002-09/00002-09-05/the bat is not a bird.mp3": [
		4048,
		2723
	],
	"./00002/00002-09/00002-09-05/the duck is a bird.mp3": [
		4049,
		2724
	],
	"./00002/00002-09/00002-09-05/the eagle is a bird.mp3": [
		4050,
		2725
	],
	"./00002/00002-09/00002-09-05/the flamingo is a bird.mp3": [
		4051,
		2726
	],
	"./00002/00002-09/00002-09-05/the ostrich is a bird.mp3": [
		4052,
		2727
	],
	"./00002/00002-09/00002-09-05/the penguin is a bird.mp3": [
		4053,
		2728
	],
	"./00002/00002-09/00002-09-05/the rooster is a bird.mp3": [
		4054,
		2729
	],
	"./00002/00002-09/00002-09-06/a crab has no backbone.mp3": [
		4055,
		2730
	],
	"./00002/00002-09/00002-09-06/a jellyfish has no backbone.mp3": [
		4056,
		2731
	],
	"./00002/00002-09/00002-09-06/a ladybug has no backbone.mp3": [
		4057,
		2732
	],
	"./00002/00002-09/00002-09-06/a spider has no backbone.mp3": [
		4058,
		2733
	],
	"./00002/00002-09/00002-09-06/a worm has no backbone.mp3": [
		4059,
		2734
	],
	"./00002/00002-09/00002-09-06/animals without backbones.mp3": [
		4060,
		2735
	],
	"./00002/00002-09/00002-09-06/here is a butterfly.mp3": [
		4061,
		2736
	],
	"./00002/00002-09/00002-09-06/here is a jellyfish.mp3": [
		4062,
		2737
	],
	"./00002/00002-09/00002-09-06/here is a ladybug.mp3": [
		4063,
		2738
	],
	"./00002/00002-09/00002-09-06/here is a lobster.mp3": [
		4064,
		2739
	],
	"./00002/00002-09/00002-09-06/here is a slug.mp3": [
		4065,
		2740
	],
	"./00002/00002-09/00002-09-06/here is a squid.mp3": [
		4066,
		2741
	],
	"./00002/00002-09/00002-09-06/i see a worm.mp3": [
		4067,
		2742
	],
	"./00002/00002-09/00002-09-06/i see the spider.mp3": [
		4068,
		2743
	],
	"./00002/00002-09/00002-09-06/intro.mp3": [
		566
	],
	"./00002/00002-09/00002-09-06/look at the crab.mp3": [
		4069,
		2744
	],
	"./00002/00002-09/00002-09-06/look at the octopus.mp3": [
		4070,
		2745
	],
	"./00002/00002-09/00002-09-06/main idea.mp3": [
		947
	],
	"./00002/00002-09/00002-09-06/the octopus has no backbone.mp3": [
		4071,
		2746
	],
	"./00002/00002-09/00002-09-07/i am an insect said the ant.mp3": [
		4072,
		2747
	],
	"./00002/00002-09/00002-09-07/i am an insect said the butterfly.mp3": [
		4073,
		2748
	],
	"./00002/00002-09/00002-09-07/i am an insect said the grasshopper.mp3": [
		4074,
		2749
	],
	"./00002/00002-09/00002-09-07/i am an insect.mp3": [
		4075,
		2750
	],
	"./00002/00002-09/00002-09-07/i am not an insect.mp3": [
		4076,
		2751
	],
	"./00002/00002-09/00002-09-07/i have 6 legs said the bee.mp3": [
		4077,
		2752
	],
	"./00002/00002-09/00002-09-07/i have 6 legs said the dragonfly.mp3": [
		4078,
		2753
	],
	"./00002/00002-09/00002-09-07/i have 6 legs said the ladybug.mp3": [
		4079,
		2754
	],
	"./00002/00002-09/00002-09-07/i have 6 legs.mp3": [
		4080,
		2755
	],
	"./00002/00002-09/00002-09-07/i have 8 legs said the spider.mp3": [
		4081,
		2756
	],
	"./00002/00002-09/00002-09-07/insects.mp3": [
		4082,
		2757
	],
	"./00002/00002-09/00002-09-07/intro.mp3": [
		567
	],
	"./00002/00002-09/00002-09-07/main idea.mp3": [
		948
	],
	"./00002/00002-09/00002-09-08/big animals.mp3": [
		4083,
		2758
	],
	"./00002/00002-09/00002-09-08/here is a dinosaur.mp3": [
		4084,
		2759
	],
	"./00002/00002-09/00002-09-08/here is a squid.mp3": [
		4085,
		2760
	],
	"./00002/00002-09/00002-09-08/i can see a giraffe.mp3": [
		4086,
		2761
	],
	"./00002/00002-09/00002-09-08/i can see an ostrich.mp3": [
		4087,
		2762
	],
	"./00002/00002-09/00002-09-08/i see a shark.mp3": [
		4088,
		2763
	],
	"./00002/00002-09/00002-09-08/i see a whale.mp3": [
		4089,
		2764
	],
	"./00002/00002-09/00002-09-08/intro.mp3": [
		568
	],
	"./00002/00002-09/00002-09-08/look at the elephant.mp3": [
		4090,
		2765
	],
	"./00002/00002-09/00002-09-08/main idea.mp3": [
		949
	],
	"./00002/00002-09/00002-09-08/this dinosaur is huge.mp3": [
		4091,
		2766
	],
	"./00002/00002-09/00002-09-08/this elephant is big.mp3": [
		4092,
		2767
	],
	"./00002/00002-09/00002-09-08/this giraffe is big.mp3": [
		4093,
		2768
	],
	"./00002/00002-09/00002-09-08/this ostrich is big.mp3": [
		4094,
		2769
	],
	"./00002/00002-09/00002-09-08/this squid is big.mp3": [
		4095,
		2770
	],
	"./00002/00002-09/00002-09-08/this whale is big.mp3": [
		4096,
		2771
	],
	"./00002/00002-09/00002-09-08/this whale shark is big.mp3": [
		4097,
		2772
	],
	"./00002/00002-09/00002-09-09/animals we saw in the book.mp3": [
		4098,
		2773
	],
	"./00002/00002-09/00002-09-09/here is a frog.mp3": [
		4099,
		2774
	],
	"./00002/00002-09/00002-09-09/intro.mp3": [
		569
	],
	"./00002/00002-09/00002-09-09/look at the ladybug.mp3": [
		4100,
		2775
	],
	"./00002/00002-09/00002-09-09/main idea.mp3": [
		950
	],
	"./00002/00002-09/00002-09-09/the alligator is a reptile.mp3": [
		4101,
		2776
	],
	"./00002/00002-09/00002-09-09/the animal book.mp3": [
		4102,
		2777
	],
	"./00002/00002-09/00002-09-09/the cat is a mammal.mp3": [
		4103,
		2778
	],
	"./00002/00002-09/00002-09-09/the dolphin is a mammal.mp3": [
		4104,
		2779
	],
	"./00002/00002-09/00002-09-09/the eagle is a bird.mp3": [
		4105,
		2780
	],
	"./00002/00002-09/00002-09-09/the frog is an amphibian.mp3": [
		4106,
		2781
	],
	"./00002/00002-09/00002-09-09/the ladybug is an insect.mp3": [
		4107,
		2782
	],
	"./00002/00002-09/00002-09-09/the penguin is a bird.mp3": [
		4108,
		2783
	],
	"./00002/00002-09/00002-09-09/the seahorse is a fish.mp3": [
		4109,
		2784
	],
	"./00002/00002-09/00002-09-09/the shark is a fish.mp3": [
		4110,
		2785
	],
	"./00002/00002-09/00002-09-09/the skunk is a mammal.mp3": [
		4111,
		2786
	],
	"./00002/00002-09/00002-09-09/the turtle is a reptile.mp3": [
		4112,
		2787
	],
	"./00002/00002-09/00002-09-09/the whale is a mammal.mp3": [
		4113,
		2788
	],
	"./00002/00002-09/00002-09-10/dinosaurs.mp3": [
		4114,
		2789
	],
	"./00002/00002-09/00002-09-10/i am a long neck dinosaur.mp3": [
		4115,
		2790
	],
	"./00002/00002-09/00002-09-10/i am a pterosaur.mp3": [
		4116,
		2791
	],
	"./00002/00002-09/00002-09-10/i am a raptor.mp3": [
		4117,
		2792
	],
	"./00002/00002-09/00002-09-10/i am a stegosaurus.mp3": [
		4118,
		2793
	],
	"./00002/00002-09/00002-09-10/i am a swimming dinosaur.mp3": [
		4119,
		2794
	],
	"./00002/00002-09/00002-09-10/i am a t rex.mp3": [
		4120,
		2795
	],
	"./00002/00002-09/00002-09-10/i am a triceratops.mp3": [
		4121,
		2796
	],
	"./00002/00002-09/00002-09-10/intro.mp3": [
		570
	],
	"./00002/00002-09/00002-09-10/look at me.mp3": [
		4122,
		2797
	],
	"./00002/00002-09/00002-09-10/main idea.mp3": [
		951
	],
	"./00002/00002-09/animal groups.mp3": [
		4123,
		2798
	],
	"./00002/00002-10/00002-10-01/animals with 4 legs.mp3": [
		4124,
		2799
	],
	"./00002/00002-10/00002-10-01/i am a dog.mp3": [
		4125,
		2800
	],
	"./00002/00002-10/00002-10-01/i am a ladybug.mp3": [
		4126,
		2801
	],
	"./00002/00002-10/00002-10-01/i am a monster.mp3": [
		4127,
		2802
	],
	"./00002/00002-10/00002-10-01/i am a parrot.mp3": [
		4128,
		2803
	],
	"./00002/00002-10/00002-10-01/i am a spider.mp3": [
		4129,
		2804
	],
	"./00002/00002-10/00002-10-01/i am a squid.mp3": [
		4130,
		2805
	],
	"./00002/00002-10/00002-10-01/i am a tiger.mp3": [
		4131,
		2806
	],
	"./00002/00002-10/00002-10-01/i have 10 legs.mp3": [
		4132,
		2807
	],
	"./00002/00002-10/00002-10-01/i have 12 legs.mp3": [
		4133,
		2808
	],
	"./00002/00002-10/00002-10-01/i have 2 legs.mp3": [
		4134,
		2809
	],
	"./00002/00002-10/00002-10-01/i have 3 legs.mp3": [
		4135,
		2810
	],
	"./00002/00002-10/00002-10-01/i have 4 legs.mp3": [
		4136,
		2811
	],
	"./00002/00002-10/00002-10-01/i have 6 legs.mp3": [
		4137,
		2812
	],
	"./00002/00002-10/00002-10-01/i have 8 legs.mp3": [
		4138,
		2813
	],
	"./00002/00002-10/00002-10-01/intro.mp3": [
		571
	],
	"./00002/00002-10/00002-10-01/legs.mp3": [
		4139,
		2814
	],
	"./00002/00002-10/00002-10-01/main idea.mp3": [
		952
	],
	"./00002/00002-10/00002-10-02/animals with spots.mp3": [
		4140,
		2815
	],
	"./00002/00002-10/00002-10-02/intro.mp3": [
		572
	],
	"./00002/00002-10/00002-10-02/look at the deer.mp3": [
		4141,
		2816
	],
	"./00002/00002-10/00002-10-02/look at the dinosaur.mp3": [
		4142,
		2817
	],
	"./00002/00002-10/00002-10-02/look at the giraffe.mp3": [
		4143,
		2818
	],
	"./00002/00002-10/00002-10-02/look at the ladybug.mp3": [
		4144,
		2819
	],
	"./00002/00002-10/00002-10-02/look at the raccoon.mp3": [
		4145,
		2820
	],
	"./00002/00002-10/00002-10-02/look at the tiger.mp3": [
		4146,
		2821
	],
	"./00002/00002-10/00002-10-02/look at the zebra.mp3": [
		4147,
		2822
	],
	"./00002/00002-10/00002-10-02/main idea.mp3": [
		953
	],
	"./00002/00002-10/00002-10-02/stripes and spots.mp3": [
		4148,
		2823
	],
	"./00002/00002-10/00002-10-02/the deer has spots.mp3": [
		4149,
		2824
	],
	"./00002/00002-10/00002-10-02/the dinosaur has spots too.mp3": [
		4150,
		2825
	],
	"./00002/00002-10/00002-10-02/the giraffe has spots.mp3": [
		4151,
		2826
	],
	"./00002/00002-10/00002-10-02/the ladybug has spots.mp3": [
		4152,
		2827
	],
	"./00002/00002-10/00002-10-02/the raccoon has stripes.mp3": [
		4153,
		2828
	],
	"./00002/00002-10/00002-10-02/the tiger has stripes.mp3": [
		4154,
		2829
	],
	"./00002/00002-10/00002-10-02/the zebra has stripes.mp3": [
		4155,
		2830
	],
	"./00002/00002-10/00002-10-03/animals with 2 eyes.mp3": [
		4156,
		2831
	],
	"./00002/00002-10/00002-10-03/eyes.mp3": [
		4157,
		2832
	],
	"./00002/00002-10/00002-10-03/i am a frog.mp3": [
		4158,
		2833
	],
	"./00002/00002-10/00002-10-03/i am a grasshopper.mp3": [
		4159,
		2834
	],
	"./00002/00002-10/00002-10-03/i am a hammerhead shark.mp3": [
		4160,
		2835
	],
	"./00002/00002-10/00002-10-03/i am a monster.mp3": [
		4161,
		2836
	],
	"./00002/00002-10/00002-10-03/i am a spider.mp3": [
		4162,
		2837
	],
	"./00002/00002-10/00002-10-03/i am a starfish.mp3": [
		4163,
		2838
	],
	"./00002/00002-10/00002-10-03/i am an owl.mp3": [
		4164,
		2839
	],
	"./00002/00002-10/00002-10-03/i have 10 eyes.mp3": [
		4165,
		2840
	],
	"./00002/00002-10/00002-10-03/i have 2 eyes.mp3": [
		4166,
		2841
	],
	"./00002/00002-10/00002-10-03/i have 5 eyes.mp3": [
		4167,
		2842
	],
	"./00002/00002-10/00002-10-03/i have 8 eyes.mp3": [
		4168,
		2843
	],
	"./00002/00002-10/00002-10-03/intro.mp3": [
		573
	],
	"./00002/00002-10/00002-10-03/main idea.mp3": [
		954
	],
	"./00002/00002-10/00002-10-04/animals with 2 horns.mp3": [
		4169,
		2844
	],
	"./00002/00002-10/00002-10-04/here is a cow.mp3": [
		4170,
		2845
	],
	"./00002/00002-10/00002-10-04/here is a dinosaur.mp3": [
		4171,
		2846
	],
	"./00002/00002-10/00002-10-04/here is a giraffe.mp3": [
		4172,
		2847
	],
	"./00002/00002-10/00002-10-04/here is a goat.mp3": [
		4173,
		2848
	],
	"./00002/00002-10/00002-10-04/here is a monster.mp3": [
		4174,
		2849
	],
	"./00002/00002-10/00002-10-04/here is a rhino.mp3": [
		4175,
		2850
	],
	"./00002/00002-10/00002-10-04/here is a unicorn.mp3": [
		4176,
		2851
	],
	"./00002/00002-10/00002-10-04/horns.mp3": [
		4177,
		2852
	],
	"./00002/00002-10/00002-10-04/intro.mp3": [
		574
	],
	"./00002/00002-10/00002-10-04/main idea.mp3": [
		955
	],
	"./00002/00002-10/00002-10-04/the cow has 2 horns.mp3": [
		4178,
		2853
	],
	"./00002/00002-10/00002-10-04/the dinosaur has 3 horns.mp3": [
		4179,
		2854
	],
	"./00002/00002-10/00002-10-04/the giraffe has 2 horns.mp3": [
		4180,
		2855
	],
	"./00002/00002-10/00002-10-04/the goat has 2 horns.mp3": [
		4181,
		2856
	],
	"./00002/00002-10/00002-10-04/the monster has horns too.mp3": [
		4182,
		2857
	],
	"./00002/00002-10/00002-10-04/the rhino has 2 horns.mp3": [
		4183,
		2858
	],
	"./00002/00002-10/00002-10-04/the unicorn has 1 horn.mp3": [
		4184,
		2859
	],
	"./00002/00002-10/00002-10-05/animals with long necks.mp3": [
		4185,
		2860
	],
	"./00002/00002-10/00002-10-05/i can see a camel.mp3": [
		4186,
		2861
	],
	"./00002/00002-10/00002-10-05/i can see a dinosaur.mp3": [
		4187,
		2862
	],
	"./00002/00002-10/00002-10-05/i can see a flamingo.mp3": [
		4188,
		2863
	],
	"./00002/00002-10/00002-10-05/i can see a giraffe.mp3": [
		4189,
		2864
	],
	"./00002/00002-10/00002-10-05/i can see a goose.mp3": [
		4190,
		2865
	],
	"./00002/00002-10/00002-10-05/i can see a pig.mp3": [
		4191,
		2866
	],
	"./00002/00002-10/00002-10-05/i can see a rhino.mp3": [
		4192,
		2867
	],
	"./00002/00002-10/00002-10-05/i can see a seal.mp3": [
		4193,
		2868
	],
	"./00002/00002-10/00002-10-05/i can see a snake.mp3": [
		4194,
		2869
	],
	"./00002/00002-10/00002-10-05/i can see an ostrich.mp3": [
		4195,
		2870
	],
	"./00002/00002-10/00002-10-05/intro.mp3": [
		575
	],
	"./00002/00002-10/00002-10-05/main idea.mp3": [
		956
	],
	"./00002/00002-10/00002-10-05/necks.mp3": [
		4196,
		2871
	],
	"./00002/00002-10/00002-10-05/the dinosaur has a long neck too.mp3": [
		4197,
		2872
	],
	"./00002/00002-10/00002-10-05/the giraffe has a long neck.mp3": [
		4198,
		2873
	],
	"./00002/00002-10/00002-10-05/the goose has a long neck.mp3": [
		4199,
		2874
	],
	"./00002/00002-10/00002-10-05/the ostrich has a long neck.mp3": [
		4200,
		2875
	],
	"./00002/00002-10/00002-10-05/the pig has a short neck.mp3": [
		4201,
		2876
	],
	"./00002/00002-10/00002-10-05/the rhino has a short neck.mp3": [
		4202,
		2877
	],
	"./00002/00002-10/00002-10-05/the seal has a short neck.mp3": [
		4203,
		2878
	],
	"./00002/00002-10/00002-10-06/animals we saw in the book.mp3": [
		4204,
		2879
	],
	"./00002/00002-10/00002-10-06/animals with long teeth.mp3": [
		4205,
		2880
	],
	"./00002/00002-10/00002-10-06/intro.mp3": [
		576
	],
	"./00002/00002-10/00002-10-06/look at the alligator.mp3": [
		4206,
		2881
	],
	"./00002/00002-10/00002-10-06/look at the bat.mp3": [
		4207,
		2882
	],
	"./00002/00002-10/00002-10-06/look at the beaver.mp3": [
		4208,
		2883
	],
	"./00002/00002-10/00002-10-06/look at the dinosaur.mp3": [
		4209,
		2884
	],
	"./00002/00002-10/00002-10-06/look at the eel.mp3": [
		4210,
		2885
	],
	"./00002/00002-10/00002-10-06/look at the elephant.mp3": [
		4211,
		2886
	],
	"./00002/00002-10/00002-10-06/look at the walrus.mp3": [
		4212,
		2887
	],
	"./00002/00002-10/00002-10-06/main idea.mp3": [
		957
	],
	"./00002/00002-10/00002-10-06/teeth.mp3": [
		4213,
		2888
	],
	"./00002/00002-10/00002-10-06/the alligator has sharp teeth.mp3": [
		4214,
		2889
	],
	"./00002/00002-10/00002-10-06/the bat has sharp teeth.mp3": [
		4215,
		2890
	],
	"./00002/00002-10/00002-10-06/the beaver has long teeth.mp3": [
		4216,
		2891
	],
	"./00002/00002-10/00002-10-06/the bird has no teeth.mp3": [
		4217,
		2892
	],
	"./00002/00002-10/00002-10-06/the dinosaur has sharp teeth.mp3": [
		4218,
		2893
	],
	"./00002/00002-10/00002-10-06/the eel has sharp teeth.mp3": [
		4219,
		2894
	],
	"./00002/00002-10/00002-10-06/the elephant has long teeth.mp3": [
		4220,
		2895
	],
	"./00002/00002-10/00002-10-06/the shark has sharp teeth.mp3": [
		4221,
		2896
	],
	"./00002/00002-10/00002-10-06/the walrus has long teeth.mp3": [
		4222,
		2897
	],
	"./00002/00002-10/00002-10-07/animals with 2 feet.mp3": [
		4223,
		2898
	],
	"./00002/00002-10/00002-10-07/feet.mp3": [
		4224,
		2899
	],
	"./00002/00002-10/00002-10-07/i have 1 foot said the slug.mp3": [
		4225,
		2900
	],
	"./00002/00002-10/00002-10-07/i have 1 foot said the snail.mp3": [
		4226,
		2901
	],
	"./00002/00002-10/00002-10-07/i have 2 feet said the bird.mp3": [
		4227,
		2902
	],
	"./00002/00002-10/00002-10-07/i have 2 feet said the duck.mp3": [
		4228,
		2903
	],
	"./00002/00002-10/00002-10-07/i have 4 feet said the frog.mp3": [
		4229,
		2904
	],
	"./00002/00002-10/00002-10-07/i have 4 feet said the raccoon.mp3": [
		4230,
		2905
	],
	"./00002/00002-10/00002-10-07/i have no feet said the whale.mp3": [
		4231,
		2906
	],
	"./00002/00002-10/00002-10-07/intro.mp3": [
		577
	],
	"./00002/00002-10/00002-10-07/look at me.mp3": [
		4232,
		2907
	],
	"./00002/00002-10/00002-10-07/main idea.mp3": [
		958
	],
	"./00002/00002-10/00002-10-08/animals with shells.mp3": [
		4233,
		2908
	],
	"./00002/00002-10/00002-10-08/i am a crab.mp3": [
		4234,
		2909
	],
	"./00002/00002-10/00002-10-08/i am a hermit crab.mp3": [
		4235,
		2910
	],
	"./00002/00002-10/00002-10-08/i am a lobster.mp3": [
		4236,
		2911
	],
	"./00002/00002-10/00002-10-08/i am a sea turtle.mp3": [
		4237,
		2912
	],
	"./00002/00002-10/00002-10-08/i am a shrimp.mp3": [
		4238,
		2913
	],
	"./00002/00002-10/00002-10-08/i am a slug.mp3": [
		4239,
		2914
	],
	"./00002/00002-10/00002-10-08/i am a snail.mp3": [
		4240,
		2915
	],
	"./00002/00002-10/00002-10-08/i am a turtle.mp3": [
		4241,
		2916
	],
	"./00002/00002-10/00002-10-08/i do not have a shell.mp3": [
		4242,
		2917
	],
	"./00002/00002-10/00002-10-08/intro.mp3": [
		578
	],
	"./00002/00002-10/00002-10-08/look at my shell.mp3": [
		4243,
		2918
	],
	"./00002/00002-10/00002-10-08/main idea.mp3": [
		959
	],
	"./00002/00002-10/00002-10-08/shells.mp3": [
		4244,
		2919
	],
	"./00002/00002-10/00002-10-09/animals with long noses.mp3": [
		4245,
		2920
	],
	"./00002/00002-10/00002-10-09/he has a long nose.mp3": [
		4246,
		2921
	],
	"./00002/00002-10/00002-10-09/i see the alligator.mp3": [
		4247,
		2922
	],
	"./00002/00002-10/00002-10-09/i see the anteater.mp3": [
		4248,
		2923
	],
	"./00002/00002-10/00002-10-09/i see the dog.mp3": [
		4249,
		2924
	],
	"./00002/00002-10/00002-10-09/i see the elephant.mp3": [
		4250,
		2925
	],
	"./00002/00002-10/00002-10-09/i see the monster.mp3": [
		4251,
		2926
	],
	"./00002/00002-10/00002-10-09/i see the seahorse.mp3": [
		4252,
		2927
	],
	"./00002/00002-10/00002-10-09/i see the swordfish.mp3": [
		4253,
		2928
	],
	"./00002/00002-10/00002-10-09/intro.mp3": [
		579
	],
	"./00002/00002-10/00002-10-09/main idea.mp3": [
		960
	],
	"./00002/00002-10/00002-10-09/noses.mp3": [
		4254,
		2929
	],
	"./00002/00002-10/00002-10-09/she has a long nose.mp3": [
		4255,
		2930
	],
	"./00002/00002-10/00002-10-10/animals with big ears.mp3": [
		4256,
		2931
	],
	"./00002/00002-10/00002-10-10/ears.mp3": [
		4257,
		2932
	],
	"./00002/00002-10/00002-10-10/intro.mp3": [
		580
	],
	"./00002/00002-10/00002-10-10/main idea.mp3": [
		961
	],
	"./00002/00002-10/00002-10-10/the bear has little ears too.mp3": [
		4258,
		2933
	],
	"./00002/00002-10/00002-10-10/the donkey has big ears too.mp3": [
		4259,
		2934
	],
	"./00002/00002-10/00002-10-10/the elephant has big ears.mp3": [
		4260,
		2935
	],
	"./00002/00002-10/00002-10-10/the kangaroo has big ears too.mp3": [
		4261,
		2936
	],
	"./00002/00002-10/00002-10-10/the rabbit has big ears.mp3": [
		4262,
		2937
	],
	"./00002/00002-10/00002-10-10/the seal has no ears.mp3": [
		4263,
		2938
	],
	"./00002/00002-10/00002-10-10/the tiger has little ears.mp3": [
		4264,
		2939
	],
	"./00002/00002-10/creature features.mp3": [
		4265,
		2940
	],
	"./00002/00002-11/00002-11-01/flying animals.mp3": [
		4266,
		2941
	],
	"./00002/00002-11/00002-11-01/intro.mp3": [
		581
	],
	"./00002/00002-11/00002-11-01/look up in the sky.mp3": [
		4267,
		2942
	],
	"./00002/00002-11/00002-11-01/main idea.mp3": [
		962
	],
	"./00002/00002-11/00002-11-01/the dragon can fly.mp3": [
		4268,
		2943
	],
	"./00002/00002-11/00002-11-01/the eagle can fly.mp3": [
		4269,
		2944
	],
	"./00002/00002-11/00002-11-01/the pig can fly.mp3": [
		4270,
		2945
	],
	"./00002/00002-11/00002-11-01/the rabbit can fly.mp3": [
		4271,
		2946
	],
	"./00002/00002-11/00002-11-01/the spaceship can fly.mp3": [
		4272,
		2947
	],
	"./00002/00002-11/00002-11-01/the tiger can fly.mp3": [
		4273,
		2948
	],
	"./00002/00002-11/00002-11-01/the unicorn can fly.mp3": [
		4274,
		2949
	],
	"./00002/00002-11/00002-11-01/what can fly.mp3": [
		4275,
		2950
	],
	"./00002/00002-11/00002-11-02/5 little dinosaurs.mp3": [
		4276,
		2951
	],
	"./00002/00002-11/00002-11-02/dinosaurs.mp3": [
		4277,
		2952
	],
	"./00002/00002-11/00002-11-02/here comes 1 more.mp3": [
		4278,
		2953
	],
	"./00002/00002-11/00002-11-02/i see 0 little dinosaurs.mp3": [
		4279,
		2954
	],
	"./00002/00002-11/00002-11-02/i see 1 big dinosaur.mp3": [
		4280,
		2955
	],
	"./00002/00002-11/00002-11-02/i see 1 little dinosaur.mp3": [
		4281,
		2956
	],
	"./00002/00002-11/00002-11-02/i see 2 little dinosaurs.mp3": [
		4282,
		2957
	],
	"./00002/00002-11/00002-11-02/i see 3 little dinosaurs.mp3": [
		4283,
		2958
	],
	"./00002/00002-11/00002-11-02/i see 4 little dinosaurs.mp3": [
		4284,
		2959
	],
	"./00002/00002-11/00002-11-02/i see 5 little dinosaurs.mp3": [
		4285,
		2960
	],
	"./00002/00002-11/00002-11-02/intro.mp3": [
		582
	],
	"./00002/00002-11/00002-11-02/look at the dinosaur.mp3": [
		4286,
		2961
	],
	"./00002/00002-11/00002-11-02/main idea.mp3": [
		963
	],
	"./00002/00002-11/00002-11-03/i am flying.mp3": [
		4287,
		2962
	],
	"./00002/00002-11/00002-11-03/i am running.mp3": [
		4288,
		2963
	],
	"./00002/00002-11/00002-11-03/i am skating.mp3": [
		4289,
		2964
	],
	"./00002/00002-11/00002-11-03/i am sleeping.mp3": [
		4290,
		2965
	],
	"./00002/00002-11/00002-11-03/i am sliding.mp3": [
		4291,
		2966
	],
	"./00002/00002-11/00002-11-03/i am swimming.mp3": [
		4292,
		2967
	],
	"./00002/00002-11/00002-11-03/intro.mp3": [
		583
	],
	"./00002/00002-11/00002-11-03/look at me.mp3": [
		4293,
		2968
	],
	"./00002/00002-11/00002-11-03/look at us.mp3": [
		4294,
		2969
	],
	"./00002/00002-11/00002-11-03/main idea.mp3": [
		964
	],
	"./00002/00002-11/00002-11-03/swimming animals.mp3": [
		4295,
		2970
	],
	"./00002/00002-11/00002-11-03/we are jumping.mp3": [
		4296,
		2971
	],
	"./00002/00002-11/00002-11-04/here is a hat for the snowman.mp3": [
		4297,
		2972
	],
	"./00002/00002-11/00002-11-04/here is a scarf for the snowman.mp3": [
		4298,
		2973
	],
	"./00002/00002-11/00002-11-04/intro.mp3": [
		584
	],
	"./00002/00002-11/00002-11-04/look at the big rocks.mp3": [
		4299,
		2974
	],
	"./00002/00002-11/00002-11-04/look at the big snowball.mp3": [
		4300,
		2975
	],
	"./00002/00002-11/00002-11-04/look at the big snowman.mp3": [
		4301,
		2976
	],
	"./00002/00002-11/00002-11-04/look at the carrot.mp3": [
		4302,
		2977
	],
	"./00002/00002-11/00002-11-04/look at the hat.mp3": [
		4303,
		2978
	],
	"./00002/00002-11/00002-11-04/look at the little rocks.mp3": [
		4304,
		2979
	],
	"./00002/00002-11/00002-11-04/look at the little snowball.mp3": [
		4305,
		2980
	],
	"./00002/00002-11/00002-11-04/look at the rocks.mp3": [
		4306,
		2981
	],
	"./00002/00002-11/00002-11-04/look at the scarf.mp3": [
		4307,
		2982
	],
	"./00002/00002-11/00002-11-04/look at the snowman.mp3": [
		4308,
		2983
	],
	"./00002/00002-11/00002-11-04/look at the snowmans eyes.mp3": [
		4309,
		2984
	],
	"./00002/00002-11/00002-11-04/look at the snowmans mouth.mp3": [
		4310,
		2985
	],
	"./00002/00002-11/00002-11-04/look at the snowmans nose.mp3": [
		4311,
		2986
	],
	"./00002/00002-11/00002-11-04/look said the cat.mp3": [
		4312,
		2987
	],
	"./00002/00002-11/00002-11-04/main idea.mp3": [
		965
	],
	"./00002/00002-11/00002-11-04/making a snowman.mp3": [
		4313,
		2988
	],
	"./00002/00002-11/00002-11-04/things you need to make a snowman.mp3": [
		4314,
		2989
	],
	"./00002/00002-11/00002-11-05/going up and down.mp3": [
		4315,
		2990
	],
	"./00002/00002-11/00002-11-05/intro.mp3": [
		585
	],
	"./00002/00002-11/00002-11-05/look at the cat.mp3": [
		4316,
		2991
	],
	"./00002/00002-11/00002-11-05/look at the dog.mp3": [
		4317,
		2992
	],
	"./00002/00002-11/00002-11-05/look at the mouse.mp3": [
		4318,
		2993
	],
	"./00002/00002-11/00002-11-05/main idea.mp3": [
		966
	],
	"./00002/00002-11/00002-11-05/the cat is going down.mp3": [
		4319,
		2994
	],
	"./00002/00002-11/00002-11-05/the cat is going up.mp3": [
		4320,
		2995
	],
	"./00002/00002-11/00002-11-05/the dog is going down.mp3": [
		4321,
		2996
	],
	"./00002/00002-11/00002-11-05/the dog is going up.mp3": [
		4322,
		2997
	],
	"./00002/00002-11/00002-11-05/the mouse is going down.mp3": [
		4323,
		2998
	],
	"./00002/00002-11/00002-11-05/the mouse is going up.mp3": [
		4324,
		2999
	],
	"./00002/00002-11/00002-11-05/things you can see up in the sky.mp3": [
		4325,
		3000
	],
	"./00002/00002-11/00002-11-06/here comes the cheetah.mp3": [
		4326,
		3001
	],
	"./00002/00002-11/00002-11-06/here comes the elephant.mp3": [
		4327,
		3002
	],
	"./00002/00002-11/00002-11-06/here comes the fox.mp3": [
		4328,
		3003
	],
	"./00002/00002-11/00002-11-06/here comes the giraffe.mp3": [
		4329,
		3004
	],
	"./00002/00002-11/00002-11-06/here comes the lion.mp3": [
		4330,
		3005
	],
	"./00002/00002-11/00002-11-06/here comes the ostrich.mp3": [
		4331,
		3006
	],
	"./00002/00002-11/00002-11-06/here comes the zebra.mp3": [
		4332,
		3007
	],
	"./00002/00002-11/00002-11-06/intro.mp3": [
		586
	],
	"./00002/00002-11/00002-11-06/look at the elephant.mp3": [
		4333,
		3008
	],
	"./00002/00002-11/00002-11-06/look at the fox.mp3": [
		4334,
		3009
	],
	"./00002/00002-11/00002-11-06/look at the giraffe.mp3": [
		4335,
		3010
	],
	"./00002/00002-11/00002-11-06/look at the lion.mp3": [
		4336,
		3011
	],
	"./00002/00002-11/00002-11-06/look at the zebra.mp3": [
		4337,
		3012
	],
	"./00002/00002-11/00002-11-06/look.mp3": [
		4338,
		3013
	],
	"./00002/00002-11/00002-11-06/main idea.mp3": [
		967
	],
	"./00002/00002-11/00002-11-06/the animal race.mp3": [
		4339,
		3014
	],
	"./00002/00002-11/00002-11-06/wild animals.mp3": [
		4340,
		3015
	],
	"./00002/00002-11/00002-11-07/here is my bird said the dinosaur.mp3": [
		4341,
		3016
	],
	"./00002/00002-11/00002-11-07/here is my bird said the girl.mp3": [
		4342,
		3017
	],
	"./00002/00002-11/00002-11-07/here is my bird said the monster.mp3": [
		4343,
		3018
	],
	"./00002/00002-11/00002-11-07/here is my cat said the boy.mp3": [
		4344,
		3019
	],
	"./00002/00002-11/00002-11-07/here is my cat said the monster.mp3": [
		4345,
		3020
	],
	"./00002/00002-11/00002-11-07/here is my dog said the girl.mp3": [
		4346,
		3021
	],
	"./00002/00002-11/00002-11-07/here is my dog said the monster.mp3": [
		4347,
		3022
	],
	"./00002/00002-11/00002-11-07/here is my pet.mp3": [
		4348,
		3023
	],
	"./00002/00002-11/00002-11-07/i love my bird too.mp3": [
		4349,
		3024
	],
	"./00002/00002-11/00002-11-07/i love my bird.mp3": [
		4350,
		3025
	],
	"./00002/00002-11/00002-11-07/i love my cat.mp3": [
		4351,
		3026
	],
	"./00002/00002-11/00002-11-07/i love my dog.mp3": [
		4352,
		3027
	],
	"./00002/00002-11/00002-11-07/intro.mp3": [
		587
	],
	"./00002/00002-11/00002-11-07/look at my cat.mp3": [
		4353,
		3028
	],
	"./00002/00002-11/00002-11-07/look at my dog.mp3": [
		4354,
		3029
	],
	"./00002/00002-11/00002-11-07/main idea.mp3": [
		968
	],
	"./00002/00002-11/00002-11-07/pets.mp3": [
		4355,
		3030
	],
	"./00002/00002-11/00002-11-08/can you.mp3": [
		4356,
		3031
	],
	"./00002/00002-11/00002-11-08/characters who can skate in the book.mp3": [
		4357,
		3032
	],
	"./00002/00002-11/00002-11-08/i can not skate said the bear.mp3": [
		4358,
		3033
	],
	"./00002/00002-11/00002-11-08/i can skate said the deer.mp3": [
		4359,
		3034
	],
	"./00002/00002-11/00002-11-08/i can skate said the monster.mp3": [
		4360,
		3035
	],
	"./00002/00002-11/00002-11-08/i can skate said the panda.mp3": [
		4361,
		3036
	],
	"./00002/00002-11/00002-11-08/i can skate said the penguin.mp3": [
		4362,
		3037
	],
	"./00002/00002-11/00002-11-08/intro.mp3": [
		588
	],
	"./00002/00002-11/00002-11-08/look at me.mp3": [
		4363,
		3038
	],
	"./00002/00002-11/00002-11-08/look at us.mp3": [
		4364,
		3039
	],
	"./00002/00002-11/00002-11-08/main idea.mp3": [
		969
	],
	"./00002/00002-11/00002-11-08/oh no.mp3": [
		4365,
		3040
	],
	"./00002/00002-11/00002-11-08/we can skate said the lions.mp3": [
		4366,
		3041
	],
	"./00002/00002-11/00002-11-08/we can skate said the rabbits.mp3": [
		4367,
		3042
	],
	"./00002/00002-11/00002-11-08/who can skate.mp3": [
		4368,
		3043
	],
	"./00002/00002-11/00002-11-09/animals with four legs.mp3": [
		4369,
		3044
	],
	"./00002/00002-11/00002-11-09/balloons.mp3": [
		4370,
		3045
	],
	"./00002/00002-11/00002-11-09/cat likes the orange balloon.mp3": [
		4371,
		3046
	],
	"./00002/00002-11/00002-11-09/dinosaur likes the blue balloon.mp3": [
		4372,
		3047
	],
	"./00002/00002-11/00002-11-09/dog likes the red balloon.mp3": [
		4373,
		3048
	],
	"./00002/00002-11/00002-11-09/intro.mp3": [
		589
	],
	"./00002/00002-11/00002-11-09/lion likes the yellow balloon.mp3": [
		4374,
		3049
	],
	"./00002/00002-11/00002-11-09/look at cat.mp3": [
		4375,
		3050
	],
	"./00002/00002-11/00002-11-09/look at dog.mp3": [
		4376,
		3051
	],
	"./00002/00002-11/00002-11-09/look at the dinosaur.mp3": [
		4377,
		3052
	],
	"./00002/00002-11/00002-11-09/look at the lion.mp3": [
		4378,
		3053
	],
	"./00002/00002-11/00002-11-09/look at the monkey.mp3": [
		4379,
		3054
	],
	"./00002/00002-11/00002-11-09/look at the octopus.mp3": [
		4380,
		3055
	],
	"./00002/00002-11/00002-11-09/look at the rabbit.mp3": [
		4381,
		3056
	],
	"./00002/00002-11/00002-11-09/main idea.mp3": [
		970
	],
	"./00002/00002-11/00002-11-09/monkey likes the green balloon.mp3": [
		4382,
		3057
	],
	"./00002/00002-11/00002-11-09/octopus likes the balloons.mp3": [
		4383,
		3058
	],
	"./00002/00002-11/00002-11-09/rabbit likes the pink balloon.mp3": [
		4384,
		3059
	],
	"./00002/00002-11/00002-11-10/ant sees the yellow flower.mp3": [
		4385,
		3060
	],
	"./00002/00002-11/00002-11-10/bee sees the orange flower.mp3": [
		4386,
		3061
	],
	"./00002/00002-11/00002-11-10/butterfly sees the red flower.mp3": [
		4387,
		3062
	],
	"./00002/00002-11/00002-11-10/grasshopper sees the pink flower.mp3": [
		4388,
		3063
	],
	"./00002/00002-11/00002-11-10/he likes flowers.mp3": [
		4389,
		3064
	],
	"./00002/00002-11/00002-11-10/hummingbird sees the blue flower.mp3": [
		4390,
		3065
	],
	"./00002/00002-11/00002-11-10/insects.mp3": [
		4391,
		3066
	],
	"./00002/00002-11/00002-11-10/intro.mp3": [
		590
	],
	"./00002/00002-11/00002-11-10/ladybug sees the purple flower.mp3": [
		4392,
		3067
	],
	"./00002/00002-11/00002-11-10/look at the flowers.mp3": [
		4393,
		3068
	],
	"./00002/00002-11/00002-11-10/main idea.mp3": [
		971
	],
	"./00002/00002-11/00002-11-10/she likes flowers.mp3": [
		4394,
		3069
	],
	"./00002/00002-11/00002-11-10/we see flowers.mp3": [
		4395,
		3070
	],
	"./00002/00002-11/00002-11-10/we see the flowers.mp3": [
		4396,
		3071
	],
	"./00002/00002-11/story town.mp3": [
		4397,
		3072
	],
	"./00002/00002-12/00002-12-01/alligator wants an airplane.mp3": [
		4398,
		3073
	],
	"./00002/00002-12/00002-12-01/bear wants a bike.mp3": [
		4399,
		3074
	],
	"./00002/00002-12/00002-12-01/cat wants a car.mp3": [
		4400,
		3075
	],
	"./00002/00002-12/00002-12-01/dog wants a dinosaur.mp3": [
		4401,
		3076
	],
	"./00002/00002-12/00002-12-01/fox wants a fire truck.mp3": [
		4402,
		3077
	],
	"./00002/00002-12/00002-12-01/hippo wants a helicopter.mp3": [
		4403,
		3078
	],
	"./00002/00002-12/00002-12-01/i see a wolf.mp3": [
		4404,
		3079
	],
	"./00002/00002-12/00002-12-01/intro.mp3": [
		591
	],
	"./00002/00002-12/00002-12-01/look at cat.mp3": [
		4405,
		3080
	],
	"./00002/00002-12/00002-12-01/look at dog.mp3": [
		4406,
		3081
	],
	"./00002/00002-12/00002-12-01/look at the airplane.mp3": [
		4407,
		3082
	],
	"./00002/00002-12/00002-12-01/look at the bear.mp3": [
		4408,
		3083
	],
	"./00002/00002-12/00002-12-01/look at the bike.mp3": [
		4409,
		3084
	],
	"./00002/00002-12/00002-12-01/look at the car.mp3": [
		4410,
		3085
	],
	"./00002/00002-12/00002-12-01/look at the dinosaur.mp3": [
		4411,
		3086
	],
	"./00002/00002-12/00002-12-01/look at the fox.mp3": [
		4412,
		3087
	],
	"./00002/00002-12/00002-12-01/look at the helicopter.mp3": [
		4413,
		3088
	],
	"./00002/00002-12/00002-12-01/main idea.mp3": [
		972
	],
	"./00002/00002-12/00002-12-01/toys.mp3": [
		4414,
		3089
	],
	"./00002/00002-12/00002-12-01/vehicles.mp3": [
		4415,
		3090
	],
	"./00002/00002-12/00002-12-01/wolf wants a wagon.mp3": [
		4416,
		3091
	],
	"./00002/00002-12/00002-12-02/alligator got a saxophone.mp3": [
		4417,
		3092
	],
	"./00002/00002-12/00002-12-02/bear got a guitar.mp3": [
		4418,
		3093
	],
	"./00002/00002-12/00002-12-02/beaver got a xylophone.mp3": [
		4419,
		3094
	],
	"./00002/00002-12/00002-12-02/dog got a tambourine.mp3": [
		4420,
		3095
	],
	"./00002/00002-12/00002-12-02/fox got a fiddle.mp3": [
		4421,
		3096
	],
	"./00002/00002-12/00002-12-02/i love music.mp3": [
		4422,
		3097
	],
	"./00002/00002-12/00002-12-02/intro.mp3": [
		592
	],
	"./00002/00002-12/00002-12-02/look at the banjo.mp3": [
		4423,
		3098
	],
	"./00002/00002-12/00002-12-02/look at the fiddle.mp3": [
		4424,
		3099
	],
	"./00002/00002-12/00002-12-02/look at the guitar.mp3": [
		4425,
		3100
	],
	"./00002/00002-12/00002-12-02/look at the saxophone.mp3": [
		4426,
		3101
	],
	"./00002/00002-12/00002-12-02/look at the tambourine.mp3": [
		4427,
		3102
	],
	"./00002/00002-12/00002-12-02/look at the triangle.mp3": [
		4428,
		3103
	],
	"./00002/00002-12/00002-12-02/look at the xylophone.mp3": [
		4429,
		3104
	],
	"./00002/00002-12/00002-12-02/main idea.mp3": [
		973
	],
	"./00002/00002-12/00002-12-02/monkey got a triangle.mp3": [
		4430,
		3105
	],
	"./00002/00002-12/00002-12-02/musical instruments.mp3": [
		4431,
		3106
	],
	"./00002/00002-12/00002-12-02/raccoon got a banjo.mp3": [
		4432,
		3107
	],
	"./00002/00002-12/00002-12-03/alligator is going to the party.mp3": [
		4433,
		3108
	],
	"./00002/00002-12/00002-12-03/cat is going to the party.mp3": [
		4434,
		3109
	],
	"./00002/00002-12/00002-12-03/crocodile is going to the party.mp3": [
		4435,
		3110
	],
	"./00002/00002-12/00002-12-03/elephant is going to the party.mp3": [
		4436,
		3111
	],
	"./00002/00002-12/00002-12-03/going to the party.mp3": [
		4437,
		3112
	],
	"./00002/00002-12/00002-12-03/here is the party.mp3": [
		4438,
		3113
	],
	"./00002/00002-12/00002-12-03/intro.mp3": [
		593
	],
	"./00002/00002-12/00002-12-03/jaguar is going to the party.mp3": [
		4439,
		3114
	],
	"./00002/00002-12/00002-12-03/look at alligator.mp3": [
		4440,
		3115
	],
	"./00002/00002-12/00002-12-03/look at cat.mp3": [
		4441,
		3116
	],
	"./00002/00002-12/00002-12-03/look at dog.mp3": [
		4442,
		3117
	],
	"./00002/00002-12/00002-12-03/look at elephant.mp3": [
		4443,
		3118
	],
	"./00002/00002-12/00002-12-03/look at the jaguar.mp3": [
		4444,
		3119
	],
	"./00002/00002-12/00002-12-03/look at the tiger.mp3": [
		4445,
		3120
	],
	"./00002/00002-12/00002-12-03/look at the zebra.mp3": [
		4446,
		3121
	],
	"./00002/00002-12/00002-12-03/main idea.mp3": [
		974
	],
	"./00002/00002-12/00002-12-03/panda is going to the party.mp3": [
		4447,
		3122
	],
	"./00002/00002-12/00002-12-03/tiger is going to the party.mp3": [
		4448,
		3123
	],
	"./00002/00002-12/00002-12-03/wild animals.mp3": [
		4449,
		3124
	],
	"./00002/00002-12/00002-12-03/zebra is going to the party.mp3": [
		4450,
		3125
	],
	"./00002/00002-12/00002-12-04/a friend for yellow duck.mp3": [
		4451,
		3126
	],
	"./00002/00002-12/00002-12-04/animals with 4 legs.mp3": [
		4452,
		3127
	],
	"./00002/00002-12/00002-12-04/intro.mp3": [
		594
	],
	"./00002/00002-12/00002-12-04/main idea.mp3": [
		975
	],
	"./00002/00002-12/00002-12-04/no i will not said skunk.mp3": [
		4453,
		3128
	],
	"./00002/00002-12/00002-12-04/no no no said sheep.mp3": [
		4454,
		3129
	],
	"./00002/00002-12/00002-12-04/no said fox.mp3": [
		4455,
		3130
	],
	"./00002/00002-12/00002-12-04/no said squirrel.mp3": [
		4456,
		3131
	],
	"./00002/00002-12/00002-12-04/no said the frog.mp3": [
		4457,
		3132
	],
	"./00002/00002-12/00002-12-04/not me said deer.mp3": [
		4458,
		3133
	],
	"./00002/00002-12/00002-12-04/will you play with me said yellow duck.mp3": [
		4459,
		3134
	],
	"./00002/00002-12/00002-12-04/yes said brown duck.mp3": [
		4460,
		3135
	],
	"./00002/00002-12/00002-12-05/cat likes to play soccer.mp3": [
		4461,
		3136
	],
	"./00002/00002-12/00002-12-05/fox likes to play soccer.mp3": [
		4462,
		3137
	],
	"./00002/00002-12/00002-12-05/goal said snake.mp3": [
		4463,
		3138
	],
	"./00002/00002-12/00002-12-05/intro.mp3": [
		595
	],
	"./00002/00002-12/00002-12-05/lion kicks the ball to skunk.mp3": [
		4464,
		3139
	],
	"./00002/00002-12/00002-12-05/lion likes to play soccer.mp3": [
		4465,
		3140
	],
	"./00002/00002-12/00002-12-05/main idea.mp3": [
		976
	],
	"./00002/00002-12/00002-12-05/rabbit kicks the ball at the goal.mp3": [
		4466,
		3141
	],
	"./00002/00002-12/00002-12-05/rabbit kicks the ball to lion.mp3": [
		4467,
		3142
	],
	"./00002/00002-12/00002-12-05/rabbit likes to play soccer too.mp3": [
		4468,
		3143
	],
	"./00002/00002-12/00002-12-05/sheep likes to play soccer.mp3": [
		4469,
		3144
	],
	"./00002/00002-12/00002-12-05/skunk kicks the ball to rabbit.mp3": [
		4470,
		3145
	],
	"./00002/00002-12/00002-12-05/skunk likes to play soccer.mp3": [
		4471,
		3146
	],
	"./00002/00002-12/00002-12-05/the ball goes in the goal.mp3": [
		4472,
		3147
	],
	"./00002/00002-12/00002-12-05/the soccer game.mp3": [
		4473,
		3148
	],
	"./00002/00002-12/00002-12-05/tiger likes to play soccer.mp3": [
		4474,
		3149
	],
	"./00002/00002-12/00002-12-05/wild animals.mp3": [
		4475,
		3150
	],
	"./00002/00002-12/00002-12-06/baby animals.mp3": [
		4476,
		3151
	],
	"./00002/00002-12/00002-12-06/can i be your mother said the rabbit.mp3": [
		4477,
		3152
	],
	"./00002/00002-12/00002-12-06/can i be your mother.mp3": [
		4478,
		3153
	],
	"./00002/00002-12/00002-12-06/intro.mp3": [
		596
	],
	"./00002/00002-12/00002-12-06/main idea.mp3": [
		977
	],
	"./00002/00002-12/00002-12-06/my mother is a cat.mp3": [
		4479,
		3154
	],
	"./00002/00002-12/00002-12-06/my mother is a chicken.mp3": [
		4480,
		3155
	],
	"./00002/00002-12/00002-12-06/my mother is a dog.mp3": [
		4481,
		3156
	],
	"./00002/00002-12/00002-12-06/my mother is a fox.mp3": [
		4482,
		3157
	],
	"./00002/00002-12/00002-12-06/my mother is a goat.mp3": [
		4483,
		3158
	],
	"./00002/00002-12/00002-12-06/my mother is a sheep.mp3": [
		4484,
		3159
	],
	"./00002/00002-12/00002-12-06/no.mp3": [
		4485,
		3160
	],
	"./00002/00002-12/00002-12-06/yes.mp3": [
		4486,
		3161
	],
	"./00002/00002-12/00002-12-06/you can be my mother.mp3": [
		4487,
		3162
	],
	"./00002/00002-12/00002-12-07/an apple fell on her head.mp3": [
		4488,
		3163
	],
	"./00002/00002-12/00002-12-07/an apple fell on your head.mp3": [
		4489,
		3164
	],
	"./00002/00002-12/00002-12-07/birds.mp3": [
		4490,
		3165
	],
	"./00002/00002-12/00002-12-07/characters in the book.mp3": [
		4491,
		3166
	],
	"./00002/00002-12/00002-12-07/chicken little was sitting under a tree.mp3": [
		4492,
		3167
	],
	"./00002/00002-12/00002-12-07/i am the king said the lion.mp3": [
		4493,
		3168
	],
	"./00002/00002-12/00002-12-07/i must tell the king.mp3": [
		4494,
		3169
	],
	"./00002/00002-12/00002-12-07/intro.mp3": [
		597
	],
	"./00002/00002-12/00002-12-07/look at the deer.mp3": [
		4495,
		3170
	],
	"./00002/00002-12/00002-12-07/look at the elephant.mp3": [
		4496,
		3171
	],
	"./00002/00002-12/00002-12-07/look at the fox.mp3": [
		4497,
		3172
	],
	"./00002/00002-12/00002-12-07/look at the jaguar.mp3": [
		4498,
		3173
	],
	"./00002/00002-12/00002-12-07/look at the lion.mp3": [
		4499,
		3174
	],
	"./00002/00002-12/00002-12-07/look at the tiger.mp3": [
		4500,
		3175
	],
	"./00002/00002-12/00002-12-07/main idea.mp3": [
		978
	],
	"./00002/00002-12/00002-12-07/the sky is falling said chicken little.mp3": [
		4501,
		3176
	],
	"./00002/00002-12/00002-12-07/the sky is falling said elephant.mp3": [
		4502,
		3177
	],
	"./00002/00002-12/00002-12-07/the sky is falling said jaguar.mp3": [
		4503,
		3178
	],
	"./00002/00002-12/00002-12-07/the sky is falling.mp3": [
		4504,
		3179
	],
	"./00002/00002-12/00002-12-07/the sky is not falling.mp3": [
		4505,
		3180
	],
	"./00002/00002-12/00002-12-07/we must tell the king.mp3": [
		4506,
		3181
	],
	"./00002/00002-12/00002-12-07/where are you going said elephant.mp3": [
		4507,
		3182
	],
	"./00002/00002-12/00002-12-07/where are you going said jaguar.mp3": [
		4508,
		3183
	],
	"./00002/00002-12/00002-12-07/where are you going said tiger.mp3": [
		4509,
		3184
	],
	"./00002/00002-12/00002-12-07/where are you going said wolf.mp3": [
		4510,
		3185
	],
	"./00002/00002-12/00002-12-08/here i am said the kitten.mp3": [
		4511,
		3186
	],
	"./00002/00002-12/00002-12-08/intro.mp3": [
		598
	],
	"./00002/00002-12/00002-12-08/main idea.mp3": [
		979
	],
	"./00002/00002-12/00002-12-08/mother cat looked in the bathroom.mp3": [
		4512,
		3187
	],
	"./00002/00002-12/00002-12-08/mother cat looked in the bathtub.mp3": [
		4513,
		3188
	],
	"./00002/00002-12/00002-12-08/mother cat looked in the bedroom.mp3": [
		4514,
		3189
	],
	"./00002/00002-12/00002-12-08/mother cat looked in the living room.mp3": [
		4515,
		3190
	],
	"./00002/00002-12/00002-12-08/mother cat looked on the bed.mp3": [
		4516,
		3191
	],
	"./00002/00002-12/00002-12-08/mother cat looked on the couch.mp3": [
		4517,
		3192
	],
	"./00002/00002-12/00002-12-08/mother cat looked on the table.mp3": [
		4518,
		3193
	],
	"./00002/00002-12/00002-12-08/no kittens here she said.mp3": [
		4519,
		3194
	],
	"./00002/00002-12/00002-12-08/non living things.mp3": [
		4520,
		3195
	],
	"./00002/00002-12/00002-12-08/where is the kitten.mp3": [
		4521,
		3196
	],
	"./00002/00002-12/00002-12-09/i love the butterflies.mp3": [
		4522,
		3197
	],
	"./00002/00002-12/00002-12-09/i love the dragonflies.mp3": [
		4523,
		3198
	],
	"./00002/00002-12/00002-12-09/i love the farms.mp3": [
		4524,
		3199
	],
	"./00002/00002-12/00002-12-09/i love the mountains.mp3": [
		4525,
		3200
	],
	"./00002/00002-12/00002-12-09/i love the ocean.mp3": [
		4526,
		3201
	],
	"./00002/00002-12/00002-12-09/i love the ponds.mp3": [
		4527,
		3202
	],
	"./00002/00002-12/00002-12-09/i love to see the bees.mp3": [
		4528,
		3203
	],
	"./00002/00002-12/00002-12-09/i love to see the boats.mp3": [
		4529,
		3204
	],
	"./00002/00002-12/00002-12-09/i love to see the dogs.mp3": [
		4530,
		3205
	],
	"./00002/00002-12/00002-12-09/i love to see the frogs.mp3": [
		4531,
		3206
	],
	"./00002/00002-12/00002-12-09/i love to see the goats.mp3": [
		4532,
		3207
	],
	"./00002/00002-12/00002-12-09/i love to see the trees.mp3": [
		4533,
		3208
	],
	"./00002/00002-12/00002-12-09/intro.mp3": [
		599
	],
	"./00002/00002-12/00002-12-09/main idea.mp3": [
		980
	],
	"./00002/00002-12/00002-12-10/birds.mp3": [
		4534,
		3209
	],
	"./00002/00002-12/00002-12-10/have you seen my mother said baby bird.mp3": [
		4535,
		3210
	],
	"./00002/00002-12/00002-12-10/have you seen my mother.mp3": [
		4536,
		3211
	],
	"./00002/00002-12/00002-12-10/help mother said baby bird.mp3": [
		4537,
		3212
	],
	"./00002/00002-12/00002-12-10/here is a dog.mp3": [
		4538,
		3213
	],
	"./00002/00002-12/00002-12-10/here is a duck.mp3": [
		4539,
		3214
	],
	"./00002/00002-12/00002-12-10/here is a pig.mp3": [
		4540,
		3215
	],
	"./00002/00002-12/00002-12-10/here is a rabbit.mp3": [
		4541,
		3216
	],
	"./00002/00002-12/00002-12-10/here is a snake.mp3": [
		4542,
		3217
	],
	"./00002/00002-12/00002-12-10/here is a worm said mother bird.mp3": [
		4543,
		3218
	],
	"./00002/00002-12/00002-12-10/here is baby bird.mp3": [
		4544,
		3219
	],
	"./00002/00002-12/00002-12-10/here is mother bird.mp3": [
		4545,
		3220
	],
	"./00002/00002-12/00002-12-10/intro.mp3": [
		600
	],
	"./00002/00002-12/00002-12-10/main idea.mp3": [
		981
	],
	"./00002/00002-12/story land.mp3": [
		4546,
		3221
	],
	"./00003/00003-01/00003-01-01/a bus goes on the road.mp3": [
		4547,
		3222
	],
	"./00003/00003-01/00003-01-01/a car goes on the road.mp3": [
		4548,
		3223
	],
	"./00003/00003-01/00003-01-01/a helicopter goes in the sky.mp3": [
		4549,
		3224
	],
	"./00003/00003-01/00003-01-01/blue vehicles.mp3": [
		4550,
		3225
	],
	"./00003/00003-01/00003-01-01/here is a blue bus.mp3": [
		4551,
		3226
	],
	"./00003/00003-01/00003-01-01/here is a blue helicopter.mp3": [
		4552,
		3227
	],
	"./00003/00003-01/00003-01-01/here is a car.mp3": [
		4553,
		3228
	],
	"./00003/00003-01/00003-01-01/intro.mp3": [
		601
	],
	"./00003/00003-01/00003-01-01/look at the airplane.mp3": [
		4554,
		3229
	],
	"./00003/00003-01/00003-01-01/look at the bus.mp3": [
		4555,
		3230
	],
	"./00003/00003-01/00003-01-01/look at the helicopter.mp3": [
		4556,
		3231
	],
	"./00003/00003-01/00003-01-01/look at the rocket.mp3": [
		4557,
		3232
	],
	"./00003/00003-01/00003-01-01/look at the truck.mp3": [
		4558,
		3233
	],
	"./00003/00003-01/00003-01-01/look at the van.mp3": [
		4559,
		3234
	],
	"./00003/00003-01/00003-01-01/main idea.mp3": [
		982
	],
	"./00003/00003-01/00003-01-01/the airplane is blue.mp3": [
		4560,
		3235
	],
	"./00003/00003-01/00003-01-01/the airplane is in the sky.mp3": [
		4561,
		3236
	],
	"./00003/00003-01/00003-01-01/the car is blue.mp3": [
		4562,
		3237
	],
	"./00003/00003-01/00003-01-01/the rocket is blue too.mp3": [
		4563,
		3238
	],
	"./00003/00003-01/00003-01-01/the rocket is up in space.mp3": [
		4564,
		3239
	],
	"./00003/00003-01/00003-01-01/the truck is blue.mp3": [
		4565,
		3240
	],
	"./00003/00003-01/00003-01-01/the truck is on the road.mp3": [
		4566,
		3241
	],
	"./00003/00003-01/00003-01-01/the van is blue.mp3": [
		4567,
		3242
	],
	"./00003/00003-01/00003-01-01/the van is on the road.mp3": [
		4568,
		3243
	],
	"./00003/00003-01/00003-01-01/vehicles.mp3": [
		4569,
		3244
	],
	"./00003/00003-01/00003-01-02/here come the cars.mp3": [
		4570,
		3245
	],
	"./00003/00003-01/00003-01-02/here come the fire trucks.mp3": [
		4571,
		3246
	],
	"./00003/00003-01/00003-01-02/here come the helicopters.mp3": [
		4572,
		3247
	],
	"./00003/00003-01/00003-01-02/here come the planes.mp3": [
		4573,
		3248
	],
	"./00003/00003-01/00003-01-02/here comes the motorcycle.mp3": [
		4574,
		3249
	],
	"./00003/00003-01/00003-01-02/here comes the tractor.mp3": [
		4575,
		3250
	],
	"./00003/00003-01/00003-01-02/here comes the train.mp3": [
		4576,
		3251
	],
	"./00003/00003-01/00003-01-02/i can see a motorcycle.mp3": [
		4577,
		3252
	],
	"./00003/00003-01/00003-01-02/i can see a tractor.mp3": [
		4578,
		3253
	],
	"./00003/00003-01/00003-01-02/i can see a train.mp3": [
		4579,
		3254
	],
	"./00003/00003-01/00003-01-02/i can see four fire trucks.mp3": [
		4580,
		3255
	],
	"./00003/00003-01/00003-01-02/i can see four planes.mp3": [
		4581,
		3256
	],
	"./00003/00003-01/00003-01-02/i can see three red helicopters.mp3": [
		4582,
		3257
	],
	"./00003/00003-01/00003-01-02/i can see two red cars.mp3": [
		4583,
		3258
	],
	"./00003/00003-01/00003-01-02/intro.mp3": [
		602
	],
	"./00003/00003-01/00003-01-02/main idea.mp3": [
		983
	],
	"./00003/00003-01/00003-01-02/red vehicles.mp3": [
		4584,
		3259
	],
	"./00003/00003-01/00003-01-02/the cars are red.mp3": [
		4585,
		3260
	],
	"./00003/00003-01/00003-01-02/the fire trucks are red.mp3": [
		4586,
		3261
	],
	"./00003/00003-01/00003-01-02/the helicopters are red.mp3": [
		4587,
		3262
	],
	"./00003/00003-01/00003-01-02/the motorcycle is red.mp3": [
		4588,
		3263
	],
	"./00003/00003-01/00003-01-02/the planes are red.mp3": [
		4589,
		3264
	],
	"./00003/00003-01/00003-01-02/the tractor is red.mp3": [
		4590,
		3265
	],
	"./00003/00003-01/00003-01-02/the train is red.mp3": [
		4591,
		3266
	],
	"./00003/00003-01/00003-01-02/things that are red.mp3": [
		4592,
		3267
	],
	"./00003/00003-01/00003-01-03/butterflies have 6 legs.mp3": [
		4593,
		3268
	],
	"./00003/00003-01/00003-01-03/crabs have 10 legs.mp3": [
		4594,
		3269
	],
	"./00003/00003-01/00003-01-03/dogs have 4 legs.mp3": [
		4595,
		3270
	],
	"./00003/00003-01/00003-01-03/ducks have 2 legs.mp3": [
		4596,
		3271
	],
	"./00003/00003-01/00003-01-03/fish have no legs.mp3": [
		4597,
		3272
	],
	"./00003/00003-01/00003-01-03/i like the bird.mp3": [
		4598,
		3273
	],
	"./00003/00003-01/00003-01-03/i like the butterfly.mp3": [
		4599,
		3274
	],
	"./00003/00003-01/00003-01-03/i like the caterpillar.mp3": [
		4600,
		3275
	],
	"./00003/00003-01/00003-01-03/i like the crab.mp3": [
		4601,
		3276
	],
	"./00003/00003-01/00003-01-03/i like the dog.mp3": [
		4602,
		3277
	],
	"./00003/00003-01/00003-01-03/i like the ducks.mp3": [
		4603,
		3278
	],
	"./00003/00003-01/00003-01-03/i like the fish.mp3": [
		4604,
		3279
	],
	"./00003/00003-01/00003-01-03/i like the parrot.mp3": [
		4605,
		3280
	],
	"./00003/00003-01/00003-01-03/i like the spider.mp3": [
		4606,
		3281
	],
	"./00003/00003-01/00003-01-03/intro.mp3": [
		603
	],
	"./00003/00003-01/00003-01-03/main idea.mp3": [
		984
	],
	"./00003/00003-01/00003-01-03/parrots have 2 legs.mp3": [
		4607,
		3282
	],
	"./00003/00003-01/00003-01-03/spiders have 8 legs.mp3": [
		4608,
		3283
	],
	"./00003/00003-01/00003-01-03/the bird is yellow.mp3": [
		4609,
		3284
	],
	"./00003/00003-01/00003-01-03/the butterfly is yellow.mp3": [
		4610,
		3285
	],
	"./00003/00003-01/00003-01-03/the caterpillar is yellow.mp3": [
		4611,
		3286
	],
	"./00003/00003-01/00003-01-03/the crab is yellow.mp3": [
		4612,
		3287
	],
	"./00003/00003-01/00003-01-03/the dog is yellow.mp3": [
		4613,
		3288
	],
	"./00003/00003-01/00003-01-03/the ducks are yellow too.mp3": [
		4614,
		3289
	],
	"./00003/00003-01/00003-01-03/the fish is yellow.mp3": [
		4615,
		3290
	],
	"./00003/00003-01/00003-01-03/the parrot is yellow.mp3": [
		4616,
		3291
	],
	"./00003/00003-01/00003-01-03/the spider is yellow.mp3": [
		4617,
		3292
	],
	"./00003/00003-01/00003-01-03/things that are yellow.mp3": [
		4618,
		3293
	],
	"./00003/00003-01/00003-01-03/yellow animals.mp3": [
		4619,
		3294
	],
	"./00003/00003-01/00003-01-04/i can not see the orange fox.mp3": [
		4620,
		3295
	],
	"./00003/00003-01/00003-01-04/i can see the orange butterfly.mp3": [
		4621,
		3296
	],
	"./00003/00003-01/00003-01-04/i can see the orange cat.mp3": [
		4622,
		3297
	],
	"./00003/00003-01/00003-01-04/i can see the orange fish.mp3": [
		4623,
		3298
	],
	"./00003/00003-01/00003-01-04/i can see the orange fox.mp3": [
		4624,
		3299
	],
	"./00003/00003-01/00003-01-04/i can see the orange salamander.mp3": [
		4625,
		3300
	],
	"./00003/00003-01/00003-01-04/i can see the orange snake.mp3": [
		4626,
		3301
	],
	"./00003/00003-01/00003-01-04/i can see the orange tiger.mp3": [
		4627,
		3302
	],
	"./00003/00003-01/00003-01-04/intro.mp3": [
		604
	],
	"./00003/00003-01/00003-01-04/main idea.mp3": [
		985
	],
	"./00003/00003-01/00003-01-04/orange things.mp3": [
		4628,
		3303
	],
	"./00003/00003-01/00003-01-04/the orange animal book.mp3": [
		4629,
		3304
	],
	"./00003/00003-01/00003-01-04/what else can i see.mp3": [
		4630,
		3305
	],
	"./00003/00003-01/00003-01-05/i look good in purple.mp3": [
		4631,
		3306
	],
	"./00003/00003-01/00003-01-05/i love purple he said.mp3": [
		4632,
		3307
	],
	"./00003/00003-01/00003-01-05/i love purple she said.mp3": [
		4633,
		3308
	],
	"./00003/00003-01/00003-01-05/i love purple.mp3": [
		4634,
		3309
	],
	"./00003/00003-01/00003-01-05/intro.mp3": [
		605
	],
	"./00003/00003-01/00003-01-05/look at me.mp3": [
		4635,
		3310
	],
	"./00003/00003-01/00003-01-05/main idea.mp3": [
		986
	],
	"./00003/00003-01/00003-01-05/the dog has a purple jacket.mp3": [
		4636,
		3311
	],
	"./00003/00003-01/00003-01-05/the goat has a purple scarf.mp3": [
		4637,
		3312
	],
	"./00003/00003-01/00003-01-05/the lion has a purple shirt.mp3": [
		4638,
		3313
	],
	"./00003/00003-01/00003-01-05/the octopus has purple mittens.mp3": [
		4639,
		3314
	],
	"./00003/00003-01/00003-01-05/the penguin has a purple helmet.mp3": [
		4640,
		3315
	],
	"./00003/00003-01/00003-01-05/the rabbit has a purple hat.mp3": [
		4641,
		3316
	],
	"./00003/00003-01/00003-01-05/the skunk has a purple dress.mp3": [
		4642,
		3317
	],
	"./00003/00003-01/00003-01-05/things that are purple.mp3": [
		4643,
		3318
	],
	"./00003/00003-01/00003-01-06/animals that are green.mp3": [
		4644,
		3319
	],
	"./00003/00003-01/00003-01-06/i am a green alligator.mp3": [
		4645,
		3320
	],
	"./00003/00003-01/00003-01-06/i am a green frog.mp3": [
		4646,
		3321
	],
	"./00003/00003-01/00003-01-06/i am a green grasshopper.mp3": [
		4647,
		3322
	],
	"./00003/00003-01/00003-01-06/i am a green praying mantis.mp3": [
		4648,
		3323
	],
	"./00003/00003-01/00003-01-06/i am a green turtle.mp3": [
		4649,
		3324
	],
	"./00003/00003-01/00003-01-06/i can hide from the alligator.mp3": [
		4650,
		3325
	],
	"./00003/00003-01/00003-01-06/i can hide from the frog.mp3": [
		4651,
		3326
	],
	"./00003/00003-01/00003-01-06/i can hide in the leaves.mp3": [
		4652,
		3327
	],
	"./00003/00003-01/00003-01-06/intro.mp3": [
		606
	],
	"./00003/00003-01/00003-01-06/main idea.mp3": [
		987
	],
	"./00003/00003-01/00003-01-06/the green book.mp3": [
		4653,
		3328
	],
	"./00003/00003-01/00003-01-06/we are green aphids.mp3": [
		4654,
		3329
	],
	"./00003/00003-01/00003-01-06/we are green dinosaurs.mp3": [
		4655,
		3330
	],
	"./00003/00003-01/00003-01-06/we can hide in the leaves too.mp3": [
		4656,
		3331
	],
	"./00003/00003-01/00003-01-06/you can not see me.mp3": [
		4657,
		3332
	],
	"./00003/00003-01/00003-01-06/you can not see us.mp3": [
		4658,
		3333
	],
	"./00003/00003-01/00003-01-07/animals that are brown.mp3": [
		4659,
		3334
	],
	"./00003/00003-01/00003-01-07/i saw 2 brown birds.mp3": [
		4660,
		3335
	],
	"./00003/00003-01/00003-01-07/i saw 2 brown rabbits.mp3": [
		4661,
		3336
	],
	"./00003/00003-01/00003-01-07/i saw 2 little brown bears.mp3": [
		4662,
		3337
	],
	"./00003/00003-01/00003-01-07/i saw 2 little brown deer.mp3": [
		4663,
		3338
	],
	"./00003/00003-01/00003-01-07/i saw a big brown bear.mp3": [
		4664,
		3339
	],
	"./00003/00003-01/00003-01-07/i saw a big brown deer.mp3": [
		4665,
		3340
	],
	"./00003/00003-01/00003-01-07/i saw a brown hedgehog.mp3": [
		4666,
		3341
	],
	"./00003/00003-01/00003-01-07/i went to the forest.mp3": [
		4667,
		3342
	],
	"./00003/00003-01/00003-01-07/intro.mp3": [
		607
	],
	"./00003/00003-01/00003-01-07/main idea.mp3": [
		988
	],
	"./00003/00003-01/00003-01-07/the brown book.mp3": [
		4668,
		3343
	],
	"./00003/00003-01/00003-01-07/what did i see.mp3": [
		4669,
		3344
	],
	"./00003/00003-01/00003-01-08/animals.mp3": [
		4670,
		3345
	],
	"./00003/00003-01/00003-01-08/intro.mp3": [
		608
	],
	"./00003/00003-01/00003-01-08/look at the ants.mp3": [
		4671,
		3346
	],
	"./00003/00003-01/00003-01-08/look at the birds.mp3": [
		4672,
		3347
	],
	"./00003/00003-01/00003-01-08/look at the cats.mp3": [
		4673,
		3348
	],
	"./00003/00003-01/00003-01-08/look at the cows.mp3": [
		4674,
		3349
	],
	"./00003/00003-01/00003-01-08/look at the dogs.mp3": [
		4675,
		3350
	],
	"./00003/00003-01/00003-01-08/look at the horses.mp3": [
		4676,
		3351
	],
	"./00003/00003-01/00003-01-08/look at the spiders.mp3": [
		4677,
		3352
	],
	"./00003/00003-01/00003-01-08/main idea.mp3": [
		989
	],
	"./00003/00003-01/00003-01-08/one of them is black and white.mp3": [
		4678,
		3353
	],
	"./00003/00003-01/00003-01-08/one of them is black.mp3": [
		4679,
		3354
	],
	"./00003/00003-01/00003-01-08/one of them is red and black.mp3": [
		4680,
		3355
	],
	"./00003/00003-01/00003-01-08/one of them is red.mp3": [
		4681,
		3356
	],
	"./00003/00003-01/00003-01-08/one of them is white.mp3": [
		4682,
		3357
	],
	"./00003/00003-01/00003-01-08/the black book.mp3": [
		4683,
		3358
	],
	"./00003/00003-01/00003-01-09/animals that live in the snow.mp3": [
		4684,
		3359
	],
	"./00003/00003-01/00003-01-09/he can hide in the snow.mp3": [
		4685,
		3360
	],
	"./00003/00003-01/00003-01-09/he is white in the winter.mp3": [
		4686,
		3361
	],
	"./00003/00003-01/00003-01-09/he is white like the snow.mp3": [
		4687,
		3362
	],
	"./00003/00003-01/00003-01-09/intro.mp3": [
		609
	],
	"./00003/00003-01/00003-01-09/main idea.mp3": [
		990
	],
	"./00003/00003-01/00003-01-09/she can hide in the snow.mp3": [
		4688,
		3363
	],
	"./00003/00003-01/00003-01-09/she is white in the winter.mp3": [
		4689,
		3364
	],
	"./00003/00003-01/00003-01-09/she is white like the snow.mp3": [
		4690,
		3365
	],
	"./00003/00003-01/00003-01-09/the arctic fox is white.mp3": [
		4691,
		3366
	],
	"./00003/00003-01/00003-01-09/the arctic wolf is white.mp3": [
		4692,
		3367
	],
	"./00003/00003-01/00003-01-09/the polar bear is white.mp3": [
		4693,
		3368
	],
	"./00003/00003-01/00003-01-09/the ptarmigan is white.mp3": [
		4694,
		3369
	],
	"./00003/00003-01/00003-01-09/the seal pup is white.mp3": [
		4695,
		3370
	],
	"./00003/00003-01/00003-01-09/the snowshoe rabbit is white.mp3": [
		4696,
		3371
	],
	"./00003/00003-01/00003-01-09/the snowy owl is white.mp3": [
		4697,
		3372
	],
	"./00003/00003-01/00003-01-09/the white book.mp3": [
		4698,
		3373
	],
	"./00003/00003-01/00003-01-10/i see a pink elephant too.mp3": [
		4699,
		3374
	],
	"./00003/00003-01/00003-01-10/i see a pink flamingo.mp3": [
		4700,
		3375
	],
	"./00003/00003-01/00003-01-10/i see a pink hermit crab.mp3": [
		4701,
		3376
	],
	"./00003/00003-01/00003-01-10/i see a pink pig.mp3": [
		4702,
		3377
	],
	"./00003/00003-01/00003-01-10/i see a pink rabbit.mp3": [
		4703,
		3378
	],
	"./00003/00003-01/00003-01-10/i see a pink shell.mp3": [
		4704,
		3379
	],
	"./00003/00003-01/00003-01-10/i see a pink starfish.mp3": [
		4705,
		3380
	],
	"./00003/00003-01/00003-01-10/i see some pink flowers.mp3": [
		4706,
		3381
	],
	"./00003/00003-01/00003-01-10/i spy something pink.mp3": [
		4707,
		3382
	],
	"./00003/00003-01/00003-01-10/i spy with my little eye said the boy.mp3": [
		4708,
		3383
	],
	"./00003/00003-01/00003-01-10/i spy with my little eye said the girl.mp3": [
		4709,
		3384
	],
	"./00003/00003-01/00003-01-10/intro.mp3": [
		610
	],
	"./00003/00003-01/00003-01-10/main idea.mp3": [
		991
	],
	"./00003/00003-01/00003-01-10/the pig likes the flowers.mp3": [
		4710,
		3385
	],
	"./00003/00003-01/00003-01-10/the pink book.mp3": [
		4711,
		3386
	],
	"./00003/00003-01/00003-01-10/things that are pink.mp3": [
		4712,
		3387
	],
	"./00003/00003-01/color land.mp3": [
		4713,
		3388
	],
	"./00003/00003-01/colors.mp3": [
		4714,
		3389
	],
	"./00003/00003-02/00003-02-01/animals.mp3": [
		4715,
		3390
	],
	"./00003/00003-02/00003-02-01/can i come in he said.mp3": [
		4716,
		3391
	],
	"./00003/00003-02/00003-02-01/can i come in said the owl.mp3": [
		4717,
		3392
	],
	"./00003/00003-02/00003-02-01/can i come in she said.mp3": [
		4718,
		3393
	],
	"./00003/00003-02/00003-02-01/here is a bear.mp3": [
		4719,
		3394
	],
	"./00003/00003-02/00003-02-01/here is a mitten.mp3": [
		4720,
		3395
	],
	"./00003/00003-02/00003-02-01/here is a rabbit.mp3": [
		4721,
		3396
	],
	"./00003/00003-02/00003-02-01/intro.mp3": [
		611
	],
	"./00003/00003-02/00003-02-01/look at the bear.mp3": [
		4722,
		3397
	],
	"./00003/00003-02/00003-02-01/look at the fox.mp3": [
		4723,
		3398
	],
	"./00003/00003-02/00003-02-01/look at the mitten.mp3": [
		4724,
		3399
	],
	"./00003/00003-02/00003-02-01/look at the mouse.mp3": [
		4725,
		3400
	],
	"./00003/00003-02/00003-02-01/look at the owl.mp3": [
		4726,
		3401
	],
	"./00003/00003-02/00003-02-01/look at the rabbit.mp3": [
		4727,
		3402
	],
	"./00003/00003-02/00003-02-01/main idea.mp3": [
		992
	],
	"./00003/00003-02/00003-02-01/no said the mouse.mp3": [
		4728,
		3403
	],
	"./00003/00003-02/00003-02-01/oh no.mp3": [
		4729,
		3404
	],
	"./00003/00003-02/00003-02-01/the bear is too big.mp3": [
		4730,
		3405
	],
	"./00003/00003-02/00003-02-01/the fox is going in the mitten.mp3": [
		4731,
		3406
	],
	"./00003/00003-02/00003-02-01/the mitten is in the snow.mp3": [
		4732,
		3407
	],
	"./00003/00003-02/00003-02-01/the mitten.mp3": [
		4733,
		3408
	],
	"./00003/00003-02/00003-02-01/the mouse is going in the mitten.mp3": [
		4734,
		3409
	],
	"./00003/00003-02/00003-02-01/the owl is going in the mitten.mp3": [
		4735,
		3410
	],
	"./00003/00003-02/00003-02-01/the rabbit is going in the mitten.mp3": [
		4736,
		3411
	],
	"./00003/00003-02/00003-02-02/dogs.mp3": [
		4737,
		3412
	],
	"./00003/00003-02/00003-02-02/here they are.mp3": [
		4738,
		3413
	],
	"./00003/00003-02/00003-02-02/intro.mp3": [
		612
	],
	"./00003/00003-02/00003-02-02/look in the bathroom.mp3": [
		4739,
		3414
	],
	"./00003/00003-02/00003-02-02/look in the bedroom.mp3": [
		4740,
		3415
	],
	"./00003/00003-02/00003-02-02/look in the box.mp3": [
		4741,
		3416
	],
	"./00003/00003-02/00003-02-02/look in the kitchen.mp3": [
		4742,
		3417
	],
	"./00003/00003-02/00003-02-02/look in the living room.mp3": [
		4743,
		3418
	],
	"./00003/00003-02/00003-02-02/look in the shower.mp3": [
		4744,
		3419
	],
	"./00003/00003-02/00003-02-02/look.mp3": [
		4745,
		3420
	],
	"./00003/00003-02/00003-02-02/main idea.mp3": [
		993
	],
	"./00003/00003-02/00003-02-02/no puppies here.mp3": [
		4746,
		3421
	],
	"./00003/00003-02/00003-02-02/where are the puppies.mp3": [
		4747,
		3422
	],
	"./00003/00003-02/00003-02-03/farm animals.mp3": [
		4748,
		3423
	],
	"./00003/00003-02/00003-02-03/intro.mp3": [
		613
	],
	"./00003/00003-02/00003-02-03/main idea.mp3": [
		994
	],
	"./00003/00003-02/00003-02-03/the animals get off the bus.mp3": [
		4749,
		3424
	],
	"./00003/00003-02/00003-02-03/the bus ride.mp3": [
		4750,
		3425
	],
	"./00003/00003-02/00003-02-03/the bus stops.mp3": [
		4751,
		3426
	],
	"./00003/00003-02/00003-02-03/the cats go on the bus.mp3": [
		4752,
		3427
	],
	"./00003/00003-02/00003-02-03/the cows go on the bus.mp3": [
		4753,
		3428
	],
	"./00003/00003-02/00003-02-03/the dogs go on the bus.mp3": [
		4754,
		3429
	],
	"./00003/00003-02/00003-02-03/the ducks go on the bus.mp3": [
		4755,
		3430
	],
	"./00003/00003-02/00003-02-03/the horses go on the bus.mp3": [
		4756,
		3431
	],
	"./00003/00003-02/00003-02-03/the lions go on the bus.mp3": [
		4757,
		3432
	],
	"./00003/00003-02/00003-02-03/the sheep go on the bus.mp3": [
		4758,
		3433
	],
	"./00003/00003-02/00003-02-03/then the bus goes fast.mp3": [
		4759,
		3434
	],
	"./00003/00003-02/00003-02-03/who will get on next.mp3": [
		4760,
		3435
	],
	"./00003/00003-02/00003-02-04/can i play with the hedgehog.mp3": [
		4761,
		3436
	],
	"./00003/00003-02/00003-02-04/can i play with the kitten.mp3": [
		4762,
		3437
	],
	"./00003/00003-02/00003-02-04/can i play with the owl.mp3": [
		4763,
		3438
	],
	"./00003/00003-02/00003-02-04/can i play with the rabbit.mp3": [
		4764,
		3439
	],
	"./00003/00003-02/00003-02-04/can i play with the skunk.mp3": [
		4765,
		3440
	],
	"./00003/00003-02/00003-02-04/can i play with the snake.mp3": [
		4766,
		3441
	],
	"./00003/00003-02/00003-02-04/can i play with the turtle.mp3": [
		4767,
		3442
	],
	"./00003/00003-02/00003-02-04/dogs.mp3": [
		4768,
		3443
	],
	"./00003/00003-02/00003-02-04/intro.mp3": [
		614
	],
	"./00003/00003-02/00003-02-04/main idea.mp3": [
		995
	],
	"./00003/00003-02/00003-02-04/no no puppy.mp3": [
		4769,
		3444
	],
	"./00003/00003-02/00003-02-04/no puppy no.mp3": [
		4770,
		3445
	],
	"./00003/00003-02/00003-02-04/no puppy.mp3": [
		4771,
		3446
	],
	"./00003/00003-02/00003-02-04/yes yes puppy.mp3": [
		4772,
		3447
	],
	"./00003/00003-02/00003-02-04/you can not play with the hedgehog.mp3": [
		4773,
		3448
	],
	"./00003/00003-02/00003-02-04/you can not play with the owl.mp3": [
		4774,
		3449
	],
	"./00003/00003-02/00003-02-04/you can not play with the rabbit.mp3": [
		4775,
		3450
	],
	"./00003/00003-02/00003-02-04/you can not play with the skunk.mp3": [
		4776,
		3451
	],
	"./00003/00003-02/00003-02-04/you can not play with the snake.mp3": [
		4777,
		3452
	],
	"./00003/00003-02/00003-02-04/you can not play with the turtle.mp3": [
		4778,
		3453
	],
	"./00003/00003-02/00003-02-04/you can play with the kitten.mp3": [
		4779,
		3454
	],
	"./00003/00003-02/00003-02-05/animals that are gray.mp3": [
		4780,
		3455
	],
	"./00003/00003-02/00003-02-05/i love black and white.mp3": [
		4781,
		3456
	],
	"./00003/00003-02/00003-02-05/i love blue.mp3": [
		4782,
		3457
	],
	"./00003/00003-02/00003-02-05/i love gray said the elephant.mp3": [
		4783,
		3458
	],
	"./00003/00003-02/00003-02-05/i love gray.mp3": [
		4784,
		3459
	],
	"./00003/00003-02/00003-02-05/i love green.mp3": [
		4785,
		3460
	],
	"./00003/00003-02/00003-02-05/i love orange said the goat.mp3": [
		4786,
		3461
	],
	"./00003/00003-02/00003-02-05/i love orange.mp3": [
		4787,
		3462
	],
	"./00003/00003-02/00003-02-05/i love purple said the girl.mp3": [
		4788,
		3463
	],
	"./00003/00003-02/00003-02-05/i love purple.mp3": [
		4789,
		3464
	],
	"./00003/00003-02/00003-02-05/i love red.mp3": [
		4790,
		3465
	],
	"./00003/00003-02/00003-02-05/i love to paint said the boy.mp3": [
		4791,
		3466
	],
	"./00003/00003-02/00003-02-05/i love to paint said the mouse.mp3": [
		4792,
		3467
	],
	"./00003/00003-02/00003-02-05/i love to paint said the rabbit.mp3": [
		4793,
		3468
	],
	"./00003/00003-02/00003-02-05/i love to paint said the zebra.mp3": [
		4794,
		3469
	],
	"./00003/00003-02/00003-02-05/i love to paint.mp3": [
		4795,
		3470
	],
	"./00003/00003-02/00003-02-05/intro.mp3": [
		615
	],
	"./00003/00003-02/00003-02-05/look at me.mp3": [
		4796,
		3471
	],
	"./00003/00003-02/00003-02-05/main idea.mp3": [
		996
	],
	"./00003/00003-02/00003-02-06/food.mp3": [
		4797,
		3472
	],
	"./00003/00003-02/00003-02-06/im the gingerbread man.mp3": [
		4798,
		3473
	],
	"./00003/00003-02/00003-02-06/intro.mp3": [
		616
	],
	"./00003/00003-02/00003-02-06/look at the alligator.mp3": [
		4799,
		3474
	],
	"./00003/00003-02/00003-02-06/look at the cow.mp3": [
		4800,
		3475
	],
	"./00003/00003-02/00003-02-06/look at the dog.mp3": [
		4801,
		3476
	],
	"./00003/00003-02/00003-02-06/look at the gingerbread man.mp3": [
		4802,
		3477
	],
	"./00003/00003-02/00003-02-06/look at the horse.mp3": [
		4803,
		3478
	],
	"./00003/00003-02/00003-02-06/look at the sheep.mp3": [
		4804,
		3479
	],
	"./00003/00003-02/00003-02-06/main idea.mp3": [
		997
	],
	"./00003/00003-02/00003-02-06/no said the gingerbread man.mp3": [
		4805,
		3480
	],
	"./00003/00003-02/00003-02-06/oh no.mp3": [
		4806,
		3481
	],
	"./00003/00003-02/00003-02-06/run run as fast as you can.mp3": [
		4807,
		3482
	],
	"./00003/00003-02/00003-02-06/stop said the alligator.mp3": [
		4808,
		3483
	],
	"./00003/00003-02/00003-02-06/stop said the cow.mp3": [
		4809,
		3484
	],
	"./00003/00003-02/00003-02-06/stop said the dog.mp3": [
		4810,
		3485
	],
	"./00003/00003-02/00003-02-06/stop said the horse.mp3": [
		4811,
		3486
	],
	"./00003/00003-02/00003-02-06/stop said the sheep.mp3": [
		4812,
		3487
	],
	"./00003/00003-02/00003-02-06/the gingerbread man.mp3": [
		4813,
		3488
	],
	"./00003/00003-02/00003-02-06/you cant catch me.mp3": [
		4814,
		3489
	],
	"./00003/00003-02/00003-02-07/0 little frogs sat on a log.mp3": [
		4815,
		3490
	],
	"./00003/00003-02/00003-02-07/1 frog jumped into the pond.mp3": [
		4816,
		3491
	],
	"./00003/00003-02/00003-02-07/1 jumped into the pond.mp3": [
		4817,
		3492
	],
	"./00003/00003-02/00003-02-07/1 little frog sat on a log.mp3": [
		4818,
		3493
	],
	"./00003/00003-02/00003-02-07/2 little frogs sat on a log.mp3": [
		4819,
		3494
	],
	"./00003/00003-02/00003-02-07/3 little frogs sat on a log.mp3": [
		4820,
		3495
	],
	"./00003/00003-02/00003-02-07/4 little frogs sat on a log.mp3": [
		4821,
		3496
	],
	"./00003/00003-02/00003-02-07/5 little frogs sat in the pond.mp3": [
		4822,
		3497
	],
	"./00003/00003-02/00003-02-07/5 little frogs sat on a log.mp3": [
		4823,
		3498
	],
	"./00003/00003-02/00003-02-07/5 little frogs.mp3": [
		4824,
		3499
	],
	"./00003/00003-02/00003-02-07/intro.mp3": [
		617
	],
	"./00003/00003-02/00003-02-07/it is hot on the log they said.mp3": [
		4825,
		3500
	],
	"./00003/00003-02/00003-02-07/main idea.mp3": [
		998
	],
	"./00003/00003-02/00003-02-07/now there are 2 little frogs on a log.mp3": [
		4826,
		3501
	],
	"./00003/00003-02/00003-02-07/now there are 3 little frogs on a log.mp3": [
		4827,
		3502
	],
	"./00003/00003-02/00003-02-07/now there are 4 little frogs on a log.mp3": [
		4828,
		3503
	],
	"./00003/00003-02/00003-02-07/now there are 5 little frogs in the pond.mp3": [
		4829,
		3504
	],
	"./00003/00003-02/00003-02-07/now there are no little frogs on a log.mp3": [
		4830,
		3505
	],
	"./00003/00003-02/00003-02-07/now there is 1 little frog on a log.mp3": [
		4831,
		3506
	],
	"./00003/00003-02/00003-02-07/she jumped into the pond.mp3": [
		4832,
		3507
	],
	"./00003/00003-02/00003-02-07/water animals.mp3": [
		4833,
		3508
	],
	"./00003/00003-02/00003-02-07/we like the pond they said.mp3": [
		4834,
		3509
	],
	"./00003/00003-02/00003-02-07/where are the frogs.mp3": [
		4835,
		3510
	],
	"./00003/00003-02/00003-02-08/a giraffe is too big.mp3": [
		4836,
		3511
	],
	"./00003/00003-02/00003-02-08/an elephant is too big.mp3": [
		4837,
		3512
	],
	"./00003/00003-02/00003-02-08/can i have a crocodile said sam.mp3": [
		4838,
		3513
	],
	"./00003/00003-02/00003-02-08/can i have a dog said sam.mp3": [
		4839,
		3514
	],
	"./00003/00003-02/00003-02-08/can i have a giraffe said sam.mp3": [
		4840,
		3515
	],
	"./00003/00003-02/00003-02-08/can i have a pet.mp3": [
		4841,
		3516
	],
	"./00003/00003-02/00003-02-08/can i have an elephant said sam.mp3": [
		4842,
		3517
	],
	"./00003/00003-02/00003-02-08/intro.mp3": [
		618
	],
	"./00003/00003-02/00003-02-08/main idea.mp3": [
		999
	],
	"./00003/00003-02/00003-02-08/no monkeys.mp3": [
		4843,
		3518
	],
	"./00003/00003-02/00003-02-08/no said dad.mp3": [
		4844,
		3519
	],
	"./00003/00003-02/00003-02-08/no said mom and dad.mp3": [
		4845,
		3520
	],
	"./00003/00003-02/00003-02-08/no said mom.mp3": [
		4846,
		3521
	],
	"./00003/00003-02/00003-02-08/pets.mp3": [
		4847,
		3522
	],
	"./00003/00003-02/00003-02-08/sam said can i have a monkey.mp3": [
		4848,
		3523
	],
	"./00003/00003-02/00003-02-08/sam said can i have a snake.mp3": [
		4849,
		3524
	],
	"./00003/00003-02/00003-02-08/sam said can i have an ostrich.mp3": [
		4850,
		3525
	],
	"./00003/00003-02/00003-02-08/we do not like snakes.mp3": [
		4851,
		3526
	],
	"./00003/00003-02/00003-02-08/yes said mom and dad.mp3": [
		4852,
		3527
	],
	"./00003/00003-02/00003-02-08/you can have a dog.mp3": [
		4853,
		3528
	],
	"./00003/00003-02/00003-02-08/you can not have a crocodile.mp3": [
		4854,
		3529
	],
	"./00003/00003-02/00003-02-08/you can not have a giraffe.mp3": [
		4855,
		3530
	],
	"./00003/00003-02/00003-02-08/you can not have a monkey.mp3": [
		4856,
		3531
	],
	"./00003/00003-02/00003-02-08/you can not have a snake.mp3": [
		4857,
		3532
	],
	"./00003/00003-02/00003-02-08/you can not have an elephant.mp3": [
		4858,
		3533
	],
	"./00003/00003-02/00003-02-08/you can not have an ostrich.mp3": [
		4859,
		3534
	],
	"./00003/00003-02/00003-02-09/do you.mp3": [
		4860,
		3535
	],
	"./00003/00003-02/00003-02-09/i like the horse.mp3": [
		4861,
		3536
	],
	"./00003/00003-02/00003-02-09/i like the slide.mp3": [
		4862,
		3537
	],
	"./00003/00003-02/00003-02-09/i like the swings.mp3": [
		4863,
		3538
	],
	"./00003/00003-02/00003-02-09/i like to play on the horse said the boy.mp3": [
		4864,
		3539
	],
	"./00003/00003-02/00003-02-09/i like to play on the horse said the monster.mp3": [
		4865,
		3540
	],
	"./00003/00003-02/00003-02-09/i like to play on the slide said the boy.mp3": [
		4866,
		3541
	],
	"./00003/00003-02/00003-02-09/i like to play on the swings said the girl.mp3": [
		4867,
		3542
	],
	"./00003/00003-02/00003-02-09/i like to play on the swings said the monster.mp3": [
		4868,
		3543
	],
	"./00003/00003-02/00003-02-09/intro.mp3": [
		619
	],
	"./00003/00003-02/00003-02-09/look at me said the boy.mp3": [
		4869,
		3544
	],
	"./00003/00003-02/00003-02-09/look at me said the girl.mp3": [
		4870,
		3545
	],
	"./00003/00003-02/00003-02-09/look at me said the monster.mp3": [
		4871,
		3546
	],
	"./00003/00003-02/00003-02-09/look at me.mp3": [
		4872,
		3547
	],
	"./00003/00003-02/00003-02-09/main idea.mp3": [
		1000
	],
	"./00003/00003-02/00003-02-09/the playground.mp3": [
		4873,
		3548
	],
	"./00003/00003-02/00003-02-09/toys.mp3": [
		4874,
		3549
	],
	"./00003/00003-02/00003-02-09/we like the seesaw.mp3": [
		4875,
		3550
	],
	"./00003/00003-02/00003-02-09/we like to play on the seesaw said the kids.mp3": [
		4876,
		3551
	],
	"./00003/00003-02/00003-02-09/we like to play on the slide said the monsters.mp3": [
		4877,
		3552
	],
	"./00003/00003-02/00003-02-10/farm animals.mp3": [
		4878,
		3553
	],
	"./00003/00003-02/00003-02-10/hello cat i like your hat.mp3": [
		4879,
		3554
	],
	"./00003/00003-02/00003-02-10/hello chicken i like your hat.mp3": [
		4880,
		3555
	],
	"./00003/00003-02/00003-02-10/hello cow i like your hat.mp3": [
		4881,
		3556
	],
	"./00003/00003-02/00003-02-10/hello dog can i have your hat.mp3": [
		4882,
		3557
	],
	"./00003/00003-02/00003-02-10/hello dog i like your hat.mp3": [
		4883,
		3558
	],
	"./00003/00003-02/00003-02-10/hello goat i like your hat.mp3": [
		4884,
		3559
	],
	"./00003/00003-02/00003-02-10/hello horse can i have your hat.mp3": [
		4885,
		3560
	],
	"./00003/00003-02/00003-02-10/hello horse i like your hat.mp3": [
		4886,
		3561
	],
	"./00003/00003-02/00003-02-10/hello sheep can i have your hat.mp3": [
		4887,
		3562
	],
	"./00003/00003-02/00003-02-10/hello sheep i like your hat.mp3": [
		4888,
		3563
	],
	"./00003/00003-02/00003-02-10/intro.mp3": [
		620
	],
	"./00003/00003-02/00003-02-10/main idea.mp3": [
		1001
	],
	"./00003/00003-02/00003-02-10/thank you.mp3": [
		4889,
		3564
	],
	"./00003/00003-02/00003-02-10/yes you can have it.mp3": [
		4890,
		3565
	],
	"./00003/00003-02/00003-02-10/you can have it.mp3": [
		4891,
		3566
	],
	"./00003/00003-02/00003-02-11/animals.mp3": [
		4892,
		3567
	],
	"./00003/00003-02/00003-02-11/here is a cat.mp3": [
		4893,
		3568
	],
	"./00003/00003-02/00003-02-11/here is a dog.mp3": [
		4894,
		3569
	],
	"./00003/00003-02/00003-02-11/i like ice cream he said.mp3": [
		4895,
		3570
	],
	"./00003/00003-02/00003-02-11/i like ice cream she said.mp3": [
		4896,
		3571
	],
	"./00003/00003-02/00003-02-11/i love ice cream she said.mp3": [
		4897,
		3572
	],
	"./00003/00003-02/00003-02-11/i see the octopus.mp3": [
		4898,
		3573
	],
	"./00003/00003-02/00003-02-11/i see the snake.mp3": [
		4899,
		3574
	],
	"./00003/00003-02/00003-02-11/intro.mp3": [
		621
	],
	"./00003/00003-02/00003-02-11/look at the bat.mp3": [
		4900,
		3575
	],
	"./00003/00003-02/00003-02-11/look at the elephant.mp3": [
		4901,
		3576
	],
	"./00003/00003-02/00003-02-11/look at the lion.mp3": [
		4902,
		3577
	],
	"./00003/00003-02/00003-02-11/main idea.mp3": [
		1002
	],
	"./00003/00003-02/00003-02-11/we like ice cream.mp3": [
		4903,
		3578
	],
	"./00003/00003-02/story park.mp3": [
		4904,
		3579
	],
	"./00003/00003-03/00003-03-01/a sea turtle lives in the sea.mp3": [
		4905,
		3580
	],
	"./00003/00003-03/00003-03-01/a seahorse lives in the sea.mp3": [
		4906,
		3581
	],
	"./00003/00003-03/00003-03-01/a shark lives in the sea.mp3": [
		4907,
		3582
	],
	"./00003/00003-03/00003-03-01/a whale lives in the sea.mp3": [
		4908,
		3583
	],
	"./00003/00003-03/00003-03-01/here comes the gray whale.mp3": [
		4909,
		3584
	],
	"./00003/00003-03/00003-03-01/here is a dolphin.mp3": [
		4910,
		3585
	],
	"./00003/00003-03/00003-03-01/here is a sea turtle.mp3": [
		4911,
		3586
	],
	"./00003/00003-03/00003-03-01/here is a seahorse.mp3": [
		4912,
		3587
	],
	"./00003/00003-03/00003-03-01/i like the crab.mp3": [
		4913,
		3588
	],
	"./00003/00003-03/00003-03-01/i see the octopus.mp3": [
		4914,
		3589
	],
	"./00003/00003-03/00003-03-01/intro.mp3": [
		622
	],
	"./00003/00003-03/00003-03-01/look at the crab.mp3": [
		4915,
		3590
	],
	"./00003/00003-03/00003-03-01/look at the octopus.mp3": [
		4916,
		3591
	],
	"./00003/00003-03/00003-03-01/look at the shark.mp3": [
		4917,
		3592
	],
	"./00003/00003-03/00003-03-01/look at the whale.mp3": [
		4918,
		3593
	],
	"./00003/00003-03/00003-03-01/main idea.mp3": [
		1003
	],
	"./00003/00003-03/00003-03-01/sea animals.mp3": [
		4919,
		3594
	],
	"./00003/00003-03/00003-03-01/the crab lives in the sea.mp3": [
		4920,
		3595
	],
	"./00003/00003-03/00003-03-01/the dolphin is a mammal.mp3": [
		4921,
		3596
	],
	"./00003/00003-03/00003-03-01/the dolphin lives in the sea.mp3": [
		4922,
		3597
	],
	"./00003/00003-03/00003-03-01/the octopus lives in the sea.mp3": [
		4923,
		3598
	],
	"./00003/00003-03/00003-03-01/the seahorse is a fish.mp3": [
		4924,
		3599
	],
	"./00003/00003-03/00003-03-01/the shark is a fish.mp3": [
		4925,
		3600
	],
	"./00003/00003-03/00003-03-01/the turtle is a reptile.mp3": [
		4926,
		3601
	],
	"./00003/00003-03/00003-03-02/intro.mp3": [
		623
	],
	"./00003/00003-03/00003-03-02/look at the beaver.mp3": [
		4927,
		3602
	],
	"./00003/00003-03/00003-03-02/look at the dragonfly.mp3": [
		4928,
		3603
	],
	"./00003/00003-03/00003-03-02/look at the duck.mp3": [
		4929,
		3604
	],
	"./00003/00003-03/00003-03-02/look at the frog.mp3": [
		4930,
		3605
	],
	"./00003/00003-03/00003-03-02/look at the salamander.mp3": [
		4931,
		3606
	],
	"./00003/00003-03/00003-03-02/look at the toad.mp3": [
		4932,
		3607
	],
	"./00003/00003-03/00003-03-02/look at the turtle.mp3": [
		4933,
		3608
	],
	"./00003/00003-03/00003-03-02/main idea.mp3": [
		1004
	],
	"./00003/00003-03/00003-03-02/me too said the dragonfly.mp3": [
		4934,
		3609
	],
	"./00003/00003-03/00003-03-02/pond animals.mp3": [
		4935,
		3610
	],
	"./00003/00003-03/00003-03-02/the beaver lives at the pond.mp3": [
		4936,
		3611
	],
	"./00003/00003-03/00003-03-02/the dragonfly lives at the pond.mp3": [
		4937,
		3612
	],
	"./00003/00003-03/00003-03-02/the duck lives at the pond too.mp3": [
		4938,
		3613
	],
	"./00003/00003-03/00003-03-02/the frog lives at the pond.mp3": [
		4939,
		3614
	],
	"./00003/00003-03/00003-03-02/the salamander lives at the pond.mp3": [
		4940,
		3615
	],
	"./00003/00003-03/00003-03-02/the toad lives at the pond.mp3": [
		4941,
		3616
	],
	"./00003/00003-03/00003-03-02/the turtle lives at the pond.mp3": [
		4942,
		3617
	],
	"./00003/00003-03/00003-03-02/who else lives at the pond.mp3": [
		4943,
		3618
	],
	"./00003/00003-03/00003-03-02/who lives at the pond.mp3": [
		4944,
		3619
	],
	"./00003/00003-03/00003-03-03/giraffes like to eat leaves.mp3": [
		4945,
		3620
	],
	"./00003/00003-03/00003-03-03/i am a cat.mp3": [
		4946,
		3621
	],
	"./00003/00003-03/00003-03-03/i am a giraffe.mp3": [
		4947,
		3622
	],
	"./00003/00003-03/00003-03-03/i am a hippo.mp3": [
		4948,
		3623
	],
	"./00003/00003-03/00003-03-03/i am a lion.mp3": [
		4949,
		3624
	],
	"./00003/00003-03/00003-03-03/i am a mammal.mp3": [
		4950,
		3625
	],
	"./00003/00003-03/00003-03-03/i am a rhino.mp3": [
		4951,
		3626
	],
	"./00003/00003-03/00003-03-03/i am a tiger.mp3": [
		4952,
		3627
	],
	"./00003/00003-03/00003-03-03/i am a wild animal.mp3": [
		4953,
		3628
	],
	"./00003/00003-03/00003-03-03/i am a zebra.mp3": [
		4954,
		3629
	],
	"./00003/00003-03/00003-03-03/i have 2 horns.mp3": [
		4955,
		3630
	],
	"./00003/00003-03/00003-03-03/i live in the wild.mp3": [
		4956,
		3631
	],
	"./00003/00003-03/00003-03-03/intro.mp3": [
		624
	],
	"./00003/00003-03/00003-03-03/look at me.mp3": [
		4957,
		3632
	],
	"./00003/00003-03/00003-03-03/look at us.mp3": [
		4958,
		3633
	],
	"./00003/00003-03/00003-03-03/main idea.mp3": [
		1005
	],
	"./00003/00003-03/00003-03-03/we are kangaroos.mp3": [
		4959,
		3634
	],
	"./00003/00003-03/00003-03-03/we are mammals.mp3": [
		4960,
		3635
	],
	"./00003/00003-03/00003-03-03/we are wild animals too.mp3": [
		4961,
		3636
	],
	"./00003/00003-03/00003-03-03/wild animals.mp3": [
		4962,
		3637
	],
	"./00003/00003-03/00003-03-03/zebras like to eat grass.mp3": [
		4963,
		3638
	],
	"./00003/00003-03/00003-03-04/he lives with me.mp3": [
		4964,
		3639
	],
	"./00003/00003-03/00003-03-04/here is my cat said the boy.mp3": [
		4965,
		3640
	],
	"./00003/00003-03/00003-03-04/here is my dog said the girl.mp3": [
		4966,
		3641
	],
	"./00003/00003-03/00003-03-04/here is my pet said the boy.mp3": [
		4967,
		3642
	],
	"./00003/00003-03/00003-03-04/here is my pet said the girl.mp3": [
		4968,
		3643
	],
	"./00003/00003-03/00003-03-04/here is my pet.mp3": [
		4969,
		3644
	],
	"./00003/00003-03/00003-03-04/i love my cat.mp3": [
		4970,
		3645
	],
	"./00003/00003-03/00003-03-04/i love my dinosaur.mp3": [
		4971,
		3646
	],
	"./00003/00003-03/00003-03-04/i love my dog.mp3": [
		4972,
		3647
	],
	"./00003/00003-03/00003-03-04/i love my fish.mp3": [
		4973,
		3648
	],
	"./00003/00003-03/00003-03-04/i love my rabbit.mp3": [
		4974,
		3649
	],
	"./00003/00003-03/00003-03-04/i love my snake.mp3": [
		4975,
		3650
	],
	"./00003/00003-03/00003-03-04/i love my turtle.mp3": [
		4976,
		3651
	],
	"./00003/00003-03/00003-03-04/intro.mp3": [
		625
	],
	"./00003/00003-03/00003-03-04/look at my pet.mp3": [
		4977,
		3652
	],
	"./00003/00003-03/00003-03-04/main idea.mp3": [
		1006
	],
	"./00003/00003-03/00003-03-04/my pet is a turtle.mp3": [
		4978,
		3653
	],
	"./00003/00003-03/00003-03-04/pets.mp3": [
		4979,
		3654
	],
	"./00003/00003-03/00003-03-04/she lives with me.mp3": [
		4980,
		3655
	],
	"./00003/00003-03/00003-03-05/forest animals.mp3": [
		4981,
		3656
	],
	"./00003/00003-03/00003-03-05/he lives in the forest.mp3": [
		4982,
		3657
	],
	"./00003/00003-03/00003-03-05/here is a bear.mp3": [
		4983,
		3658
	],
	"./00003/00003-03/00003-03-05/here is a deer.mp3": [
		4984,
		3659
	],
	"./00003/00003-03/00003-03-05/here is a rabbit.mp3": [
		4985,
		3660
	],
	"./00003/00003-03/00003-03-05/i see a bird.mp3": [
		4986,
		3661
	],
	"./00003/00003-03/00003-03-05/i see a fox.mp3": [
		4987,
		3662
	],
	"./00003/00003-03/00003-03-05/i see a hedgehog.mp3": [
		4988,
		3663
	],
	"./00003/00003-03/00003-03-05/i see a squirrel.mp3": [
		4989,
		3664
	],
	"./00003/00003-03/00003-03-05/intro.mp3": [
		626
	],
	"./00003/00003-03/00003-03-05/look at the bear.mp3": [
		4990,
		3665
	],
	"./00003/00003-03/00003-03-05/look at the bird.mp3": [
		4991,
		3666
	],
	"./00003/00003-03/00003-03-05/look at the deer.mp3": [
		4992,
		3667
	],
	"./00003/00003-03/00003-03-05/look at the fox.mp3": [
		4993,
		3668
	],
	"./00003/00003-03/00003-03-05/look at the hedgehog.mp3": [
		4994,
		3669
	],
	"./00003/00003-03/00003-03-05/look at the owl.mp3": [
		4995,
		3670
	],
	"./00003/00003-03/00003-03-05/look at the rabbit.mp3": [
		4996,
		3671
	],
	"./00003/00003-03/00003-03-05/look at the squirrel.mp3": [
		4997,
		3672
	],
	"./00003/00003-03/00003-03-05/main idea.mp3": [
		1007
	],
	"./00003/00003-03/00003-03-05/she lives in the forest.mp3": [
		4998,
		3673
	],
	"./00003/00003-03/00003-03-05/the deer is in the forest.mp3": [
		4999,
		3674
	],
	"./00003/00003-03/00003-03-05/the fox is in the forest.mp3": [
		5000,
		3675
	],
	"./00003/00003-03/00003-03-05/the squirrel is up in the tree.mp3": [
		5001,
		3676
	],
	"./00003/00003-03/00003-03-06/do you.mp3": [
		5002,
		3677
	],
	"./00003/00003-03/00003-03-06/farm animals.mp3": [
		5003,
		3678
	],
	"./00003/00003-03/00003-03-06/he lives on a farm.mp3": [
		5004,
		3679
	],
	"./00003/00003-03/00003-03-06/here is a chicken.mp3": [
		5005,
		3680
	],
	"./00003/00003-03/00003-03-06/here is a cow.mp3": [
		5006,
		3681
	],
	"./00003/00003-03/00003-03-06/here is a donkey.mp3": [
		5007,
		3682
	],
	"./00003/00003-03/00003-03-06/here is a goat.mp3": [
		5008,
		3683
	],
	"./00003/00003-03/00003-03-06/here is a horse.mp3": [
		5009,
		3684
	],
	"./00003/00003-03/00003-03-06/here is a pig.mp3": [
		5010,
		3685
	],
	"./00003/00003-03/00003-03-06/here is a sheep.mp3": [
		5011,
		3686
	],
	"./00003/00003-03/00003-03-06/i am a farm animal.mp3": [
		5012,
		3687
	],
	"./00003/00003-03/00003-03-06/i live in a tree.mp3": [
		5013,
		3688
	],
	"./00003/00003-03/00003-03-06/i live on a farm said the goat.mp3": [
		5014,
		3689
	],
	"./00003/00003-03/00003-03-06/i live on a farm said the horse.mp3": [
		5015,
		3690
	],
	"./00003/00003-03/00003-03-06/i live on a farm said the sheep.mp3": [
		5016,
		3691
	],
	"./00003/00003-03/00003-03-06/i live on a farm too.mp3": [
		5017,
		3692
	],
	"./00003/00003-03/00003-03-06/intro.mp3": [
		627
	],
	"./00003/00003-03/00003-03-06/look at the cow.mp3": [
		5018,
		3693
	],
	"./00003/00003-03/00003-03-06/look at the donkey.mp3": [
		5019,
		3694
	],
	"./00003/00003-03/00003-03-06/look at the horse.mp3": [
		5020,
		3695
	],
	"./00003/00003-03/00003-03-06/main idea.mp3": [
		1008
	],
	"./00003/00003-03/00003-03-06/not me said the owl - copy.mp3": [
		5021,
		3696
	],
	"./00003/00003-03/00003-03-06/not me said the owl.mp3": [
		5022,
		3697
	],
	"./00003/00003-03/00003-03-06/she lives on a farm.mp3": [
		5023,
		3698
	],
	"./00003/00003-03/00003-03-06/yes said the chicken.mp3": [
		5024,
		3699
	],
	"./00003/00003-03/00003-03-06/yes said the cow.mp3": [
		5025,
		3700
	],
	"./00003/00003-03/00003-03-06/yes said the pig.mp3": [
		5026,
		3701
	],
	"./00003/00003-03/00003-03-07/animals that live in the snow.mp3": [
		5027,
		3702
	],
	"./00003/00003-03/00003-03-07/arctic animals.mp3": [
		5028,
		3703
	],
	"./00003/00003-03/00003-03-07/he can hide in the snow.mp3": [
		5029,
		3704
	],
	"./00003/00003-03/00003-03-07/he lives in the snow.mp3": [
		5030,
		3705
	],
	"./00003/00003-03/00003-03-07/intro.mp3": [
		628
	],
	"./00003/00003-03/00003-03-07/main idea.mp3": [
		1009
	],
	"./00003/00003-03/00003-03-07/she can hide from the fox.mp3": [
		5031,
		3706
	],
	"./00003/00003-03/00003-03-07/she can hide from the polar bear.mp3": [
		5032,
		3707
	],
	"./00003/00003-03/00003-03-07/she can hide in the snow.mp3": [
		5033,
		3708
	],
	"./00003/00003-03/00003-03-07/she lives in the snow.mp3": [
		5034,
		3709
	],
	"./00003/00003-03/00003-03-07/the arctic fox is white.mp3": [
		5035,
		3710
	],
	"./00003/00003-03/00003-03-07/the arctic wolf is white.mp3": [
		5036,
		3711
	],
	"./00003/00003-03/00003-03-07/the owl is white.mp3": [
		5037,
		3712
	],
	"./00003/00003-03/00003-03-07/the polar bear is white.mp3": [
		5038,
		3713
	],
	"./00003/00003-03/00003-03-07/the ptarmigan is white.mp3": [
		5039,
		3714
	],
	"./00003/00003-03/00003-03-07/the seal pup is white.mp3": [
		5040,
		3715
	],
	"./00003/00003-03/00003-03-07/the snowshoe rabbit is white.mp3": [
		5041,
		3716
	],
	"./00003/00003-03/00003-03-07/the snowy owl is white.mp3": [
		5042,
		3717
	],
	"./00003/00003-03/00003-03-07/the wolf is white.mp3": [
		5043,
		3718
	],
	"./00003/00003-03/00003-03-08/desert animals.mp3": [
		5044,
		3719
	],
	"./00003/00003-03/00003-03-08/i am a big horned sheep.mp3": [
		5045,
		3720
	],
	"./00003/00003-03/00003-03-08/i am a bighorn sheep.mp3": [
		5046,
		3721
	],
	"./00003/00003-03/00003-03-08/i am a camel.mp3": [
		5047,
		3722
	],
	"./00003/00003-03/00003-03-08/i am a fennec fox.mp3": [
		5048,
		3723
	],
	"./00003/00003-03/00003-03-08/i am a fox.mp3": [
		5049,
		3724
	],
	"./00003/00003-03/00003-03-08/i am a rabbit.mp3": [
		5050,
		3725
	],
	"./00003/00003-03/00003-03-08/i am a snake.mp3": [
		5051,
		3726
	],
	"./00003/00003-03/00003-03-08/i am a spider.mp3": [
		5052,
		3727
	],
	"./00003/00003-03/00003-03-08/i am an iguana.mp3": [
		5053,
		3728
	],
	"./00003/00003-03/00003-03-08/i live in the desert too.mp3": [
		5054,
		3729
	],
	"./00003/00003-03/00003-03-08/i live in the desert.mp3": [
		5055,
		3730
	],
	"./00003/00003-03/00003-03-08/intro.mp3": [
		629
	],
	"./00003/00003-03/00003-03-08/main idea.mp3": [
		1010
	],
	"./00003/00003-03/00003-03-08/my home is dry.mp3": [
		5056,
		3731
	],
	"./00003/00003-03/00003-03-08/my home is hot.mp3": [
		5057,
		3732
	],
	"./00003/00003-03/00003-03-09/i am a butterfly.mp3": [
		5058,
		3733
	],
	"./00003/00003-03/00003-03-09/i am a frog.mp3": [
		5059,
		3734
	],
	"./00003/00003-03/00003-03-09/i am a jaguar.mp3": [
		5060,
		3735
	],
	"./00003/00003-03/00003-03-09/i am a monkey.mp3": [
		5061,
		3736
	],
	"./00003/00003-03/00003-03-09/i am a parrot.mp3": [
		5062,
		3737
	],
	"./00003/00003-03/00003-03-09/i am a snake.mp3": [
		5063,
		3738
	],
	"./00003/00003-03/00003-03-09/i am a toucan.mp3": [
		5064,
		3739
	],
	"./00003/00003-03/00003-03-09/i live in the rainforest too.mp3": [
		5065,
		3740
	],
	"./00003/00003-03/00003-03-09/i live in the rainforest.mp3": [
		5066,
		3741
	],
	"./00003/00003-03/00003-03-09/intro.mp3": [
		630
	],
	"./00003/00003-03/00003-03-09/main idea.mp3": [
		1011
	],
	"./00003/00003-03/00003-03-09/my home is hot.mp3": [
		5067,
		3742
	],
	"./00003/00003-03/00003-03-09/my home is wet.mp3": [
		5068,
		3743
	],
	"./00003/00003-03/00003-03-09/rainforest animals.mp3": [
		5069,
		3744
	],
	"./00003/00003-03/00003-03-10/he is a wild animal.mp3": [
		5070,
		3745
	],
	"./00003/00003-03/00003-03-10/he lives in a tree.mp3": [
		5071,
		3746
	],
	"./00003/00003-03/00003-03-10/he lives on a farm.mp3": [
		5072,
		3747
	],
	"./00003/00003-03/00003-03-10/he lives with me.mp3": [
		5073,
		3748
	],
	"./00003/00003-03/00003-03-10/i am a dog.mp3": [
		5074,
		3749
	],
	"./00003/00003-03/00003-03-10/i am a lion.mp3": [
		5075,
		3750
	],
	"./00003/00003-03/00003-03-10/i am a parrot.mp3": [
		5076,
		3751
	],
	"./00003/00003-03/00003-03-10/i am a zebra.mp3": [
		5077,
		3752
	],
	"./00003/00003-03/00003-03-10/i am an owl.mp3": [
		5078,
		3753
	],
	"./00003/00003-03/00003-03-10/intro.mp3": [
		631
	],
	"./00003/00003-03/00003-03-10/is it tame.mp3": [
		5079,
		3754
	],
	"./00003/00003-03/00003-03-10/is it wild is it tame.mp3": [
		5080,
		3755
	],
	"./00003/00003-03/00003-03-10/is it wild.mp3": [
		5081,
		3756
	],
	"./00003/00003-03/00003-03-10/look at the bird.mp3": [
		5082,
		3757
	],
	"./00003/00003-03/00003-03-10/look at the parrot.mp3": [
		5083,
		3758
	],
	"./00003/00003-03/00003-03-10/main idea.mp3": [
		1012
	],
	"./00003/00003-03/00003-03-10/she is a wild animal.mp3": [
		5084,
		3759
	],
	"./00003/00003-03/00003-03-10/she lives in a cage.mp3": [
		5085,
		3760
	],
	"./00003/00003-03/00003-03-10/she lives in a house.mp3": [
		5086,
		3761
	],
	"./00003/00003-03/00003-03-10/this cat is a pet animal.mp3": [
		5087,
		3762
	],
	"./00003/00003-03/00003-03-10/this dog is my pet.mp3": [
		5088,
		3763
	],
	"./00003/00003-03/00003-03-10/this horse is a farm animal.mp3": [
		5089,
		3764
	],
	"./00003/00003-03/00003-03-10/this lion is not a pet.mp3": [
		5090,
		3765
	],
	"./00003/00003-03/00003-03-10/this owl is a wild bird.mp3": [
		5091,
		3766
	],
	"./00003/00003-03/00003-03-10/this parrot is a pet bird.mp3": [
		5092,
		3767
	],
	"./00003/00003-03/00003-03-10/this zebra is not a farm animal.mp3": [
		5093,
		3768
	],
	"./00003/00003-03/00003-03-10/wild animals.mp3": [
		5094,
		3769
	],
	"./00003/00003-03/00003-03-10/wild or tame.mp3": [
		5095,
		3770
	],
	"./00003/00003-03/animal land.mp3": [
		5096,
		3771
	],
	"./00003/00003-03/animals.mp3": [
		5097,
		3772
	],
	"./00003/00003-04/00003-04-01/animals.mp3": [
		5098,
		3773
	],
	"./00003/00003-04/00003-04-01/i can see one box.mp3": [
		5099,
		3774
	],
	"./00003/00003-04/00003-04-01/i can see one car.mp3": [
		5100,
		3775
	],
	"./00003/00003-04/00003-04-01/i can see one cat.mp3": [
		5101,
		3776
	],
	"./00003/00003-04/00003-04-01/i can see one clock.mp3": [
		5102,
		3777
	],
	"./00003/00003-04/00003-04-01/i can see one dog.mp3": [
		5103,
		3778
	],
	"./00003/00003-04/00003-04-01/i can see one duck.mp3": [
		5104,
		3779
	],
	"./00003/00003-04/00003-04-01/i can see one fox.mp3": [
		5105,
		3780
	],
	"./00003/00003-04/00003-04-01/i can see one frog.mp3": [
		5106,
		3781
	],
	"./00003/00003-04/00003-04-01/i can see one hat.mp3": [
		5107,
		3782
	],
	"./00003/00003-04/00003-04-01/i can see one house.mp3": [
		5108,
		3783
	],
	"./00003/00003-04/00003-04-01/i can see one mouse.mp3": [
		5109,
		3784
	],
	"./00003/00003-04/00003-04-01/i can see one sock.mp3": [
		5110,
		3785
	],
	"./00003/00003-04/00003-04-01/i can see one star.mp3": [
		5111,
		3786
	],
	"./00003/00003-04/00003-04-01/i can see one truck.mp3": [
		5112,
		3787
	],
	"./00003/00003-04/00003-04-01/intro.mp3": [
		632
	],
	"./00003/00003-04/00003-04-01/main idea.mp3": [
		1013
	],
	"./00003/00003-04/00003-04-01/my book of one.mp3": [
		5113,
		3788
	],
	"./00003/00003-04/00003-04-01/the clock is on the sock.mp3": [
		5114,
		3789
	],
	"./00003/00003-04/00003-04-01/the duck is on the truck.mp3": [
		5115,
		3790
	],
	"./00003/00003-04/00003-04-01/the fox is in the box.mp3": [
		5116,
		3791
	],
	"./00003/00003-04/00003-04-01/the frog is on the dog.mp3": [
		5117,
		3792
	],
	"./00003/00003-04/00003-04-01/the hat is on the cat.mp3": [
		5118,
		3793
	],
	"./00003/00003-04/00003-04-01/the mouse is in the house.mp3": [
		5119,
		3794
	],
	"./00003/00003-04/00003-04-01/the star is on the car.mp3": [
		5120,
		3795
	],
	"./00003/00003-04/00003-04-02/i have two big ears said the monster.mp3": [
		5121,
		3796
	],
	"./00003/00003-04/00003-04-02/i have two big ears.mp3": [
		5122,
		3797
	],
	"./00003/00003-04/00003-04-02/i have two eyes said the monster.mp3": [
		5123,
		3798
	],
	"./00003/00003-04/00003-04-02/i have two eyes.mp3": [
		5124,
		3799
	],
	"./00003/00003-04/00003-04-02/i have two heads said the monster.mp3": [
		5125,
		3800
	],
	"./00003/00003-04/00003-04-02/i have two wings said the eagle.mp3": [
		5126,
		3801
	],
	"./00003/00003-04/00003-04-02/i have two wings said the monster.mp3": [
		5127,
		3802
	],
	"./00003/00003-04/00003-04-02/intro.mp3": [
		633
	],
	"./00003/00003-04/00003-04-02/look at my ears said the fox.mp3": [
		5128,
		3803
	],
	"./00003/00003-04/00003-04-02/look at my ears.mp3": [
		5129,
		3804
	],
	"./00003/00003-04/00003-04-02/look at my eyes said the hammerhead shark.mp3": [
		5130,
		3805
	],
	"./00003/00003-04/00003-04-02/look at my eyes.mp3": [
		5131,
		3806
	],
	"./00003/00003-04/00003-04-02/look at my heads.mp3": [
		5132,
		3807
	],
	"./00003/00003-04/00003-04-02/look at my wings.mp3": [
		5133,
		3808
	],
	"./00003/00003-04/00003-04-02/main idea.mp3": [
		1014
	],
	"./00003/00003-04/00003-04-02/parts of the body.mp3": [
		5134,
		3809
	],
	"./00003/00003-04/00003-04-02/what comes in 2s.mp3": [
		5135,
		3810
	],
	"./00003/00003-04/00003-04-03/animals with four legs.mp3": [
		5136,
		3811
	],
	"./00003/00003-04/00003-04-03/can you see 3 boats.mp3": [
		5137,
		3812
	],
	"./00003/00003-04/00003-04-03/can you see 3 boxes.mp3": [
		5138,
		3813
	],
	"./00003/00003-04/00003-04-03/can you see 3 cakes.mp3": [
		5139,
		3814
	],
	"./00003/00003-04/00003-04-03/can you see 3 dogs.mp3": [
		5140,
		3815
	],
	"./00003/00003-04/00003-04-03/can you see 3 foxes.mp3": [
		5141,
		3816
	],
	"./00003/00003-04/00003-04-03/can you see 3 frogs.mp3": [
		5142,
		3817
	],
	"./00003/00003-04/00003-04-03/can you see 3 goats.mp3": [
		5143,
		3818
	],
	"./00003/00003-04/00003-04-03/can you see 3 hats.mp3": [
		5144,
		3819
	],
	"./00003/00003-04/00003-04-03/can you see 3 kittens.mp3": [
		5145,
		3820
	],
	"./00003/00003-04/00003-04-03/can you see 3 mittens.mp3": [
		5146,
		3821
	],
	"./00003/00003-04/00003-04-03/can you see 3 rats.mp3": [
		5147,
		3822
	],
	"./00003/00003-04/00003-04-03/can you see 3 snails.mp3": [
		5148,
		3823
	],
	"./00003/00003-04/00003-04-03/can you see 3 snakes.mp3": [
		5149,
		3824
	],
	"./00003/00003-04/00003-04-03/can you see 3 whales.mp3": [
		5150,
		3825
	],
	"./00003/00003-04/00003-04-03/intro.mp3": [
		634
	],
	"./00003/00003-04/00003-04-03/main idea.mp3": [
		1015
	],
	"./00003/00003-04/00003-04-03/my book of three.mp3": [
		5151,
		3826
	],
	"./00003/00003-04/00003-04-03/the foxes are in the boxes.mp3": [
		5152,
		3827
	],
	"./00003/00003-04/00003-04-03/the frogs are on the dogs.mp3": [
		5153,
		3828
	],
	"./00003/00003-04/00003-04-03/the goats are in the boats.mp3": [
		5154,
		3829
	],
	"./00003/00003-04/00003-04-03/the hats are on the rats.mp3": [
		5155,
		3830
	],
	"./00003/00003-04/00003-04-03/the mittens are on the kittens.mp3": [
		5156,
		3831
	],
	"./00003/00003-04/00003-04-03/the snails are on the whales.mp3": [
		5157,
		3832
	],
	"./00003/00003-04/00003-04-03/the snakes are on the cakes.mp3": [
		5158,
		3833
	],
	"./00003/00003-04/00003-04-04/here come three cars.mp3": [
		5159,
		3834
	],
	"./00003/00003-04/00003-04-04/here come three rockets.mp3": [
		5160,
		3835
	],
	"./00003/00003-04/00003-04-04/here come two boats.mp3": [
		5161,
		3836
	],
	"./00003/00003-04/00003-04-04/here come two cars.mp3": [
		5162,
		3837
	],
	"./00003/00003-04/00003-04-04/here come two helicopters.mp3": [
		5163,
		3838
	],
	"./00003/00003-04/00003-04-04/here come two planes.mp3": [
		5164,
		3839
	],
	"./00003/00003-04/00003-04-04/here come two trucks.mp3": [
		5165,
		3840
	],
	"./00003/00003-04/00003-04-04/here comes one fire truck.mp3": [
		5166,
		3841
	],
	"./00003/00003-04/00003-04-04/here comes one spaceship.mp3": [
		5167,
		3842
	],
	"./00003/00003-04/00003-04-04/intro.mp3": [
		635
	],
	"./00003/00003-04/00003-04-04/main idea.mp3": [
		1016
	],
	"./00003/00003-04/00003-04-04/my book of four.mp3": [
		5168,
		3843
	],
	"./00003/00003-04/00003-04-04/one and three is four.mp3": [
		5169,
		3844
	],
	"./00003/00003-04/00003-04-04/three and one is four.mp3": [
		5170,
		3845
	],
	"./00003/00003-04/00003-04-04/two and two is four.mp3": [
		5171,
		3846
	],
	"./00003/00003-04/00003-04-04/vehicles.mp3": [
		5172,
		3847
	],
	"./00003/00003-04/00003-04-05/farm animals.mp3": [
		5173,
		3848
	],
	"./00003/00003-04/00003-04-05/four and one is five.mp3": [
		5174,
		3849
	],
	"./00003/00003-04/00003-04-05/i can see five farm animals.mp3": [
		5175,
		3850
	],
	"./00003/00003-04/00003-04-05/i can see four chicks.mp3": [
		5176,
		3851
	],
	"./00003/00003-04/00003-04-05/i can see four cows.mp3": [
		5177,
		3852
	],
	"./00003/00003-04/00003-04-05/i can see four ducklings.mp3": [
		5178,
		3853
	],
	"./00003/00003-04/00003-04-05/i can see one chicken.mp3": [
		5179,
		3854
	],
	"./00003/00003-04/00003-04-05/i can see one duck.mp3": [
		5180,
		3855
	],
	"./00003/00003-04/00003-04-05/i can see three goats.mp3": [
		5181,
		3856
	],
	"./00003/00003-04/00003-04-05/i can see three sheep.mp3": [
		5182,
		3857
	],
	"./00003/00003-04/00003-04-05/i can see two dogs.mp3": [
		5183,
		3858
	],
	"./00003/00003-04/00003-04-05/i can see two horses.mp3": [
		5184,
		3859
	],
	"./00003/00003-04/00003-04-05/intro.mp3": [
		636
	],
	"./00003/00003-04/00003-04-05/main idea.mp3": [
		1017
	],
	"./00003/00003-04/00003-04-05/my book of five.mp3": [
		5185,
		3860
	],
	"./00003/00003-04/00003-04-05/one and four is five.mp3": [
		5186,
		3861
	],
	"./00003/00003-04/00003-04-05/three and two is fiv.mp3": [
		5187,
		3862
	],
	"./00003/00003-04/00003-04-05/three and two is five.mp3": [
		5188,
		3863
	],
	"./00003/00003-04/00003-04-05/two and three is five.mp3": [
		5189,
		3864
	],
	"./00003/00003-04/00003-04-06/can you see five dogs.mp3": [
		5190,
		3865
	],
	"./00003/00003-04/00003-04-06/can you see five fish.mp3": [
		5191,
		3866
	],
	"./00003/00003-04/00003-04-06/can you see four birds.mp3": [
		5192,
		3867
	],
	"./00003/00003-04/00003-04-06/can you see four brids.mp3": [
		5193,
		3868
	],
	"./00003/00003-04/00003-04-06/can you see four fish.mp3": [
		5194,
		3869
	],
	"./00003/00003-04/00003-04-06/can you see one cat.mp3": [
		5195,
		3870
	],
	"./00003/00003-04/00003-04-06/can you see three cats.mp3": [
		5196,
		3871
	],
	"./00003/00003-04/00003-04-06/can you see three rabbits.mp3": [
		5197,
		3872
	],
	"./00003/00003-04/00003-04-06/can you see two snakes.mp3": [
		5198,
		3873
	],
	"./00003/00003-04/00003-04-06/can you see two turtles.mp3": [
		5199,
		3874
	],
	"./00003/00003-04/00003-04-06/five and one is six.mp3": [
		5200,
		3875
	],
	"./00003/00003-04/00003-04-06/four and two is six.mp3": [
		5201,
		3876
	],
	"./00003/00003-04/00003-04-06/intro.mp3": [
		637
	],
	"./00003/00003-04/00003-04-06/main idea.mp3": [
		1018
	],
	"./00003/00003-04/00003-04-06/my book of six.mp3": [
		5202,
		3877
	],
	"./00003/00003-04/00003-04-06/one and five is six.mp3": [
		5203,
		3878
	],
	"./00003/00003-04/00003-04-06/pet animals.mp3": [
		5204,
		3879
	],
	"./00003/00003-04/00003-04-06/three and three is six.mp3": [
		5205,
		3880
	],
	"./00003/00003-04/00003-04-06/two and four is six.mp3": [
		5206,
		3881
	],
	"./00003/00003-04/00003-04-07/can you see five little fish.mp3": [
		5207,
		3882
	],
	"./00003/00003-04/00003-04-07/can you see four little penguins.mp3": [
		5208,
		3883
	],
	"./00003/00003-04/00003-04-07/can you see four little starfish.mp3": [
		5209,
		3884
	],
	"./00003/00003-04/00003-04-07/can you see one little seahorse.mp3": [
		5210,
		3885
	],
	"./00003/00003-04/00003-04-07/can you see three little crabs.mp3": [
		5211,
		3886
	],
	"./00003/00003-04/00003-04-07/intro.mp3": [
		638
	],
	"./00003/00003-04/00003-04-07/main idea.mp3": [
		1019
	],
	"./00003/00003-04/00003-04-07/my book of seven.mp3": [
		5212,
		3887
	],
	"./00003/00003-04/00003-04-07/sea animals.mp3": [
		5213,
		3888
	],
	"./00003/00003-04/00003-04-07/you can count seven animals in the sea.mp3": [
		5214,
		3889
	],
	"./00003/00003-04/00003-04-07/you can count to seven.mp3": [
		5215,
		3890
	],
	"./00003/00003-04/00003-04-07/you can see five sea turtles.mp3": [
		5216,
		3891
	],
	"./00003/00003-04/00003-04-07/you can see six big seahorses.mp3": [
		5217,
		3892
	],
	"./00003/00003-04/00003-04-07/you can see three big penguins.mp3": [
		5218,
		3893
	],
	"./00003/00003-04/00003-04-07/you can see two big sharks.mp3": [
		5219,
		3894
	],
	"./00003/00003-04/00003-04-07/you can see two whales.mp3": [
		5220,
		3895
	],
	"./00003/00003-04/00003-04-08/can you count eight things up in space.mp3": [
		5221,
		3896
	],
	"./00003/00003-04/00003-04-08/can you count five little planets.mp3": [
		5222,
		3897
	],
	"./00003/00003-04/00003-04-08/can you count four astronauts.mp3": [
		5223,
		3898
	],
	"./00003/00003-04/00003-04-08/can you count four rockets.mp3": [
		5224,
		3899
	],
	"./00003/00003-04/00003-04-08/can you count four spaceships.mp3": [
		5225,
		3900
	],
	"./00003/00003-04/00003-04-08/can you count to eight.mp3": [
		5226,
		3901
	],
	"./00003/00003-04/00003-04-08/can you see six little stars.mp3": [
		5227,
		3902
	],
	"./00003/00003-04/00003-04-08/can you see two big stars.mp3": [
		5228,
		3903
	],
	"./00003/00003-04/00003-04-08/intro.mp3": [
		639
	],
	"./00003/00003-04/00003-04-08/main idea.mp3": [
		1020
	],
	"./00003/00003-04/00003-04-08/my book of eight.mp3": [
		5229,
		3904
	],
	"./00003/00003-04/00003-04-08/things in space.mp3": [
		5230,
		3905
	],
	"./00003/00003-04/00003-04-08/you can count seven satellites.mp3": [
		5231,
		3906
	],
	"./00003/00003-04/00003-04-08/you can see one planet.mp3": [
		5232,
		3907
	],
	"./00003/00003-04/00003-04-08/you can see three big planets.mp3": [
		5233,
		3908
	],
	"./00003/00003-04/00003-04-09/eight and one makes nine.mp3": [
		5234,
		3909
	],
	"./00003/00003-04/00003-04-09/five and four makes nine.mp3": [
		5235,
		3910
	],
	"./00003/00003-04/00003-04-09/four and five makes nine.mp3": [
		5236,
		3911
	],
	"./00003/00003-04/00003-04-09/i see elephants and zebras.mp3": [
		5237,
		3912
	],
	"./00003/00003-04/00003-04-09/i see hippos and rhinos.mp3": [
		5238,
		3913
	],
	"./00003/00003-04/00003-04-09/i see hippos rhinos and alligators.mp3": [
		5239,
		3914
	],
	"./00003/00003-04/00003-04-09/i see nine animals in all.mp3": [
		5240,
		3915
	],
	"./00003/00003-04/00003-04-09/i see nine baby animals.mp3": [
		5241,
		3916
	],
	"./00003/00003-04/00003-04-09/i see tigers and lions.mp3": [
		5242,
		3917
	],
	"./00003/00003-04/00003-04-09/intro.mp3": [
		640
	],
	"./00003/00003-04/00003-04-09/lets count the animals.mp3": [
		5243,
		3918
	],
	"./00003/00003-04/00003-04-09/main idea.mp3": [
		1021
	],
	"./00003/00003-04/00003-04-09/my book of nine.mp3": [
		5244,
		3919
	],
	"./00003/00003-04/00003-04-09/seven and two makes nine.mp3": [
		5245,
		3920
	],
	"./00003/00003-04/00003-04-09/six and three makes nine.mp3": [
		5246,
		3921
	],
	"./00003/00003-04/00003-04-09/three and three and three makes nine.mp3": [
		5247,
		3922
	],
	"./00003/00003-04/00003-04-09/wild animals.mp3": [
		5248,
		3923
	],
	"./00003/00003-04/00003-04-10/brown animals.mp3": [
		5249,
		3924
	],
	"./00003/00003-04/00003-04-10/can you see five green dragons.mp3": [
		5250,
		3925
	],
	"./00003/00003-04/00003-04-10/can you see five green turtles.mp3": [
		5251,
		3926
	],
	"./00003/00003-04/00003-04-10/can you see six yellow giraffes.mp3": [
		5252,
		3927
	],
	"./00003/00003-04/00003-04-10/can you see three brown deer.mp3": [
		5253,
		3928
	],
	"./00003/00003-04/00003-04-10/eight and two equals ten.mp3": [
		5254,
		3929
	],
	"./00003/00003-04/00003-04-10/five and five equals ten.mp3": [
		5255,
		3930
	],
	"./00003/00003-04/00003-04-10/four and six equals ten.mp3": [
		5256,
		3931
	],
	"./00003/00003-04/00003-04-10/intro.mp3": [
		641
	],
	"./00003/00003-04/00003-04-10/main idea.mp3": [
		1022
	],
	"./00003/00003-04/00003-04-10/my book of ten.mp3": [
		5257,
		3932
	],
	"./00003/00003-04/00003-04-10/one and nine equals ten.mp3": [
		5258,
		3933
	],
	"./00003/00003-04/00003-04-10/seven and three equals ten.mp3": [
		5259,
		3934
	],
	"./00003/00003-04/00003-04-10/ten and zero equals ten.mp3": [
		5260,
		3935
	],
	"./00003/00003-04/00003-04-10/you can see eight gray hippos.mp3": [
		5261,
		3936
	],
	"./00003/00003-04/00003-04-10/you can see five green alligators.mp3": [
		5262,
		3937
	],
	"./00003/00003-04/00003-04-10/you can see four yellow chicks.mp3": [
		5263,
		3938
	],
	"./00003/00003-04/00003-04-10/you can see nine white unicorns.mp3": [
		5264,
		3939
	],
	"./00003/00003-04/00003-04-10/you can see one white sheep.mp3": [
		5265,
		3940
	],
	"./00003/00003-04/00003-04-10/you can see seven brown monkeys.mp3": [
		5266,
		3941
	],
	"./00003/00003-04/00003-04-10/you can see ten pink dinosaurs.mp3": [
		5267,
		3942
	],
	"./00003/00003-04/00003-04-10/you can see two gray elephants.mp3": [
		5268,
		3943
	],
	"./00003/00003-04/00003-04-10/you can see zero pink cats.mp3": [
		5269,
		3944
	],
	"./00003/00003-04/number land.mp3": [
		5270,
		3945
	],
	"./00003/00003-04/numbers.mp3": [
		5271,
		3946
	],
	"./00003/00003-05/00003-05-01/all circles are round.mp3": [
		5272,
		3947
	],
	"./00003/00003-05/00003-05-01/circles are round.mp3": [
		5273,
		3948
	],
	"./00003/00003-05/00003-05-01/i can see big circles.mp3": [
		5274,
		3949
	],
	"./00003/00003-05/00003-05-01/i can see little circles.mp3": [
		5275,
		3950
	],
	"./00003/00003-05/00003-05-01/intro.mp3": [
		642
	],
	"./00003/00003-05/00003-05-01/main idea.mp3": [
		1023
	],
	"./00003/00003-05/00003-05-01/some circles are black.mp3": [
		5276,
		3951
	],
	"./00003/00003-05/00003-05-01/some circles are blue.mp3": [
		5277,
		3952
	],
	"./00003/00003-05/00003-05-01/some circles are green.mp3": [
		5278,
		3953
	],
	"./00003/00003-05/00003-05-01/some circles are orange.mp3": [
		5279,
		3954
	],
	"./00003/00003-05/00003-05-01/some circles are purple.mp3": [
		5280,
		3955
	],
	"./00003/00003-05/00003-05-01/some circles are red.mp3": [
		5281,
		3956
	],
	"./00003/00003-05/00003-05-01/some circles are white.mp3": [
		5282,
		3957
	],
	"./00003/00003-05/00003-05-01/some circles are yellow.mp3": [
		5283,
		3958
	],
	"./00003/00003-05/00003-05-01/things that are round.mp3": [
		5284,
		3959
	],
	"./00003/00003-05/00003-05-02/can you count the corners.mp3": [
		5285,
		3960
	],
	"./00003/00003-05/00003-05-02/can you count the sides.mp3": [
		5286,
		3961
	],
	"./00003/00003-05/00003-05-02/intro.mp3": [
		643
	],
	"./00003/00003-05/00003-05-02/main idea.mp3": [
		1024
	],
	"./00003/00003-05/00003-05-02/my square is black.mp3": [
		5287,
		3962
	],
	"./00003/00003-05/00003-05-02/my square is blue.mp3": [
		5288,
		3963
	],
	"./00003/00003-05/00003-05-02/my square is orange.mp3": [
		5289,
		3964
	],
	"./00003/00003-05/00003-05-02/my square is red.mp3": [
		5290,
		3965
	],
	"./00003/00003-05/00003-05-02/my square is yellow.mp3": [
		5291,
		3966
	],
	"./00003/00003-05/00003-05-02/my squares are green.mp3": [
		5292,
		3967
	],
	"./00003/00003-05/00003-05-02/my squares are pink.mp3": [
		5293,
		3968
	],
	"./00003/00003-05/00003-05-02/shapes.mp3": [
		5294,
		3969
	],
	"./00003/00003-05/00003-05-02/squares have four corners.mp3": [
		5295,
		3970
	],
	"./00003/00003-05/00003-05-02/squares have four sides.mp3": [
		5296,
		3971
	],
	"./00003/00003-05/00003-05-03/elephant likes the gray triangle.mp3": [
		5297,
		3972
	],
	"./00003/00003-05/00003-05-03/goat likes the orange triangle.mp3": [
		5298,
		3973
	],
	"./00003/00003-05/00003-05-03/intro.mp3": [
		644
	],
	"./00003/00003-05/00003-05-03/main idea.mp3": [
		1025
	],
	"./00003/00003-05/00003-05-03/monkey likes the triangle.mp3": [
		5299,
		3974
	],
	"./00003/00003-05/00003-05-03/mouse likes the blue triangle.mp3": [
		5300,
		3975
	],
	"./00003/00003-05/00003-05-03/musical instruments.mp3": [
		5301,
		3976
	],
	"./00003/00003-05/00003-05-03/rabbit likes the red triangle.mp3": [
		5302,
		3977
	],
	"./00003/00003-05/00003-05-03/the boy likes the purple triangle.mp3": [
		5303,
		3978
	],
	"./00003/00003-05/00003-05-03/the girl likes the green triangle.mp3": [
		5304,
		3979
	],
	"./00003/00003-05/00003-05-03/this triangle is big.mp3": [
		5305,
		3980
	],
	"./00003/00003-05/00003-05-03/this triangle is little.mp3": [
		5306,
		3981
	],
	"./00003/00003-05/00003-05-03/triangles have three corners.mp3": [
		5307,
		3982
	],
	"./00003/00003-05/00003-05-03/triangles have three sides.mp3": [
		5308,
		3983
	],
	"./00003/00003-05/00003-05-04/animals with four legs.mp3": [
		5309,
		3984
	],
	"./00003/00003-05/00003-05-04/crocodile can see a long rectangle.mp3": [
		5310,
		3985
	],
	"./00003/00003-05/00003-05-04/giraffe can see a long rectangle.mp3": [
		5311,
		3986
	],
	"./00003/00003-05/00003-05-04/hedgehog can see a short rectangle.mp3": [
		5312,
		3987
	],
	"./00003/00003-05/00003-05-04/intro.mp3": [
		645
	],
	"./00003/00003-05/00003-05-04/it has two long sides.mp3": [
		5313,
		3988
	],
	"./00003/00003-05/00003-05-04/it has two short sides.mp3": [
		5314,
		3989
	],
	"./00003/00003-05/00003-05-04/main idea.mp3": [
		1026
	],
	"./00003/00003-05/00003-05-04/pig can see a fat rectangle.mp3": [
		5315,
		3990
	],
	"./00003/00003-05/00003-05-04/rectangles have four corners.mp3": [
		5316,
		3991
	],
	"./00003/00003-05/00003-05-04/rectangles have four sides.mp3": [
		5317,
		3992
	],
	"./00003/00003-05/00003-05-04/sheep can see a fat rectangle.mp3": [
		5318,
		3993
	],
	"./00003/00003-05/00003-05-04/snake can see a thin rectangle.mp3": [
		5319,
		3994
	],
	"./00003/00003-05/00003-05-04/turtle can see a short rectangle.mp3": [
		5320,
		3995
	],
	"./00003/00003-05/00003-05-05/can you see it too.mp3": [
		5321,
		3996
	],
	"./00003/00003-05/00003-05-05/come with me.mp3": [
		5322,
		3997
	],
	"./00003/00003-05/00003-05-05/i can go with you.mp3": [
		5323,
		3998
	],
	"./00003/00003-05/00003-05-05/i can see a hexagon.mp3": [
		5324,
		3999
	],
	"./00003/00003-05/00003-05-05/i can see a pentagon.mp3": [
		5325,
		4000
	],
	"./00003/00003-05/00003-05-05/i can see a rectangle.mp3": [
		5326,
		4001
	],
	"./00003/00003-05/00003-05-05/i can see a square.mp3": [
		5327,
		4002
	],
	"./00003/00003-05/00003-05-05/i can see a triangle.mp3": [
		5328,
		4003
	],
	"./00003/00003-05/00003-05-05/i can see an octagon.mp3": [
		5329,
		4004
	],
	"./00003/00003-05/00003-05-05/i can see circles.mp3": [
		5330,
		4005
	],
	"./00003/00003-05/00003-05-05/i can see hexagons.mp3": [
		5331,
		4006
	],
	"./00003/00003-05/00003-05-05/intro.mp3": [
		646
	],
	"./00003/00003-05/00003-05-05/let's go look for shapes.mp3": [
		5332,
		4007
	],
	"./00003/00003-05/00003-05-05/lets go look for shapes.mp3": [
		5333,
		4008
	],
	"./00003/00003-05/00003-05-05/main idea.mp3": [
		1027
	],
	"./00003/00003-05/00003-05-05/rectangles have four sides.mp3": [
		5334,
		4009
	],
	"./00003/00003-05/00003-05-05/shapes.mp3": [
		5335,
		4010
	],
	"./00003/00003-05/00003-05-05/what can you see.mp3": [
		5336,
		4011
	],
	"./00003/00003-05/00003-05-06/balls are solid.mp3": [
		5337,
		4012
	],
	"./00003/00003-05/00003-05-06/boxes are solid.mp3": [
		5338,
		4013
	],
	"./00003/00003-05/00003-05-06/camels are solid too.mp3": [
		5339,
		4014
	],
	"./00003/00003-05/00003-05-06/cones are solid.mp3": [
		5340,
		4015
	],
	"./00003/00003-05/00003-05-06/cubes are solid.mp3": [
		5341,
		4016
	],
	"./00003/00003-05/00003-05-06/cylinders are solid.mp3": [
		5342,
		4017
	],
	"./00003/00003-05/00003-05-06/faces are flat.mp3": [
		5343,
		4018
	],
	"./00003/00003-05/00003-05-06/intro.mp3": [
		647
	],
	"./00003/00003-05/00003-05-06/main idea.mp3": [
		1028
	],
	"./00003/00003-05/00003-05-06/pyramids are solid.mp3": [
		5344,
		4019
	],
	"./00003/00003-05/00003-05-06/solid shapes.mp3": [
		5345,
		4020
	],
	"./00003/00003-05/00003-05-06/spheres are solid.mp3": [
		5346,
		4021
	],
	"./00003/00003-05/00003-05-06/they are round.mp3": [
		5347,
		4022
	],
	"./00003/00003-05/00003-05-06/they have four faces.mp3": [
		5348,
		4023
	],
	"./00003/00003-05/00003-05-06/they have funny faces.mp3": [
		5349,
		4024
	],
	"./00003/00003-05/00003-05-06/they have one face.mp3": [
		5350,
		4025
	],
	"./00003/00003-05/00003-05-06/they have six faces.mp3": [
		5351,
		4026
	],
	"./00003/00003-05/00003-05-06/they have two faces.mp3": [
		5352,
		4027
	],
	"./00003/00003-05/00003-05-06/they have zero faces.mp3": [
		5353,
		4028
	],
	"./00003/00003-05/00003-05-07/all the faces are square.mp3": [
		5354,
		4029
	],
	"./00003/00003-05/00003-05-07/cubes have six faces.mp3": [
		5355,
		4030
	],
	"./00003/00003-05/00003-05-07/faces are flat.mp3": [
		5356,
		4031
	],
	"./00003/00003-05/00003-05-07/forest animals.mp3": [
		5357,
		4032
	],
	"./00003/00003-05/00003-05-07/intro.mp3": [
		648
	],
	"./00003/00003-05/00003-05-07/look at the bear face.mp3": [
		5358,
		4033
	],
	"./00003/00003-05/00003-05-07/look at the cube.mp3": [
		5359,
		4034
	],
	"./00003/00003-05/00003-05-07/look at the deer face.mp3": [
		5360,
		4035
	],
	"./00003/00003-05/00003-05-07/look at the elephant face.mp3": [
		5361,
		4036
	],
	"./00003/00003-05/00003-05-07/look at the faces.mp3": [
		5362,
		4037
	],
	"./00003/00003-05/00003-05-07/look at the fox face.mp3": [
		5363,
		4038
	],
	"./00003/00003-05/00003-05-07/look at the panda face.mp3": [
		5364,
		4039
	],
	"./00003/00003-05/00003-05-07/look at the rabbit face.mp3": [
		5365,
		4040
	],
	"./00003/00003-05/00003-05-07/main idea.mp3": [
		1029
	],
	"./00003/00003-05/00003-05-08/how many can you see.mp3": [
		5366,
		4041
	],
	"./00003/00003-05/00003-05-08/how many shapes can you see.mp3": [
		5367,
		4042
	],
	"./00003/00003-05/00003-05-08/intro.mp3": [
		649
	],
	"./00003/00003-05/00003-05-08/look at the circles.mp3": [
		5368,
		4043
	],
	"./00003/00003-05/00003-05-08/look at the hexagons.mp3": [
		5369,
		4044
	],
	"./00003/00003-05/00003-05-08/look at the octagons.mp3": [
		5370,
		4045
	],
	"./00003/00003-05/00003-05-08/look at the pentagons.mp3": [
		5371,
		4046
	],
	"./00003/00003-05/00003-05-08/look at the rectangles.mp3": [
		5372,
		4047
	],
	"./00003/00003-05/00003-05-08/look at the squares.mp3": [
		5373,
		4048
	],
	"./00003/00003-05/00003-05-08/look at the triangles.mp3": [
		5374,
		4049
	],
	"./00003/00003-05/00003-05-08/main idea.mp3": [
		1030
	],
	"./00003/00003-05/00003-05-08/non living things.mp3": [
		5375,
		4050
	],
	"./00003/00003-05/00003-05-08/there are shapes on the quilt.mp3": [
		5376,
		4051
	],
	"./00003/00003-05/00003-05-09/i can make a circle.mp3": [
		5377,
		4052
	],
	"./00003/00003-05/00003-05-09/i can make a fox.mp3": [
		5378,
		4053
	],
	"./00003/00003-05/00003-05-09/i can make a hexagon.mp3": [
		5379,
		4054
	],
	"./00003/00003-05/00003-05-09/i can make a new shape.mp3": [
		5380,
		4055
	],
	"./00003/00003-05/00003-05-09/i can make a pentagon.mp3": [
		5381,
		4056
	],
	"./00003/00003-05/00003-05-09/i can make a rectangle.mp3": [
		5382,
		4057
	],
	"./00003/00003-05/00003-05-09/i can make a square.mp3": [
		5383,
		4058
	],
	"./00003/00003-05/00003-05-09/i can make an octagon.mp3": [
		5384,
		4059
	],
	"./00003/00003-05/00003-05-09/i have a square.mp3": [
		5385,
		4060
	],
	"./00003/00003-05/00003-05-09/i have a triangle.mp3": [
		5386,
		4061
	],
	"./00003/00003-05/00003-05-09/i have four quarter circles.mp3": [
		5387,
		4062
	],
	"./00003/00003-05/00003-05-09/i have some triangles.mp3": [
		5388,
		4063
	],
	"./00003/00003-05/00003-05-09/intro.mp3": [
		650
	],
	"./00003/00003-05/00003-05-09/main idea.mp3": [
		1031
	],
	"./00003/00003-05/00003-05-09/shapes.mp3": [
		5389,
		4064
	],
	"./00003/00003-05/00003-05-09/what can i make.mp3": [
		5390,
		4065
	],
	"./00003/00003-05/00003-05-10/intro.mp3": [
		651
	],
	"./00003/00003-05/00003-05-10/look around.mp3": [
		5391,
		4066
	],
	"./00003/00003-05/00003-05-10/main idea.mp3": [
		1032
	],
	"./00003/00003-05/00003-05-10/places.mp3": [
		5392,
		4067
	],
	"./00003/00003-05/00003-05-10/shapes are all around us.mp3": [
		5393,
		4068
	],
	"./00003/00003-05/00003-05-10/we can see circles.mp3": [
		5394,
		4069
	],
	"./00003/00003-05/00003-05-10/we can see cones.mp3": [
		5395,
		4070
	],
	"./00003/00003-05/00003-05-10/we can see cubes.mp3": [
		5396,
		4071
	],
	"./00003/00003-05/00003-05-10/we can see cylinders.mp3": [
		5397,
		4072
	],
	"./00003/00003-05/00003-05-10/we can see flat shapes.mp3": [
		5398,
		4073
	],
	"./00003/00003-05/00003-05-10/we can see rectangles.mp3": [
		5399,
		4074
	],
	"./00003/00003-05/00003-05-10/we can see solid shapes.mp3": [
		5400,
		4075
	],
	"./00003/00003-05/00003-05-10/we can see squares.mp3": [
		5401,
		4076
	],
	"./00003/00003-05/00003-05-10/we can see triangles.mp3": [
		5402,
		4077
	],
	"./00003/00003-05/00003-05-10/what shapes can we see.mp3": [
		5403,
		4078
	],
	"./00003/00003-05/shapes land.mp3": [
		5404,
		4079
	],
	"./00003/00003-05/shapes.mp3": [
		5405,
		4080
	],
	"./00003/00003-06/00003-06-01/i do not need air said the fish.mp3": [
		5406,
		4081
	],
	"./00003/00003-06/00003-06-01/i do not need air said the octopus.mp3": [
		5407,
		4082
	],
	"./00003/00003-06/00003-06-01/i have a tank for air too.mp3": [
		5408,
		4083
	],
	"./00003/00003-06/00003-06-01/i have a tank for air.mp3": [
		5409,
		4084
	],
	"./00003/00003-06/00003-06-01/i have to come up for air too.mp3": [
		5410,
		4085
	],
	"./00003/00003-06/00003-06-01/i have to come up for air.mp3": [
		5411,
		4086
	],
	"./00003/00003-06/00003-06-01/i need air said the astronaut.mp3": [
		5412,
		4087
	],
	"./00003/00003-06/00003-06-01/i need air said the cat.mp3": [
		5413,
		4088
	],
	"./00003/00003-06/00003-06-01/i need air said the sea turtle.mp3": [
		5414,
		4089
	],
	"./00003/00003-06/00003-06-01/intro.mp3": [
		652
	],
	"./00003/00003-06/00003-06-01/main idea.mp3": [
		1033
	],
	"./00003/00003-06/00003-06-01/me too said the eagle.mp3": [
		5415,
		4090
	],
	"./00003/00003-06/00003-06-01/me too said the scuba diver.mp3": [
		5416,
		4091
	],
	"./00003/00003-06/00003-06-01/me too said the whale.mp3": [
		5417,
		4092
	],
	"./00003/00003-06/00003-06-01/the air goes in my lungs too.mp3": [
		5418,
		4093
	],
	"./00003/00003-06/00003-06-01/the air goes in my lungs.mp3": [
		5419,
		4094
	],
	"./00003/00003-06/00003-06-01/water animals.mp3": [
		5420,
		4095
	],
	"./00003/00003-06/00003-06-01/we need air.mp3": [
		5421,
		4096
	],
	"./00003/00003-06/00003-06-02/animals that live in trees.mp3": [
		5422,
		4097
	],
	"./00003/00003-06/00003-06-02/i live in a cave said the bear.mp3": [
		5423,
		4098
	],
	"./00003/00003-06/00003-06-02/i live in a cave too said the bat.mp3": [
		5424,
		4099
	],
	"./00003/00003-06/00003-06-02/i live in a tree said the monkey.mp3": [
		5425,
		4100
	],
	"./00003/00003-06/00003-06-02/i live in a tree too said the owl.mp3": [
		5426,
		4101
	],
	"./00003/00003-06/00003-06-02/i live in the sea.mp3": [
		5427,
		4102
	],
	"./00003/00003-06/00003-06-02/i live on a farm said the cow.mp3": [
		5428,
		4103
	],
	"./00003/00003-06/00003-06-02/i live on a farm too said the pig.mp3": [
		5429,
		4104
	],
	"./00003/00003-06/00003-06-02/intro.mp3": [
		653
	],
	"./00003/00003-06/00003-06-02/little bat where do you live.mp3": [
		5430,
		4105
	],
	"./00003/00003-06/00003-06-02/little bear where do you live.mp3": [
		5431,
		4106
	],
	"./00003/00003-06/00003-06-02/little cow where do you live.mp3": [
		5432,
		4107
	],
	"./00003/00003-06/00003-06-02/little monkey where do you live.mp3": [
		5433,
		4108
	],
	"./00003/00003-06/00003-06-02/little owl where do you live.mp3": [
		5434,
		4109
	],
	"./00003/00003-06/00003-06-02/little pig where do you live.mp3": [
		5435,
		4110
	],
	"./00003/00003-06/00003-06-02/main idea.mp3": [
		1034
	],
	"./00003/00003-06/00003-06-02/not me said the fish.mp3": [
		5436,
		4111
	],
	"./00003/00003-06/00003-06-02/we need homes.mp3": [
		5437,
		4112
	],
	"./00003/00003-06/00003-06-03/all animals need to eat.mp3": [
		5438,
		4113
	],
	"./00003/00003-06/00003-06-03/animals that eat plants.mp3": [
		5439,
		4114
	],
	"./00003/00003-06/00003-06-03/bats like to eat insects.mp3": [
		5440,
		4115
	],
	"./00003/00003-06/00003-06-03/do you like bananas.mp3": [
		5441,
		4116
	],
	"./00003/00003-06/00003-06-03/do you like fish.mp3": [
		5442,
		4117
	],
	"./00003/00003-06/00003-06-03/giraffes do not eat fish.mp3": [
		5443,
		4118
	],
	"./00003/00003-06/00003-06-03/giraffes like to eat leaves.mp3": [
		5444,
		4119
	],
	"./00003/00003-06/00003-06-03/intro.mp3": [
		654
	],
	"./00003/00003-06/00003-06-03/main idea.mp3": [
		1035
	],
	"./00003/00003-06/00003-06-03/monkeys like to eat bananas.mp3": [
		5445,
		4120
	],
	"./00003/00003-06/00003-06-03/pelicans like to eat fish too.mp3": [
		5446,
		4121
	],
	"./00003/00003-06/00003-06-03/sharks do not eat insects.mp3": [
		5447,
		4122
	],
	"./00003/00003-06/00003-06-03/sharks like to eat fish.mp3": [
		5448,
		4123
	],
	"./00003/00003-06/00003-06-03/some animals eat grass.mp3": [
		5449,
		4124
	],
	"./00003/00003-06/00003-06-03/some animals like to eat insects.mp3": [
		5450,
		4125
	],
	"./00003/00003-06/00003-06-03/some dinosaurs liked to eat leaves.mp3": [
		5451,
		4126
	],
	"./00003/00003-06/00003-06-03/some dinosaurs liked to eat meat.mp3": [
		5452,
		4127
	],
	"./00003/00003-06/00003-06-03/we need to eat.mp3": [
		5453,
		4128
	],
	"./00003/00003-06/00003-06-03/zebras like to eat grass.mp3": [
		5454,
		4129
	],
	"./00003/00003-06/00003-06-04/animals that live in the snow.mp3": [
		5455,
		4130
	],
	"./00003/00003-06/00003-06-04/he is out in the snow.mp3": [
		5456,
		4131
	],
	"./00003/00003-06/00003-06-04/i am out in the snow too.mp3": [
		5457,
		4132
	],
	"./00003/00003-06/00003-06-04/intro.mp3": [
		655
	],
	"./00003/00003-06/00003-06-04/it is snowing.mp3": [
		5458,
		4133
	],
	"./00003/00003-06/00003-06-04/it is winter.mp3": [
		5459,
		4134
	],
	"./00003/00003-06/00003-06-04/look at me.mp3": [
		5460,
		4135
	],
	"./00003/00003-06/00003-06-04/look at the deer.mp3": [
		5461,
		4136
	],
	"./00003/00003-06/00003-06-04/look at the dog.mp3": [
		5462,
		4137
	],
	"./00003/00003-06/00003-06-04/look at the fox.mp3": [
		5463,
		4138
	],
	"./00003/00003-06/00003-06-04/look at the owl.mp3": [
		5464,
		4139
	],
	"./00003/00003-06/00003-06-04/look at the rabbit.mp3": [
		5465,
		4140
	],
	"./00003/00003-06/00003-06-04/look at the squirrel.mp3": [
		5466,
		4141
	],
	"./00003/00003-06/00003-06-04/main idea.mp3": [
		1036
	],
	"./00003/00003-06/00003-06-04/out in the snow.mp3": [
		5467,
		4142
	],
	"./00003/00003-06/00003-06-04/she is out in the snow.mp3": [
		5468,
		4143
	],
	"./00003/00003-06/00003-06-05/are they alive.mp3": [
		5469,
		4144
	],
	"./00003/00003-06/00003-06-05/i can see a log.mp3": [
		5470,
		4145
	],
	"./00003/00003-06/00003-06-05/i can see a seal.mp3": [
		5471,
		4146
	],
	"./00003/00003-06/00003-06-05/i can see a wheel.mp3": [
		5472,
		4147
	],
	"./00003/00003-06/00003-06-05/i can see one box.mp3": [
		5473,
		4148
	],
	"./00003/00003-06/00003-06-05/i can see one cat.mp3": [
		5474,
		4149
	],
	"./00003/00003-06/00003-06-05/i can see one duck.mp3": [
		5475,
		4150
	],
	"./00003/00003-06/00003-06-05/i can see one fox.mp3": [
		5476,
		4151
	],
	"./00003/00003-06/00003-06-05/i can see one frog.mp3": [
		5477,
		4152
	],
	"./00003/00003-06/00003-06-05/i can see one hat.mp3": [
		5478,
		4153
	],
	"./00003/00003-06/00003-06-05/i can see one house.mp3": [
		5479,
		4154
	],
	"./00003/00003-06/00003-06-05/i can see one mouse.mp3": [
		5480,
		4155
	],
	"./00003/00003-06/00003-06-05/i can see one truck.mp3": [
		5481,
		4156
	],
	"./00003/00003-06/00003-06-05/intro.mp3": [
		656
	],
	"./00003/00003-06/00003-06-05/living things.mp3": [
		5482,
		4157
	],
	"./00003/00003-06/00003-06-05/look at the jeep.mp3": [
		5483,
		4158
	],
	"./00003/00003-06/00003-06-05/look at the sheep.mp3": [
		5484,
		4159
	],
	"./00003/00003-06/00003-06-05/main idea.mp3": [
		1037
	],
	"./00003/00003-06/00003-06-05/the cat is alive.mp3": [
		5485,
		4160
	],
	"./00003/00003-06/00003-06-05/the duck is alive.mp3": [
		5486,
		4161
	],
	"./00003/00003-06/00003-06-05/the fox is alive.mp3": [
		5487,
		4162
	],
	"./00003/00003-06/00003-06-05/the frog is alive.mp3": [
		5488,
		4163
	],
	"./00003/00003-06/00003-06-05/the mouse is alive.mp3": [
		5489,
		4164
	],
	"./00003/00003-06/00003-06-05/the seal is alive.mp3": [
		5490,
		4165
	],
	"./00003/00003-06/00003-06-05/the sheep is alive.mp3": [
		5491,
		4166
	],
	"./00003/00003-06/00003-06-05/which one is alive.mp3": [
		5492,
		4167
	],
	"./00003/00003-06/00003-06-06/baby animals.mp3": [
		5493,
		4168
	],
	"./00003/00003-06/00003-06-06/here is my mother.mp3": [
		5494,
		4169
	],
	"./00003/00003-06/00003-06-06/i am a duckling.mp3": [
		5495,
		4170
	],
	"./00003/00003-06/00003-06-06/i am a lamb.mp3": [
		5496,
		4171
	],
	"./00003/00003-06/00003-06-06/i am a puppy.mp3": [
		5497,
		4172
	],
	"./00003/00003-06/00003-06-06/i love my mother.mp3": [
		5498,
		4173
	],
	"./00003/00003-06/00003-06-06/intro.mp3": [
		657
	],
	"./00003/00003-06/00003-06-06/main idea.mp3": [
		1038
	],
	"./00003/00003-06/00003-06-06/mammals.mp3": [
		5499,
		4174
	],
	"./00003/00003-06/00003-06-06/mom.mp3": [
		5500,
		4175
	],
	"./00003/00003-06/00003-06-06/mother.mp3": [
		5501,
		4176
	],
	"./00003/00003-06/00003-06-06/my mother is a bear.mp3": [
		5502,
		4177
	],
	"./00003/00003-06/00003-06-06/my mother is a cow.mp3": [
		5503,
		4178
	],
	"./00003/00003-06/00003-06-06/my mother is a dolphin.mp3": [
		5504,
		4179
	],
	"./00003/00003-06/00003-06-06/my mother is a duck.mp3": [
		5505,
		4180
	],
	"./00003/00003-06/00003-06-06/my mother is a kangaroo.mp3": [
		5506,
		4181
	],
	"./00003/00003-06/00003-06-06/my mother is a rabbit.mp3": [
		5507,
		4182
	],
	"./00003/00003-06/00003-06-06/my mother is a sheep.mp3": [
		5508,
		4183
	],
	"./00003/00003-06/00003-06-07/birds need water.mp3": [
		5509,
		4184
	],
	"./00003/00003-06/00003-06-07/deer need water.mp3": [
		5510,
		4185
	],
	"./00003/00003-06/00003-06-07/dogs need water too.mp3": [
		5511,
		4186
	],
	"./00003/00003-06/00003-06-07/dolphins need water.mp3": [
		5512,
		4187
	],
	"./00003/00003-06/00003-06-07/ducks need water.mp3": [
		5513,
		4188
	],
	"./00003/00003-06/00003-06-07/everyone needs water.mp3": [
		5514,
		4189
	],
	"./00003/00003-06/00003-06-07/flowers need water.mp3": [
		5515,
		4190
	],
	"./00003/00003-06/00003-06-07/frogs need water.mp3": [
		5516,
		4191
	],
	"./00003/00003-06/00003-06-07/intro.mp3": [
		658
	],
	"./00003/00003-06/00003-06-07/look at the birds.mp3": [
		5517,
		4192
	],
	"./00003/00003-06/00003-06-07/look at the deer.mp3": [
		5518,
		4193
	],
	"./00003/00003-06/00003-06-07/look at the dog.mp3": [
		5519,
		4194
	],
	"./00003/00003-06/00003-06-07/look at the dolphins.mp3": [
		5520,
		4195
	],
	"./00003/00003-06/00003-06-07/look at the ducks.mp3": [
		5521,
		4196
	],
	"./00003/00003-06/00003-06-07/look at the flowers.mp3": [
		5522,
		4197
	],
	"./00003/00003-06/00003-06-07/look at the frogs.mp3": [
		5523,
		4198
	],
	"./00003/00003-06/00003-06-07/main idea.mp3": [
		1039
	],
	"./00003/00003-06/00003-06-07/they need water to drink.mp3": [
		5524,
		4199
	],
	"./00003/00003-06/00003-06-07/they need water to grow.mp3": [
		5525,
		4200
	],
	"./00003/00003-06/00003-06-07/they need water to swim.mp3": [
		5526,
		4201
	],
	"./00003/00003-06/00003-06-07/water.mp3": [
		5527,
		4202
	],
	"./00003/00003-06/00003-06-07/we all need water to live.mp3": [
		5528,
		4203
	],
	"./00003/00003-06/00003-06-08/grow seeds grow.mp3": [
		5529,
		4204
	],
	"./00003/00003-06/00003-06-08/i can see the apples.mp3": [
		5530,
		4205
	],
	"./00003/00003-06/00003-06-08/i can see the branch.mp3": [
		5531,
		4206
	],
	"./00003/00003-06/00003-06-08/i can see the flowers.mp3": [
		5532,
		4207
	],
	"./00003/00003-06/00003-06-08/i can see the leaves.mp3": [
		5533,
		4208
	],
	"./00003/00003-06/00003-06-08/i can see the roots.mp3": [
		5534,
		4209
	],
	"./00003/00003-06/00003-06-08/i can see the seeds.mp3": [
		5535,
		4210
	],
	"./00003/00003-06/00003-06-08/i can see the stem.mp3": [
		5536,
		4211
	],
	"./00003/00003-06/00003-06-08/i like apples he said.mp3": [
		5537,
		4212
	],
	"./00003/00003-06/00003-06-08/i see some pink flowers.mp3": [
		5538,
		4213
	],
	"./00003/00003-06/00003-06-08/intro.mp3": [
		659
	],
	"./00003/00003-06/00003-06-08/look at the apples.mp3": [
		5539,
		4214
	],
	"./00003/00003-06/00003-06-08/look at the branch.mp3": [
		5540,
		4215
	],
	"./00003/00003-06/00003-06-08/look at the flowers.mp3": [
		5541,
		4216
	],
	"./00003/00003-06/00003-06-08/look at the green apples.mp3": [
		5542,
		4217
	],
	"./00003/00003-06/00003-06-08/look at the horse.mp3": [
		5543,
		4218
	],
	"./00003/00003-06/00003-06-08/look at the leaves.mp3": [
		5544,
		4219
	],
	"./00003/00003-06/00003-06-08/look at the roots.mp3": [
		5545,
		4220
	],
	"./00003/00003-06/00003-06-08/look at the seeds.mp3": [
		5546,
		4221
	],
	"./00003/00003-06/00003-06-08/look at the stem.mp3": [
		5547,
		4222
	],
	"./00003/00003-06/00003-06-08/main idea.mp3": [
		1040
	],
	"./00003/00003-06/00003-06-08/the plant grows and grows.mp3": [
		5548,
		4223
	],
	"./00003/00003-06/00003-06-08/the plant grows.mp3": [
		5549,
		4224
	],
	"./00003/00003-06/00003-06-08/things that grow on trees.mp3": [
		5550,
		4225
	],
	"./00003/00003-06/00003-06-09/baby animals.mp3": [
		5551,
		4226
	],
	"./00003/00003-06/00003-06-09/here is my dad.mp3": [
		5552,
		4227
	],
	"./00003/00003-06/00003-06-09/i am a chick.mp3": [
		5553,
		4228
	],
	"./00003/00003-06/00003-06-09/i am a puppy.mp3": [
		5554,
		4229
	],
	"./00003/00003-06/00003-06-09/i love my dad.mp3": [
		5555,
		4230
	],
	"./00003/00003-06/00003-06-09/intro.mp3": [
		660
	],
	"./00003/00003-06/00003-06-09/look at me.mp3": [
		5556,
		4231
	],
	"./00003/00003-06/00003-06-09/look at my dad.mp3": [
		5557,
		4232
	],
	"./00003/00003-06/00003-06-09/main idea.mp3": [
		1041
	],
	"./00003/00003-06/00003-06-09/mammals.mp3": [
		5558,
		4233
	],
	"./00003/00003-06/00003-06-09/my dad is a deer.mp3": [
		5559,
		4234
	],
	"./00003/00003-06/00003-06-09/my dad is a dinosaur.mp3": [
		5560,
		4235
	],
	"./00003/00003-06/00003-06-09/my dad is a dog.mp3": [
		5561,
		4236
	],
	"./00003/00003-06/00003-06-09/my dad is a pig.mp3": [
		5562,
		4237
	],
	"./00003/00003-06/00003-06-09/my dad is a rooster.mp3": [
		5563,
		4238
	],
	"./00003/00003-06/00003-06-09/my dad is a seahorse.mp3": [
		5564,
		4239
	],
	"./00003/00003-06/00003-06-09/my dad is an elephant.mp3": [
		5565,
		4240
	],
	"./00003/00003-06/00003-06-09/we are dinosaurs.mp3": [
		5566,
		4241
	],
	"./00003/00003-06/00003-06-09/we are pigs.mp3": [
		5567,
		4242
	],
	"./00003/00003-06/00003-06-10/can you see 3 boats.mp3": [
		5568,
		4243
	],
	"./00003/00003-06/00003-06-10/can you see 3 boxes.mp3": [
		5569,
		4244
	],
	"./00003/00003-06/00003-06-10/can you see 3 cakes.mp3": [
		5570,
		4245
	],
	"./00003/00003-06/00003-06-10/can you see 3 foxes.mp3": [
		5571,
		4246
	],
	"./00003/00003-06/00003-06-10/can you see 3 frogs.mp3": [
		5572,
		4247
	],
	"./00003/00003-06/00003-06-10/can you see 3 goats.mp3": [
		5573,
		4248
	],
	"./00003/00003-06/00003-06-10/can you see 3 hats.mp3": [
		5574,
		4249
	],
	"./00003/00003-06/00003-06-10/can you see 3 kittens.mp3": [
		5575,
		4250
	],
	"./00003/00003-06/00003-06-10/can you see 3 logs.mp3": [
		5576,
		4251
	],
	"./00003/00003-06/00003-06-10/can you see 3 mittens.mp3": [
		5577,
		4252
	],
	"./00003/00003-06/00003-06-10/can you see 3 nails.mp3": [
		5578,
		4253
	],
	"./00003/00003-06/00003-06-10/can you see 3 rats.mp3": [
		5579,
		4254
	],
	"./00003/00003-06/00003-06-10/can you see 3 snails.mp3": [
		5580,
		4255
	],
	"./00003/00003-06/00003-06-10/can you see 3 snakes.mp3": [
		5581,
		4256
	],
	"./00003/00003-06/00003-06-10/do they grow yes or no.mp3": [
		5582,
		4257
	],
	"./00003/00003-06/00003-06-10/do they grow.mp3": [
		5583,
		4258
	],
	"./00003/00003-06/00003-06-10/intro.mp3": [
		661
	],
	"./00003/00003-06/00003-06-10/living things.mp3": [
		5584,
		4259
	],
	"./00003/00003-06/00003-06-10/main idea.mp3": [
		1042
	],
	"./00003/00003-06/00003-06-10/non living things.mp3": [
		5585,
		4260
	],
	"./00003/00003-06/00003-06-10/the foxes grow.mp3": [
		5586,
		4261
	],
	"./00003/00003-06/00003-06-10/the frogs grow.mp3": [
		5587,
		4262
	],
	"./00003/00003-06/00003-06-10/the goats grow.mp3": [
		5588,
		4263
	],
	"./00003/00003-06/00003-06-10/the kittens grow.mp3": [
		5589,
		4264
	],
	"./00003/00003-06/00003-06-10/the rats grow.mp3": [
		5590,
		4265
	],
	"./00003/00003-06/00003-06-10/the snails grow.mp3": [
		5591,
		4266
	],
	"./00003/00003-06/00003-06-10/the snakes grow.mp3": [
		5592,
		4267
	],
	"./00003/00003-06/life science.mp3": [
		5593,
		4268
	],
	"./00003/00003-07/00003-07-01/big and little.mp3": [
		5594,
		4269
	],
	"./00003/00003-07/00003-07-01/big cars and buses go on the road.mp3": [
		5595,
		4270
	],
	"./00003/00003-07/00003-07-01/big planes and helicopters go up in the sky.mp3": [
		5596,
		4271
	],
	"./00003/00003-07/00003-07-01/i play with my car and my bus.mp3": [
		5597,
		4272
	],
	"./00003/00003-07/00003-07-01/i play with my helicopter and my plane.mp3": [
		5598,
		4273
	],
	"./00003/00003-07/00003-07-01/i play with my little trucks.mp3": [
		5599,
		4274
	],
	"./00003/00003-07/00003-07-01/i play with my monsters.mp3": [
		5600,
		4275
	],
	"./00003/00003-07/00003-07-01/intro.mp3": [
		662
	],
	"./00003/00003-07/00003-07-01/main idea.mp3": [
		1043
	],
	"./00003/00003-07/00003-07-01/my bus is little.mp3": [
		5601,
		4276
	],
	"./00003/00003-07/00003-07-01/my car is little.mp3": [
		5602,
		4277
	],
	"./00003/00003-07/00003-07-01/my dump truck is little.mp3": [
		5603,
		4278
	],
	"./00003/00003-07/00003-07-01/my fire truck is little.mp3": [
		5604,
		4279
	],
	"./00003/00003-07/00003-07-01/my green monster is little.mp3": [
		5605,
		4280
	],
	"./00003/00003-07/00003-07-01/my helicopter is little.mp3": [
		5606,
		4281
	],
	"./00003/00003-07/00003-07-01/my plane is little.mp3": [
		5607,
		4282
	],
	"./00003/00003-07/00003-07-01/my red monster is big.mp3": [
		5608,
		4283
	],
	"./00003/00003-07/00003-07-01/the big trucks go on the road.mp3": [
		5609,
		4284
	],
	"./00003/00003-07/00003-07-01/this bus is big.mp3": [
		5610,
		4285
	],
	"./00003/00003-07/00003-07-01/this car is big.mp3": [
		5611,
		4286
	],
	"./00003/00003-07/00003-07-01/this dump truck is big.mp3": [
		5612,
		4287
	],
	"./00003/00003-07/00003-07-01/this fire truck is big.mp3": [
		5613,
		4288
	],
	"./00003/00003-07/00003-07-01/this helicopter is big.mp3": [
		5614,
		4289
	],
	"./00003/00003-07/00003-07-01/this plane is big.mp3": [
		5615,
		4290
	],
	"./00003/00003-07/00003-07-01/vehicles.mp3": [
		5616,
		4291
	],
	"./00003/00003-07/00003-07-02/electricity.mp3": [
		5617,
		4292
	],
	"./00003/00003-07/00003-07-02/intro.mp3": [
		663
	],
	"./00003/00003-07/00003-07-02/look at the computer.mp3": [
		5618,
		4293
	],
	"./00003/00003-07/00003-07-02/look at the fan.mp3": [
		5619,
		4294
	],
	"./00003/00003-07/00003-07-02/look at the fridge.mp3": [
		5620,
		4295
	],
	"./00003/00003-07/00003-07-02/look at the guitar.mp3": [
		5621,
		4296
	],
	"./00003/00003-07/00003-07-02/look at the light.mp3": [
		5622,
		4297
	],
	"./00003/00003-07/00003-07-02/look at the stove.mp3": [
		5623,
		4298
	],
	"./00003/00003-07/00003-07-02/look at the television.mp3": [
		5624,
		4299
	],
	"./00003/00003-07/00003-07-02/main idea.mp3": [
		1044
	],
	"./00003/00003-07/00003-07-02/the computer is on.mp3": [
		5625,
		4300
	],
	"./00003/00003-07/00003-07-02/the computer uses electricity.mp3": [
		5626,
		4301
	],
	"./00003/00003-07/00003-07-02/the fan is not on.mp3": [
		5627,
		4302
	],
	"./00003/00003-07/00003-07-02/the fan uses electricity.mp3": [
		5628,
		4303
	],
	"./00003/00003-07/00003-07-02/the fridge is not on.mp3": [
		5629,
		4304
	],
	"./00003/00003-07/00003-07-02/the fridge uses electricity.mp3": [
		5630,
		4305
	],
	"./00003/00003-07/00003-07-02/the guitar is rocking on.mp3": [
		5631,
		4306
	],
	"./00003/00003-07/00003-07-02/the guitar uses electricity.mp3": [
		5632,
		4307
	],
	"./00003/00003-07/00003-07-02/the light is on.mp3": [
		5633,
		4308
	],
	"./00003/00003-07/00003-07-02/the light uses electricity.mp3": [
		5634,
		4309
	],
	"./00003/00003-07/00003-07-02/the stove is not on.mp3": [
		5635,
		4310
	],
	"./00003/00003-07/00003-07-02/the stove uses electricity.mp3": [
		5636,
		4311
	],
	"./00003/00003-07/00003-07-02/the television is on.mp3": [
		5637,
		4312
	],
	"./00003/00003-07/00003-07-02/the television uses electricity.mp3": [
		5638,
		4313
	],
	"./00003/00003-07/00003-07-02/things that use electricity.mp3": [
		5639,
		4314
	],
	"./00003/00003-07/00003-07-03/bear is playing the guitar.mp3": [
		5640,
		4315
	],
	"./00003/00003-07/00003-07-03/dog is playing the tambourine.mp3": [
		5641,
		4316
	],
	"./00003/00003-07/00003-07-03/donkey is playing the harp.mp3": [
		5642,
		4317
	],
	"./00003/00003-07/00003-07-03/elephant is playing the cymbals.mp3": [
		5643,
		4318
	],
	"./00003/00003-07/00003-07-03/intro.mp3": [
		664
	],
	"./00003/00003-07/00003-07-03/listen to the music.mp3": [
		5644,
		4319
	],
	"./00003/00003-07/00003-07-03/loud and soft.mp3": [
		5645,
		4320
	],
	"./00003/00003-07/00003-07-03/main idea.mp3": [
		1045
	],
	"./00003/00003-07/00003-07-03/monkey is playing the triangle.mp3": [
		5646,
		4321
	],
	"./00003/00003-07/00003-07-03/musical instruments.mp3": [
		5647,
		4322
	],
	"./00003/00003-07/00003-07-03/rabbit is playing the drum.mp3": [
		5648,
		4323
	],
	"./00003/00003-07/00003-07-03/raccoon is playing the banjo.mp3": [
		5649,
		4324
	],
	"./00003/00003-07/00003-07-03/racoon is playing the banjo.mp3": [
		5650,
		4325
	],
	"./00003/00003-07/00003-07-03/the banjo is loud.mp3": [
		5651,
		4326
	],
	"./00003/00003-07/00003-07-03/the cymbals are loud.mp3": [
		5652,
		4327
	],
	"./00003/00003-07/00003-07-03/the drum is loud.mp3": [
		5653,
		4328
	],
	"./00003/00003-07/00003-07-03/the guitar is loud.mp3": [
		5654,
		4329
	],
	"./00003/00003-07/00003-07-03/the harp is soft.mp3": [
		5655,
		4330
	],
	"./00003/00003-07/00003-07-03/the tambourine is soft.mp3": [
		5656,
		4331
	],
	"./00003/00003-07/00003-07-03/the triangle is soft.mp3": [
		5657,
		4332
	],
	"./00003/00003-07/00003-07-04/deer goes up in the pulley.mp3": [
		5658,
		4333
	],
	"./00003/00003-07/00003-07-04/elephant goes down in the pulley.mp3": [
		5659,
		4334
	],
	"./00003/00003-07/00003-07-04/elephant goes up in the pulley.mp3": [
		5660,
		4335
	],
	"./00003/00003-07/00003-07-04/he goes up and up.mp3": [
		5661,
		4336
	],
	"./00003/00003-07/00003-07-04/intro.mp3": [
		665
	],
	"./00003/00003-07/00003-07-04/lion goes up in the pulley.mp3": [
		5662,
		4337
	],
	"./00003/00003-07/00003-07-04/main idea.mp3": [
		1046
	],
	"./00003/00003-07/00003-07-04/oh no.mp3": [
		5663,
		4338
	],
	"./00003/00003-07/00003-07-04/panda and skunk go up.mp3": [
		5664,
		4339
	],
	"./00003/00003-07/00003-07-04/panda goes up in the pulley.mp3": [
		5665,
		4340
	],
	"./00003/00003-07/00003-07-04/she pulls and pulls and pulls.mp3": [
		5666,
		4341
	],
	"./00003/00003-07/00003-07-04/she pulls and pulls.mp3": [
		5667,
		4342
	],
	"./00003/00003-07/00003-07-04/skunk goes up in the pulley.mp3": [
		5668,
		4343
	],
	"./00003/00003-07/00003-07-04/squirrel lets go.mp3": [
		5669,
		4344
	],
	"./00003/00003-07/00003-07-04/squirrel pulls hard.mp3": [
		5670,
		4345
	],
	"./00003/00003-07/00003-07-04/squirrel pulls the animals up in the pulley.mp3": [
		5671,
		4346
	],
	"./00003/00003-07/00003-07-04/tiger goes up in the pulley.mp3": [
		5672,
		4347
	],
	"./00003/00003-07/00003-07-04/up in the pulley.mp3": [
		5673,
		4348
	],
	"./00003/00003-07/00003-07-04/who else goes up in the pulley.mp3": [
		5674,
		4349
	],
	"./00003/00003-07/00003-07-04/wild animals.mp3": [
		5675,
		4350
	],
	"./00003/00003-07/00003-07-05/intro.mp3": [
		666
	],
	"./00003/00003-07/00003-07-05/it will go down.mp3": [
		5676,
		4351
	],
	"./00003/00003-07/00003-07-05/it will go go go.mp3": [
		5677,
		4352
	],
	"./00003/00003-07/00003-07-05/it will go up.mp3": [
		5678,
		4353
	],
	"./00003/00003-07/00003-07-05/main idea.mp3": [
		1047
	],
	"./00003/00003-07/00003-07-05/the ball will move.mp3": [
		5679,
		4354
	],
	"./00003/00003-07/00003-07-05/the car will move.mp3": [
		5680,
		4355
	],
	"./00003/00003-07/00003-07-05/the swing will move.mp3": [
		5681,
		4356
	],
	"./00003/00003-07/00003-07-05/the swing will not move.mp3": [
		5682,
		4357
	],
	"./00003/00003-07/00003-07-05/the truck will move.mp3": [
		5683,
		4358
	],
	"./00003/00003-07/00003-07-05/the truck will not move.mp3": [
		5684,
		4359
	],
	"./00003/00003-07/00003-07-05/toys.mp3": [
		5685,
		4360
	],
	"./00003/00003-07/00003-07-05/what will make it move.mp3": [
		5686,
		4361
	],
	"./00003/00003-07/00003-07-05/will it move.mp3": [
		5687,
		4362
	],
	"./00003/00003-07/00003-07-06/i can see the nail.mp3": [
		5688,
		4363
	],
	"./00003/00003-07/00003-07-06/intro.mp3": [
		667
	],
	"./00003/00003-07/00003-07-06/look at the apple.mp3": [
		5689,
		4364
	],
	"./00003/00003-07/00003-07-06/look at the ball.mp3": [
		5690,
		4365
	],
	"./00003/00003-07/00003-07-06/look at the boat.mp3": [
		5691,
		4366
	],
	"./00003/00003-07/00003-07-06/look at the cube.mp3": [
		5692,
		4367
	],
	"./00003/00003-07/00003-07-06/look at the duck.mp3": [
		5693,
		4368
	],
	"./00003/00003-07/00003-07-06/look at the key.mp3": [
		5694,
		4369
	],
	"./00003/00003-07/00003-07-06/look.mp3": [
		5695,
		4370
	],
	"./00003/00003-07/00003-07-06/main idea.mp3": [
		1048
	],
	"./00003/00003-07/00003-07-06/no.mp3": [
		5696,
		4371
	],
	"./00003/00003-07/00003-07-06/the apple floats.mp3": [
		5697,
		4372
	],
	"./00003/00003-07/00003-07-06/the ball floats.mp3": [
		5698,
		4373
	],
	"./00003/00003-07/00003-07-06/the boat floats.mp3": [
		5699,
		4374
	],
	"./00003/00003-07/00003-07-06/the cube floats.mp3": [
		5700,
		4375
	],
	"./00003/00003-07/00003-07-06/the duck floats too.mp3": [
		5701,
		4376
	],
	"./00003/00003-07/00003-07-06/the key sinks.mp3": [
		5702,
		4377
	],
	"./00003/00003-07/00003-07-06/the nail sinks.mp3": [
		5703,
		4378
	],
	"./00003/00003-07/00003-07-06/things that float.mp3": [
		5704,
		4379
	],
	"./00003/00003-07/00003-07-06/things that sink.mp3": [
		5705,
		4380
	],
	"./00003/00003-07/00003-07-06/will it float.mp3": [
		5706,
		4381
	],
	"./00003/00003-07/00003-07-06/will it sink.mp3": [
		5707,
		4382
	],
	"./00003/00003-07/00003-07-06/yes.mp3": [
		5708,
		4383
	],
	"./00003/00003-07/00003-07-07/fishing with a magnet.mp3": [
		5709,
		4384
	],
	"./00003/00003-07/00003-07-07/intro.mp3": [
		668
	],
	"./00003/00003-07/00003-07-07/it is made of metal.mp3": [
		5710,
		4385
	],
	"./00003/00003-07/00003-07-07/look at the anchor.mp3": [
		5711,
		4386
	],
	"./00003/00003-07/00003-07-07/look at the ball.mp3": [
		5712,
		4387
	],
	"./00003/00003-07/00003-07-07/look at the car.mp3": [
		5713,
		4388
	],
	"./00003/00003-07/00003-07-07/look at the chipmunk.mp3": [
		5714,
		4389
	],
	"./00003/00003-07/00003-07-07/look at the deer.mp3": [
		5715,
		4390
	],
	"./00003/00003-07/00003-07-07/look at the fox.mp3": [
		5716,
		4391
	],
	"./00003/00003-07/00003-07-07/look at the helicopter.mp3": [
		5717,
		4392
	],
	"./00003/00003-07/00003-07-07/look at the lion.mp3": [
		5718,
		4393
	],
	"./00003/00003-07/00003-07-07/look at the rocket.mp3": [
		5719,
		4394
	],
	"./00003/00003-07/00003-07-07/look at the sheep.mp3": [
		5720,
		4395
	],
	"./00003/00003-07/00003-07-07/look at the squirrel.mp3": [
		5721,
		4396
	],
	"./00003/00003-07/00003-07-07/look at the tiger.mp3": [
		5722,
		4397
	],
	"./00003/00003-07/00003-07-07/made.mp3": [
		5723,
		4398
	],
	"./00003/00003-07/00003-07-07/magnet.mp3": [
		5724,
		4399
	],
	"./00003/00003-07/00003-07-07/magnets.mp3": [
		5725,
		4400
	],
	"./00003/00003-07/00003-07-07/main idea.mp3": [
		1049
	],
	"./00003/00003-07/00003-07-07/metal.mp3": [
		5726,
		4401
	],
	"./00003/00003-07/00003-07-07/the chipmunk got a nail.mp3": [
		5727,
		4402
	],
	"./00003/00003-07/00003-07-07/the deer got a helicopter.mp3": [
		5728,
		4403
	],
	"./00003/00003-07/00003-07-07/the fox got a magnet.mp3": [
		5729,
		4404
	],
	"./00003/00003-07/00003-07-07/the lion got a rocket.mp3": [
		5730,
		4405
	],
	"./00003/00003-07/00003-07-07/the sheep got an anchor.mp3": [
		5731,
		4406
	],
	"./00003/00003-07/00003-07-07/the squirrel got a ball.mp3": [
		5732,
		4407
	],
	"./00003/00003-07/00003-07-07/the tiger got a car.mp3": [
		5733,
		4408
	],
	"./00003/00003-07/00003-07-07/things made of metal.mp3": [
		5734,
		4409
	],
	"./00003/00003-07/00003-07-08/here comes the motorcycle.mp3": [
		5735,
		4410
	],
	"./00003/00003-07/00003-07-08/here comes the plane.mp3": [
		5736,
		4411
	],
	"./00003/00003-07/00003-07-08/here comes the train.mp3": [
		5737,
		4412
	],
	"./00003/00003-07/00003-07-08/here is a car.mp3": [
		5738,
		4413
	],
	"./00003/00003-07/00003-07-08/here is a dump truck.mp3": [
		5739,
		4414
	],
	"./00003/00003-07/00003-07-08/intro.mp3": [
		669
	],
	"./00003/00003-07/00003-07-08/look at the bus.mp3": [
		5740,
		4415
	],
	"./00003/00003-07/00003-07-08/look at the unicycle.mp3": [
		5741,
		4416
	],
	"./00003/00003-07/00003-07-08/main idea.mp3": [
		1050
	],
	"./00003/00003-07/00003-07-08/the bus has six wheels.mp3": [
		5742,
		4417
	],
	"./00003/00003-07/00003-07-08/the car has four wheels.mp3": [
		5743,
		4418
	],
	"./00003/00003-07/00003-07-08/the car truck has four wheels.mp3": [
		5744,
		4419
	],
	"./00003/00003-07/00003-07-08/the dump truck has four wheels.mp3": [
		5745,
		4420
	],
	"./00003/00003-07/00003-07-08/the motorcycle has two wheels.mp3": [
		5746,
		4421
	],
	"./00003/00003-07/00003-07-08/the plane has three wheels.mp3": [
		5747,
		4422
	],
	"./00003/00003-07/00003-07-08/the train has eight wheels.mp3": [
		5748,
		4423
	],
	"./00003/00003-07/00003-07-08/the unicycle has one wheel.mp3": [
		5749,
		4424
	],
	"./00003/00003-07/00003-07-08/vehicles.mp3": [
		5750,
		4425
	],
	"./00003/00003-07/00003-07-08/wheels make things go.mp3": [
		5751,
		4426
	],
	"./00003/00003-07/00003-07-08/wheels.mp3": [
		5752,
		4427
	],
	"./00003/00003-07/00003-07-09/here is saturn.mp3": [
		5753,
		4428
	],
	"./00003/00003-07/00003-07-09/i can see the iceberg.mp3": [
		5754,
		4429
	],
	"./00003/00003-07/00003-07-09/i see a fire.mp3": [
		5755,
		4430
	],
	"./00003/00003-07/00003-07-09/i see a fox.mp3": [
		5756,
		4431
	],
	"./00003/00003-07/00003-07-09/i see the sun.mp3": [
		5757,
		4432
	],
	"./00003/00003-07/00003-07-09/i see the volcano.mp3": [
		5758,
		4433
	],
	"./00003/00003-07/00003-07-09/intro.mp3": [
		670
	],
	"./00003/00003-07/00003-07-09/is it cold.mp3": [
		5759,
		4434
	],
	"./00003/00003-07/00003-07-09/is it hot is it cold.mp3": [
		5760,
		4435
	],
	"./00003/00003-07/00003-07-09/is it hot or cold.mp3": [
		5761,
		4436
	],
	"./00003/00003-07/00003-07-09/is it hot.mp3": [
		5762,
		4437
	],
	"./00003/00003-07/00003-07-09/look at the fridge.mp3": [
		5763,
		4438
	],
	"./00003/00003-07/00003-07-09/look at the stove.mp3": [
		5764,
		4439
	],
	"./00003/00003-07/00003-07-09/main idea.mp3": [
		1051
	],
	"./00003/00003-07/00003-07-09/non living things.mp3": [
		5765,
		4440
	],
	"./00003/00003-07/00003-07-09/saturn is cold.mp3": [
		5766,
		4441
	],
	"./00003/00003-07/00003-07-09/the fire is hot.mp3": [
		5767,
		4442
	],
	"./00003/00003-07/00003-07-09/the fridge is cold.mp3": [
		5768,
		4443
	],
	"./00003/00003-07/00003-07-09/the iceberg is cold.mp3": [
		5769,
		4444
	],
	"./00003/00003-07/00003-07-09/the stove is hot.mp3": [
		5770,
		4445
	],
	"./00003/00003-07/00003-07-09/the sun is hot.mp3": [
		5771,
		4446
	],
	"./00003/00003-07/00003-07-09/the volcano is hot.mp3": [
		5772,
		4447
	],
	"./00003/00003-07/00003-07-10/big things.mp3": [
		5773,
		4448
	],
	"./00003/00003-07/00003-07-10/here comes the car.mp3": [
		5774,
		4449
	],
	"./00003/00003-07/00003-07-10/here comes the fire truck.mp3": [
		5775,
		4450
	],
	"./00003/00003-07/00003-07-10/here comes the plane.mp3": [
		5776,
		4451
	],
	"./00003/00003-07/00003-07-10/here is a car.mp3": [
		5777,
		4452
	],
	"./00003/00003-07/00003-07-10/here is a dump truck.mp3": [
		5778,
		4453
	],
	"./00003/00003-07/00003-07-10/here is a helicopter.mp3": [
		5779,
		4454
	],
	"./00003/00003-07/00003-07-10/here is a monster.mp3": [
		5780,
		4455
	],
	"./00003/00003-07/00003-07-10/i like the monster.mp3": [
		5781,
		4456
	],
	"./00003/00003-07/00003-07-10/intro.mp3": [
		671
	],
	"./00003/00003-07/00003-07-10/look at the bus.mp3": [
		5782,
		4457
	],
	"./00003/00003-07/00003-07-10/main idea.mp3": [
		1052
	],
	"./00003/00003-07/00003-07-10/my red monster is big.mp3": [
		5783,
		4458
	],
	"./00003/00003-07/00003-07-10/the fire truck is red.mp3": [
		5784,
		4459
	],
	"./00003/00003-07/00003-07-10/the helicopter is red.mp3": [
		5785,
		4460
	],
	"./00003/00003-07/00003-07-10/the plane is red.mp3": [
		5786,
		4461
	],
	"./00003/00003-07/00003-07-10/this bus is big.mp3": [
		5787,
		4462
	],
	"./00003/00003-07/00003-07-10/this car is big.mp3": [
		5788,
		4463
	],
	"./00003/00003-07/00003-07-10/this dinosaur is huge.mp3": [
		5789,
		4464
	],
	"./00003/00003-07/00003-07-10/this dump truck is big.mp3": [
		5790,
		4465
	],
	"./00003/00003-07/00003-07-10/this fire truck is big.mp3": [
		5791,
		4466
	],
	"./00003/00003-07/00003-07-10/this giraffe is big.mp3": [
		5792,
		4467
	],
	"./00003/00003-07/00003-07-10/this helicopter is big.mp3": [
		5793,
		4468
	],
	"./00003/00003-07/00003-07-10/this monster is big.mp3": [
		5794,
		4469
	],
	"./00003/00003-07/00003-07-10/this plane is big.mp3": [
		5795,
		4470
	],
	"./00003/00003-07/00003-07-10/this whale is big.mp3": [
		5796,
		4471
	],
	"./00003/00003-07/00003-07-10/this whale shark is big.mp3": [
		5797,
		4472
	],
	"./00003/00003-07/00003-07-10/vehicles.mp3": [
		5798,
		4473
	],
	"./00003/00003-07/physical science.mp3": [
		5799,
		4474
	],
	"./00003/00003-08/00003-08-01/i love the mountains said the goat.mp3": [
		5800,
		4475
	],
	"./00003/00003-08/00003-08-01/i love the sea said the whale.mp3": [
		5801,
		4476
	],
	"./00003/00003-08/00003-08-01/intro.mp3": [
		672
	],
	"./00003/00003-08/00003-08-01/main idea.mp3": [
		1053
	],
	"./00003/00003-08/00003-08-01/the earth is our home too said the kids.mp3": [
		5802,
		4477
	],
	"./00003/00003-08/00003-08-01/the earth is our home.mp3": [
		5803,
		4478
	],
	"./00003/00003-08/00003-08-01/the forest is our home said the foxes.mp3": [
		5804,
		4479
	],
	"./00003/00003-08/00003-08-01/the lake is our home said the birds.mp3": [
		5805,
		4480
	],
	"./00003/00003-08/00003-08-01/the mountains are my home.mp3": [
		5806,
		4481
	],
	"./00003/00003-08/00003-08-01/the river is our home.mp3": [
		5807,
		4482
	],
	"./00003/00003-08/00003-08-01/the sea is my home.mp3": [
		5808,
		4483
	],
	"./00003/00003-08/00003-08-01/things on the earth.mp3": [
		5809,
		4484
	],
	"./00003/00003-08/00003-08-01/we love the earth said the animals.mp3": [
		5810,
		4485
	],
	"./00003/00003-08/00003-08-01/we love the earth.mp3": [
		5811,
		4486
	],
	"./00003/00003-08/00003-08-01/we love the forest.mp3": [
		5812,
		4487
	],
	"./00003/00003-08/00003-08-01/we love the lake.mp3": [
		5813,
		4488
	],
	"./00003/00003-08/00003-08-01/we love the river said the ducks.mp3": [
		5814,
		4489
	],
	"./00003/00003-08/00003-08-02/earth goes around the sun.mp3": [
		5815,
		4490
	],
	"./00003/00003-08/00003-08-02/earth is a small planet.mp3": [
		5816,
		4491
	],
	"./00003/00003-08/00003-08-02/here is earth.mp3": [
		5817,
		4492
	],
	"./00003/00003-08/00003-08-02/here is jupiter.mp3": [
		5818,
		4493
	],
	"./00003/00003-08/00003-08-02/here is mars.mp3": [
		5819,
		4494
	],
	"./00003/00003-08/00003-08-02/here is mercury.mp3": [
		5820,
		4495
	],
	"./00003/00003-08/00003-08-02/here is the moon.mp3": [
		5821,
		4496
	],
	"./00003/00003-08/00003-08-02/here is venus.mp3": [
		5822,
		4497
	],
	"./00003/00003-08/00003-08-02/intro.mp3": [
		673
	],
	"./00003/00003-08/00003-08-02/jupiter goes around the sun too.mp3": [
		5823,
		4498
	],
	"./00003/00003-08/00003-08-02/jupiter is a big planet.mp3": [
		5824,
		4499
	],
	"./00003/00003-08/00003-08-02/main idea.mp3": [
		1054
	],
	"./00003/00003-08/00003-08-02/mars goes around the sun.mp3": [
		5825,
		4500
	],
	"./00003/00003-08/00003-08-02/mars is a small planet.mp3": [
		5826,
		4501
	],
	"./00003/00003-08/00003-08-02/mercury goes around the sun.mp3": [
		5827,
		4502
	],
	"./00003/00003-08/00003-08-02/mercury is a small planet.mp3": [
		5828,
		4503
	],
	"./00003/00003-08/00003-08-02/planets.mp3": [
		5829,
		4504
	],
	"./00003/00003-08/00003-08-02/saturn uranus and neptune are big planets.mp3": [
		5830,
		4505
	],
	"./00003/00003-08/00003-08-02/the moon goes around the earth.mp3": [
		5831,
		4506
	],
	"./00003/00003-08/00003-08-02/the moon is not a planet.mp3": [
		5832,
		4507
	],
	"./00003/00003-08/00003-08-02/the planets.mp3": [
		5833,
		4508
	],
	"./00003/00003-08/00003-08-02/they go around the sun.mp3": [
		5834,
		4509
	],
	"./00003/00003-08/00003-08-02/things in space.mp3": [
		5835,
		4510
	],
	"./00003/00003-08/00003-08-02/venus goes around the sun.mp3": [
		5836,
		4511
	],
	"./00003/00003-08/00003-08-02/venus is a small planet.mp3": [
		5837,
		4512
	],
	"./00003/00003-08/00003-08-03/animals that live in the snow.mp3": [
		5838,
		4513
	],
	"./00003/00003-08/00003-08-03/in the winter.mp3": [
		5839,
		4514
	],
	"./00003/00003-08/00003-08-03/intro.mp3": [
		674
	],
	"./00003/00003-08/00003-08-03/it is cold.mp3": [
		5840,
		4515
	],
	"./00003/00003-08/00003-08-03/it is winter.mp3": [
		5841,
		4516
	],
	"./00003/00003-08/00003-08-03/look at the bear.mp3": [
		5842,
		4517
	],
	"./00003/00003-08/00003-08-03/look at the frost.mp3": [
		5843,
		4518
	],
	"./00003/00003-08/00003-08-03/look at the ice.mp3": [
		5844,
		4519
	],
	"./00003/00003-08/00003-08-03/look at the mountains.mp3": [
		5845,
		4520
	],
	"./00003/00003-08/00003-08-03/look at the pond.mp3": [
		5846,
		4521
	],
	"./00003/00003-08/00003-08-03/look at the river.mp3": [
		5847,
		4522
	],
	"./00003/00003-08/00003-08-03/look at the trees.mp3": [
		5848,
		4523
	],
	"./00003/00003-08/00003-08-03/main idea.mp3": [
		1055
	],
	"./00003/00003-08/00003-08-03/the bear is sleeping.mp3": [
		5849,
		4524
	],
	"./00003/00003-08/00003-08-04/i can see five ducklings.mp3": [
		5850,
		4525
	],
	"./00003/00003-08/00003-08-04/i can see four chicks.mp3": [
		5851,
		4526
	],
	"./00003/00003-08/00003-08-04/i can see seven flowers.mp3": [
		5852,
		4527
	],
	"./00003/00003-08/00003-08-04/i can see six butterflies.mp3": [
		5853,
		4528
	],
	"./00003/00003-08/00003-08-04/i can see the rain.mp3": [
		5854,
		4529
	],
	"./00003/00003-08/00003-08-04/i can see three frogs.mp3": [
		5855,
		4530
	],
	"./00003/00003-08/00003-08-04/i can see two lambs.mp3": [
		5856,
		4531
	],
	"./00003/00003-08/00003-08-04/intro.mp3": [
		675
	],
	"./00003/00003-08/00003-08-04/main idea.mp3": [
		1056
	],
	"./00003/00003-08/00003-08-04/signs of spring.mp3": [
		5857,
		4532
	],
	"./00003/00003-08/00003-08-04/spring is here.mp3": [
		5858,
		4533
	],
	"./00003/00003-08/00003-08-04/spring is on the way.mp3": [
		5859,
		4534
	],
	"./00003/00003-08/00003-08-04/what can i see.mp3": [
		5860,
		4535
	],
	"./00003/00003-08/00003-08-05/i have fun in the sun.mp3": [
		5861,
		4536
	],
	"./00003/00003-08/00003-08-05/i like summer.mp3": [
		5862,
		4537
	],
	"./00003/00003-08/00003-08-05/i like the hermit crab.mp3": [
		5863,
		4538
	],
	"./00003/00003-08/00003-08-05/i like the sandcastle.mp3": [
		5864,
		4539
	],
	"./00003/00003-08/00003-08-05/i like the sea.mp3": [
		5865,
		4540
	],
	"./00003/00003-08/00003-08-05/i like the seagull.mp3": [
		5866,
		4541
	],
	"./00003/00003-08/00003-08-05/i like the shell.mp3": [
		5867,
		4542
	],
	"./00003/00003-08/00003-08-05/i like the starfish.mp3": [
		5868,
		4543
	],
	"./00003/00003-08/00003-08-05/i like the sun.mp3": [
		5869,
		4544
	],
	"./00003/00003-08/00003-08-05/intro.mp3": [
		676
	],
	"./00003/00003-08/00003-08-05/main idea.mp3": [
		1057
	],
	"./00003/00003-08/00003-08-05/sea animals.mp3": [
		5870,
		4545
	],
	"./00003/00003-08/00003-08-06/colors in the fall.mp3": [
		5871,
		4546
	],
	"./00003/00003-08/00003-08-06/i like apples he said.mp3": [
		5872,
		4547
	],
	"./00003/00003-08/00003-08-06/i like grapes she said.mp3": [
		5873,
		4548
	],
	"./00003/00003-08/00003-08-06/i like hay she said.mp3": [
		5874,
		4549
	],
	"./00003/00003-08/00003-08-06/i like leaves he said.mp3": [
		5875,
		4550
	],
	"./00003/00003-08/00003-08-06/i like nuts said the squirrel.mp3": [
		5876,
		4551
	],
	"./00003/00003-08/00003-08-06/i like pumpkins he said.mp3": [
		5877,
		4552
	],
	"./00003/00003-08/00003-08-06/intro.mp3": [
		677
	],
	"./00003/00003-08/00003-08-06/look at the ant.mp3": [
		5878,
		4553
	],
	"./00003/00003-08/00003-08-06/look at the bear.mp3": [
		5879,
		4554
	],
	"./00003/00003-08/00003-08-06/look at the bird.mp3": [
		5880,
		4555
	],
	"./00003/00003-08/00003-08-06/look at the brown nuts.mp3": [
		5881,
		4556
	],
	"./00003/00003-08/00003-08-06/look at the cow.mp3": [
		5882,
		4557
	],
	"./00003/00003-08/00003-08-06/look at the gray geese.mp3": [
		5883,
		4558
	],
	"./00003/00003-08/00003-08-06/look at the green apples.mp3": [
		5884,
		4559
	],
	"./00003/00003-08/00003-08-06/look at the horse.mp3": [
		5885,
		4560
	],
	"./00003/00003-08/00003-08-06/look at the orange pumpkin.mp3": [
		5886,
		4561
	],
	"./00003/00003-08/00003-08-06/look at the purple grapes.mp3": [
		5887,
		4562
	],
	"./00003/00003-08/00003-08-06/look at the red leaves.mp3": [
		5888,
		4563
	],
	"./00003/00003-08/00003-08-06/look at the squirrel.mp3": [
		5889,
		4564
	],
	"./00003/00003-08/00003-08-06/look at the trees.mp3": [
		5890,
		4565
	],
	"./00003/00003-08/00003-08-06/look at the yellow hay.mp3": [
		5891,
		4566
	],
	"./00003/00003-08/00003-08-06/main idea.mp3": [
		1058
	],
	"./00003/00003-08/00003-08-06/pumpkins.mp3": [
		5892,
		4567
	],
	"./00003/00003-08/00003-08-06/things we see in the fall.mp3": [
		5893,
		4568
	],
	"./00003/00003-08/00003-08-06/we like fall they said.mp3": [
		5894,
		4569
	],
	"./00003/00003-08/00003-08-07/intro.mp3": [
		678
	],
	"./00003/00003-08/00003-08-07/look at the soil.mp3": [
		5895,
		4570
	],
	"./00003/00003-08/00003-08-07/main idea.mp3": [
		1059
	],
	"./00003/00003-08/00003-08-07/they eat the leaves.mp3": [
		5896,
		4571
	],
	"./00003/00003-08/00003-08-07/things we see in the soil.mp3": [
		5897,
		4572
	],
	"./00003/00003-08/00003-08-07/we can see ants.mp3": [
		5898,
		4573
	],
	"./00003/00003-08/00003-08-07/we can see bones.mp3": [
		5899,
		4574
	],
	"./00003/00003-08/00003-08-07/we can see leaves.mp3": [
		5900,
		4575
	],
	"./00003/00003-08/00003-08-07/we can see rocks.mp3": [
		5901,
		4576
	],
	"./00003/00003-08/00003-08-07/we can see roots.mp3": [
		5902,
		4577
	],
	"./00003/00003-08/00003-08-07/we can see shells.mp3": [
		5903,
		4578
	],
	"./00003/00003-08/00003-08-07/we can see worms.mp3": [
		5904,
		4579
	],
	"./00003/00003-08/00003-08-07/what else can we see.mp3": [
		5905,
		4580
	],
	"./00003/00003-08/00003-08-07/what is in the soil.mp3": [
		5906,
		4581
	],
	"./00003/00003-08/00003-08-08/alligator likes the green rock.mp3": [
		5907,
		4582
	],
	"./00003/00003-08/00003-08-08/cheetah likes the yellow rock.mp3": [
		5908,
		4583
	],
	"./00003/00003-08/00003-08-08/chipmunk likes the brown rock.mp3": [
		5909,
		4584
	],
	"./00003/00003-08/00003-08-08/elephant likes the gray rock.mp3": [
		5910,
		4585
	],
	"./00003/00003-08/00003-08-08/fox likes the red rock.mp3": [
		5911,
		4586
	],
	"./00003/00003-08/00003-08-08/intro.mp3": [
		679
	],
	"./00003/00003-08/00003-08-08/look at my rock he said.mp3": [
		5912,
		4587
	],
	"./00003/00003-08/00003-08-08/look at my rock she said.mp3": [
		5913,
		4588
	],
	"./00003/00003-08/00003-08-08/main idea.mp3": [
		1060
	],
	"./00003/00003-08/00003-08-08/my rock has spots.mp3": [
		5914,
		4589
	],
	"./00003/00003-08/00003-08-08/my rock has stripes.mp3": [
		5915,
		4590
	],
	"./00003/00003-08/00003-08-08/my rock is big.mp3": [
		5916,
		4591
	],
	"./00003/00003-08/00003-08-08/my rock is little.mp3": [
		5917,
		4592
	],
	"./00003/00003-08/00003-08-08/non living things.mp3": [
		5918,
		4593
	],
	"./00003/00003-08/00003-08-08/rocks.mp3": [
		5919,
		4594
	],
	"./00003/00003-08/00003-08-08/skunk likes the black rock.mp3": [
		5920,
		4595
	],
	"./00003/00003-08/00003-08-08/tiger likes the orange rock.mp3": [
		5921,
		4596
	],
	"./00003/00003-08/00003-08-09/intro.mp3": [
		680
	],
	"./00003/00003-08/00003-08-09/it is night.mp3": [
		5922,
		4597
	],
	"./00003/00003-08/00003-08-09/look up in the sky.mp3": [
		5923,
		4598
	],
	"./00003/00003-08/00003-08-09/look up.mp3": [
		5924,
		4599
	],
	"./00003/00003-08/00003-08-09/main idea.mp3": [
		1061
	],
	"./00003/00003-08/00003-08-09/things in the sky.mp3": [
		5925,
		4600
	],
	"./00003/00003-08/00003-08-09/things you can see up in the sky.mp3": [
		5926,
		4601
	],
	"./00003/00003-08/00003-08-09/what can you see in the sky.mp3": [
		5927,
		4602
	],
	"./00003/00003-08/00003-08-09/what can you see.mp3": [
		5928,
		4603
	],
	"./00003/00003-08/00003-08-09/you can see a dragon.mp3": [
		5929,
		4604
	],
	"./00003/00003-08/00003-08-09/you can see the clouds.mp3": [
		5930,
		4605
	],
	"./00003/00003-08/00003-08-09/you can see the moon.mp3": [
		5931,
		4606
	],
	"./00003/00003-08/00003-08-09/you can see the rain.mp3": [
		5932,
		4607
	],
	"./00003/00003-08/00003-08-09/you can see the rainbow.mp3": [
		5933,
		4608
	],
	"./00003/00003-08/00003-08-09/you can see the stars.mp3": [
		5934,
		4609
	],
	"./00003/00003-08/00003-08-09/you can see the sun.mp3": [
		5935,
		4610
	],
	"./00003/00003-08/00003-08-10/intro.mp3": [
		681
	],
	"./00003/00003-08/00003-08-10/it is a cloudy day.mp3": [
		5936,
		4611
	],
	"./00003/00003-08/00003-08-10/it is a rainy day.mp3": [
		5937,
		4612
	],
	"./00003/00003-08/00003-08-10/it is a rainy night.mp3": [
		5938,
		4613
	],
	"./00003/00003-08/00003-08-10/it is a snowy day.mp3": [
		5939,
		4614
	],
	"./00003/00003-08/00003-08-10/it is a snowy night.mp3": [
		5940,
		4615
	],
	"./00003/00003-08/00003-08-10/it is a sunny day.mp3": [
		5941,
		4616
	],
	"./00003/00003-08/00003-08-10/it is a windy day.mp3": [
		5942,
		4617
	],
	"./00003/00003-08/00003-08-10/look at me said the boy.mp3": [
		5943,
		4618
	],
	"./00003/00003-08/00003-08-10/look at me said the cat.mp3": [
		5944,
		4619
	],
	"./00003/00003-08/00003-08-10/look at me said the fox.mp3": [
		5945,
		4620
	],
	"./00003/00003-08/00003-08-10/look at me said the girl.mp3": [
		5946,
		4621
	],
	"./00003/00003-08/00003-08-10/look at me.mp3": [
		5947,
		4622
	],
	"./00003/00003-08/00003-08-10/look at us said the animals.mp3": [
		5948,
		4623
	],
	"./00003/00003-08/00003-08-10/look at us.mp3": [
		5949,
		4624
	],
	"./00003/00003-08/00003-08-10/main idea.mp3": [
		1062
	],
	"./00003/00003-08/00003-08-10/weather.mp3": [
		5950,
		4625
	],
	"./00003/00003-08/earth and space.mp3": [
		5951,
		4626
	],
	"./00003/00003-09/00003-09-01/fish.mp3": [
		5952,
		4627
	],
	"./00003/00003-09/00003-09-01/i am a dolphin.mp3": [
		5953,
		4628
	],
	"./00003/00003-09/00003-09-01/i am a fish.mp3": [
		5954,
		4629
	],
	"./00003/00003-09/00003-09-01/i am a flying fish.mp3": [
		5955,
		4630
	],
	"./00003/00003-09/00003-09-01/i am a hammerhead shark.mp3": [
		5956,
		4631
	],
	"./00003/00003-09/00003-09-01/i am a seahorse.mp3": [
		5957,
		4632
	],
	"./00003/00003-09/00003-09-01/i am a shark.mp3": [
		5958,
		4633
	],
	"./00003/00003-09/00003-09-01/i am a swordfish.mp3": [
		5959,
		4634
	],
	"./00003/00003-09/00003-09-01/i am an eel.mp3": [
		5960,
		4635
	],
	"./00003/00003-09/00003-09-01/i am not a fish.mp3": [
		5961,
		4636
	],
	"./00003/00003-09/00003-09-01/i breathe with my gills.mp3": [
		5962,
		4637
	],
	"./00003/00003-09/00003-09-01/i breathe with my lungs.mp3": [
		5963,
		4638
	],
	"./00003/00003-09/00003-09-01/i live in the water.mp3": [
		5964,
		4639
	],
	"./00003/00003-09/00003-09-01/intro.mp3": [
		682
	],
	"./00003/00003-09/00003-09-01/main idea.mp3": [
		1063
	],
	"./00003/00003-09/00003-09-02/i am a mammal.mp3": [
		5965,
		4640
	],
	"./00003/00003-09/00003-09-02/i am not a mammal.mp3": [
		5966,
		4641
	],
	"./00003/00003-09/00003-09-02/i do not have fur said the duck.mp3": [
		5967,
		4642
	],
	"./00003/00003-09/00003-09-02/i do not have hair said the shark.mp3": [
		5968,
		4643
	],
	"./00003/00003-09/00003-09-02/i have fur said the panda.mp3": [
		5969,
		4644
	],
	"./00003/00003-09/00003-09-02/i have fur said the skunk.mp3": [
		5970,
		4645
	],
	"./00003/00003-09/00003-09-02/i have hair said the whale.mp3": [
		5971,
		4646
	],
	"./00003/00003-09/00003-09-02/i have hair said the zebra.mp3": [
		5972,
		4647
	],
	"./00003/00003-09/00003-09-02/intro.mp3": [
		683
	],
	"./00003/00003-09/00003-09-02/main idea.mp3": [
		1064
	],
	"./00003/00003-09/00003-09-02/mammals are furry.mp3": [
		5973,
		4648
	],
	"./00003/00003-09/00003-09-02/mammals.mp3": [
		5974,
		4649
	],
	"./00003/00003-09/00003-09-02/so i am a mammal too.mp3": [
		5975,
		4650
	],
	"./00003/00003-09/00003-09-02/so we are mammals too.mp3": [
		5976,
		4651
	],
	"./00003/00003-09/00003-09-02/we have hair said the kids.mp3": [
		5977,
		4652
	],
	"./00003/00003-09/00003-09-03/cold blooded reptiles.mp3": [
		5978,
		4653
	],
	"./00003/00003-09/00003-09-03/i am a crocodile.mp3": [
		5979,
		4654
	],
	"./00003/00003-09/00003-09-03/i am a reptile.mp3": [
		5980,
		4655
	],
	"./00003/00003-09/00003-09-03/i am a snake.mp3": [
		5981,
		4656
	],
	"./00003/00003-09/00003-09-03/i am a turtle.mp3": [
		5982,
		4657
	],
	"./00003/00003-09/00003-09-03/i sit in the sun to get warm.mp3": [
		5983,
		4658
	],
	"./00003/00003-09/00003-09-03/intro.mp3": [
		684
	],
	"./00003/00003-09/00003-09-03/look at the alligator.mp3": [
		5984,
		4659
	],
	"./00003/00003-09/00003-09-03/look at the lizard.mp3": [
		5985,
		4660
	],
	"./00003/00003-09/00003-09-03/main idea.mp3": [
		1065
	],
	"./00003/00003-09/00003-09-03/mammals are warm blooded.mp3": [
		5986,
		4661
	],
	"./00003/00003-09/00003-09-03/reptiles are cold blooded.mp3": [
		5987,
		4662
	],
	"./00003/00003-09/00003-09-03/reptiles.mp3": [
		5988,
		4663
	],
	"./00003/00003-09/00003-09-03/the alligator is a reptile.mp3": [
		5989,
		4664
	],
	"./00003/00003-09/00003-09-03/the alligator is sitting in the sun.mp3": [
		5990,
		4665
	],
	"./00003/00003-09/00003-09-03/the lion is a mammal.mp3": [
		5991,
		4666
	],
	"./00003/00003-09/00003-09-03/the lizard is a reptile.mp3": [
		5992,
		4667
	],
	"./00003/00003-09/00003-09-03/the lizard is sitting in the sun.mp3": [
		5993,
		4668
	],
	"./00003/00003-09/00003-09-03/they sit in the sun for fun.mp3": [
		5994,
		4669
	],
	"./00003/00003-09/00003-09-03/they sit in the sun to get warm.mp3": [
		5995,
		4670
	],
	"./00003/00003-09/00003-09-04/amphibians.mp3": [
		5996,
		4671
	],
	"./00003/00003-09/00003-09-04/i am an amphibian said the frog.mp3": [
		5997,
		4672
	],
	"./00003/00003-09/00003-09-04/i am an amphibian said the salamander.mp3": [
		5998,
		4673
	],
	"./00003/00003-09/00003-09-04/i am an amphibian said the toad.mp3": [
		5999,
		4674
	],
	"./00003/00003-09/00003-09-04/i am an amphibian.mp3": [
		6000,
		4675
	],
	"./00003/00003-09/00003-09-04/i am not an amphibian.mp3": [
		6001,
		4676
	],
	"./00003/00003-09/00003-09-04/i can live on land said the frog.mp3": [
		6002,
		4677
	],
	"./00003/00003-09/00003-09-04/i can live on land said the salamander.mp3": [
		6003,
		4678
	],
	"./00003/00003-09/00003-09-04/i can live on land said the toad.mp3": [
		6004,
		4679
	],
	"./00003/00003-09/00003-09-04/i can not live on land said the shark.mp3": [
		6005,
		4680
	],
	"./00003/00003-09/00003-09-04/i was born in the water.mp3": [
		6006,
		4681
	],
	"./00003/00003-09/00003-09-04/intro.mp3": [
		685
	],
	"./00003/00003-09/00003-09-04/main idea.mp3": [
		1066
	],
	"./00003/00003-09/00003-09-05/are you a bird duck.mp3": [
		6007,
		4682
	],
	"./00003/00003-09/00003-09-05/are you a bird eagle.mp3": [
		6008,
		4683
	],
	"./00003/00003-09/00003-09-05/are you a bird.mp3": [
		6009,
		4684
	],
	"./00003/00003-09/00003-09-05/birds.mp3": [
		6010,
		4685
	],
	"./00003/00003-09/00003-09-05/hello bat.mp3": [
		6011,
		4686
	],
	"./00003/00003-09/00003-09-05/hello birds.mp3": [
		6012,
		4687
	],
	"./00003/00003-09/00003-09-05/hello ostrich.mp3": [
		6013,
		4688
	],
	"./00003/00003-09/00003-09-05/hello owl.mp3": [
		6014,
		4689
	],
	"./00003/00003-09/00003-09-05/hello parrot.mp3": [
		6015,
		4690
	],
	"./00003/00003-09/00003-09-05/hello penguin.mp3": [
		6016,
		4691
	],
	"./00003/00003-09/00003-09-05/i am a bird.mp3": [
		6017,
		4692
	],
	"./00003/00003-09/00003-09-05/i am not a bird.mp3": [
		6018,
		4693
	],
	"./00003/00003-09/00003-09-05/i can fly but i have no feathers.mp3": [
		6019,
		4694
	],
	"./00003/00003-09/00003-09-05/i can not fly but i am a bird.mp3": [
		6020,
		4695
	],
	"./00003/00003-09/00003-09-05/i have feathers.mp3": [
		6021,
		4696
	],
	"./00003/00003-09/00003-09-05/intro.mp3": [
		686
	],
	"./00003/00003-09/00003-09-05/main idea.mp3": [
		1067
	],
	"./00003/00003-09/00003-09-05/no i can fly but i have no feathers.mp3": [
		6022,
		4697
	],
	"./00003/00003-09/00003-09-05/no.mp3": [
		6023,
		4698
	],
	"./00003/00003-09/00003-09-05/yes i am a bird.mp3": [
		6024,
		4699
	],
	"./00003/00003-09/00003-09-05/yes.mp3": [
		6025,
		4700
	],
	"./00003/00003-09/00003-09-06/a crab has a hard body.mp3": [
		6026,
		4701
	],
	"./00003/00003-09/00003-09-06/a crab has no backbone.mp3": [
		6027,
		4702
	],
	"./00003/00003-09/00003-09-06/a jellyfish has a soft body.mp3": [
		6028,
		4703
	],
	"./00003/00003-09/00003-09-06/a jellyfish has no backbone.mp3": [
		6029,
		4704
	],
	"./00003/00003-09/00003-09-06/a ladybug has a hard body.mp3": [
		6030,
		4705
	],
	"./00003/00003-09/00003-09-06/a ladybug has no backbone.mp3": [
		6031,
		4706
	],
	"./00003/00003-09/00003-09-06/a snail has a hard shell.mp3": [
		6032,
		4707
	],
	"./00003/00003-09/00003-09-06/a spider has a hard body.mp3": [
		6033,
		4708
	],
	"./00003/00003-09/00003-09-06/a spider has no backbone.mp3": [
		6034,
		4709
	],
	"./00003/00003-09/00003-09-06/a worm has a soft body.mp3": [
		6035,
		4710
	],
	"./00003/00003-09/00003-09-06/a worm has no backbone.mp3": [
		6036,
		4711
	],
	"./00003/00003-09/00003-09-06/animals without backbones.mp3": [
		6037,
		4712
	],
	"./00003/00003-09/00003-09-06/dinosaurs had backbones.mp3": [
		6038,
		4713
	],
	"./00003/00003-09/00003-09-06/intro.mp3": [
		687
	],
	"./00003/00003-09/00003-09-06/lions and tigers have backbones.mp3": [
		6039,
		4714
	],
	"./00003/00003-09/00003-09-06/main idea.mp3": [
		1068
	],
	"./00003/00003-09/00003-09-06/slugs and snails have soft bodies.mp3": [
		6040,
		4715
	],
	"./00003/00003-09/00003-09-06/the octopus has a soft body.mp3": [
		6041,
		4716
	],
	"./00003/00003-09/00003-09-06/the octopus has no backbone.mp3": [
		6042,
		4717
	],
	"./00003/00003-09/00003-09-06/we have backbones too.mp3": [
		6043,
		4718
	],
	"./00003/00003-09/00003-09-07/ants are insects.mp3": [
		6044,
		4719
	],
	"./00003/00003-09/00003-09-07/bees are insects.mp3": [
		6045,
		4720
	],
	"./00003/00003-09/00003-09-07/but i am not an insect.mp3": [
		6046,
		4721
	],
	"./00003/00003-09/00003-09-07/i am an insect said the ant.mp3": [
		6047,
		4722
	],
	"./00003/00003-09/00003-09-07/i am an insect said the butterfly.mp3": [
		6048,
		4723
	],
	"./00003/00003-09/00003-09-07/i am an insect said the grasshopper.mp3": [
		6049,
		4724
	],
	"./00003/00003-09/00003-09-07/i am an insect.mp3": [
		6050,
		4725
	],
	"./00003/00003-09/00003-09-07/i am not an insect.mp3": [
		6051,
		4726
	],
	"./00003/00003-09/00003-09-07/i have 2 antennas and 6 legs.mp3": [
		6052,
		4727
	],
	"./00003/00003-09/00003-09-07/i have 2 antennas.mp3": [
		6053,
		4728
	],
	"./00003/00003-09/00003-09-07/i have 6 legs and 2 antennas said the butterfly.mp3": [
		6054,
		4729
	],
	"./00003/00003-09/00003-09-07/i have 6 legs and 2 antennas said the monster.mp3": [
		6055,
		4730
	],
	"./00003/00003-09/00003-09-07/i have 6 legs and 2 antennas.mp3": [
		6056,
		4731
	],
	"./00003/00003-09/00003-09-07/i have 6 legs said the dragonfly.mp3": [
		6057,
		4732
	],
	"./00003/00003-09/00003-09-07/i have 6 legs said the ladybug.mp3": [
		6058,
		4733
	],
	"./00003/00003-09/00003-09-07/i have 6 legs.mp3": [
		6059,
		4734
	],
	"./00003/00003-09/00003-09-07/i have 8 legs said the spider.mp3": [
		6060,
		4735
	],
	"./00003/00003-09/00003-09-07/insects.mp3": [
		6061,
		4736
	],
	"./00003/00003-09/00003-09-07/intro.mp3": [
		688
	],
	"./00003/00003-09/00003-09-07/ladybugs are insects.mp3": [
		6062,
		4737
	],
	"./00003/00003-09/00003-09-07/main idea.mp3": [
		1069
	],
	"./00003/00003-09/00003-09-07/me too said the dragonfly.mp3": [
		6063,
		4738
	],
	"./00003/00003-09/00003-09-07/me too said the grasshopper.mp3": [
		6064,
		4739
	],
	"./00003/00003-09/00003-09-07/spiders are not insects.mp3": [
		6065,
		4740
	],
	"./00003/00003-09/00003-09-08/big animals.mp3": [
		6066,
		4741
	],
	"./00003/00003-09/00003-09-08/he is as big as 2 kids.mp3": [
		6067,
		4742
	],
	"./00003/00003-09/00003-09-08/he is as big as 25 kids.mp3": [
		6068,
		4743
	],
	"./00003/00003-09/00003-09-08/he is as big as 5 kids.mp3": [
		6069,
		4744
	],
	"./00003/00003-09/00003-09-08/he is as big as 6 kids.mp3": [
		6070,
		4745
	],
	"./00003/00003-09/00003-09-08/here is a dinosaur.mp3": [
		6071,
		4746
	],
	"./00003/00003-09/00003-09-08/here is a squid.mp3": [
		6072,
		4747
	],
	"./00003/00003-09/00003-09-08/i can see a giraffe.mp3": [
		6073,
		4748
	],
	"./00003/00003-09/00003-09-08/i can see an ostrich.mp3": [
		6074,
		4749
	],
	"./00003/00003-09/00003-09-08/i see a whale.mp3": [
		6075,
		4750
	],
	"./00003/00003-09/00003-09-08/intro.mp3": [
		689
	],
	"./00003/00003-09/00003-09-08/look at the elephant.mp3": [
		6076,
		4751
	],
	"./00003/00003-09/00003-09-08/main idea.mp3": [
		1070
	],
	"./00003/00003-09/00003-09-08/she is as big as 10 kids.mp3": [
		6077,
		4752
	],
	"./00003/00003-09/00003-09-08/she is as big as 15 kids.mp3": [
		6078,
		4753
	],
	"./00003/00003-09/00003-09-08/she is as big as 30 kids.mp3": [
		6079,
		4754
	],
	"./00003/00003-09/00003-09-08/this dinosaur is huge.mp3": [
		6080,
		4755
	],
	"./00003/00003-09/00003-09-08/this elephant is big.mp3": [
		6081,
		4756
	],
	"./00003/00003-09/00003-09-08/this giraffe is big.mp3": [
		6082,
		4757
	],
	"./00003/00003-09/00003-09-08/this ostrich is big.mp3": [
		6083,
		4758
	],
	"./00003/00003-09/00003-09-08/this squid is big.mp3": [
		6084,
		4759
	],
	"./00003/00003-09/00003-09-08/this whale is big.mp3": [
		6085,
		4760
	],
	"./00003/00003-09/00003-09-08/this whale shark is big.mp3": [
		6086,
		4761
	],
	"./00003/00003-09/00003-09-09/animals we saw in the book.mp3": [
		6087,
		4762
	],
	"./00003/00003-09/00003-09-09/here is a cat.mp3": [
		6088,
		4763
	],
	"./00003/00003-09/00003-09-09/here is a frog.mp3": [
		6089,
		4764
	],
	"./00003/00003-09/00003-09-09/here is a shark.mp3": [
		6090,
		4765
	],
	"./00003/00003-09/00003-09-09/here is a skunk.mp3": [
		6091,
		4766
	],
	"./00003/00003-09/00003-09-09/intro.mp3": [
		690
	],
	"./00003/00003-09/00003-09-09/look at the dinosaurs.mp3": [
		6092,
		4767
	],
	"./00003/00003-09/00003-09-09/look at the eagle.mp3": [
		6093,
		4768
	],
	"./00003/00003-09/00003-09-09/look at the ladybug.mp3": [
		6094,
		4769
	],
	"./00003/00003-09/00003-09-09/look at the turtle.mp3": [
		6095,
		4770
	],
	"./00003/00003-09/00003-09-09/main idea.mp3": [
		1071
	],
	"./00003/00003-09/00003-09-09/the alligator is a reptile.mp3": [
		6096,
		4771
	],
	"./00003/00003-09/00003-09-09/the animal book.mp3": [
		6097,
		4772
	],
	"./00003/00003-09/00003-09-09/the cat is a mammal.mp3": [
		6098,
		4773
	],
	"./00003/00003-09/00003-09-09/the cat is in the book.mp3": [
		6099,
		4774
	],
	"./00003/00003-09/00003-09-09/the dinosaurs are in the book too.mp3": [
		6100,
		4775
	],
	"./00003/00003-09/00003-09-09/the dolphin is a mammal.mp3": [
		6101,
		4776
	],
	"./00003/00003-09/00003-09-09/the eagle is a bird.mp3": [
		6102,
		4777
	],
	"./00003/00003-09/00003-09-09/the eagle is in the book.mp3": [
		6103,
		4778
	],
	"./00003/00003-09/00003-09-09/the frog is an amphibian.mp3": [
		6104,
		4779
	],
	"./00003/00003-09/00003-09-09/the frog is in the book.mp3": [
		6105,
		4780
	],
	"./00003/00003-09/00003-09-09/the ladybug is an insect.mp3": [
		6106,
		4781
	],
	"./00003/00003-09/00003-09-09/the ladybug is in the book.mp3": [
		6107,
		4782
	],
	"./00003/00003-09/00003-09-09/the penguin is a bird.mp3": [
		6108,
		4783
	],
	"./00003/00003-09/00003-09-09/the seahorse is a fish.mp3": [
		6109,
		4784
	],
	"./00003/00003-09/00003-09-09/the shark is a fish.mp3": [
		6110,
		4785
	],
	"./00003/00003-09/00003-09-09/the shark is in the book.mp3": [
		6111,
		4786
	],
	"./00003/00003-09/00003-09-09/the skunk is a mammal.mp3": [
		6112,
		4787
	],
	"./00003/00003-09/00003-09-09/the skunk is in the book.mp3": [
		6113,
		4788
	],
	"./00003/00003-09/00003-09-09/the turtle is a reptile.mp3": [
		6114,
		4789
	],
	"./00003/00003-09/00003-09-09/the turtle is in the book.mp3": [
		6115,
		4790
	],
	"./00003/00003-09/00003-09-09/the whale is a mammal.mp3": [
		6116,
		4791
	],
	"./00003/00003-09/00003-09-10/dinosaurs.mp3": [
		6117,
		4792
	],
	"./00003/00003-09/00003-09-10/i am a long neck dinosaur.mp3": [
		6118,
		4793
	],
	"./00003/00003-09/00003-09-10/i am a pterosaur.mp3": [
		6119,
		4794
	],
	"./00003/00003-09/00003-09-10/i am a raptor.mp3": [
		6120,
		4795
	],
	"./00003/00003-09/00003-09-10/i am a stegosaurus.mp3": [
		6121,
		4796
	],
	"./00003/00003-09/00003-09-10/i am a swimming dinosaur.mp3": [
		6122,
		4797
	],
	"./00003/00003-09/00003-09-10/i am a t rex.mp3": [
		6123,
		4798
	],
	"./00003/00003-09/00003-09-10/i am a triceratops.mp3": [
		6124,
		4799
	],
	"./00003/00003-09/00003-09-10/i can fly.mp3": [
		6125,
		4800
	],
	"./00003/00003-09/00003-09-10/i can swim.mp3": [
		6126,
		4801
	],
	"./00003/00003-09/00003-09-10/i eat meat too.mp3": [
		6127,
		4802
	],
	"./00003/00003-09/00003-09-10/i eat meat.mp3": [
		6128,
		4803
	],
	"./00003/00003-09/00003-09-10/i eat plants too.mp3": [
		6129,
		4804
	],
	"./00003/00003-09/00003-09-10/i eat plants.mp3": [
		6130,
		4805
	],
	"./00003/00003-09/00003-09-10/i have 3 horns.mp3": [
		6131,
		4806
	],
	"./00003/00003-09/00003-09-10/intro.mp3": [
		691
	],
	"./00003/00003-09/00003-09-10/look at me.mp3": [
		6132,
		4807
	],
	"./00003/00003-09/00003-09-10/main idea.mp3": [
		1072
	],
	"./00003/00003-09/animal groups.mp3": [
		6133,
		4808
	],
	"./00003/00003-10/00003-10-01/animals with 4 legs.mp3": [
		6134,
		4809
	],
	"./00003/00003-10/00003-10-01/butterflies are insects.mp3": [
		6135,
		4810
	],
	"./00003/00003-10/00003-10-01/butterflies have 6 legs.mp3": [
		6136,
		4811
	],
	"./00003/00003-10/00003-10-01/fish have no legs.mp3": [
		6137,
		4812
	],
	"./00003/00003-10/00003-10-01/i am a bird.mp3": [
		6138,
		4813
	],
	"./00003/00003-10/00003-10-01/i am a butterfly.mp3": [
		6139,
		4814
	],
	"./00003/00003-10/00003-10-01/i am a dog.mp3": [
		6140,
		4815
	],
	"./00003/00003-10/00003-10-01/i am a fish.mp3": [
		6141,
		4816
	],
	"./00003/00003-10/00003-10-01/i am a ladybug.mp3": [
		6142,
		4817
	],
	"./00003/00003-10/00003-10-01/i am a monster.mp3": [
		6143,
		4818
	],
	"./00003/00003-10/00003-10-01/i am a parrot.mp3": [
		6144,
		4819
	],
	"./00003/00003-10/00003-10-01/i am a spider.mp3": [
		6145,
		4820
	],
	"./00003/00003-10/00003-10-01/i am a squid.mp3": [
		6146,
		4821
	],
	"./00003/00003-10/00003-10-01/i am an insect.mp3": [
		6147,
		4822
	],
	"./00003/00003-10/00003-10-01/i have 10 legs.mp3": [
		6148,
		4823
	],
	"./00003/00003-10/00003-10-01/i have 12 legs.mp3": [
		6149,
		4824
	],
	"./00003/00003-10/00003-10-01/i have 2 legs.mp3": [
		6150,
		4825
	],
	"./00003/00003-10/00003-10-01/i have 3 legs.mp3": [
		6151,
		4826
	],
	"./00003/00003-10/00003-10-01/i have 4 legs.mp3": [
		6152,
		4827
	],
	"./00003/00003-10/00003-10-01/i have 6 legs.mp3": [
		6153,
		4828
	],
	"./00003/00003-10/00003-10-01/i have 8 legs.mp3": [
		6154,
		4829
	],
	"./00003/00003-10/00003-10-01/intro.mp3": [
		692
	],
	"./00003/00003-10/00003-10-01/legs.mp3": [
		6155,
		4830
	],
	"./00003/00003-10/00003-10-01/main idea.mp3": [
		1073
	],
	"./00003/00003-10/00003-10-01/parrots have 2 legs.mp3": [
		6156,
		4831
	],
	"./00003/00003-10/00003-10-01/spiders are not insects.mp3": [
		6157,
		4832
	],
	"./00003/00003-10/00003-10-01/spiders have 8 legs.mp3": [
		6158,
		4833
	],
	"./00003/00003-10/00003-10-02/animals with spots.mp3": [
		6159,
		4834
	],
	"./00003/00003-10/00003-10-02/here is a dinosaur.mp3": [
		6160,
		4835
	],
	"./00003/00003-10/00003-10-02/here is a raccoon.mp3": [
		6161,
		4836
	],
	"./00003/00003-10/00003-10-02/i can see a giraffe.mp3": [
		6162,
		4837
	],
	"./00003/00003-10/00003-10-02/i like the tiger.mp3": [
		6163,
		4838
	],
	"./00003/00003-10/00003-10-02/i like the zebra.mp3": [
		6164,
		4839
	],
	"./00003/00003-10/00003-10-02/i see a deer.mp3": [
		6165,
		4840
	],
	"./00003/00003-10/00003-10-02/intro.mp3": [
		693
	],
	"./00003/00003-10/00003-10-02/look at the ladybug.mp3": [
		6166,
		4841
	],
	"./00003/00003-10/00003-10-02/main idea.mp3": [
		1074
	],
	"./00003/00003-10/00003-10-02/stripes and spots.mp3": [
		6167,
		4842
	],
	"./00003/00003-10/00003-10-02/the deer has spots.mp3": [
		6168,
		4843
	],
	"./00003/00003-10/00003-10-02/the dinosaur has spots too.mp3": [
		6169,
		4844
	],
	"./00003/00003-10/00003-10-02/the giraffe has spots.mp3": [
		6170,
		4845
	],
	"./00003/00003-10/00003-10-02/the ladybug has spots.mp3": [
		6171,
		4846
	],
	"./00003/00003-10/00003-10-02/the raccoon has stripes.mp3": [
		6172,
		4847
	],
	"./00003/00003-10/00003-10-02/the tiger has stripes.mp3": [
		6173,
		4848
	],
	"./00003/00003-10/00003-10-02/the zebra has stripes.mp3": [
		6174,
		4849
	],
	"./00003/00003-10/00003-10-03/animals with 2 eyes.mp3": [
		6175,
		4850
	],
	"./00003/00003-10/00003-10-03/eyes.mp3": [
		6176,
		4851
	],
	"./00003/00003-10/00003-10-03/i am a bird.mp3": [
		6177,
		4852
	],
	"./00003/00003-10/00003-10-03/i am a fish.mp3": [
		6178,
		4853
	],
	"./00003/00003-10/00003-10-03/i am a green frog.mp3": [
		6179,
		4854
	],
	"./00003/00003-10/00003-10-03/i am a green grasshopper.mp3": [
		6180,
		4855
	],
	"./00003/00003-10/00003-10-03/i am a hammerhead shark.mp3": [
		6181,
		4856
	],
	"./00003/00003-10/00003-10-03/i am a monster.mp3": [
		6182,
		4857
	],
	"./00003/00003-10/00003-10-03/i am a spider.mp3": [
		6183,
		4858
	],
	"./00003/00003-10/00003-10-03/i am a starfish.mp3": [
		6184,
		4859
	],
	"./00003/00003-10/00003-10-03/i am an amphibian.mp3": [
		6185,
		4860
	],
	"./00003/00003-10/00003-10-03/i am an insect.mp3": [
		6186,
		4861
	],
	"./00003/00003-10/00003-10-03/i am an owl.mp3": [
		6187,
		4862
	],
	"./00003/00003-10/00003-10-03/i am not a fish.mp3": [
		6188,
		4863
	],
	"./00003/00003-10/00003-10-03/i have 10 eyes.mp3": [
		6189,
		4864
	],
	"./00003/00003-10/00003-10-03/i have 2 eyes.mp3": [
		6190,
		4865
	],
	"./00003/00003-10/00003-10-03/i have 5 eyes.mp3": [
		6191,
		4866
	],
	"./00003/00003-10/00003-10-03/i have 8 eyes.mp3": [
		6192,
		4867
	],
	"./00003/00003-10/00003-10-03/i have 8 legs.mp3": [
		6193,
		4868
	],
	"./00003/00003-10/00003-10-03/intro.mp3": [
		694
	],
	"./00003/00003-10/00003-10-03/look at my eyes.mp3": [
		6194,
		4869
	],
	"./00003/00003-10/00003-10-03/main idea.mp3": [
		1075
	],
	"./00003/00003-10/00003-10-04/animals with 2 horns.mp3": [
		6195,
		4870
	],
	"./00003/00003-10/00003-10-04/here is a dinosaur.mp3": [
		6196,
		4871
	],
	"./00003/00003-10/00003-10-04/here is a goat.mp3": [
		6197,
		4872
	],
	"./00003/00003-10/00003-10-04/here is a monster.mp3": [
		6198,
		4873
	],
	"./00003/00003-10/00003-10-04/horns.mp3": [
		6199,
		4874
	],
	"./00003/00003-10/00003-10-04/i can see a giraffe.mp3": [
		6200,
		4875
	],
	"./00003/00003-10/00003-10-04/i can see a rhino.mp3": [
		6201,
		4876
	],
	"./00003/00003-10/00003-10-04/i see the unicorn.mp3": [
		6202,
		4877
	],
	"./00003/00003-10/00003-10-04/intro.mp3": [
		695
	],
	"./00003/00003-10/00003-10-04/look at the cow.mp3": [
		6203,
		4878
	],
	"./00003/00003-10/00003-10-04/main idea.mp3": [
		1076
	],
	"./00003/00003-10/00003-10-04/the cow has 2 horns.mp3": [
		6204,
		4879
	],
	"./00003/00003-10/00003-10-04/the dinosaur has 3 horns.mp3": [
		6205,
		4880
	],
	"./00003/00003-10/00003-10-04/the giraffe has 2 horns.mp3": [
		6206,
		4881
	],
	"./00003/00003-10/00003-10-04/the goat has 2 horns.mp3": [
		6207,
		4882
	],
	"./00003/00003-10/00003-10-04/the monster has horns too.mp3": [
		6208,
		4883
	],
	"./00003/00003-10/00003-10-04/the rhino has 2 horns.mp3": [
		6209,
		4884
	],
	"./00003/00003-10/00003-10-04/the unicorn has 1 horn.mp3": [
		6210,
		4885
	],
	"./00003/00003-10/00003-10-05/animals with long necks.mp3": [
		6211,
		4886
	],
	"./00003/00003-10/00003-10-05/here comes the ostrich.mp3": [
		6212,
		4887
	],
	"./00003/00003-10/00003-10-05/here is a rhino.mp3": [
		6213,
		4888
	],
	"./00003/00003-10/00003-10-05/i can see a flamingo.mp3": [
		6214,
		4889
	],
	"./00003/00003-10/00003-10-05/i can see a goose.mp3": [
		6215,
		4890
	],
	"./00003/00003-10/00003-10-05/i can see a seal.mp3": [
		6216,
		4891
	],
	"./00003/00003-10/00003-10-05/i can see a snake.mp3": [
		6217,
		4892
	],
	"./00003/00003-10/00003-10-05/i see a pink pig.mp3": [
		6218,
		4893
	],
	"./00003/00003-10/00003-10-05/intro.mp3": [
		696
	],
	"./00003/00003-10/00003-10-05/look at the dinosaur.mp3": [
		6219,
		4894
	],
	"./00003/00003-10/00003-10-05/look at the giraffe.mp3": [
		6220,
		4895
	],
	"./00003/00003-10/00003-10-05/main idea.mp3": [
		1077
	],
	"./00003/00003-10/00003-10-05/necks.mp3": [
		6221,
		4896
	],
	"./00003/00003-10/00003-10-05/the dinosaur has a long neck too.mp3": [
		6222,
		4897
	],
	"./00003/00003-10/00003-10-05/the giraffe has a long neck.mp3": [
		6223,
		4898
	],
	"./00003/00003-10/00003-10-05/the goose has a long neck.mp3": [
		6224,
		4899
	],
	"./00003/00003-10/00003-10-05/the ostrich has a long neck.mp3": [
		6225,
		4900
	],
	"./00003/00003-10/00003-10-05/the pig has a short neck.mp3": [
		6226,
		4901
	],
	"./00003/00003-10/00003-10-05/the rhino has a short neck.mp3": [
		6227,
		4902
	],
	"./00003/00003-10/00003-10-05/the seal has a short neck.mp3": [
		6228,
		4903
	],
	"./00003/00003-10/00003-10-05/this giraffe is big.mp3": [
		6229,
		4904
	],
	"./00003/00003-10/00003-10-05/this ostrich is big.mp3": [
		6230,
		4905
	],
	"./00003/00003-10/00003-10-06/animals we saw in the book.mp3": [
		6231,
		4906
	],
	"./00003/00003-10/00003-10-06/here is a dinosaur.mp3": [
		6232,
		4907
	],
	"./00003/00003-10/00003-10-06/i see a beaver.mp3": [
		6233,
		4908
	],
	"./00003/00003-10/00003-10-06/i see a bird.mp3": [
		6234,
		4909
	],
	"./00003/00003-10/00003-10-06/i see a walrus.mp3": [
		6235,
		4910
	],
	"./00003/00003-10/00003-10-06/intro.mp3": [
		697
	],
	"./00003/00003-10/00003-10-06/look at the bat.mp3": [
		6236,
		4911
	],
	"./00003/00003-10/00003-10-06/look at the eel.mp3": [
		6237,
		4912
	],
	"./00003/00003-10/00003-10-06/look at the elephant.mp3": [
		6238,
		4913
	],
	"./00003/00003-10/00003-10-06/main idea.mp3": [
		1078
	],
	"./00003/00003-10/00003-10-06/teeth.mp3": [
		6239,
		4914
	],
	"./00003/00003-10/00003-10-06/the alligator has sharp teeth.mp3": [
		6240,
		4915
	],
	"./00003/00003-10/00003-10-06/the bat has sharp teeth.mp3": [
		6241,
		4916
	],
	"./00003/00003-10/00003-10-06/the bat likes insects.mp3": [
		6242,
		4917
	],
	"./00003/00003-10/00003-10-06/the beaver has long teeth.mp3": [
		6243,
		4918
	],
	"./00003/00003-10/00003-10-06/the beaver lives at the pond.mp3": [
		6244,
		4919
	],
	"./00003/00003-10/00003-10-06/the bird has no teeth.mp3": [
		6245,
		4920
	],
	"./00003/00003-10/00003-10-06/the dinosaur has sharp teeth.mp3": [
		6246,
		4921
	],
	"./00003/00003-10/00003-10-06/the eel has sharp teeth.mp3": [
		6247,
		4922
	],
	"./00003/00003-10/00003-10-06/the elephant has big ears.mp3": [
		6248,
		4923
	],
	"./00003/00003-10/00003-10-06/the elephant has long teeth.mp3": [
		6249,
		4924
	],
	"./00003/00003-10/00003-10-06/the shark has sharp teeth.mp3": [
		6250,
		4925
	],
	"./00003/00003-10/00003-10-06/the walrus has long teeth.mp3": [
		6251,
		4926
	],
	"./00003/00003-10/00003-10-07/animals with 2 feet.mp3": [
		6252,
		4927
	],
	"./00003/00003-10/00003-10-07/feet.mp3": [
		6253,
		4928
	],
	"./00003/00003-10/00003-10-07/i have 1 foot said the slug.mp3": [
		6254,
		4929
	],
	"./00003/00003-10/00003-10-07/i have 1 foot said the snail.mp3": [
		6255,
		4930
	],
	"./00003/00003-10/00003-10-07/i have 2 feet said the duck.mp3": [
		6256,
		4931
	],
	"./00003/00003-10/00003-10-07/i have 2 feet.mp3": [
		6257,
		4932
	],
	"./00003/00003-10/00003-10-07/i have 4 feet said the frog.mp3": [
		6258,
		4933
	],
	"./00003/00003-10/00003-10-07/i have 4 feet.mp3": [
		6259,
		4934
	],
	"./00003/00003-10/00003-10-07/i have no feet said the whale.mp3": [
		6260,
		4935
	],
	"./00003/00003-10/00003-10-07/intro.mp3": [
		698
	],
	"./00003/00003-10/00003-10-07/look at me.mp3": [
		6261,
		4936
	],
	"./00003/00003-10/00003-10-07/look at my feet said the bird (2).mp3": [
		6262,
		4937
	],
	"./00003/00003-10/00003-10-07/look at my feet said the bird.mp3": [
		6263,
		4938
	],
	"./00003/00003-10/00003-10-07/look at my feet said the raccoon.mp3": [
		6264,
		4939
	],
	"./00003/00003-10/00003-10-07/look at my feet.mp3": [
		6265,
		4940
	],
	"./00003/00003-10/00003-10-07/look at my foot.mp3": [
		6266,
		4941
	],
	"./00003/00003-10/00003-10-07/main idea.mp3": [
		1079
	],
	"./00003/00003-10/00003-10-08/animals with shells.mp3": [
		6267,
		4942
	],
	"./00003/00003-10/00003-10-08/do you.mp3": [
		6268,
		4943
	],
	"./00003/00003-10/00003-10-08/i do not have a shell.mp3": [
		6269,
		4944
	],
	"./00003/00003-10/00003-10-08/i have a shell said the hermit crab.mp3": [
		6270,
		4945
	],
	"./00003/00003-10/00003-10-08/i have a shell said the lobster.mp3": [
		6271,
		4946
	],
	"./00003/00003-10/00003-10-08/i have a shell said the snail.mp3": [
		6272,
		4947
	],
	"./00003/00003-10/00003-10-08/i have a shell said the turtle.mp3": [
		6273,
		4948
	],
	"./00003/00003-10/00003-10-08/intro.mp3": [
		699
	],
	"./00003/00003-10/00003-10-08/look at my shell.mp3": [
		6274,
		4949
	],
	"./00003/00003-10/00003-10-08/main idea.mp3": [
		1080
	],
	"./00003/00003-10/00003-10-08/no said the fish.mp3": [
		6275,
		4950
	],
	"./00003/00003-10/00003-10-08/no said the frog.mp3": [
		6276,
		4951
	],
	"./00003/00003-10/00003-10-08/no said the slug.mp3": [
		6277,
		4952
	],
	"./00003/00003-10/00003-10-08/shells.mp3": [
		6278,
		4953
	],
	"./00003/00003-10/00003-10-09/animals with long noses.mp3": [
		6279,
		4954
	],
	"./00003/00003-10/00003-10-09/animals with short noses.mp3": [
		6280,
		4955
	],
	"./00003/00003-10/00003-10-09/he has a long nose.mp3": [
		6281,
		4956
	],
	"./00003/00003-10/00003-10-09/i have a long nose said the alligator.mp3": [
		6282,
		4957
	],
	"./00003/00003-10/00003-10-09/i have a long nose said the dog.mp3": [
		6283,
		4958
	],
	"./00003/00003-10/00003-10-09/i have a long nose said the elephant.mp3": [
		6284,
		4959
	],
	"./00003/00003-10/00003-10-09/i have a long nose said the monster.mp3": [
		6285,
		4960
	],
	"./00003/00003-10/00003-10-09/i have a short nose said the cat.mp3": [
		6286,
		4961
	],
	"./00003/00003-10/00003-10-09/i have a short nose said the dog.mp3": [
		6287,
		4962
	],
	"./00003/00003-10/00003-10-09/i have a short nose said the pig.mp3": [
		6288,
		4963
	],
	"./00003/00003-10/00003-10-09/i see the alligator.mp3": [
		6289,
		4964
	],
	"./00003/00003-10/00003-10-09/i see the dog.mp3": [
		6290,
		4965
	],
	"./00003/00003-10/00003-10-09/i see the elephant.mp3": [
		6291,
		4966
	],
	"./00003/00003-10/00003-10-09/i see the monster.mp3": [
		6292,
		4967
	],
	"./00003/00003-10/00003-10-09/i see the seahorse.mp3": [
		6293,
		4968
	],
	"./00003/00003-10/00003-10-09/i see the swordfish.mp3": [
		6294,
		4969
	],
	"./00003/00003-10/00003-10-09/intro.mp3": [
		700
	],
	"./00003/00003-10/00003-10-09/look at my nose.mp3": [
		6295,
		4970
	],
	"./00003/00003-10/00003-10-09/look at the anteater.mp3": [
		6296,
		4971
	],
	"./00003/00003-10/00003-10-09/main idea.mp3": [
		1081
	],
	"./00003/00003-10/00003-10-09/noses.mp3": [
		6297,
		4972
	],
	"./00003/00003-10/00003-10-09/not me.mp3": [
		6298,
		4973
	],
	"./00003/00003-10/00003-10-09/she has a long nose.mp3": [
		6299,
		4974
	],
	"./00003/00003-10/00003-10-10/animals with big ears.mp3": [
		6300,
		4975
	],
	"./00003/00003-10/00003-10-10/ears.mp3": [
		6301,
		4976
	],
	"./00003/00003-10/00003-10-10/here is a donkey.mp3": [
		6302,
		4977
	],
	"./00003/00003-10/00003-10-10/i can see the orange tiger.mp3": [
		6303,
		4978
	],
	"./00003/00003-10/00003-10-10/i like the elephant.mp3": [
		6304,
		4979
	],
	"./00003/00003-10/00003-10-10/i like the rabbit.mp3": [
		6305,
		4980
	],
	"./00003/00003-10/00003-10-10/i see the seal.mp3": [
		6306,
		4981
	],
	"./00003/00003-10/00003-10-10/intro.mp3": [
		701
	],
	"./00003/00003-10/00003-10-10/look at the bear.mp3": [
		6307,
		4982
	],
	"./00003/00003-10/00003-10-10/look at the kangaroo.mp3": [
		6308,
		4983
	],
	"./00003/00003-10/00003-10-10/main idea.mp3": [
		1082
	],
	"./00003/00003-10/00003-10-10/the bear has little ears too.mp3": [
		6309,
		4984
	],
	"./00003/00003-10/00003-10-10/the donkey has big ears too.mp3": [
		6310,
		4985
	],
	"./00003/00003-10/00003-10-10/the elephant has big ears.mp3": [
		6311,
		4986
	],
	"./00003/00003-10/00003-10-10/the kangaroo has big ears too.mp3": [
		6312,
		4987
	],
	"./00003/00003-10/00003-10-10/the rabbit has big ears.mp3": [
		6313,
		4988
	],
	"./00003/00003-10/00003-10-10/the seal has no ears.mp3": [
		6314,
		4989
	],
	"./00003/00003-10/00003-10-10/the tiger has little ears.mp3": [
		6315,
		4990
	],
	"./00003/00003-10/creature features.mp3": [
		6316,
		4991
	],
	"./00003/00003-11/00003-11-01/flying animals.mp3": [
		6317,
		4992
	],
	"./00003/00003-11/00003-11-01/intro.mp3": [
		702
	],
	"./00003/00003-11/00003-11-01/look at the eagle.mp3": [
		6318,
		4993
	],
	"./00003/00003-11/00003-11-01/look at the rabbit.mp3": [
		6319,
		4994
	],
	"./00003/00003-11/00003-11-01/look at the tiger.mp3": [
		6320,
		4995
	],
	"./00003/00003-11/00003-11-01/look up in the sky.mp3": [
		6321,
		4996
	],
	"./00003/00003-11/00003-11-01/look up.mp3": [
		6322,
		4997
	],
	"./00003/00003-11/00003-11-01/main idea.mp3": [
		1083
	],
	"./00003/00003-11/00003-11-01/the dragon can fly.mp3": [
		6323,
		4998
	],
	"./00003/00003-11/00003-11-01/the eagle can fly.mp3": [
		6324,
		4999
	],
	"./00003/00003-11/00003-11-01/the pig can fly.mp3": [
		6325,
		5000
	],
	"./00003/00003-11/00003-11-01/the rabbit can fly.mp3": [
		6326,
		5001
	],
	"./00003/00003-11/00003-11-01/the spaceship can fly.mp3": [
		6327,
		5002
	],
	"./00003/00003-11/00003-11-01/the tiger can fly.mp3": [
		6328,
		5003
	],
	"./00003/00003-11/00003-11-01/the unicorn can fly.mp3": [
		6329,
		5004
	],
	"./00003/00003-11/00003-11-01/what can fly.mp3": [
		6330,
		5005
	],
	"./00003/00003-11/00003-11-01/you can see a dragon.mp3": [
		6331,
		5006
	],
	"./00003/00003-11/00003-11-02/1 more dinosaur comes to play.mp3": [
		6332,
		5007
	],
	"./00003/00003-11/00003-11-02/5 little dinosaurs.mp3": [
		6333,
		5008
	],
	"./00003/00003-11/00003-11-02/dinosaurs.mp3": [
		6334,
		5009
	],
	"./00003/00003-11/00003-11-02/i see 0 little dinosaurs.mp3": [
		6335,
		5010
	],
	"./00003/00003-11/00003-11-02/i see 1 big dinosaur.mp3": [
		6336,
		5011
	],
	"./00003/00003-11/00003-11-02/i see 1 little dinosaur.mp3": [
		6337,
		5012
	],
	"./00003/00003-11/00003-11-02/i see 2 little dinosaurs.mp3": [
		6338,
		5013
	],
	"./00003/00003-11/00003-11-02/i see 3 little dinosaurs.mp3": [
		6339,
		5014
	],
	"./00003/00003-11/00003-11-02/i see 4 little dinosaurs.mp3": [
		6340,
		5015
	],
	"./00003/00003-11/00003-11-02/i see 5 little dinosaurs.mp3": [
		6341,
		5016
	],
	"./00003/00003-11/00003-11-02/intro.mp3": [
		703
	],
	"./00003/00003-11/00003-11-02/little dinosaurs play and play.mp3": [
		6342,
		5017
	],
	"./00003/00003-11/00003-11-02/little dinosaurs run away.mp3": [
		6343,
		5018
	],
	"./00003/00003-11/00003-11-02/look at the dinosaur.mp3": [
		6344,
		5019
	],
	"./00003/00003-11/00003-11-02/look out.mp3": [
		6345,
		5020
	],
	"./00003/00003-11/00003-11-02/main idea.mp3": [
		1084
	],
	"./00003/00003-11/00003-11-02/one and four is five.mp3": [
		6346,
		5021
	],
	"./00003/00003-11/00003-11-02/one and three is four.mp3": [
		6347,
		5022
	],
	"./00003/00003-11/00003-11-03/i am a brown bear.mp3": [
		6348,
		5023
	],
	"./00003/00003-11/00003-11-03/i am a crocodile.mp3": [
		6349,
		5024
	],
	"./00003/00003-11/00003-11-03/i am a dinosaur.mp3": [
		6350,
		5025
	],
	"./00003/00003-11/00003-11-03/i am a panda.mp3": [
		6351,
		5026
	],
	"./00003/00003-11/00003-11-03/i am a penguin.mp3": [
		6352,
		5027
	],
	"./00003/00003-11/00003-11-03/i am a shark.mp3": [
		6353,
		5028
	],
	"./00003/00003-11/00003-11-03/i am flying.mp3": [
		6354,
		5029
	],
	"./00003/00003-11/00003-11-03/i am running.mp3": [
		6355,
		5030
	],
	"./00003/00003-11/00003-11-03/i am skating.mp3": [
		6356,
		5031
	],
	"./00003/00003-11/00003-11-03/i am sleeping.mp3": [
		6357,
		5032
	],
	"./00003/00003-11/00003-11-03/i am sliding.mp3": [
		6358,
		5033
	],
	"./00003/00003-11/00003-11-03/i am swimming.mp3": [
		6359,
		5034
	],
	"./00003/00003-11/00003-11-03/intro.mp3": [
		704
	],
	"./00003/00003-11/00003-11-03/look at me.mp3": [
		6360,
		5035
	],
	"./00003/00003-11/00003-11-03/look at us.mp3": [
		6361,
		5036
	],
	"./00003/00003-11/00003-11-03/main idea.mp3": [
		1085
	],
	"./00003/00003-11/00003-11-03/swimming animals.mp3": [
		6362,
		5037
	],
	"./00003/00003-11/00003-11-03/we are jumping.mp3": [
		6363,
		5038
	],
	"./00003/00003-11/00003-11-03/we are kangaroos.mp3": [
		6364,
		5039
	],
	"./00003/00003-11/00003-11-04/here are 2 big rocks said the dog.mp3": [
		6365,
		5040
	],
	"./00003/00003-11/00003-11-04/here are 6 little rocks said the goose.mp3": [
		6366,
		5041
	],
	"./00003/00003-11/00003-11-04/here is a big snowball said the elephant.mp3": [
		6367,
		5042
	],
	"./00003/00003-11/00003-11-04/here is a carrot said the deer.mp3": [
		6368,
		5043
	],
	"./00003/00003-11/00003-11-04/here is a hat for the snowman.mp3": [
		6369,
		5044
	],
	"./00003/00003-11/00003-11-04/here is a hat said the penguin.mp3": [
		6370,
		5045
	],
	"./00003/00003-11/00003-11-04/here is a little snowball too.mp3": [
		6371,
		5046
	],
	"./00003/00003-11/00003-11-04/here is a scarf for the snowman.mp3": [
		6372,
		5047
	],
	"./00003/00003-11/00003-11-04/here is a scarf said the alligator.mp3": [
		6373,
		5048
	],
	"./00003/00003-11/00003-11-04/intro.mp3": [
		705
	],
	"./00003/00003-11/00003-11-04/look at the big rocks.mp3": [
		6374,
		5049
	],
	"./00003/00003-11/00003-11-04/look at the big snowman.mp3": [
		6375,
		5050
	],
	"./00003/00003-11/00003-11-04/look at the little rocks.mp3": [
		6376,
		5051
	],
	"./00003/00003-11/00003-11-04/look at the snowmans eyes.mp3": [
		6377,
		5052
	],
	"./00003/00003-11/00003-11-04/look at the snowmans mouth.mp3": [
		6378,
		5053
	],
	"./00003/00003-11/00003-11-04/look at the snowmans nose.mp3": [
		6379,
		5054
	],
	"./00003/00003-11/00003-11-04/look said the cat.mp3": [
		6380,
		5055
	],
	"./00003/00003-11/00003-11-04/main idea.mp3": [
		1086
	],
	"./00003/00003-11/00003-11-04/making a snowman.mp3": [
		6381,
		5056
	],
	"./00003/00003-11/00003-11-04/the big rocks are for the snowmans eyes.mp3": [
		6382,
		5057
	],
	"./00003/00003-11/00003-11-04/the carrot is for the snowmans nose.mp3": [
		6383,
		5058
	],
	"./00003/00003-11/00003-11-04/the little rocks are for the snowmans mouth.mp3": [
		6384,
		5059
	],
	"./00003/00003-11/00003-11-04/things you need to make a snowman.mp3": [
		6385,
		5060
	],
	"./00003/00003-11/00003-11-05/going up and down.mp3": [
		6386,
		5061
	],
	"./00003/00003-11/00003-11-05/intro.mp3": [
		706
	],
	"./00003/00003-11/00003-11-05/look at the cat.mp3": [
		6387,
		5062
	],
	"./00003/00003-11/00003-11-05/look at the dog.mp3": [
		6388,
		5063
	],
	"./00003/00003-11/00003-11-05/look at the mouse.mp3": [
		6389,
		5064
	],
	"./00003/00003-11/00003-11-05/main idea.mp3": [
		1087
	],
	"./00003/00003-11/00003-11-05/the cat is going down.mp3": [
		6390,
		5065
	],
	"./00003/00003-11/00003-11-05/the cat is going up.mp3": [
		6391,
		5066
	],
	"./00003/00003-11/00003-11-05/the dog is going down.mp3": [
		6392,
		5067
	],
	"./00003/00003-11/00003-11-05/the dog is going up.mp3": [
		6393,
		5068
	],
	"./00003/00003-11/00003-11-05/the mouse is going down.mp3": [
		6394,
		5069
	],
	"./00003/00003-11/00003-11-05/the mouse is going up.mp3": [
		6395,
		5070
	],
	"./00003/00003-11/00003-11-05/things you can see up in the sky.mp3": [
		6396,
		5071
	],
	"./00003/00003-11/00003-11-06/here comes the cheetah.mp3": [
		6397,
		5072
	],
	"./00003/00003-11/00003-11-06/here comes the elephant.mp3": [
		6398,
		5073
	],
	"./00003/00003-11/00003-11-06/here comes the fox.mp3": [
		6399,
		5074
	],
	"./00003/00003-11/00003-11-06/here comes the giraffe.mp3": [
		6400,
		5075
	],
	"./00003/00003-11/00003-11-06/here comes the lion.mp3": [
		6401,
		5076
	],
	"./00003/00003-11/00003-11-06/here comes the ostrich.mp3": [
		6402,
		5077
	],
	"./00003/00003-11/00003-11-06/here comes the zebra.mp3": [
		6403,
		5078
	],
	"./00003/00003-11/00003-11-06/intro.mp3": [
		707
	],
	"./00003/00003-11/00003-11-06/main idea.mp3": [
		1088
	],
	"./00003/00003-11/00003-11-06/the animal race.mp3": [
		6404,
		5079
	],
	"./00003/00003-11/00003-11-06/the cheetah runs the fastest.mp3": [
		6405,
		5080
	],
	"./00003/00003-11/00003-11-06/the elephant runs fast.mp3": [
		6406,
		5081
	],
	"./00003/00003-11/00003-11-06/the fox runs faster.mp3": [
		6407,
		5082
	],
	"./00003/00003-11/00003-11-06/the giraffe runs faster.mp3": [
		6408,
		5083
	],
	"./00003/00003-11/00003-11-06/the lion runs faster.mp3": [
		6409,
		5084
	],
	"./00003/00003-11/00003-11-06/the ostrich runs faster.mp3": [
		6410,
		5085
	],
	"./00003/00003-11/00003-11-06/the zebra runs faster.mp3": [
		6411,
		5086
	],
	"./00003/00003-11/00003-11-06/wild animals.mp3": [
		6412,
		5087
	],
	"./00003/00003-11/00003-11-07/he lives with me.mp3": [
		6413,
		5088
	],
	"./00003/00003-11/00003-11-07/here is my bird said the dinosaur.mp3": [
		6414,
		5089
	],
	"./00003/00003-11/00003-11-07/here is my bird said the girl.mp3": [
		6415,
		5090
	],
	"./00003/00003-11/00003-11-07/here is my bird said the monster.mp3": [
		6416,
		5091
	],
	"./00003/00003-11/00003-11-07/here is my cat said the boy.mp3": [
		6417,
		5092
	],
	"./00003/00003-11/00003-11-07/here is my cat said the monster.mp3": [
		6418,
		5093
	],
	"./00003/00003-11/00003-11-07/here is my dog said the girl.mp3": [
		6419,
		5094
	],
	"./00003/00003-11/00003-11-07/here is my dog said the monster.mp3": [
		6420,
		5095
	],
	"./00003/00003-11/00003-11-07/here is my pet said the boy.mp3": [
		6421,
		5096
	],
	"./00003/00003-11/00003-11-07/here is my pet said the girl.mp3": [
		6422,
		5097
	],
	"./00003/00003-11/00003-11-07/here is my pet.mp3": [
		6423,
		5098
	],
	"./00003/00003-11/00003-11-07/i love my bird too.mp3": [
		6424,
		5099
	],
	"./00003/00003-11/00003-11-07/i love my bird.mp3": [
		6425,
		5100
	],
	"./00003/00003-11/00003-11-07/i love my cat.mp3": [
		6426,
		5101
	],
	"./00003/00003-11/00003-11-07/i love my dog.mp3": [
		6427,
		5102
	],
	"./00003/00003-11/00003-11-07/intro.mp3": [
		708
	],
	"./00003/00003-11/00003-11-07/look at my pet.mp3": [
		6428,
		5103
	],
	"./00003/00003-11/00003-11-07/main idea.mp3": [
		1089
	],
	"./00003/00003-11/00003-11-07/me too said the dinosaur.mp3": [
		6429,
		5104
	],
	"./00003/00003-11/00003-11-07/pets.mp3": [
		6430,
		5105
	],
	"./00003/00003-11/00003-11-07/she lives with me.mp3": [
		6431,
		5106
	],
	"./00003/00003-11/00003-11-08/can you.mp3": [
		6432,
		5107
	],
	"./00003/00003-11/00003-11-08/characters who can skate in the book.mp3": [
		6433,
		5108
	],
	"./00003/00003-11/00003-11-08/i can not skate said the bear.mp3": [
		6434,
		5109
	],
	"./00003/00003-11/00003-11-08/i can skate said the deer.mp3": [
		6435,
		5110
	],
	"./00003/00003-11/00003-11-08/i can skate said the monster.mp3": [
		6436,
		5111
	],
	"./00003/00003-11/00003-11-08/i can skate said the panda.mp3": [
		6437,
		5112
	],
	"./00003/00003-11/00003-11-08/i can skate said the penguin.mp3": [
		6438,
		5113
	],
	"./00003/00003-11/00003-11-08/intro.mp3": [
		709
	],
	"./00003/00003-11/00003-11-08/look at me.mp3": [
		6439,
		5114
	],
	"./00003/00003-11/00003-11-08/look at us.mp3": [
		6440,
		5115
	],
	"./00003/00003-11/00003-11-08/main idea.mp3": [
		1090
	],
	"./00003/00003-11/00003-11-08/oh no.mp3": [
		6441,
		5116
	],
	"./00003/00003-11/00003-11-08/we can skate said the lions.mp3": [
		6442,
		5117
	],
	"./00003/00003-11/00003-11-08/we can skate said the rabbits.mp3": [
		6443,
		5118
	],
	"./00003/00003-11/00003-11-08/who can skate.mp3": [
		6444,
		5119
	],
	"./00003/00003-11/00003-11-09/animals with four legs.mp3": [
		6445,
		5120
	],
	"./00003/00003-11/00003-11-09/balloons.mp3": [
		6446,
		5121
	],
	"./00003/00003-11/00003-11-09/cat likes the orange balloon.mp3": [
		6447,
		5122
	],
	"./00003/00003-11/00003-11-09/dinosaur likes the blue balloon.mp3": [
		6448,
		5123
	],
	"./00003/00003-11/00003-11-09/dog likes the red balloon.mp3": [
		6449,
		5124
	],
	"./00003/00003-11/00003-11-09/here is a cat.mp3": [
		6450,
		5125
	],
	"./00003/00003-11/00003-11-09/here is a dog.mp3": [
		6451,
		5126
	],
	"./00003/00003-11/00003-11-09/here is a rabbit.mp3": [
		6452,
		5127
	],
	"./00003/00003-11/00003-11-09/i can see a dinosaur.mp3": [
		6453,
		5128
	],
	"./00003/00003-11/00003-11-09/i like the monkey.mp3": [
		6454,
		5129
	],
	"./00003/00003-11/00003-11-09/i see the octopus.mp3": [
		6455,
		5130
	],
	"./00003/00003-11/00003-11-09/i see the yellow lion.mp3": [
		6456,
		5131
	],
	"./00003/00003-11/00003-11-09/intro.mp3": [
		710
	],
	"./00003/00003-11/00003-11-09/lion likes the yellow balloon.mp3": [
		6457,
		5132
	],
	"./00003/00003-11/00003-11-09/look at the cat.mp3": [
		6458,
		5133
	],
	"./00003/00003-11/00003-11-09/look at the dinosaur.mp3": [
		6459,
		5134
	],
	"./00003/00003-11/00003-11-09/look at the dog.mp3": [
		6460,
		5135
	],
	"./00003/00003-11/00003-11-09/look at the lion.mp3": [
		6461,
		5136
	],
	"./00003/00003-11/00003-11-09/look at the monkey.mp3": [
		6462,
		5137
	],
	"./00003/00003-11/00003-11-09/look at the octopus.mp3": [
		6463,
		5138
	],
	"./00003/00003-11/00003-11-09/look at the rabbit.mp3": [
		6464,
		5139
	],
	"./00003/00003-11/00003-11-09/main idea.mp3": [
		1091
	],
	"./00003/00003-11/00003-11-09/monkey likes the green balloon.mp3": [
		6465,
		5140
	],
	"./00003/00003-11/00003-11-09/octopus likes the balloons.mp3": [
		6466,
		5141
	],
	"./00003/00003-11/00003-11-09/rabbit likes the pink balloon.mp3": [
		6467,
		5142
	],
	"./00003/00003-11/00003-11-10/ant sees the yellow flower.mp3": [
		6468,
		5143
	],
	"./00003/00003-11/00003-11-10/bee sees the orange flower.mp3": [
		6469,
		5144
	],
	"./00003/00003-11/00003-11-10/butterfly sees the red flower.mp3": [
		6470,
		5145
	],
	"./00003/00003-11/00003-11-10/do you.mp3": [
		6471,
		5146
	],
	"./00003/00003-11/00003-11-10/grasshopper sees the pink flower.mp3": [
		6472,
		5147
	],
	"./00003/00003-11/00003-11-10/he likes flowers.mp3": [
		6473,
		5148
	],
	"./00003/00003-11/00003-11-10/hummingbird sees the blue flower.mp3": [
		6474,
		5149
	],
	"./00003/00003-11/00003-11-10/i like flowers he said.mp3": [
		6475,
		5150
	],
	"./00003/00003-11/00003-11-10/i like flowers she said.mp3": [
		6476,
		5151
	],
	"./00003/00003-11/00003-11-10/insects.mp3": [
		6477,
		5152
	],
	"./00003/00003-11/00003-11-10/intro.mp3": [
		711
	],
	"./00003/00003-11/00003-11-10/ladybug sees the purple flower.mp3": [
		6478,
		5153
	],
	"./00003/00003-11/00003-11-10/look at the flowers.mp3": [
		6479,
		5154
	],
	"./00003/00003-11/00003-11-10/main idea.mp3": [
		1092
	],
	"./00003/00003-11/00003-11-10/she likes flowers.mp3": [
		6480,
		5155
	],
	"./00003/00003-11/00003-11-10/we see flowers.mp3": [
		6481,
		5156
	],
	"./00003/00003-11/00003-11-10/we see the flowers.mp3": [
		6482,
		5157
	],
	"./00003/00003-11/00003-11-10/yes said the insects.mp3": [
		6483,
		5158
	],
	"./00003/00003-11/00003-11-10/yes.mp3": [
		6484,
		5159
	],
	"./00003/00003-11/story town.mp3": [
		6485,
		5160
	],
	"./00003/00003-12/00003-12-01/alligator wants an airplane.mp3": [
		6486,
		5161
	],
	"./00003/00003-12/00003-12-01/bear wants a bike.mp3": [
		6487,
		5162
	],
	"./00003/00003-12/00003-12-01/cat wants a car.mp3": [
		6488,
		5163
	],
	"./00003/00003-12/00003-12-01/christmas is here.mp3": [
		6489,
		5164
	],
	"./00003/00003-12/00003-12-01/dog wants a dinosaur.mp3": [
		6490,
		5165
	],
	"./00003/00003-12/00003-12-01/fox wants a fire truck.mp3": [
		6491,
		5166
	],
	"./00003/00003-12/00003-12-01/here comes the gray hippo.mp3": [
		6492,
		5167
	],
	"./00003/00003-12/00003-12-01/hippo wants a helicopter.mp3": [
		6493,
		5168
	],
	"./00003/00003-12/00003-12-01/i see a wagon.mp3": [
		6494,
		5169
	],
	"./00003/00003-12/00003-12-01/i see a wolf.mp3": [
		6495,
		5170
	],
	"./00003/00003-12/00003-12-01/i see the alligator.mp3": [
		6496,
		5171
	],
	"./00003/00003-12/00003-12-01/intro.mp3": [
		712
	],
	"./00003/00003-12/00003-12-01/look at the airplane.mp3": [
		6497,
		5172
	],
	"./00003/00003-12/00003-12-01/look at the alligator.mp3": [
		6498,
		5173
	],
	"./00003/00003-12/00003-12-01/look at the bear.mp3": [
		6499,
		5174
	],
	"./00003/00003-12/00003-12-01/look at the bike.mp3": [
		6500,
		5175
	],
	"./00003/00003-12/00003-12-01/look at the car.mp3": [
		6501,
		5176
	],
	"./00003/00003-12/00003-12-01/look at the cat.mp3": [
		6502,
		5177
	],
	"./00003/00003-12/00003-12-01/look at the dinosaur.mp3": [
		6503,
		5178
	],
	"./00003/00003-12/00003-12-01/look at the dog.mp3": [
		6504,
		5179
	],
	"./00003/00003-12/00003-12-01/look at the fox.mp3": [
		6505,
		5180
	],
	"./00003/00003-12/00003-12-01/look at the helicopter.mp3": [
		6506,
		5181
	],
	"./00003/00003-12/00003-12-01/main idea.mp3": [
		1093
	],
	"./00003/00003-12/00003-12-01/the fire truck is red.mp3": [
		6507,
		5182
	],
	"./00003/00003-12/00003-12-01/toys.mp3": [
		6508,
		5183
	],
	"./00003/00003-12/00003-12-01/vehicles.mp3": [
		6509,
		5184
	],
	"./00003/00003-12/00003-12-01/wolf wants a wagon.mp3": [
		6510,
		5185
	],
	"./00003/00003-12/00003-12-02/alligator got a saxophone.mp3": [
		6511,
		5186
	],
	"./00003/00003-12/00003-12-02/bear got a guitar.mp3": [
		6512,
		5187
	],
	"./00003/00003-12/00003-12-02/beaver got a xylophone.mp3": [
		6513,
		5188
	],
	"./00003/00003-12/00003-12-02/dog got a tambourine.mp3": [
		6514,
		5189
	],
	"./00003/00003-12/00003-12-02/fox got a fiddle.mp3": [
		6515,
		5190
	],
	"./00003/00003-12/00003-12-02/i love music he said.mp3": [
		6516,
		5191
	],
	"./00003/00003-12/00003-12-02/i love music she said.mp3": [
		6517,
		5192
	],
	"./00003/00003-12/00003-12-02/i love music.mp3": [
		6518,
		5193
	],
	"./00003/00003-12/00003-12-02/intro.mp3": [
		713
	],
	"./00003/00003-12/00003-12-02/look at the banjo.mp3": [
		6519,
		5194
	],
	"./00003/00003-12/00003-12-02/look at the fiddle.mp3": [
		6520,
		5195
	],
	"./00003/00003-12/00003-12-02/look at the guitar.mp3": [
		6521,
		5196
	],
	"./00003/00003-12/00003-12-02/look at the saxophone.mp3": [
		6522,
		5197
	],
	"./00003/00003-12/00003-12-02/look at the tambourine.mp3": [
		6523,
		5198
	],
	"./00003/00003-12/00003-12-02/look at the triangle.mp3": [
		6524,
		5199
	],
	"./00003/00003-12/00003-12-02/look at the xylophone.mp3": [
		6525,
		5200
	],
	"./00003/00003-12/00003-12-02/main idea.mp3": [
		1094
	],
	"./00003/00003-12/00003-12-02/monkey got a triangle.mp3": [
		6526,
		5201
	],
	"./00003/00003-12/00003-12-02/musical instruments.mp3": [
		6527,
		5202
	],
	"./00003/00003-12/00003-12-02/raccoon got a banjo.mp3": [
		6528,
		5203
	],
	"./00003/00003-12/00003-12-03/alligator is going to the party.mp3": [
		6529,
		5204
	],
	"./00003/00003-12/00003-12-03/cat is going to the party.mp3": [
		6530,
		5205
	],
	"./00003/00003-12/00003-12-03/characters in the book.mp3": [
		6531,
		5206
	],
	"./00003/00003-12/00003-12-03/crocodile is going to the party.mp3": [
		6532,
		5207
	],
	"./00003/00003-12/00003-12-03/dog is going to the party.mp3": [
		6533,
		5208
	],
	"./00003/00003-12/00003-12-03/elephant is going to the party.mp3": [
		6534,
		5209
	],
	"./00003/00003-12/00003-12-03/going to the party.mp3": [
		6535,
		5210
	],
	"./00003/00003-12/00003-12-03/he is going to the party.mp3": [
		6536,
		5211
	],
	"./00003/00003-12/00003-12-03/here is the party.mp3": [
		6537,
		5212
	],
	"./00003/00003-12/00003-12-03/intro.mp3": [
		714
	],
	"./00003/00003-12/00003-12-03/jaguar is going to the party.mp3": [
		6538,
		5213
	],
	"./00003/00003-12/00003-12-03/look at the alligator.mp3": [
		6539,
		5214
	],
	"./00003/00003-12/00003-12-03/look at the animals.mp3": [
		6540,
		5215
	],
	"./00003/00003-12/00003-12-03/look at the cat.mp3": [
		6541,
		5216
	],
	"./00003/00003-12/00003-12-03/look at the dog.mp3": [
		6542,
		5217
	],
	"./00003/00003-12/00003-12-03/look at the elephant.mp3": [
		6543,
		5218
	],
	"./00003/00003-12/00003-12-03/look at the jaguar.mp3": [
		6544,
		5219
	],
	"./00003/00003-12/00003-12-03/look at the tiger.mp3": [
		6545,
		5220
	],
	"./00003/00003-12/00003-12-03/look at the zebra.mp3": [
		6546,
		5221
	],
	"./00003/00003-12/00003-12-03/main idea.mp3": [
		1095
	],
	"./00003/00003-12/00003-12-03/panda is going to the party.mp3": [
		6547,
		5222
	],
	"./00003/00003-12/00003-12-03/she is going to the party.mp3": [
		6548,
		5223
	],
	"./00003/00003-12/00003-12-03/they are going to the party.mp3": [
		6549,
		5224
	],
	"./00003/00003-12/00003-12-03/tiger is going to the party.mp3": [
		6550,
		5225
	],
	"./00003/00003-12/00003-12-03/wild animals.mp3": [
		6551,
		5226
	],
	"./00003/00003-12/00003-12-03/zebra is going to the party.mp3": [
		6552,
		5227
	],
	"./00003/00003-12/00003-12-04/a friend for yellow duck.mp3": [
		6553,
		5228
	],
	"./00003/00003-12/00003-12-04/animals with 4 legs.mp3": [
		6554,
		5229
	],
	"./00003/00003-12/00003-12-04/can we play too said the fox and the deer.mp3": [
		6555,
		5230
	],
	"./00003/00003-12/00003-12-04/can we play too said the squirrel the skunk and the sheep.mp3": [
		6556,
		5231
	],
	"./00003/00003-12/00003-12-04/hello deer said yellow duck.mp3": [
		6557,
		5232
	],
	"./00003/00003-12/00003-12-04/hello sheep said yellow duck.mp3": [
		6558,
		5233
	],
	"./00003/00003-12/00003-12-04/here is brown duck.mp3": [
		6559,
		5234
	],
	"./00003/00003-12/00003-12-04/here is fox.mp3": [
		6560,
		5235
	],
	"./00003/00003-12/00003-12-04/here is skunk.mp3": [
		6561,
		5236
	],
	"./00003/00003-12/00003-12-04/i will not play with you.mp3": [
		6562,
		5237
	],
	"./00003/00003-12/00003-12-04/intro.mp3": [
		715
	],
	"./00003/00003-12/00003-12-04/look at the deer.mp3": [
		6563,
		5238
	],
	"./00003/00003-12/00003-12-04/main idea.mp3": [
		1096
	],
	"./00003/00003-12/00003-12-04/no i will not said skunk.mp3": [
		6564,
		5239
	],
	"./00003/00003-12/00003-12-04/no no no said sheep.mp3": [
		6565,
		5240
	],
	"./00003/00003-12/00003-12-04/no said fox.mp3": [
		6566,
		5241
	],
	"./00003/00003-12/00003-12-04/no said squirrel.mp3": [
		6567,
		5242
	],
	"./00003/00003-12/00003-12-04/not me said deer.mp3": [
		6568,
		5243
	],
	"./00003/00003-12/00003-12-04/squirrel will you play with me said yellow duck.mp3": [
		6569,
		5244
	],
	"./00003/00003-12/00003-12-04/will you play with me said yellow duck.mp3": [
		6570,
		5245
	],
	"./00003/00003-12/00003-12-04/will you play with me she said.mp3": [
		6571,
		5246
	],
	"./00003/00003-12/00003-12-04/will you play with me.mp3": [
		6572,
		5247
	],
	"./00003/00003-12/00003-12-04/yellow duck is looking for a friend.mp3": [
		6573,
		5248
	],
	"./00003/00003-12/00003-12-04/yellow duck said will you play with me.mp3": [
		6574,
		5249
	],
	"./00003/00003-12/00003-12-04/yes said brown duck.mp3": [
		6575,
		5250
	],
	"./00003/00003-12/00003-12-04/yes said yellow duck.mp3": [
		6576,
		5251
	],
	"./00003/00003-12/00003-12-05/cat likes to play soccer.mp3": [
		6577,
		5252
	],
	"./00003/00003-12/00003-12-05/fox likes to play soccer.mp3": [
		6578,
		5253
	],
	"./00003/00003-12/00003-12-05/goal said snake.mp3": [
		6579,
		5254
	],
	"./00003/00003-12/00003-12-05/i can not kick the ball.mp3": [
		6580,
		5255
	],
	"./00003/00003-12/00003-12-05/i can not play soccer.mp3": [
		6581,
		5256
	],
	"./00003/00003-12/00003-12-05/i have no feet said snake.mp3": [
		6582,
		5257
	],
	"./00003/00003-12/00003-12-05/intro.mp3": [
		716
	],
	"./00003/00003-12/00003-12-05/lion kicks the ball to skunk.mp3": [
		6583,
		5258
	],
	"./00003/00003-12/00003-12-05/lion likes to play soccer.mp3": [
		6584,
		5259
	],
	"./00003/00003-12/00003-12-05/main idea.mp3": [
		1097
	],
	"./00003/00003-12/00003-12-05/rabbit kicks the ball at the goal.mp3": [
		6585,
		5260
	],
	"./00003/00003-12/00003-12-05/rabbit kicks the ball to lion.mp3": [
		6586,
		5261
	],
	"./00003/00003-12/00003-12-05/rabbit likes to play soccer too.mp3": [
		6587,
		5262
	],
	"./00003/00003-12/00003-12-05/sheep likes to play soccer.mp3": [
		6588,
		5263
	],
	"./00003/00003-12/00003-12-05/skunk kicks the ball to rabbit.mp3": [
		6589,
		5264
	],
	"./00003/00003-12/00003-12-05/skunk likes to play soccer.mp3": [
		6590,
		5265
	],
	"./00003/00003-12/00003-12-05/the ball goes in the goal.mp3": [
		6591,
		5266
	],
	"./00003/00003-12/00003-12-05/the soccer game.mp3": [
		6592,
		5267
	],
	"./00003/00003-12/00003-12-05/tiger likes to play soccer.mp3": [
		6593,
		5268
	],
	"./00003/00003-12/00003-12-05/wild animals.mp3": [
		6594,
		5269
	],
	"./00003/00003-12/00003-12-06/baby animals.mp3": [
		6595,
		5270
	],
	"./00003/00003-12/00003-12-06/can i be your mother said the rabbit.mp3": [
		6596,
		5271
	],
	"./00003/00003-12/00003-12-06/can i be your mother.mp3": [
		6597,
		5272
	],
	"./00003/00003-12/00003-12-06/farm animals.mp3": [
		6598,
		5273
	],
	"./00003/00003-12/00003-12-06/i do not have a mother.mp3": [
		6599,
		5274
	],
	"./00003/00003-12/00003-12-06/i have a mother said the baby fox.mp3": [
		6600,
		5275
	],
	"./00003/00003-12/00003-12-06/i have a mother said the baby sheep.mp3": [
		6601,
		5276
	],
	"./00003/00003-12/00003-12-06/i have a mother said the chick.mp3": [
		6602,
		5277
	],
	"./00003/00003-12/00003-12-06/i have a mother.mp3": [
		6603,
		5278
	],
	"./00003/00003-12/00003-12-06/intro.mp3": [
		717
	],
	"./00003/00003-12/00003-12-06/main idea.mp3": [
		1098
	],
	"./00003/00003-12/00003-12-06/my mother is a cat.mp3": [
		6604,
		5279
	],
	"./00003/00003-12/00003-12-06/my mother is a chicken.mp3": [
		6605,
		5280
	],
	"./00003/00003-12/00003-12-06/my mother is a dog.mp3": [
		6606,
		5281
	],
	"./00003/00003-12/00003-12-06/my mother is a fox.mp3": [
		6607,
		5282
	],
	"./00003/00003-12/00003-12-06/my mother is a goat.mp3": [
		6608,
		5283
	],
	"./00003/00003-12/00003-12-06/my mother is a sheep.mp3": [
		6609,
		5284
	],
	"./00003/00003-12/00003-12-06/no said the baby goat.mp3": [
		6610,
		5285
	],
	"./00003/00003-12/00003-12-06/no said the kitten.mp3": [
		6611,
		5286
	],
	"./00003/00003-12/00003-12-06/no said the puppy.mp3": [
		6612,
		5287
	],
	"./00003/00003-12/00003-12-06/no.mp3": [
		6613,
		5288
	],
	"./00003/00003-12/00003-12-06/the rabbit said can i be your mother.mp3": [
		6614,
		5289
	],
	"./00003/00003-12/00003-12-06/yes said the baby turtle.mp3": [
		6615,
		5290
	],
	"./00003/00003-12/00003-12-06/yes.mp3": [
		6616,
		5291
	],
	"./00003/00003-12/00003-12-06/you can be my mother.mp3": [
		6617,
		5292
	],
	"./00003/00003-12/00003-12-07/an apple fell on her head.mp3": [
		6618,
		5293
	],
	"./00003/00003-12/00003-12-07/an apple fell on your head.mp3": [
		6619,
		5294
	],
	"./00003/00003-12/00003-12-07/birds.mp3": [
		6620,
		5295
	],
	"./00003/00003-12/00003-12-07/characters in the book.mp3": [
		6621,
		5296
	],
	"./00003/00003-12/00003-12-07/chicken little was sitting under a tree.mp3": [
		6622,
		5297
	],
	"./00003/00003-12/00003-12-07/i am the king said the lion.mp3": [
		6623,
		5298
	],
	"./00003/00003-12/00003-12-07/i must tell the king.mp3": [
		6624,
		5299
	],
	"./00003/00003-12/00003-12-07/intro.mp3": [
		718
	],
	"./00003/00003-12/00003-12-07/look at the deer.mp3": [
		6625,
		5300
	],
	"./00003/00003-12/00003-12-07/look at the elephant.mp3": [
		6626,
		5301
	],
	"./00003/00003-12/00003-12-07/look at the fox.mp3": [
		6627,
		5302
	],
	"./00003/00003-12/00003-12-07/look at the jaguar.mp3": [
		6628,
		5303
	],
	"./00003/00003-12/00003-12-07/look at the lion.mp3": [
		6629,
		5304
	],
	"./00003/00003-12/00003-12-07/look at the tiger.mp3": [
		6630,
		5305
	],
	"./00003/00003-12/00003-12-07/main idea.mp3": [
		1099
	],
	"./00003/00003-12/00003-12-07/the sky is falling said chicken little.mp3": [
		6631,
		5306
	],
	"./00003/00003-12/00003-12-07/the sky is falling said elephant.mp3": [
		6632,
		5307
	],
	"./00003/00003-12/00003-12-07/the sky is falling said jaguar.mp3": [
		6633,
		5308
	],
	"./00003/00003-12/00003-12-07/the sky is falling.mp3": [
		6634,
		5309
	],
	"./00003/00003-12/00003-12-07/the sky is not falling.mp3": [
		6635,
		5310
	],
	"./00003/00003-12/00003-12-07/we must tell the king.mp3": [
		6636,
		5311
	],
	"./00003/00003-12/00003-12-07/where are you going said elephant.mp3": [
		6637,
		5312
	],
	"./00003/00003-12/00003-12-07/where are you going said jaguar.mp3": [
		6638,
		5313
	],
	"./00003/00003-12/00003-12-07/where are you going said tiger.mp3": [
		6639,
		5314
	],
	"./00003/00003-12/00003-12-07/where are you going said wolf.mp3": [
		6640,
		5315
	],
	"./00003/00003-12/00003-12-08/here i am said the kitten.mp3": [
		6641,
		5316
	],
	"./00003/00003-12/00003-12-08/here you are said mother cat.mp3": [
		6642,
		5317
	],
	"./00003/00003-12/00003-12-08/intro.mp3": [
		719
	],
	"./00003/00003-12/00003-12-08/kitten where are you.mp3": [
		6643,
		5318
	],
	"./00003/00003-12/00003-12-08/main idea.mp3": [
		1100
	],
	"./00003/00003-12/00003-12-08/mother cat looked and looked.mp3": [
		6644,
		5319
	],
	"./00003/00003-12/00003-12-08/mother cat looked in the bathroom.mp3": [
		6645,
		5320
	],
	"./00003/00003-12/00003-12-08/mother cat looked in the bathtub.mp3": [
		6646,
		5321
	],
	"./00003/00003-12/00003-12-08/mother cat looked in the bedroom.mp3": [
		6647,
		5322
	],
	"./00003/00003-12/00003-12-08/mother cat looked in the living room.mp3": [
		6648,
		5323
	],
	"./00003/00003-12/00003-12-08/mother cat looked on the bed.mp3": [
		6649,
		5324
	],
	"./00003/00003-12/00003-12-08/mother cat looked on the couch.mp3": [
		6650,
		5325
	],
	"./00003/00003-12/00003-12-08/mother cat looked on the table.mp3": [
		6651,
		5326
	],
	"./00003/00003-12/00003-12-08/mother cat looked.mp3": [
		6652,
		5327
	],
	"./00003/00003-12/00003-12-08/no kittens here she said.mp3": [
		6653,
		5328
	],
	"./00003/00003-12/00003-12-08/non living things.mp3": [
		6654,
		5329
	],
	"./00003/00003-12/00003-12-08/she looked and looked.mp3": [
		6655,
		5330
	],
	"./00003/00003-12/00003-12-08/she looked in the box.mp3": [
		6656,
		5331
	],
	"./00003/00003-12/00003-12-08/she looked in the car.mp3": [
		6657,
		5332
	],
	"./00003/00003-12/00003-12-08/where is my kitten said mother cat.mp3": [
		6658,
		5333
	],
	"./00003/00003-12/00003-12-08/where is the kitten.mp3": [
		6659,
		5334
	],
	"./00003/00003-12/00003-12-09/i love the butterflies.mp3": [
		6660,
		5335
	],
	"./00003/00003-12/00003-12-09/i love the dragonflies.mp3": [
		6661,
		5336
	],
	"./00003/00003-12/00003-12-09/i love the farms.mp3": [
		6662,
		5337
	],
	"./00003/00003-12/00003-12-09/i love the mountains.mp3": [
		6663,
		5338
	],
	"./00003/00003-12/00003-12-09/i love the ocean.mp3": [
		6664,
		5339
	],
	"./00003/00003-12/00003-12-09/i love the ponds.mp3": [
		6665,
		5340
	],
	"./00003/00003-12/00003-12-09/i love to see the bees.mp3": [
		6666,
		5341
	],
	"./00003/00003-12/00003-12-09/i love to see the boats.mp3": [
		6667,
		5342
	],
	"./00003/00003-12/00003-12-09/i love to see the dogs.mp3": [
		6668,
		5343
	],
	"./00003/00003-12/00003-12-09/i love to see the frogs.mp3": [
		6669,
		5344
	],
	"./00003/00003-12/00003-12-09/i love to see the goats.mp3": [
		6670,
		5345
	],
	"./00003/00003-12/00003-12-09/i love to see the trees.mp3": [
		6671,
		5346
	],
	"./00003/00003-12/00003-12-09/intro.mp3": [
		720
	],
	"./00003/00003-12/00003-12-09/main idea.mp3": [
		1101
	],
	"./00003/00003-12/00003-12-09/things on the earth.mp3": [
		6672,
		5347
	],
	"./00003/00003-12/00003-12-09/we love the animals.mp3": [
		6673,
		5348
	],
	"./00003/00003-12/00003-12-09/we love the earth.mp3": [
		6674,
		5349
	],
	"./00003/00003-12/00003-12-10/birds.mp3": [
		6675,
		5350
	],
	"./00003/00003-12/00003-12-10/have you seen my mother said baby bird.mp3": [
		6676,
		5351
	],
	"./00003/00003-12/00003-12-10/have you seen my mother.mp3": [
		6677,
		5352
	],
	"./00003/00003-12/00003-12-10/help mother said baby bird.mp3": [
		6678,
		5353
	],
	"./00003/00003-12/00003-12-10/here is a dog.mp3": [
		6679,
		5354
	],
	"./00003/00003-12/00003-12-10/here is a worm said mother bird.mp3": [
		6680,
		5355
	],
	"./00003/00003-12/00003-12-10/here is baby bird.mp3": [
		6681,
		5356
	],
	"./00003/00003-12/00003-12-10/here is mother bird.mp3": [
		6682,
		5357
	],
	"./00003/00003-12/00003-12-10/i can see a pig.mp3": [
		6683,
		5358
	],
	"./00003/00003-12/00003-12-10/i can see a snake.mp3": [
		6684,
		5359
	],
	"./00003/00003-12/00003-12-10/intro.mp3": [
		721
	],
	"./00003/00003-12/00003-12-10/look at the duck.mp3": [
		6685,
		5360
	],
	"./00003/00003-12/00003-12-10/look at the rabbit.mp3": [
		6686,
		5361
	],
	"./00003/00003-12/00003-12-10/main idea.mp3": [
		1102
	],
	"./00003/00003-12/story land.mp3": [
		6687,
		5362
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 74;
module.exports = webpackAsyncContext;